import React, { useContext, useEffect, useLayoutEffect, useState, useRef, useCallback, useMemo, useTransition } from "react";
import ReactDOM from "react-dom";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import Layout from "../../components/Layout";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import MaterialIcon from "../../components/MaterialIcon";
import { getProjectTagColors } from "../../utils/projectTagColor";

import { callAPI, callAPI2 } from "../../helper/apiUtils";
import { getBadgeCount, invalidateBadgeCount, applyOptimisticChatRead } from "../../helper/badgeCount";
import { decrementRoomUnreadInLists, findRoomInLists, PINNED_ROOMS_MAX } from "../Project/roomDnd";
import { BASE_URL, KJUUP_COLORS, API_ROOT, makeid } from "../../helper/constants";
import { SOCKET_BASE } from "../../helper/SocketObj";
import { preloadAvatars } from "../../helper/avatarCache";
import {
  ALL_BADGE_COUNT,
  FETCH_ALL_REQUEST,
  GROUPS,
  GROUP_CHATS,
  IS_NEW_MESSAGE,
  NEWS_BADGE_COUNT,
  OPEN_CHATS,
  OPEN_PROJECTS,
  RESET_LATEST_MESSAGES,
  RESET_MARKIN_PROJECT,
  RIGHT_TOP,
  SET_ACTIVITY_MESSAGES,
  SET_ACTIVITY_MESSAGES_REMINDERS,
  SET_IN_ACTIVITY,
  SET_DEEPLINK_DATA,
  SET_DEEPLINK_LOADING,
  SET_PENDING_EMAIL_OPEN,
  SET_NEW_MESSAGE_DATA,
  TOGGLE_LATEST_MSG,
  TOGGLE_PROJECT,
  SET_OPEN_SIDE_BAR,
  UPDATE_PROJECT_ACTION_FIRE,
  TOGGLE_TODO_VIEW,
  REFRESH_TODO_LIST,
  SET_ACTIVITY_MESSAGES_LAST_FETCHED,
  EMAIL_SYNC,
  EMAIL_CATCH_UP,
  MY_SPACE_PINNED,
  RESET_UNSEEN_EMAIL_COUNT,
  DECREMENT_UNSEEN_EMAIL_COUNT,
  INCREMENT_UNSEEN_EMAIL_COUNT,
  DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
  INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
  DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT,
  INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT,
  SET_PENDING_EMAIL,
  SET_PENDING_CHAT,
  CLEAR_EMAIL_SEARCH,
  SET_EMAIL_ACCOUNTS,
  SET_EMAIL_CUSTOM_FOLDERS,
  SET_SEARCH_STATUS,
  PROJECTS,
  INTERNAL_PROJECTS,
  SET_OVERSIGHT_ROOM,
  store,
} from "../../store";
import { emailSyncEventsAfter, latestEmailSyncSeq } from "../../utils/emailSyncQueue";
import { connect, useDispatch, useSelector } from "react-redux";
import { canShowEmailCalendarIntegration } from "../../utils/kjuupIoEntitlement";
import { resolveCockpitPersona, chatsHidden, emailClientHidden, teamsClientHidden } from "../../utils/cockpitPersona";
import { resolveStripeFlags } from "../../utils/stripeFeature";


import { $crud } from "../../helper/CrudFactory";
import { onlyUsername } from "../Project/GroupChat/getUsername";
import { findDraftForChat, getDraftPreviewText } from "../../utils/draftMessages";
import Dropdown from "react-bootstrap/Dropdown";
import Coversation from "../Chat/Coversation";
import ProjectDetail from "../Project/ProjectChildComponent/ProjectDetail";
import SearchBar from "../../components/SearchBar";
import { FiSearch, FiFileText } from "react-icons/fi";
import kjuupIcon from "../../Icons/KjuupIcon.svg";
import { SocketContext } from "../../context/socket";
import { PaneActiveContext } from "../../context/paneActive";
import { $user } from "../../helper/UserFactory";
import { decryptMessage, encryptMessage } from "../../utils/encryptDecryptFunction";
import { getVoiceMediaStream } from "../../utils/voiceRecordingConstraints";
import { MentionsInput, Mention } from "react-mentions";
import "../../styles/components.css";
import "../../styles/customStyles.css";
import "../../styles/latestMessages.css";
import { MENTIONS_INPUT_STYLE, MENTION_SUGGESTIONS_CONTAINER_STYLE, MENTION_SUGGESTION_ROW_STYLE, MENTION_AVATAR_STYLE, MENTION_NAME_WRAPPER_STYLE } from "../../styles/chatStyles";

import ProjectNotification from "../Project/ProjectNotification";
import MemberSelection from "../../components/MemberSelection";
import { formatDate } from "../../utils/formatUtils";
import { renderTextWithMentions } from "../../utils/mentionUtils";
import { isMessageEmojiOnly, cleanTranscript, stripMarkdown, stripHtmlToPlainText, getOneToOnePartnerAvatar, getOneToOnePartnerName, isSelfChatGroup, isDirectMessageChat, isArchivedChat, excludeArchivedChats } from "../../utils/conversationUtils";
import {
  TEAMS_PROJECT_EVENT,
  newTeamsChatRow,
  TEAMS_UNREAD_EVENT,
  isTeamsChat,
  isTeamsOneOnOne,
  isTeamsTarget,
  mergeFirstPageRows,
  mergeTeamsLatestMsg,
  rememberTeamsChats,
  teamsChatEntry,
  teamsChatTitle,
  teamsLatestUnseen,
  teamsProjectOf,
} from "../../utils/teams/teamsChats";
import { teamsCallPreview } from "../../utils/teams/teamsCall";
import TeamsChatRoomModal from "../../components/chat/TeamsChatRoomModal";
import BookmarkProjectSheet from "../../components/chat/BookmarkProjectSheet";
import useTeamsConnected from "../../hooks/useTeamsConnected";
import { teamsBridgeOf } from "../../utils/teams/combinedChat";
import { DOC_ACCEPT_ATTRIBUTE, DOC_EXTENSIONS, isSameMediaSend } from "../../utils/documentAlbum";
import { cancelPreTranslation, getTranslateText, translateMessagesBatch, preserveOriginalFormatting, isUntranslatableText } from "../../utils/translationUtils";
import { shouldAutoTranslateFromSender, detectLanguageClient } from "../../utils/autoTranslationLanguages";
import {
  composerMarkdownToHtml as composerMdToHtml,
  htmlToMarkdown as sharedHtmlToMarkdown,
  syncComposerEmptiness,
  applyActiveFormatsIfChanged,
  readComposerFormats,
  pasteAsPlainText,
  handleComposerDrop,
  getDroppedFiles,
  fileFingerprint,
  handleComposerEnterKey,
} from "../../utils/composerUtils";
import MarkdownPreview from "../../components/MarkdownPreview";
import EmailInbox from "../../components/EmailInbox";
import { extractSenderEmail } from "../../helper/emailSenderLogo";
import EmailEmptyState from "../../components/EmailEmptyState";
import TrialWarningBanner from "../../components/TrialWarningBanner";
import EmailConnectionWarningBanner from "../../components/EmailConnectionWarningBanner";
import { fetchAndStoreSubscriptionStatus } from "../../services/PaymentService";
import EmailDetailView from "../../components/EmailDetailView";
import DailyBriefingDocument, { isDailyBriefingEmail } from "../../components/DailyBriefingDocument";
import EmailAssignModal from "../../components/EmailAssignModal";
import EmailClassifyBusyOverlay from "../../components/EmailClassifyBusyOverlay";
import ProjectTagActionModal from "../../components/ProjectTagActionModal";
import { createInternalEmailRoom } from "../../utils/emailAssignRoom";
import {
  classifySpamWithProgress,
  classifyProjectWithProgress,
  classifyProgressLabel,
} from "../../utils/emailClassifyWithProgress";
import { navigateToChatDeeplink } from "../../helper/chatDeeplink";
import { prefetchChatMessages, prefetchChatList, resolveListChatId } from "../../helper/chatMessageCache";
import { dedupeSentFolderMessages, mergeEnrichedEmail, classifyMessageId, isPersistedEmailId, assignModalSnapshot, isClassificationPending, getEmailListPreview, firstEmailSentence, oneSentenceMessageSummary, cleanChatMessageText } from "../../helper/emailBodyFormat";
import { beginExternalBookmarkTodo, emailProjectIdOf, finishBookmarkTodo, failBookmarkTodo } from "../../helper/bookmarkTodo";
import EmailFolderSidebar, { ALL_ACCOUNTS_ID } from "../../components/EmailFolderSidebar";
import CompanySelector from "../../components/CompanySelector";
import OversightRoomList from "../Project/OversightRoomList";
import OversightRoomDetail from "../Project/OversightRoomDetail";
import { persistPinnedRooms } from "../../utils/pinnedRooms";
import { cachedMyCompanies, fetchMyCompanies, managesCompanyRooms } from "../../utils/roomOversight";
import {
  badgeChatsOf,
  chatColorOf,
  chatRowKind,
  countUnreadChats,
  fillTemplate,
  firstNameOf,
  formatChatListTime,
  formatMailListTime,
  idOf as rowIdOf,
  isPilotChat,
  isRoomPinned,
  partnerIdOf,
  pickRoomCompany,
  resolveOversight,
  roomOfChatRow,
  unreadChatsByChip,
} from "./chatListModel";
import { useChatListSocket } from "./useChatListLive";
import {
  ChatListAvatar,
  ChatListChips,
  ChatListEmpty,
  ChatListSkeleton,
  ChatRowMenu,
  LivePreview,
  MailChatRow,
  MessagesJoinCard,
  RowQuickActions,
} from "./ChatListParts";
import "./LatestMessagesPro.css";
import {
  PHOTO_VIDEO_ACCEPT_ATTRIBUTE,
  compressChatVideo,
  formatVideoDuration,
  isPhotoFile,
  isVideoFile,
  prepareChatVideo,
} from "../../utils/chatVideo";

const getPreviewSource = (chat) =>
  String(chat?.previewMessage || chat?.message || chat?.originalMessage || "").trim();

/**
 * Build a chatGroups[] array (in the same shape `/building/:id/chat` returns)
 * from the chats already loaded in `LatestMessages`. Used to hand `ProjectDetail`
 * an immediate sidebar so it can paint the building view without waiting for
 * the (often 1-2s) /building/:id/chat round-trip. The full payload is then
 * fetched in the background and replaces this seed once it arrives.
 *
 * Notes:
 * - We can only synthesize the current user's row in `users[]` (other users'
 *   isLeave/isMute flags aren't in the latest-messages payload). That's enough
 *   for ProjectDetail's sidebar rendering and `_sortArray` checks.
 * - Groups in the building that have no messages (e.g. an empty default "All")
 *   may be missing from AllChats; the background refresh fills them in.
 */
function buildPreloadedChatGroupsFromAllChats(allChats, clickedGroup, currentUser) {
  if (!allChats || !clickedGroup) return [];
  const targetBuilding = clickedGroup.buildingList;
  const clickedGroupId = clickedGroup.group?.id;
  const candidates = allChats.filter(
    (c) =>
      c &&
      c.buildingList === targetBuilding &&
      c.isInternal &&
      c.group &&
      !c.group.isOneToOne
  );
  return candidates.map((c) => ({
    id: c.group?.id,
    name: c.group?.name,
    image: c.groupImage || null,
    users: [
      {
        id: currentUser?.id,
        isBlock: c.group?.isBlock ? 1 : 0,
        isLeave: c.group?.isLeave ? 1 : 0,
        isMute: c.group?.isMute ? 1 : 0,
      },
    ],
    themeColor: c.group?.themeColor || null,
    avatar: null,
    groupType: c.group?.groupType || "building",
    projectNo: c.group?.projectNo || null,
    building: c.buildingList,
    buildingName: c.buildingName,
    isOneToOne: 0,
    isPrivet: c.group?.isPrivet ? 1 : 0,
    defaultChatGroup: !!c.defaultChatGroup,
    unseenChatCount: c.unseenChatCount || 0,
    lastMessage: c.message || c.lastMessage || "",
    lastMessageType: c.messageType || c.lastMessageType || null,
    lastMessageDeleted: c.lastMessageDeleted || null,
    messageDate: c.createdAt || c.messageDate || null,
    senderId: c.senderId || null,
    isOpened: c.group?.id === clickedGroupId,
  }));
}

/** Same email row as selected detail if any id field matches (GET vs list may differ). */
function emailEntriesShareId(a, b) {
  if (!a || !b) return false;
  const accA = emailRowAccountId(a);
  const accB = emailRowAccountId(b);
  const ids = (e, acc) =>
    [e.id, e._id, e.messageId, e.providerMessageId, e.internetMessageId, classifyMessageId(e)]
      .filter((x) => x != null && String(x).trim() !== "")
      .map((x) => {
        const id = String(x);
        return acc && /^\d+$/.test(id) ? `${acc}:${id}` : id;
      });
  const as = ids(a, accA);
  const bs = ids(b, accB);
  return as.some((x) => bs.includes(x));
}

function emailRowAccountId(m) {
  if (!m) return "";
  return String(m.__accountId || m.emailAccount || m.emailAccountId || m.accountId || "");
}

function emailEntryIds(e) {
  if (!e) return [];
  return [e.id, e._id, e.messageId, e.providerMessageId, e.draftId]
    .filter((x) => x != null && String(x).trim() !== "")
    .map(String);
}

function latestChatKey(c) {
  const id = c && ((c.group && c.group.id) || c.id || c.mainId);
  return id != null && String(id) !== "" ? String(id) : "";
}

function dropStaleDraftRows(messages, staleIds) {
  if (!Array.isArray(messages) || !staleIds || staleIds.length === 0) return messages;
  const drop = new Set(staleIds.map(String));
  const isStale = (m) => emailEntryIds(m).some((id) => drop.has(id));
  if (!messages.some((m) => !isStale(m))) return messages;
  return messages.filter((m) => !isStale(m));
}

const COMBINED_FEED_EXCLUDE_FOLDERS = new Set(["SENT", "DRAFT", "TRASH", "SPAM", "DELETED", "OUTBOX"]);

// DELETE /email/messages/:id answered 404: no row for that id or provider id
// (a sync removed it after the list loaded), so there is nothing left to delete.
function isEmailGoneResult(result) {
  if (!result || result.status !== 404) return false;
  const data = result.data || {};
  return data.code === "MESSAGE_GONE" || data.message === "Message not found";
}

// How long a deleted mail stays hidden from list refetches (see recentlyDeletedEmailsRef).
const RECENT_DELETE_TTL_MS = 3 * 60 * 1000;
// Unread-only mail list: rows kept loaded / added per "load more".
const EMAIL_LIST_PAGE_SIZE = 30;
const countUnreadEmailRows = (rows) => (rows || []).filter((m) => m && m.isRead === false).length;
// My Space missing from page 1: the result of the extra lookup ({ at, uid, raw }),
// raw = the self-chat row or null when the user has none. Kept across reloads:
// for a user without My Space the lookup (getUserChats 100 + shareTargets)
// costs several seconds and never finds anything.
const MY_SPACE_LOOKUP_TTL_MS = 12 * 60 * 60 * 1000;
let mySpaceLookup = null;
// The lookup in flight ({ uid, promise }), shared by overlapping page-1 loads.
let mySpaceLookupInFlight = null;

function mySpaceLookupStorageKey(userId) {
  return `mySpaceLookup:${userId || "anon"}`;
}

function readMySpaceLookup(userId) {
  if (mySpaceLookup && mySpaceLookup.uid === userId) return mySpaceLookup;
  try {
    const stored = JSON.parse(localStorage.getItem(mySpaceLookupStorageKey(userId)) || "null");
    if (stored && stored.uid === userId) mySpaceLookup = stored;
  } catch {}
  return mySpaceLookup && mySpaceLookup.uid === userId ? mySpaceLookup : null;
}

function writeMySpaceLookup(userId, value) {
  mySpaceLookup = value;
  try {
    if (value) localStorage.setItem(mySpaceLookupStorageKey(userId), JSON.stringify(value));
    else localStorage.removeItem(mySpaceLookupStorageKey(userId));
  } catch {}
}

function isInboxFeedFolder(folder) {
  return !folder || folder === "INBOX";
}

/** Alle / combined list: incoming inbox mail only — never Sent, Drafts, Trash, or Spam. */
function isCombinedFeedEmail(em) {
  if (!em) return false;
  if (String(em.direction || "").toLowerCase() === "outgoing") return false;
  const folder = String(em.folder || em.providerFolder || "").toUpperCase();
  if (COMBINED_FEED_EXCLUDE_FOLDERS.has(folder)) return false;
  const labels = Array.isArray(em.labels)
    ? em.labels.map((l) => String(l).toUpperCase())
    : [];
  const hasInboxLabel = labels.some((l) => l === "INBOX");
  const hasSentLabel = labels.some((l) => l === "SENT" || l === "\\SENT");
  if (hasSentLabel && !hasInboxLabel) return false;
  return true;
}

/**
 * Does this combined-list row refer to the chat/email the cockpit navigated to?
 * Emails are matched leniently because the navigation carries one id while the
 * list row may be keyed by another (messageId vs. providerMessageId).
 */
/**
 * The project a chat row belongs to: the room of a room chat, or the project a
 * Microsoft Teams chat is filed under. null for 1:1 chats and groups without one.
 */
function chatProjectIdOf(row) {
  if (!row) return null;
  if (isTeamsChat(row)) {
    const project = teamsProjectOf(row);
    return project ? project.id : null;
  }
  const raw = row.buildingList || (row.group && row.group.buildingList);
  const id = raw && typeof raw === "object" ? raw.id || raw._id : raw;
  return id != null && id !== "" ? id : null;
}

function matchesHoistedRow(item, hoisted) {
  if (!item || !hoisted) return false;
  if (hoisted.kind === "email") {
    if (!item._isEmail) return false;
    const id = hoisted.id;
    return emailEntriesShareId(item._emailData, {
      id,
      _id: id,
      messageId: id,
      providerMessageId: id,
    });
  }
  if (item._isEmail) return false;
  return String(item.group?.id) === String(hoisted.id);
}

function isAllScopeReport(em) {
  if (!em) return false;
  if (String(em.systemTag || "") !== "daily_briefing") return false;
  return String(em.providerMessageId || "").includes("-all-");
}

function emailListRowId(em) {
  return em && (em.id || em._id || em.providerMessageId);
}

function tagFolderEmails(messages, folder) {
  if (!Array.isArray(messages) || !folder) return messages || [];
  const folderKey = String(folder).toUpperCase();
  return messages.map((m) => {
    if (!m) return m;
    const next = { ...m, folder: m.folder || folderKey };
    if ((folderKey === "SENT" || folderKey === "DRAFT") && !next.direction) {
      next.direction = "outgoing";
    }
    return next;
  });
}

function liveEmailClassifyContext(source, folder, accountId) {
  const ctx = {};
  const folderKey = (source && source.folder) || folder;
  if (folderKey) ctx.folder = folderKey;
  const acc = (source && (source.__accountId || source.emailAccountId || source.emailAccount)) || accountId;
  if (acc) ctx.accountId = acc;
  if (!source) return ctx;
  if (source.providerMessageId) ctx.providerMessageId = source.providerMessageId;
  if (source.internetMessageId) ctx.internetMessageId = source.internetMessageId;
  if (source.subject) ctx.subject = source.subject;
  if (source.from) ctx.from = source.from;
  if (source.fromName) ctx.fromName = source.fromName;
  if (source.fromAddress) ctx.fromAddress = source.fromAddress;
  if (source.to) ctx.to = source.to;
  if (source.toAddresses) ctx.toAddresses = source.toAddresses;
  if (source.cc) ctx.cc = source.cc;
  if (source.ccAddresses) ctx.ccAddresses = source.ccAddresses;
  if (source.snippet) ctx.snippet = String(source.snippet).slice(0, 280);
  else if (source.bodyText) ctx.snippet = String(source.bodyText).replace(/\s+/g, " ").trim().slice(0, 280);
  if (source.bodyText) ctx.bodyText = String(source.bodyText).slice(0, 4000);
  if (source.date || source.receivedAt) {
    ctx.date = source.date || source.receivedAt;
    ctx.receivedAt = source.receivedAt || source.date;
  }
  if (source.threadId) ctx.threadId = source.threadId;
  if (source.hasAttachments != null) ctx.hasAttachments = source.hasAttachments;
  if (source.isStarred != null) ctx.isStarred = source.isStarred;
  if (!ctx.folder) {
    const dir = String(source.direction || "").toLowerCase();
    const labels = Array.isArray(source.labels) ? source.labels : [];
    if (dir === "outgoing" || labels.some((l) => String(l).toUpperCase() === "SENT")) {
      ctx.folder = "SENT";
    }
  }
  return ctx;
}

const MY_SPACE_PINNED_SORT = Number.MAX_SAFE_INTEGER;

// How often a visible inbox re-reads its first page in case a socket event
// was lost. Socket events still deliver new mail instantly.
const EMAIL_INBOX_SAFETY_POLL_MS = 30000;

// Inline reply: how long the box takes to fold away (LatestMessagesPro.css lmp-reply-fold) and how
// long a sent photo / video reply shows its full bar before it closes.
const REPLY_COLLAPSE_MS = 260;
const REPLY_SENT_HOLD_MS = 450;

function mySpacePinStorageKey(userId) {
  return `mySpacePinned:${userId || "anon"}`;
}

function readMySpacePinned(userId) {
  try {
    if (userId) {
      const keyed = localStorage.getItem(mySpacePinStorageKey(userId));
      if (keyed === "1" || keyed === "0") return keyed === "1";
    }
    return localStorage.getItem(mySpacePinStorageKey()) === "1";
  } catch {
    return false;
  }
}

function writeMySpacePinned(userId, pinned) {
  try {
    localStorage.setItem(mySpacePinStorageKey(userId), pinned ? "1" : "0");
  } catch {}
}

/** Normalize getUserChats rows so My Space is treated as a DM, not a group. */
/** Cockpit / sidebar "Kjuup-Email" entry: ?view=email or history state openEmailTab. */
function locationRequestsEmailView(location) {
  if (!location) return false;
  const state = location.state;
  if (state && state.openEmailTab) return true;
  return /(?:^|[?&])view=email(?:&|$)/.test(location.search || "");
}

/** Sidebar "Kjuup-Chats" entry: ?view=all or history state openAllTab -> "Alle" tab. */
function locationRequestsAllView(location) {
  if (!location) return false;
  const state = location.state;
  if (state && state.openAllTab) return true;
  return /(?:^|[?&])view=all(?:&|$)/.test(location.search || "");
}

// A direct chat for the chips and counts: a Kjuup 1:1 or a Microsoft Teams 1:1 (a group on the
// server, isOneToOne false). Teams group chats stay under Groups.
const isDirectChatRow = (item) => isDirectMessageChat(item) || isTeamsOneOnOne(item);

// The new-chat picker's "Teams contacts" tab: a connected Teams account, Kjuup.io, chats shown.
function canPickTeamsContacts(teamsConnected, hasActiveKjuupIoPlan, hideChatsPref) {
  return !!teamsConnected && !!hasActiveKjuupIoPlan && !hideChatsPref;
}

function mapUserChatRow(e) {
  const isDirect = isDirectMessageChat(e);
  return {
    ...e,
    mainId: e.id,
    // A Microsoft Teams mirror has no room: keyed like a direct row.
    id: isDirect || isTeamsChat(e) ? e.id : e.buildingList,
    building: e.buildingList,
    isSelfChat: !!(e.isSelfChat || e.group?.isSelfChat),
    group: {
      ...e.group,
      building: e.buildingList,
      isOneToOne: isDirect ? (e.group?.isOneToOne || 1) : e.group?.isOneToOne,
      isSelfChat: !!(e.group?.isSelfChat || e.isSelfChat),
      isPinned: !!(e.group?.isPinned === true || e.group?.isPinned === 1 || e.group?.isPinned === "1"),
    },
  };
}

function chatListHasMySpace(chats) {
  return (chats || []).some((c) => isSelfChatGroup(c));
}

function isRowPinned(chat) {
  const flag = chat?.group?.isPinned ?? chat?.isPinned;
  return flag === true || flag === 1 || flag === "1";
}

function getChatActivitySortDate(chat) {
  return Math.max(
    new Date(chat.createdAt || 0).getTime(),
    chat._reactionBumpAt || 0,
    chat.lastReactionAt ? new Date(chat.lastReactionAt).getTime() : 0,
    chat.lastReactionActivityAt
      ? (typeof chat.lastReactionActivityAt === "number"
          ? chat.lastReactionActivityAt
          : new Date(chat.lastReactionActivityAt).getTime())
      : 0
  );
}

/**
 * Run `worker` over `items` with a bounded number of concurrent invocations,
 * returning Promise.allSettled-shaped results in the original order. Used for
 * batch e-mail actions so selecting hundreds of messages doesn't fire hundreds
 * of simultaneous requests (which can exhaust the server / provider).
 */
async function mapWithConcurrency(items, limit, worker) {
  const results = new Array(items.length);
  let cursor = 0;
  const runWorker = async () => {
    while (cursor < items.length) {
      const i = cursor;
      cursor += 1;
      try {
        results[i] = { status: "fulfilled", value: await worker(items[i], i) };
      } catch (reason) {
        results[i] = { status: "rejected", reason };
      }
    }
  };
  const workerCount = Math.min(Math.max(1, limit), items.length || 1);
  await Promise.all(Array.from({ length: workerCount }, runWorker));
  return results;
}

// Survives leaving /messages so a wide layout can reopen the same chat or email.
let lastMessagesDetail = null;

function LatestMessages({
  updateGroups,
  resetMessages,
  updateGroupChats,
  updateOpenChats,
  updateOpenProjects,
  updateRightTop,
  openChats,
  openProjects,
  groupChats,
  groups,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isLatestMessagesRoute = location.pathname === "/messages";
  const isLatestMessagesRouteRef = useRef(isLatestMessagesRoute);
  isLatestMessagesRouteRef.current = isLatestMessagesRoute;
  const {
    unSeenAllCount,
    isNewMessage,
    activityMessages,
    activityMessagesReminders,
    user,
    inActivity,
    openLatestMsgToggle,
    activityMessagesLastFetched,
    isAutoTranslation,
    autoTranslationLanguages,
    cachedMessages,
    draftMessages,
    mySpacePin,
    translateRoomAndGroupNames,
  } = useSelector((state) => state);
  const reduxProjects = useSelector((state) => state.projects);
  const reduxInternalProjects = useSelector((state) => state.internalProjectsAll);
  const { isGerm, strings, language } = useContext(LanguageContext);
  // False while another page is shown (the Messages pane stays mounted).
  const paneActive = useContext(PaneActiveContext);
  const [isTabSelect, setIsTabSelect] = useState(true);
  const [messageFilter, setMessageFilter] = useState("all");
  // Mirror of `messageFilter` that we update synchronously when a filter
  // tab is clicked, so the active highlight snaps immediately while the
  // (potentially expensive) list re-render is deferred via startTransition.
  const [activeFilterUI, setActiveFilterUI] = useState("all");
  // Sub-filter under Rooms / Groups: all, internal, external (Rooms: also the
  // company-admin "oversight" list).
  const [groupScopeFilter, setGroupScopeFilter] = useState("all");
  // Chat list chips (mobile parity): the group chats split into "rooms" (a
  // room's own chat, defaultChatGroup) and "groups" (the groups inside rooms).
  const [chatScope, setChatScope] = useState(null);
  // Rooms > Intern with more than one Kjuup+ company: the company shown.
  const [roomCompanyId, setRoomCompanyId] = useState(null);
  // Rooms > Oversight: the managed company shown.
  const [oversightCompanyId, setOversightCompanyId] = useState(null);
  const selectedCompanyId = useSelector((state) => state.selectedCompanyId);
  const pinnedRooms = useSelector((state) => state.pinnedRooms);
  const oversightRoom = useSelector((state) => state.oversightRoom);
  const loginToken = useSelector((state) => state.userLoginToken);
  // /company/my rows (shared cache with Räume): which companies' rooms the viewer manages.
  const [myCompanies, setMyCompanies] = useState(() => cachedMyCompanies(loginToken));
  // The row menu (⋮ / right click): { x, y, align, anchorTop, title, items }.
  const [rowMenu, setRowMenu] = useState(null);
  // Microsoft Teams row whose project room is being assigned (TeamsChatRoomModal), or null.
  const [teamsRoomRow, setTeamsRoomRow] = useState(null);
  const closeRowMenu = useCallback(() => setRowMenu(null), []);
  // "Unread only" toggle that sits next to the filter tabs. When on, the
  // chat-with-emails list is filtered to items with `unseenChatCount > 0`
  // or (for email rows) `isRead === false`. The currently opened/selected
  // item stays visible until deselected so opening a message doesn't yank
  // it out of the list mid-read. In the full email section the same toggle
  // filters the inbox view to unread messages only (same sticky exception).
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  // List as it was before "Unread only" started paging through the whole
  // history. Turning the filter off restores this instead of painting every
  // page that scan loaded, and in-flight scan requests are ignored.
  // Deletes while the filter is on must also drop those rows here — otherwise
  // turning the filter off paints the pre-delete list and the entries return.
  const preUnreadSnapshotRef = useRef(null);
  const unreadListEpochRef = useRef(0);
  const skipUnreadOffEmailRefetchRef = useRef(false);
  const dropEmailsFromUnreadSnapshot = useCallback((rawIds) => {
    const snap = preUnreadSnapshotRef.current;
    const ids = (rawIds || [])
      .filter((id) => id != null && String(id).trim() !== "")
      .map(String);
    if (!snap || ids.length === 0) return { emails: [], inbox: [] };
    const drop = new Set(ids);
    const isDropped = (m) => emailEntryIds(m).some((id) => drop.has(id));
    const removedEmails = [];
    const removedInbox = [];
    const emails = (snap.emails || []).filter((m) => {
      if (!isDropped(m)) return true;
      removedEmails.push(m);
      return false;
    });
    const inbox = (snap.inbox || []).filter((m) => {
      if (!isDropped(m)) return true;
      removedInbox.push(m);
      return false;
    });
    preUnreadSnapshotRef.current = { ...snap, emails, inbox };
    return { emails: removedEmails, inbox: removedInbox };
  }, []);
  const restoreEmailsInUnreadSnapshot = useCallback((removed) => {
    const snap = preUnreadSnapshotRef.current;
    if (!snap || !removed) return;
    const putBack = (list, rows) => {
      const next = [...(list || [])];
      (rows || []).forEach((row) => {
        if (!next.some((m) => emailEntriesShareId(m, row))) next.push(row);
      });
      return next;
    };
    preUnreadSnapshotRef.current = {
      ...snap,
      emails: putBack(snap.emails, removed.emails),
      inbox: putBack(snap.inbox, removed.inbox),
    };
  }, []);
  const [, startFilterTransition] = useTransition();
  const [AllChats, setAllChats] = useState([]);
  const [AllChatsReminder, setAllChatsReminders] = useState([]);
  const [gettingChats, setGettingChats] = useState(false);
  const [isChatsOver, setIsChatsOver] = useState(false);
  const [gettingChatsBottom, setGettingChatsBottom] = useState(false);
  const [page, setPage] = useState(1);
  const [pageReminder, setPageReminder] = useState(1);
  const [shouldGet, setShouldGet] = useState(false);
  const [isReminderOver, setIsReminderOver] = useState(false);
  const [clickedGroup, setClickedGroup] = useState(null);
  const isDesktop = useSelector(state => state.isDeskTopResolution);
  const isDeskTopResolution = isDesktop;
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  // Up to 1366px (phones and tablets, including iPad Pro 13 portrait) show
  // one surface at a time: the entry list, or the opened chat, or the email.
  // Wider screens keep the side-by-side split. Matches the existing
  // `.mobile_none` rules in custom.css.
  const exclusiveMessagesPane = screenWidth <= 1366;
  const messagesSplitLayout = isDeskTopResolution && !exclusiveMessagesPane;
  const panelContainerRef = useRef(null);
  const [panelWidths, setPanelWidths] = useState({ left: null, right: null });
  const [translatedChatNames, setTranslatedChatNames] = useState({});
  const [translatedRoomNames, setTranslatedRoomNames] = useState({});
  const [translatedPreviews, setTranslatedPreviews] = useState({});
  // chatId -> "name\0preview" signature that was last sent for translation.
  const translatedChatIdsRef = useRef(new Map());
  const previewTranslateMountedRef = useRef(true);
  const [bookmarkedGroupIds, setBookmarkedGroupIds] = useState(new Set());
  // A chat message without a project waits here for the user's project pick before it becomes a task.
  const [taskProjectFor, setTaskProjectFor] = useState(null);
  const [isMySpacePinned, setIsMySpacePinned] = useState(() => readMySpacePinned(user?.id));
  const [bookmarkedEmailIds, setBookmarkedEmailIds] = useState(() => {
    try {
      const stored = localStorage.getItem('bookmarkedEmailIds');
      return stored ? new Set(JSON.parse(stored)) : new Set();
    } catch { return new Set(); }
  });
  
  useEffect(() => {
    try { localStorage.setItem('bookmarkedEmailIds', JSON.stringify([...bookmarkedEmailIds])); } catch {}
  }, [bookmarkedEmailIds]);

  const emailBookmarkKey = (m) =>
    String((m && (m.id || m._id || m.messageId || m.providerMessageId)) || "");

  const mergeBookmarkedEmailIdsFromMessages = (list, { append = false } = {}) => {
    setBookmarkedEmailIds((prev) => {
      const next = new Set(prev);
      (list || []).forEach((m) => {
        const mid = emailBookmarkKey(m);
        if (!mid) return;
        if (m.isTodoBookmarked) next.add(mid);
        else if (!append) next.delete(mid);
      });
      return next;
    });
  };

  // Track screen width for responsive adjustments
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    if (!messagesSplitLayout) {
      if (panelWidths.left !== null || panelWidths.right !== null) {
        setPanelWidths({ left: null, right: null });
      }
      return;
    }

    const container = panelContainerRef.current;
    if (!container) return;

    const updateWidths = () => {
      const width = container.clientWidth;
      if (!width) return;
      const leftRatio = screenWidth < 1050 && screenWidth >= 860 ? 0.35 : 0.5;
      const left = Math.max(0, Math.round(width * leftRatio));
      const right = Math.max(0, width - left);
      setPanelWidths((prev) =>
        prev.left === left && prev.right === right ? prev : { left, right }
      );
    };

    updateWidths();

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateWidths);
      resizeObserver.observe(container);
    }
    window.addEventListener("resize", updateWidths);

    return () => {
      window.removeEventListener("resize", updateWidths);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [screenWidth, messagesSplitLayout, panelWidths.left, panelWidths.right]);
  const activeSideBar = useSelector(e => e.activeSideBar)
  const isLatestMessagesSidebar = activeSideBar === 'LatestMessages';
  const resetLatestMessages = useSelector(e => e.resetLatestMessages)
  const [pendingRequests, setPendingRequests] = useState([]);
  const [showPendingRequests, setShowPendingRequests] = useState(false);
  const fetchAllRequeest = useSelector(e => e.fetchAllRequeest)
  const emailSyncData = useSelector(state => state.emailSyncData);
  const emailSyncEvents = useSelector(state => state.emailSyncEvents);
  const emailCatchUpAt = useSelector(state => state.emailCatchUpAt);
  // Sequence number of the last socket email event applied to the lists.
  const emailSyncSeqRef = useRef(null);
  const emailAccountsChangedAt = useSelector(state => state.emailAccountsChangedAt);
  const profile = useSelector((state) => state.profile);
  const subscriptionState = useSelector((state) => state.subscription) || {};
  const {
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
    isKjuupPlusMember,
    stripeUiEnabled,
  } = resolveStripeFlags(profile, subscriptionState);
  const hasActiveKjuupIoPlan = !stripeUiEnabled || !!subscriptionState.active;
  const hasUsedTrial = !!subscriptionState.hasUsedTrial;
  const showCompanyTrialEndedNote = !!subscriptionState.showCompanyTrialEndedNote;
  const unseenEmailCount = useSelector(state => state.unseenEmailCount);
  const [isLoading, setIsLoading] = useState(true);
  const [isContentReady, setIsContentReady] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);

  // Stripe-gated email; hidden when Stripe is disabled for this user.
  const isEmailFeatureEnabled = canShowEmailCalendarIntegration({
    isKjuupPlusMember,
    hasActiveKjuupIoPlan,
    showCompanyTrialEndedNote,
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
  });
  // Combined messages+email view when email feature is on.
  // Email *entries* are only merged into Alle while the plan is active;
  // after trial end / cancel the Email tab still opens the lock/empty note.
  const integrateEmailInMessages = !!isEmailFeatureEnabled;
  const mergeEmailsIntoLatestList =
    integrateEmailInMessages && hasActiveKjuupIoPlan;
  // Kjuup.io workspace preferences (cockpit setup / personal settings):
  //   hideChatsPref       -> the page IS the email client (sidebar entry "E-Mail",
  //                          no chat rows, no filter tabs)
  //   hideEmailClientPref -> "Nur Projekte + Berichte" mode: no inbox / compose;
  //                          with chats hidden as well the page redirects to the cockpit
  // Daily reports (Berichte) are never shown here any more — they live on the cockpit.
  const reduxUserForPrefs = useSelector((state) => state.user);
  const workspacePersona = useMemo(
    () => resolveCockpitPersona(profile, subscriptionState, reduxUserForPrefs),
    [profile, subscriptionState, reduxUserForPrefs]
  );
  const hideChatsPref = chatsHidden(workspacePersona) && integrateEmailInMessages;
  const hideEmailClientPref = emailClientHidden(workspacePersona);
  // Microsoft Teams off ("Microsoft Teams" in the settings): no Teams rows, chip or counts.
  const hideTeamsPref = teamsClientHidden(workspacePersona);

  const [emailTabActive, setEmailTabActive] = useState(
    isEmailFeatureEnabled && !integrateEmailInMessages && profile?.defaultMessagesView === 'email'
  );

  // Refresh entitlement on Messages load / Email focus so trial lock updates live.
  useEffect(() => {
    fetchAndStoreSubscriptionStatus(dispatch);
  }, [dispatch]);
  useEffect(() => {
    if (emailTabActive || (integrateEmailInMessages && activeFilterUI === "email")) {
      fetchAndStoreSubscriptionStatus(dispatch);
    }
  }, [dispatch, emailTabActive, integrateEmailInMessages, activeFilterUI]);

  const prevDefaultViewRef = useRef(profile?.defaultMessagesView);
  useEffect(() => {
    if (!isEmailFeatureEnabled) {
      setEmailTabActive(false);
      setActiveFilterUI((prev) => (prev === "email" ? "all" : prev));
      return;
    }
    if (integrateEmailInMessages) {
      // Chats hidden: this page is the email client. Don't kick the user back
      // to the chat list when profile fields refresh.
      if (!(hideChatsPref && !hideEmailClientPref)) setEmailTabActive(false);
      return;
    }
    const currentView = profile?.defaultMessagesView;
    if (currentView !== prevDefaultViewRef.current) {
      prevDefaultViewRef.current = currentView;
      if (isEmailFeatureEnabled) {
        setEmailTabActive(currentView === 'email');
      }
    }
  }, [profile?.defaultMessagesView, profile?.emailFeatureEnabled, integrateEmailInMessages, isEmailFeatureEnabled, hideChatsPref, hideEmailClientPref]);
  const emailAccounts = useSelector(state => state.emailAccounts);
  const emailAccountsRef = useRef(emailAccounts);
  useEffect(() => { emailAccountsRef.current = emailAccounts; }, [emailAccounts]);
  const [activeEmailAccountId, setActiveEmailAccountId] = useState(null);
  const [activeEmailFolder, setActiveEmailFolder] = useState("INBOX");
  const [emailMessages, setEmailMessages] = useState([]);
  const emailMessagesRef = useRef(emailMessages);
  emailMessagesRef.current = emailMessages;
  const [inboxFeedEmails, setInboxFeedEmails] = useState([]);
  const inboxFeedEmailsRef = useRef(inboxFeedEmails);
  useEffect(() => { inboxFeedEmailsRef.current = inboxFeedEmails; }, [inboxFeedEmails]);
  // Daily reports are no longer listed in Nachrichten (cockpit only). The list
  // stays empty; the mark-read / delete helpers below still update it so a
  // report opened via deeplink keeps working.
  const [reportFeedEmails, setReportFeedEmails] = useState([]);
  const [emailPage, setEmailPage] = useState(1);
  const emailPageRef = useRef(emailPage);
  emailPageRef.current = emailPage;
  const [emailLoading, setEmailLoading] = useState(false);
  const [isFolderSearching, setIsFolderSearching] = useState(false);
  // Combined Alle list: keep skeleton until the first email inbox fetch finishes
  // so chats and emails paint together (instead of chats first, emails later).
  const [emailInitialReady, setEmailInitialReady] = useState(false);
  const [isEmailsOver, setIsEmailsOver] = useState(false);
  const isEmailsOverRef = useRef(isEmailsOver);
  isEmailsOverRef.current = isEmailsOver;
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [emailReplyMode, setEmailReplyMode] = useState(null);
  const emailReplyModeRef = useRef(null);
  emailReplyModeRef.current = emailReplyMode;
  const [emailDeeplinkScroll, setEmailDeeplinkScroll] = useState(null);
  const [emailPaginationLoading, setEmailPaginationLoading] = useState(false);
  const emailDetailViewRef = useRef(null);
  const requestCloseInlineEmailCompose = useCallback(async () => {
    if (!emailReplyModeRef.current) return true;
    if (!emailDetailViewRef.current?.requestCloseCompose) {
      setEmailReplyMode(null);
      return true;
    }
    return emailDetailViewRef.current.requestCloseCompose();
  }, []);
  const guardAndLeaveEmailSection = useCallback(async (leaveAction) => {
    const inlineClosed = await requestCloseInlineEmailCompose();
    if (!inlineClosed) return false;
    leaveAction();
    return true;
  }, [requestCloseInlineEmailCompose]);
  const emailNavigationGuardBypassRef = useRef(false);
  const emailToggleMsgRef = useRef(null);
  const emailToggleEmailRef = useRef(null);
  // When the user clicks the E-Mail toggle, we want the right panel to immediately
  // show the first email's details (instead of a blank/previous chat). Email messages
  // may not be loaded at click time, so we set this flag and pick the first email
  // once emailMessages becomes populated.
  const autoOpenFirstEmailPendingRef = useRef(false);
  /** Last inbox fetch for account+folder; avoids refetch (and list reset) when toggling Messages/E-Mail sub-tab. */
  const emailInboxFetchKeyRef = useRef(null);
  const draftsReloadTimerRef = useRef(null);
  const staleDraftIdsRef = useRef(null);
  useEffect(() => () => {
    if (draftsReloadTimerRef.current) clearTimeout(draftsReloadTimerRef.current);
  }, []);
  const customFolders = useSelector(state => state.emailCustomFolders);
  /** Mirrors customFolders so callbacks can read current value without depending on it (prevents re-creating callbacks on every dispatch). */
  const customFoldersRef = useRef(customFolders);
  useEffect(() => { customFoldersRef.current = customFolders; }, [customFolders]);
  /** Tracks accounts whose custom folders have already been fetched to prevent infinite re-fetch loops when an account has no folders. */
  const fetchedCustomFoldersAccountsRef = useRef(new Set());
  /** Mirrors the rendered chat list so the async chat-merge in _getMessages
   * always reads the freshest order (incl. a quick-reaction reorder that landed
   * while the request was in flight) instead of a stale closure value. */
  const allChatsRef = useRef([]);
  useEffect(() => { allChatsRef.current = AllChats; }, [AllChats]);
  const hasAutoOpenedReminderRef = useRef(false);
  const mySpacePinToggledAtRef = useRef(0);

  useEffect(() => {
    if (!user?.id) return;
    try {
      const keyed = localStorage.getItem(mySpacePinStorageKey(user.id));
      if (keyed === "1" || keyed === "0") {
        setIsMySpacePinned(keyed === "1");
        return;
      }
      const anon = localStorage.getItem(mySpacePinStorageKey());
      if (anon === "1" || anon === "0") {
        const pinned = anon === "1";
        setIsMySpacePinned(pinned);
        writeMySpacePinned(user.id, pinned);
      }
    } catch {}
  }, [user?.id]);

  useEffect(() => {
    if (!mySpacePin || typeof mySpacePin.isPinned !== "boolean") return;
    mySpacePinToggledAtRef.current = Date.now();
    setIsMySpacePinned(!!mySpacePin.isPinned);
    writeMySpacePinned(user?.id, !!mySpacePin.isPinned);
  }, [mySpacePin, user?.id]);

  const liveMySpacePinned = (mySpacePin && typeof mySpacePin.isPinned === "boolean")
    ? !!mySpacePin.isPinned
    : isMySpacePinned;

  const isMySpaceRowPinned = useCallback(
    (chat) => !!(liveMySpacePinned || isRowPinned(chat)),
    [liveMySpacePinned]
  );

  const getListSortDate = useCallback((chat) => {
    const activity = getChatActivitySortDate(chat);
    if (!isSelfChatGroup(chat)) return activity;
    if (isMySpaceRowPinned(chat)) return MY_SPACE_PINNED_SORT;
    return activity;
  }, [isMySpaceRowPinned]);

  // Query-string fragment that asks the backend (getUserChats) to include each
  // last message's persisted translation (ChatTranslation) so previews render
  // in the user's language without a slow client-side translate round-trip.
  const translationLangParam = useCallback(() => {
    // Auto-translation is always on — always request server preview translations.
    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0];
    return lang ? `&translationLang=${lang}` : '';
  }, [language]);

  const prefetchListChat = useCallback((chat) => {
    const chatId = resolveListChatId(chat);
    if (!chatId) return;
    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0].toLowerCase();
    const isDirect = !!(chat?.group?.isOneToOne || chat?.isOneToOne);
    prefetchChatMessages({
      chatId,
      userId: user?.id,
      translationLang: lang,
      building: isDirect ? undefined : (chat.building || chat.buildingList || chat.group?.building),
    });
  }, [language, user?.id]);

  // If page 1 omitted My Space (archived filter / recency window), recover it
  // the way the mobile app does — and if getUserChats still lacks it, shareTargets
  // still returns the self-chat on prod.
  // applyPreview is declared further down; the background lookup reads it here.
  const applyPreviewRef = useRef((chat) => chat);
  const ensureMySpaceInList = useCallback(async (chats) => {
    const list = Array.isArray(chats) ? chats : [];
    const uid = user?.id;
    if (chatListHasMySpace(list)) {
      writeMySpaceLookup(uid, null);
      return list;
    }

    const prepend = (rows, raw) => {
      const row = mapUserChatRow(raw);
      const foundId = String(row.group?.id || "");
      return [row, ...rows.filter((c) => String(c.group?.id) !== foundId)];
    };

    // The two lookups below (one of them a heavy shareTargets call) took
    // several seconds in front of the list. Their answer is kept, and when
    // there is none yet the list shows at once and My Space joins it later.
    const cached = readMySpaceLookup(uid);
    if (cached && Date.now() - cached.at < MY_SPACE_LOOKUP_TTL_MS) {
      return cached.raw ? prepend(list, cached.raw) : list;
    }

    const lookup = async () => {
      try {
        const { data } = await callAPI(
          `/group/getUserChats?page=1&limit=100${translationLangParam()}`,
          {},
          "GET"
        );
        const found = (data?.chats || []).find((c) => !!(c?.group?.isSelfChat || c?.isSelfChat || isSelfChatGroup(c)));
        if (found) return found;
      } catch {}

      const { data } = await callAPI("/group/shareTargets?page=1&limit=8", {}, "GET");
      const items = data?.data?.items || data?.items || [];
      const self = items.find((i) => i && (i.isSelfChat || i.kind === "selfchat"));
      const groupId = self?.groupID || self?.id;
      if (!groupId) return null;
      return {
        id: groupId,
        isSelfChat: true,
        name: strings.my_notes || "My Space",
        message: null,
        messageType: "simple",
        createdAt: new Date(),
        unseenChatCount: 0,
        group: {
          id: groupId,
          isSelfChat: true,
          isOneToOne: 1,
          isPinned: true,
          users: [],
        },
      };
    };

    if (!mySpaceLookupInFlight || mySpaceLookupInFlight.uid !== uid) {
      const promise = lookup().then(
        (raw) => {
          writeMySpaceLookup(uid, { at: Date.now(), uid, raw: raw || null });
          return raw || null;
        },
        // A failed lookup is not stored: the next page-1 load asks again.
        () => null
      );
      mySpaceLookupInFlight = { uid, promise };
      promise.then((raw) => {
        if (mySpaceLookupInFlight && mySpaceLookupInFlight.promise === promise) mySpaceLookupInFlight = null;
        if (!raw) return;
        const current = store.getState().activityMessages || [];
        if (chatListHasMySpace(current)) return;
        dispatch({
          type: SET_ACTIVITY_MESSAGES,
          messages: prepend(current, raw).map((chat, i) => (i === 0 ? applyPreviewRef.current(chat) : chat)),
        });
      });
    }
    return list;
  }, [translationLangParam, strings.my_notes, user?.id, dispatch]);

  // Centralized preview text helper to avoid flicker/missing text
  const getPreviewText = useCallback((item) => {
    // If last message is deleted, show nothing until the previous message is loaded.
    if (item?.lastMessageDeleted) {
      return "";
    }
    const type = item?.messageType;
    // Prefer explicit preview/message/original text
    const direct = item?.previewMessage || item?.message || item?.originalMessage || "";
    // Don't show deleted message content
    if (direct && (direct.includes("message_delete") || direct === strings?.message_delete)) {
      return "";
    }
    if (type === "poll") return strings?.create_poll || "Poll";
    // A Teams call link (call buttons of a Teams chat): "📞 Teams call", not the Markdown link.
    const callPreview = type === "simple" || !type ? teamsCallPreview(direct, strings, isGerm) : null;
    if (callPreview) return callPreview;
    if (direct) {
      const uiLang = (localStorage.getItem('language') || language || 'en').split('-')[0];
      let shouldTranslate = false;
      if (isAutoTranslation && item?.senderId !== user?.id && type === 'simple' && !direct.startsWith('U2FsdGVkX1') && !isUntranslatableText(direct)) {
        const det = item?.detectedMessageLanguage || detectLanguageClient(direct);
        shouldTranslate = shouldAutoTranslateFromSender(det, uiLang, autoTranslationLanguages);
      }
      const withoutMentionMarkers = (value) => {
        const named = onlyUsername(String(value || ""), strings);
        return named.replace(/\*\*(@[^*]+?)\*\*/g, "$1");
      };
      if (shouldTranslate) {
        if (item?.translatedMessage) {
          return withoutMentionMarkers(preserveOriginalFormatting(item.translatedMessage, direct));
        }
        const chatId = item?.group?.id || item?.mainId;
        const stored = chatId ? translatedPreviews[chatId] : null;
        if (stored && stored.source === getPreviewSource(item)) {
          return withoutMentionMarkers(stored.text);
        }
        return strings?.translating || "Translating...";
      }
      return withoutMentionMarkers(direct);
    }
    // For non-text types, use sensible labels
    if (type === "image") return strings?.s_image || "Image";
    if (type === "doc") return strings?.document || "Document";
    if (type === "video") return strings?.video || "Video";
    if (type === "audio") return strings?.audio || "Audio";
    if (type === "contact") return strings?.contact || "Contact";
    if (type === "map") return strings?.location || "Location";
    // Otherwise leave empty (no generic placeholder like "Testo")
    return "";
  }, [strings, isGerm, isAutoTranslation, autoTranslationLanguages, translatedPreviews, user?.id, language]);

  const findChatDraft = useCallback((item) => {
    return findDraftForChat(
      draftMessages,
      user?.id,
      [item?.group?.id, item?.mainId]
    );
  }, [draftMessages, user?.id]);

  const formatNonDeletedMessage = useCallback((msg) => {
    let previewText = msg.message || "";
    const messageType = msg.messageType || "simple";

    if (!previewText || previewText.trim() === '') {
      const mediaLabels = {
        image: strings?.s_image || "Image",
        doc: strings?.document || "Document",
        video: strings?.video || "Video",
        audio: strings?.audio || "Audio",
        contact: strings?.contact || "Contact",
        map: strings?.location || "Location"
      };
      previewText = mediaLabels[messageType] || "";
    }

    return {
      message: previewText,
      messageType: messageType,
      previewMessage: previewText,
      createdAt: msg.createdAt
    };
  }, [strings]);

  // Fetch the last non-deleted message for a chat.
  // Checks Redux cachedMessages first; only calls getChat if no cache exists.
  const fetchLastNonDeletedMessage = useCallback(async (chat) => {
    if (!chat?.group?.id) return null;

    const chatId = chat.group.isOneToOne ? chat.id : chat.mainId;
    if (!chatId) return null;

    // Check Redux cache first
    const cached = cachedMessages?.[chatId];
    if (cached?.rawMessages?.length > 0) {
      const lastNonDeleted = cached.rawMessages.find(msg => !msg.isDeleted && !msg.userDeleted);
      if (lastNonDeleted) return formatNonDeletedMessage(lastNonDeleted);
    }

    try {
      let apiUrl = `/group/${chatId}/getChat?page=1&limit=10`;
      if (chat.group.isOneToOne && user?.id) {
        apiUrl += `&userId=${user.id}`;
      } else if (!chat.group.isOneToOne && chat.building) {
        apiUrl += `&building=${chat.building}`;
      }

      const { data } = await callAPI(apiUrl, {}, "GET");

      if (data?.status && data?.chatHistory?.length > 0) {
        const lastNonDeleted = data.chatHistory.find(msg => !msg.isDeleted && !msg.userDeleted);
        if (lastNonDeleted) return formatNonDeletedMessage(lastNonDeleted);
      }
    } catch (error) {
    }
    return null;
  }, [strings, user, cachedMessages, formatNonDeletedMessage]);

  // Ensure every chat item carries a stable preview message
  const applyPreview = useCallback((chat) => {
    if (!chat) return chat;
    
    // If last message is deleted, ALWAYS clear the message fields
    // This ensures deleted message content is never displayed
    if (chat?.lastMessageDeleted) {
      return {
        ...chat,
        previewMessage: "",
        message: "",
        originalMessage: "",
      };
    }
    
    const type = chat?.messageType;
    let txt = (chat?.previewMessage ?? chat?.message ?? chat?.originalMessage ?? "").toString();
    txt = txt.trim();
    
    const beforeTxt = txt;
    
    if (!txt) {
      if (type === "image") {
        const count = chat?.count ?? chat?.images?.length ?? 0;
        txt = count > 1
          ? (strings?.m_image || strings?.s_image || "Images")
          : (strings?.s_image || "Image");
      } else if (type === "doc") {
        txt = strings?.document || "Document";
      } else if (type === "video") {
        txt = strings?.video || "Video";
      } else if (type === "audio") {
        txt = strings?.audio || "Audio";
      } else if (type === "contact") {
        txt = strings?.contact || "Contact";
      } else if (type === "map") {
        txt = strings?.location || "Location";
      }
    }
    
    return {
      ...chat,
      previewMessage: txt,
      message: txt || chat?.message || "",
    };
  }, [strings]);
  applyPreviewRef.current = applyPreview;
  useEffect(() => {
    if (resetLatestMessages) {
      dispatch({ type: RESET_LATEST_MESSAGES, status: false });
      const hasList =
        (allChatsRef.current && allChatsRef.current.length > 0) ||
        activityMessages.length > 0;
      if (hasList) {
        _getMessages(1, true);
      } else {
        _resetAndGetLatestMessages();
      }
    }
  }, [resetLatestMessages]);
  
  // Pre-translation of chat histories is now deferred to when each chat
  // is actually opened (Conversation / GroupConversation already pass
  // translationLang to getChat).  Calling preTranslateChats here was
  // issuing a getChat request for every chat in the list on every tab
  // switch and whenever AllChats.length changed.
  useEffect(() => {
    if (!isAutoTranslation) {
      cancelPreTranslation();
    }
  }, [isAutoTranslation]);

  // Warm the browser image cache for every avatar / group image as soon as
  // chats arrive. This is what makes profile images appear instantly when
  // the user switches to the Direktnachrichten (or any other) filter tab –
  // by the time those rows mount the bytes are already in cache, so there
  // is no perceptible network or fade-in delay.
  useEffect(() => {
    if (!AllChats || AllChats.length === 0) return;
    const urls = [];
    AllChats.forEach((chat) => {
      if (chat?.group?.isOneToOne) {
        const avatar = getOneToOnePartnerAvatar(chat, user);
        if (avatar) urls.push(BASE_URL + avatar);
      } else if (chat?.groupImage) {
        urls.push(BASE_URL + chat.groupImage);
      }
    });
    if (urls.length > 0) preloadAvatars(urls);
  }, [AllChats, user?.id]);

  // Load the set of Kjuup+ colleagues (users sharing a Kjuup+ company with the
  // current user) so one-to-one chats with them can show the green outline.
  useEffect(() => {
    let cancelled = false;
    const normalizeName = (n) => String(n || "").replace(/\s+/g, " ").trim().toLowerCase();
    (async () => {
      try {
        const { data } = await callAPI('/user/colleagues', {}, 'GET');
        if (!cancelled && data?.status && Array.isArray(data.colleagues)) {
          // Normalize to strings so Set.has matches regardless of id type from chat payloads.
          setKjuupColleagueIds(new Set(data.colleagues.map((c) => String(c.id))));
          // Name fallback for list rows where partner id is still missing.
          setKjuupColleagueNames(
            new Set(data.colleagues.map((c) => normalizeName(c.name)).filter(Boolean))
          );
        }
      } catch (e) {
        console.error('Failed to load Kjuup+ colleagues:', e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const prevNameTranslationRef = useRef(translateRoomAndGroupNames);
  useEffect(() => {
    if (prevNameTranslationRef.current === translateRoomAndGroupNames) return;
    prevNameTranslationRef.current = translateRoomAndGroupNames;
    setTranslatedChatNames({});
    setTranslatedRoomNames({});
    translatedChatIdsRef.current.clear();
  }, [translateRoomAndGroupNames]);

  useEffect(() => {
    previewTranslateMountedRef.current = true;
    return () => { previewTranslateMountedRef.current = false; };
  }, []);

  useEffect(() => {
    if (!AllChats || AllChats.length === 0) return;

    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0];

    // Re-process a chat whenever its last message (or name) changes, not just
    // the first time it appears — otherwise a new incoming message in an
    // existing chat stays on "Translating..." until the next list refetch.
    const newChats = [];
    for (const chat of AllChats) {
      const chatId = chat.group?.id || chat.mainId;
      if (!chatId) continue;
      const signature = `${chat.originalName || chat.name || ''}\u0000${getPreviewSource(chat)}`;
      if (translatedChatIdsRef.current.get(chatId) === signature) continue;
      translatedChatIdsRef.current.set(chatId, signature);
      newChats.push(chat);
    }
    if (newChats.length === 0) return;

    // Collect all texts and batch-translate in a single API call.
    const batchItems = [];
    for (const chat of newChats) {
      const chatId = chat.group?.id || chat.mainId;

      // Microsoft Teams chat names are people and Teams topics: only the preview is translated.
      if (translateRoomAndGroupNames && chat.group && chat.name && !chat.defaultChatGroup && !chat.translatedName && !isTeamsChat(chat)) {
        batchItems.push({ id: `n-${chatId}`, message: chat.originalName || chat.name });
      }

      let shouldTranslatePreview;
      if (chat.detectedMessageLanguage) {
        shouldTranslatePreview = shouldAutoTranslateFromSender(chat.detectedMessageLanguage, lang, autoTranslationLanguages);
      } else if (!autoTranslationLanguages || autoTranslationLanguages.length === 0) {
        shouldTranslatePreview = true;
      } else {
        const previewText = getPreviewSource(chat);
        const det = previewText && !previewText.startsWith('U2FsdGVkX1') ? detectLanguageClient(previewText) : null;
        shouldTranslatePreview = !det || det === lang || shouldAutoTranslateFromSender(det, lang, autoTranslationLanguages);
      }
      if (chat.senderId !== user?.id && chat.messageType === 'simple' && !chat.lastMessageDeleted && shouldTranslatePreview && !chat.translatedMessage) {
        const preview = getPreviewSource(chat);
        if (preview && !preview.startsWith('U2FsdGVkX1') && !isUntranslatableText(preview)) {
          batchItems.push({ id: `p-${chatId}`, message: preview });
        }
      }
    }

    if (batchItems.length === 0) return;

    // No effect-cleanup cancellation: this effect re-runs on every AllChats
    // change, and chats are already marked processed, so cancelling would
    // drop results for good. Stale results are harmless because previews
    // are stored together with the source text they were translated from.
    const translateNewItems = async () => {
      const results = await translateMessagesBatch(batchItems, lang);
      if (!previewTranslateMountedRef.current) return;

      const resultMap = new Map(results.map(r => [r.id, r.translatedMessage]));
      const sourceMap = new Map(batchItems.map(b => [b.id, b.message]));

      for (const chat of newChats) {
        const chatId = chat.group?.id || chat.mainId;

        const translatedName = resultMap.get(`n-${chatId}`);
        if (translatedName && translatedName !== chat.name) {
          setTranslatedChatNames(prev => prev[chatId] === translatedName ? prev : { ...prev, [chatId]: translatedName });
        }

        const translatedRoom = resultMap.get(`r-${chatId}`);
        if (translatedRoom && translatedRoom !== chat.buildingName) {
          setTranslatedRoomNames(prev => prev[chatId] === translatedRoom ? prev : { ...prev, [chatId]: translatedRoom });
        }

        const translatedPreview = resultMap.get(`p-${chatId}`);
        if (translatedPreview) {
          const source = sourceMap.get(`p-${chatId}`);
          setTranslatedPreviews(prev => (
            prev[chatId]?.source === source && prev[chatId]?.text === translatedPreview
              ? prev
              : { ...prev, [chatId]: { source, text: translatedPreview } }
          ));
        }
      }
    };

    translateNewItems();
  }, [isAutoTranslation, translateRoomAndGroupNames, AllChats]);

  // Reset reminder auto-open when leaving Latest Messages. Chats are not
  // auto-opened on enter — the right pane stays empty until the user clicks.
  useEffect(() => {
    if (!isLatestMessagesRoute) {
      hasAutoOpenedReminderRef.current = false;
    }
  }, [isLatestMessagesRoute]);

  const prevOpenChatIdRef = useRef(null);
  useEffect(() => {
    if (!(openChats && openChats.length === 1)) return;
    const target = openChats[0];
    const targetId = target?.id;
    if (!targetId || targetId === prevOpenChatIdRef.current) return;
    prevOpenChatIdRef.current = targetId;

    const targetStr = String(targetId);
    const targetUserId = target?.replacementUserId;

    const matchesTarget = (c) => {
      if (String(c.group?.id) === targetStr) return true;
      if (String(c.id) === targetStr || String(c.mainId) === targetStr) return true;
      if (targetUserId && c.group?.isOneToOne) {
        if (c.senderId === targetUserId) return true;
        if (c.group?.users) {
          const otherUser = c.group.users.find(u => (u.id || u) !== user?.id);
          if (otherUser && (otherUser.id || otherUser) === targetUserId) return true;
        }
      }
      return false;
    };

    setAllChats(prev => {
      const exists = prev.some(matchesTarget);
      if (!exists) return prev;
      return prev.map(c => {
        const opened = matchesTarget(c);
        return {
          ...c,
          isOpened: opened,
          unseenChatCount: opened ? 0 : c.unseenChatCount,
        };
      });
    });
  }, [openChats, user?.id]);

  // New state to track pagination triggering
  const [isPaginationTriggered, setIsPaginationTriggered] = useState(false);

  // New states for todo toggle functionality
  const [todoSelected, setTodoSelected] = useState(0); // 0 for chats, 1 for todo
  const [searchValue, setSearchValue] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);


  // IDs / names of users who share a Kjuup+ company with the current user.
  // Used to render the green Kjuup+ outline on matching one-to-one chat avatars.
  const [kjuupColleagueIds, setKjuupColleagueIds] = useState(() => new Set());
  const [kjuupColleagueNames, setKjuupColleagueNames] = useState(() => new Set());


  // State to track project icon hover

  // State for member selection
  const [showMemberSelection, setShowMemberSelection] = useState(false);

  // State for new message type selector (Email vs Kjuup Message)
  const [showNewMessageTypeSelector, setShowNewMessageTypeSelector] = useState(false);
  const newMessageTypeSelectorRef = useRef(null);
  // A connected Teams account: the new-chat picker (MemberSelection) gets its "Teams contacts" tab.
  const teamsConnected = useTeamsConnected(hideTeamsPref);


  // Reply functionality state variables
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [replyingTo, setReplyingTo] = useState(null); // message id
  const [replyText, setReplyText] = useState('');
  const [replyLoading, setReplyLoading] = useState(false);
  const [replyExiting, setReplyExiting] = useState(null); // for exit animation
  const [groupSecret, setGroupSecret] = useState(null);
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]); // For multiple images
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoStage, setVideoStage] = useState(null); // 'processing' | 'uploading' | null
  const [videoProgress, setVideoProgress] = useState(0);
  // Photo replies: upload progress ({ pct, index, count }) and the short "Sent" beat before the box closes.
  const [imageSend, setImageSend] = useState(null);
  const [replySent, setReplySent] = useState(false);
  const [attachmentError, setAttachmentError] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [audioDuration, setAudioDuration] = useState(0);
  const joinRequestsInternal = useSelector(state => state.joinRequestsInternal)
  const joinRequestsExternal = useSelector(state => state.joinRequestsExternal)
  const newMessagedata = useSelector(state => state.newMessagedata)

  const [animatedChatId, setAnimatedChatId] = useState(null)
  // Refs for audio recording
  const mediaRecorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);
  const audioChunksRef = useRef([]);
  const attachmentErrorTimeout = useRef(null);
  const processMediaFilesRef = useRef(null);
  const videoJobRef = useRef(0);
  const audioRef = useRef(null);
  const mediaStreamRef = useRef(null);

  // Add state and ref for audio preview duration
  const [audioPreviewDuration, setAudioPreviewDuration] = useState(null);
  const audioPreviewRef = useRef(null);

  // Auto-suggestion states
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [suggestionsError, setSuggestionsError] = useState(null);
  const [showSuggestionLoadingPopup, setShowSuggestionLoadingPopup] = useState(false);
  const [pendingSuggestionIndex, setPendingSuggestionIndex] = useState(null);
  // Kept for the editors' focus handlers; the suggestions now show as soon as the reply opens.
  const [, setIsReplyInputFocused] = useState(false);
  const [currentReplyMessage, setCurrentReplyMessage] = useState(null);
  const suggestionsRef = useRef([]);
  const lastSuggestionRequestRef = useRef({ replyingTo: null, messageText: '' });
  const suggestionsLoadingRef = useRef(false);
  const [showTodoCreatingLoader, setShowTodoCreatingLoader] = useState(false);
  const [todoCreatingStep, setTodoCreatingStep] = useState(1); // 1: Creating, 2: Navigating
  const [emailTodoModal, setEmailTodoModal] = useState({ open: false, emailId: null, messageDate: null, summaryText: "" });
  const [emailTodoDate, setEmailTodoDate] = useState(""); // date only: YYYY-MM-DD

  // WYSIWYG rich editor state & refs
  const [isComposerToolbarOpen, setIsComposerToolbarOpen] = useState(true);
  const [activeFormats, setActiveFormats] = useState({});
  const activeFormatsRef = useRef(null);
  const richEditorRef = useRef(null);
  const mentionCursorRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const composerMarkdownToHtml = useCallback((md) => composerMdToHtml(md), []);
  const htmlToMarkdown = useCallback((html) => sharedHtmlToMarkdown(html), []);

  const getRichEditorContent = useCallback(() => {
    const editor = richEditorRef.current;
    if (!editor) return "";
    return sharedHtmlToMarkdown(editor.innerHTML);
  }, []);

  const updateActiveFormats = useCallback(() => {
    if (!isComposerToolbarOpen) return;
    try {
      applyActiveFormatsIfChanged(setActiveFormats, activeFormatsRef, readComposerFormats(richEditorRef.current));
    } catch (e) { /* ignore */ }
  }, [isComposerToolbarOpen]);

  useEffect(() => {
    if (!isComposerToolbarOpen) return;
    document.addEventListener("selectionchange", updateActiveFormats);
    return () => document.removeEventListener("selectionchange", updateActiveFormats);
  }, [isComposerToolbarOpen, updateActiveFormats]);

  const applyComposerFormat = useCallback((formatType) => {
    const editor = richEditorRef.current;
    if (editor && isComposerToolbarOpen) {
      editor.focus();
      switch (formatType) {
        case "bold":
          document.execCommand("bold", false, null);
          break;
        case "italic":
          document.execCommand("italic", false, null);
          break;
        case "underline":
          document.execCommand("underline", false, null);
          break;
        case "unordered":
          document.execCommand("insertUnorderedList", false, null);
          break;
        case "ordered":
          document.execCommand("insertOrderedList", false, null);
          break;
        default:
          break;
      }
    }
  }, [isComposerToolbarOpen]);

  const onMentionSelect = useCallback((mention) => {
    if (isComposerToolbarOpen && mentionCursorRef.current) {
      const editor = richEditorRef.current;
      if (editor) {
        const { node, offset, atIndex } = mentionCursorRef.current;
        if (node && node.parentNode && editor.contains(node)) {
          const before = node.textContent.substring(0, atIndex);
          const after = node.textContent.substring(offset);
          const mentionSpan = document.createElement("span");
          mentionSpan.className = "mention-tag";
          mentionSpan.setAttribute("data-mention-id", mention.id);
          mentionSpan.setAttribute("data-mention-name", mention.name);
          mentionSpan.contentEditable = "false";
          mentionSpan.textContent = `@${mention.name}`;
          const parent = node.parentNode;
          const beforeText = document.createTextNode(before);
          const afterText = document.createTextNode("\u00A0" + after);
          parent.insertBefore(beforeText, node);
          parent.insertBefore(mentionSpan, node);
          parent.insertBefore(afterText, node);
          parent.removeChild(node);
          const sel = window.getSelection();
          const newRange = document.createRange();
          newRange.setStart(afterText, 1);
          newRange.collapse(true);
          sel.removeAllRanges();
          sel.addRange(newRange);
          const md = getRichEditorContent();
          setReplyText(md);
        }
      }
      mentionCursorRef.current = null;
    }
    setShowMentionSuggestions(false);
    setMentionQuery("");
  }, [isComposerToolbarOpen, getRichEditorContent]);

  const [showMentionSuggestions, setShowMentionSuggestions] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");

  const dedupeByMainId = useCallback((items = []) => {
    const seen = new Set();
    return items.filter((item) => {
      const id = item?.mainId ?? item?.id;
      if (!id) return true;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, []);
  
  const fetchingPage1Ref = useRef(false);

  // Helper to format seconds as mm:ss
  function formatAudioDuration(seconds) {
    if (!isFinite(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  // Effect to update audio duration when recordedAudio changes
  useEffect(() => {
    if (recordedAudio && audioPreviewRef.current) {
      const audioEl = audioPreviewRef.current;

      const updateDuration = () => {
        if (audioEl.duration && isFinite(audioEl.duration)) {
          setAudioPreviewDuration(audioEl.duration);
        }
      };

      const handleLoadedMetadata = () => {
        updateDuration();
      };

      const handleCanPlay = () => {
        updateDuration();
      };

      // Add multiple event listeners to ensure we catch the duration
      audioEl.addEventListener('loadedmetadata', handleLoadedMetadata);
      audioEl.addEventListener('canplay', handleCanPlay);
      audioEl.addEventListener('loadeddata', updateDuration);

      // Force load the audio to trigger metadata loading
      audioEl.load();

      // If metadata is already loaded
      if (audioEl.readyState >= 1) {
        updateDuration();
      }

      return () => {
        audioEl.removeEventListener('loadedmetadata', handleLoadedMetadata);
        audioEl.removeEventListener('canplay', handleCanPlay);
        audioEl.removeEventListener('loadeddata', updateDuration);
      };
    } else {
      setAudioPreviewDuration(null);
    }
  }, [recordedAudio]);

  // Returning to global search (?gs=1&gq=…) — clear email in the same frame as SearchBar
  // restores the popup (useLayoutEffect) so the list never flashes underneath.
  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search || '');
    if (params.get('gs') === '1' && params.get('gq')) {
      setSelectedEmail(null);
      setEmailReplyMode(null);
    }
  }, [location.search]);

  // On a small screen the list replaces the open chat. Drop the selected
  // highlight once the list is showing again.
  useEffect(() => {
    if (!exclusiveMessagesPane || !openLatestMsgToggle) return;
    const source = (allChatsRef.current && allChatsRef.current.length > 0)
      ? allChatsRef.current
      : AllChats;
    if (!source || !source.some((c) => c.isOpened)) return;
    const next = source.map((c) => (c.isOpened ? { ...c, isOpened: false } : c));
    allChatsRef.current = next;
    setAllChats(next);
    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: next });
  }, [exclusiveMessagesPane, openLatestMsgToggle, AllChats, dispatch]);

  // Ensure correct mode and data when entering LatestMessages
  useEffect(() => {
    if (!isLatestMessagesRoute) return;

    // Always mark activity when on messages route
    dispatch({ type: SET_IN_ACTIVITY, status: true });
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'LatestMessages' });
    
    // Handle pre-opened direct message chats (from UserProfile, companydetails, etc.)
    // On mobile, if there's already an open chat, hide the list to show the chat
    // On desktop, always show the list (both list and chat are visible)
    if (openChats && openChats.length > 0 && exclusiveMessagesPane) {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    } else {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    }

    // Chat view
    setIsTabSelect(true);

    // Skip if already fetching
    if (gettingChats) {
      return;
    }

    // Cached list stays on screen. A return to this tab refreshes quietly.
    if (activityMessages.length > 0) {
      setIsLoading(false);
      setShowSkeleton(false);
      setIsContentReady(true);
      _getMessages(1, true);
    } else if ((openChats && openChats.length > 0) || activityMessages.some(msg => msg.isOpened)) {
      // We have a pre-opened chat but no cached messages yet - fetch without resetting
      setIsLoading(false);
      setShowSkeleton(false);
      _getMessages(1, true);
    } else {
      // No cached data and no pre-opened chat, show skeleton and fetch
      setIsLoading(true);
      setShowSkeleton(true);
      _resetAndGetLatestMessages();
    }
  }, [isLatestMessagesRoute, dispatch]);

  useEffect(() => {
    if (!isLatestMessagesRoute) return;
    if (openChats && openChats.length > 0) {
      lastMessagesDetail = { kind: "chat", chat: openChats[0] };
    } else if (openProjects && openProjects.length > 0) {
      lastMessagesDetail = {
        kind: "group",
        project: openProjects[0],
        groupChat: (groupChats && groupChats[0]) || null,
        clickedGroupId: clickedGroup || openProjects[0]?.group?.id || (groupChats && groupChats[0]?.id) || null,
      };
    } else if (selectedEmail) {
      lastMessagesDetail = { kind: "email", email: selectedEmail };
    }
  }, [isLatestMessagesRoute, openChats, openProjects, groupChats, clickedGroup, selectedEmail]);

  // Auto-open the first ToDo on desktop (ToDo tab)
  useEffect(() => {
    if (isTabSelect) return;
    if (!isDesktop) return;
    if (AllChatsReminder && AllChatsReminder.length > 0 && !isLoading && !hasAutoOpenedReminderRef.current) {
      const hasOpened = AllChatsReminder.some(chat => chat.isOpened);
      if (!hasOpened && (!openChats || openChats.length === 0) && (!openProjects || openProjects.length === 0)) {
        const timer = setTimeout(() => {
          const firstReminder = AllChatsReminder[0];
          if (firstReminder && firstReminder.group) {
            hasAutoOpenedReminderRef.current = true;
            if (firstReminder.group.isOneToOne) {
              chat_click_reminder(firstReminder, 0);
            } else {
              chat_click_group_reminder(firstReminder, 0);
            }
          }
        }, 200);
        return () => clearTimeout(timer);
      }
    }
  }, [isTabSelect, isDesktop, AllChatsReminder, isLoading, openChats, openProjects]);


  // Move chat to top and update preview when new message arrives from socket
  useEffect(() => {
    if (!newMessagedata) return;

    
    // Clear the "deleted" flag from localStorage since we have a new message
    try {
      const deletedChats = JSON.parse(localStorage.getItem('deletedMessageChats') || '{}');
      if (deletedChats[newMessagedata.groupId]) {
        delete deletedChats[newMessagedata.groupId];
        localStorage.setItem('deletedMessageChats', JSON.stringify(deletedChats));
      }
    } catch (e) {
    }

    // Get current chat list
    const currentChats = isTabSelect ? [...AllChats] : [...AllChatsReminder];
    const targetChat = currentChats.find(chat => chat.group?.id === newMessagedata.groupId);

    if (!targetChat || isArchivedChat(targetChat)) {
      if (!targetChat && currentChats.length > 0) {
        _getMessages(1, true);
      }
      if (currentChats.length > 0) {
        dispatch({ type: SET_NEW_MESSAGE_DATA, payload: null });
      }
      return;
    }

    // 1. Generate preview message
    let previewMessage = newMessagedata.previewMessage || newMessagedata.message || "";
    const originalMessage = previewMessage; // Keep original for fallback
    
    // Decrypt if needed
    if (!newMessagedata.decrypted && previewMessage && groupSecret) {
      try {
        const decrypted = decryptMessage(previewMessage, groupSecret);
        if (decrypted && decrypted.trim()) {
          previewMessage = decrypted;
        }
      } catch (err) {
        // Keep original message if decryption fails
      }
    }

    // Normalize mention markup for group previews so truncation doesn't break @username text
    if (!targetChat?.group?.isOneToOne && previewMessage) {
      previewMessage = onlyUsername(previewMessage, strings);
    }

    // Handle special cases for multi-image galleries
    const isGalleryImage = newMessagedata.messageType === "image" && 
      !previewMessage && 
      newMessagedata.isLastImage === false;
    
    if (isGalleryImage) {
      const existingMessage = targetChat.message || targetChat.previewMessage || "";
      const hasText = existingMessage && 
        existingMessage.trim() !== '' && 
        existingMessage !== (strings?.s_image || "Image") &&
        existingMessage !== (strings?.m_image || "Images");
      
      if (hasText) {
        previewMessage = existingMessage;
      }
    }

    // Fallback for media types (only if still empty)
    if (!previewMessage || previewMessage.trim() === '') {
      const mediaLabels = {
        image: strings?.s_image || "Image",
        doc: strings?.document || "Document",
        video: strings?.video || "Video",
        audio: strings?.audio || "Audio"
      };
      previewMessage = mediaLabels[newMessagedata.messageType] || originalMessage || newMessagedata.message || "";
    }

    // 2. Update the chat with new message data
    const nextSenderId = newMessagedata.senderId || targetChat.senderId;
    const senderChanged =
      targetChat.group?.isOneToOne &&
      nextSenderId &&
      String(nextSenderId) !== String(targetChat.senderId);
    // getUserChats encodes senderAvatar/name as the last sender and
    // avatar/name as the other person. Swap when senderId changes so a
    // 1:1 row keeps showing the receiver after we send.
    const swappedOneToOne = senderChanged
      ? {
          avatar: targetChat.senderAvatar,
          senderAvatar: newMessagedata.senderAvatar || targetChat.avatar,
          name: targetChat.senderName,
          senderName: newMessagedata.senderName || targetChat.name,
        }
      : {};
    // Room / group rows prefix the last sender's first name: keep it current.
    // A new sender without a name in the payload drops the old one rather than
    // showing the wrong person.
    const groupSender = !targetChat.group?.isOneToOne
      ? {
          senderName:
            newMessagedata.senderName ||
            newMessagedata.fullName ||
            (String(nextSenderId) === String(targetChat.senderId) ? targetChat.senderName : ""),
        }
      : {};
    const updatedChat = {
      ...targetChat,
      ...groupSender,
      message: previewMessage,
      previewMessage: previewMessage,
      messageType: newMessagedata.messageType || targetChat.messageType,
      id: newMessagedata.id || targetChat.id,
      createdAt: newMessagedata.createdAt || targetChat.createdAt,
      senderId: nextSenderId,
      senderLanguage: newMessagedata.senderLanguage || targetChat.senderLanguage,
      count: newMessagedata.count || (newMessagedata.messageType === "image" ? 1 : targetChat.count),
      lastMessageDeleted: false,
      transcribedAudio: newMessagedata.transcribedAudio || (newMessagedata.messageType === targetChat.messageType ? targetChat.transcribedAudio : undefined),
      lastReactionEmoji: null,
      lastReactionSenderName: null,
      // Server-side preview fields belong to the previous last message.
      translatedMessage: undefined,
      detectedMessageLanguage: newMessagedata.detectedMessageLanguage,
      ...swappedOneToOne,
    };

    // Apply preview formatting
    const enrichedChat = applyPreview(updatedChat);

    // 3. Move to top of list
    const otherChats = currentChats.filter(chat => chat.group?.id !== newMessagedata.groupId);
    const reorderedChats = [enrichedChat, ...otherChats];

    // 4. Update Redux and local state atomically
    if (isTabSelect) {
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: reorderedChats });
      setAllChats(reorderedChats);
    } else {
      dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: reorderedChats });
      setAllChatsReminders(reorderedChats);
    }

    // 5. Trigger animation
    setAnimatedChatId(newMessagedata.groupId);
    setTimeout(() => setAnimatedChatId(null), 1300);

    // 6. Cleanup
    dispatch({ type: SET_NEW_MESSAGE_DATA, payload: null });

  }, [newMessagedata, isTabSelect, AllChats, AllChatsReminder, groupSecret, strings, applyPreview, dispatch, isAutoTranslation, user?.id])

  // Socket context
  const socket = useContext(SocketContext);

  // Helper function to close reply section with smooth animation
  const closeReplySection = useCallback(async () => {
    if (replyingTo !== null) {
      // Set exit animation first
      setReplyExiting(replyingTo);
      // Unsubscribe in background (don't await to avoid blocking animation)
      unsubscribeFromChat(activeGroupId).catch(() => {});
      // Wait for the exit animation (the reply box folds away, LatestMessagesPro.css)
      setTimeout(() => {
        setActiveGroupId(null);
        setReplyingTo(null);
        setReplyText('');
        clearAttachments();
        setReplyExiting(null);
        setIsReplyInputFocused(false);
        setSuggestions([]);
        setSuggestionsError(null);
        setCurrentReplyMessage(null);
      }, REPLY_COLLAPSE_MS);
    }
  }, [replyingTo, activeGroupId]);

  // The fold-away animation starts from the reply box's real height (LatestMessagesPro.css).
  useLayoutEffect(() => {
    if (replyExiting == null) return;
    const box = document.querySelector(".lmp-item--replying .reply-box.reply-exit");
    if (box) box.style.setProperty("--lmp-reply-h", `${box.offsetHeight}px`);
  }, [replyExiting]);

  // Photo / video replies end with a short "Sent" beat on the full progress bar, then the reply
  // box folds away and the chat moves to the top with the row highlight.
  const finishMediaReply = async (item, moveChat) => {
    setReplySent(true);
    await new Promise((resolve) => setTimeout(resolve, REPLY_SENT_HOLD_MS));
    closeReplySection();
    setTimeout(() => {
      moveChat();
      setReplySent(false);
      setImageSend(null);
      const groupId = item.group?.id;
      if (groupId) {
        setAnimatedChatId(groupId);
        setTimeout(() => setAnimatedChatId((cur) => (cur === groupId ? null : cur)), 1300);
      }
      scrollToTop();
    }, REPLY_COLLAPSE_MS);
  };

  // Function to fetch auto-suggestions from API
  const fetchSuggestions = async (message) => {
    if (!message || message.trim() === '') {
      setSuggestions([]);
      suggestionsRef.current = [];
      return;
    }
    
    setSuggestionsLoading(true);
    suggestionsLoadingRef.current = true;
    setSuggestionsError(null);
    
    try {
      let messageArray = [];
      if (typeof message === 'string') {
        messageArray = [message.replace(/<br\s*[/]?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()];
      } else if (Array.isArray(message)) {
        messageArray = message;
      }
      
      const response = await callAPI(
        '/message/generateSuggestionMessage',
        {},
        'POST',
        { message: messageArray, chat_id: replyingTo, group_id: activeGroupId }
      );
      
      if (response.data && response.data.suggestion && Array.isArray(response.data.suggestion)) {
        const newSuggestions = response.data.suggestion.slice(0, 3);
        setSuggestions(newSuggestions);
        suggestionsRef.current = newSuggestions;
      } else {
        setSuggestions([]);
        suggestionsRef.current = [];
      }
    } catch (error) {
      setSuggestionsError(strings.suggestions_error || 'Failed to load suggestions');
      setSuggestions([]);
      suggestionsRef.current = [];
    } finally {
      setSuggestionsLoading(false);
      suggestionsLoadingRef.current = false;
    }
  };

  // Handle placeholder chip click - uses refs to avoid stale closure
  const handlePlaceholderClick = (index) => {
    const currentSuggestions = suggestionsRef.current;
    const isLoading = suggestionsLoadingRef.current;
    
    if (isLoading) {
      setShowSuggestionLoadingPopup(true);
      setPendingSuggestionIndex(index);
    } else if (currentSuggestions.length > index) {
      const text = currentSuggestions[index];
      setReplyText(text);
      if (isComposerToolbarOpen && richEditorRef.current) {
        richEditorRef.current.innerHTML = composerMarkdownToHtml(text);
      }
    }
  };

  // Watch for suggestions to load and insert pending suggestion. The popup closes once loading
  // ends even when the request failed or returned fewer suggestions than the clicked chip.
  useEffect(() => {
    if (!suggestionsLoading && pendingSuggestionIndex !== null) {
      const text = suggestions[pendingSuggestionIndex];
      if (text) {
        setReplyText(text);
        if (isComposerToolbarOpen && richEditorRef.current) {
          richEditorRef.current.innerHTML = composerMarkdownToHtml(text);
        }
      }
      setTimeout(() => {
        setShowSuggestionLoadingPopup(false);
        setPendingSuggestionIndex(null);
      }, 300);
    }
  }, [suggestionsLoading, suggestions, pendingSuggestionIndex]);

  // Fetch suggestions when reply message and groupSecret are available
  useEffect(() => {
    if (!currentReplyMessage || !replyingTo) {
      setSuggestions([]);
      suggestionsRef.current = [];
      lastSuggestionRequestRef.current = { replyingTo: null, messageText: '' };
      return;
    }

    // Decrypt message before sending to API
    let messageText = currentReplyMessage;
    if (groupSecret) {
      try {
        const decrypted = decryptMessage(messageText, groupSecret);
        if (decrypted) {
          messageText = decrypted;
        }
      } catch (e) {
        // Use original if decryption fails
      }
    }

    if (isMessageEmojiOnly(messageText)) {
      setSuggestions([]);
      suggestionsRef.current = [];
      return;
    }

    // Skip duplicate request when same contact + message (e.g. groupSecret arrived after first fetch)
    const last = lastSuggestionRequestRef.current;
    if (last.replyingTo === replyingTo && last.messageText === messageText) {
      return;
    }
    lastSuggestionRequestRef.current = { replyingTo, messageText };

    fetchSuggestions(messageText);
  }, [currentReplyMessage, groupSecret, replyingTo, activeGroupId]);

  const createTodoDirectly = async (chatId, messageText, messageDate, messageType, groupId = null, buildingList = null, isOneToOne = false) => {
    const cleanText = cleanChatMessageText(messageText);
    const summary = oneSentenceMessageSummary(cleanText) || cleanText.slice(0, 180);

    // Fill icon immediately (optimistic)
    if (groupId) {
      setBookmarkedGroupIds(prev => new Set(prev).add(groupId));
    }
    const tempId = `pending-bookmark-${chatId || groupId || Date.now()}-${Date.now()}`;
    const roomId = buildingList && (typeof buildingList === "object" ? (buildingList.id || buildingList._id) : buildingList);
    beginExternalBookmarkTodo(dispatch, {
      tempId,
      chatId,
      groupId,
      roomId,
      strings,
    });

    try {
      const payload = {
        summary,
        messageText: cleanText,
      };
      
      if (groupId || chatId) {
        payload.group = groupId || chatId;
      }
      
      if (chatId) {
        payload.chat = chatId;
      }

      if (roomId) {
        payload.roomId = roomId;
      }

      const { data } = await callAPI('/todo/manualTodoCreate', {}, 'POST', payload);
      
      if (data.status) {
        finishBookmarkTodo(dispatch, { tempId, chatId, todo: data.data || null });
        $crud.notify({
          type: 'success',
          message: strings.todo_bookmarked || 'Aufgabe wurde vorgemerkt',
        });
      } else {
        // Revert on failure
        if (groupId) {
          setBookmarkedGroupIds(prev => { const next = new Set(prev); next.delete(groupId); return next; });
        }
        failBookmarkTodo(dispatch, { tempId, chatId });
        $crud.notify({
          type: 'error',
          message: data.message || strings.todo_creation_failed,
        });
      }
    } catch (error) {
      // Revert on error
      if (groupId) {
        setBookmarkedGroupIds(prev => { const next = new Set(prev); next.delete(groupId); return next; });
      }
      failBookmarkTodo(dispatch, { tempId, chatId });
      $crud.notify({
        type: 'error',
        message: strings.todo_creation_failed || 'Failed to create todo',
      });
    }
  };

  const createTodoFromEmail = async (emailId, messageDate, summaryText, emailItem = null) => {
    const cleanText = emailItem
      ? (getEmailListPreview(emailItem, !!user?.emailSummaryPreviewEnabled)
        || firstEmailSentence(summaryText)
        || stripHtmlToPlainText(summaryText || emailItem.subject || "").replace(/\s+/g, " ").trim())
      : (firstEmailSentence(summaryText) || (summaryText ? stripHtmlToPlainText(summaryText).replace(/\s+/g, " ").trim() : ""));

    if (!emailId) {
      $crud.notify({
        type: "error",
        message: strings.todo_creation_failed || "Failed to create todo",
      });
      return;
    }

    // Optimistic UI: immediately show bookmark as filled
    setBookmarkedEmailIds(prev => new Set(prev).add(String(emailId)));
        setEmailMessages((prev) =>
          prev.map((m) => {
            const id = m.id || m._id || m.messageId || m.providerMessageId;
            return String(id) === String(emailId) ? { ...m, isTodoBookmarked: true } : m;
          })
        );
        setSelectedEmail((prev) => {
          if (!prev) return prev;
          const id = prev.id || prev._id || prev.messageId || prev.providerMessageId;
          return String(id) === String(emailId) ? { ...prev, isTodoBookmarked: true } : prev;
        });

    // The email's project (the server also finds it from the email's project link).
    const roomId = emailProjectIdOf(emailItem);
    const tempId = `pending-bookmark-email-${emailId}-${Date.now()}`;
    beginExternalBookmarkTodo(dispatch, {
      tempId,
      emailId: String(emailId),
      roomId,
      strings,
    });

    try {
      const payload = {
        emailId: String(emailId),
        summary: cleanText || "(No subject)",
        messageText: emailItem?.bodyText || emailItem?.snippet || summaryText || cleanText,
      };
      if (roomId) {
        payload.roomId = roomId;
      }

      const { data } = await callAPI("/todo/manualTodoCreate", {}, "POST", payload);


      if (data.status) {
        finishBookmarkTodo(dispatch, { tempId, todo: data.data || null });
        $crud.notify({
          type: "success",
          message: strings.todo_bookmarked || "Aufgabe wurde vorgemerkt",
        });
      } else {
        // Revert on failure
        setBookmarkedEmailIds(prev => { const next = new Set(prev); next.delete(String(emailId)); return next; });
        setEmailMessages((prev) =>
          prev.map((m) => {
            const id = m.id || m._id || m.messageId || m.providerMessageId;
            return String(id) === String(emailId) ? { ...m, isTodoBookmarked: false } : m;
          })
        );
        failBookmarkTodo(dispatch, { tempId });
        $crud.notify({
          type: "error",
          message: data.message || strings.todo_creation_failed,
        });
      }
    } catch (error) {
      // Revert on error
      setBookmarkedEmailIds(prev => { const next = new Set(prev); next.delete(String(emailId)); return next; });
      setEmailMessages((prev) =>
        prev.map((m) => {
          const id = m.id || m._id || m.messageId || m.providerMessageId;
          return String(id) === String(emailId) ? { ...m, isTodoBookmarked: false } : m;
        })
      );
      failBookmarkTodo(dispatch, { tempId });
      $crud.notify({
        type: "error",
        message: strings.todo_creation_failed || "Failed to create todo",
      });
    }
  };

  // Legacy function aliases for backwards compatibility
  const openTodoModal = createTodoDirectly;

  const removeBookmarkTodo = async ({ chatId, emailId, groupId } = {}) => {
    if (!chatId && !emailId && !groupId) return;

    if (groupId) {
      setBookmarkedGroupIds(prev => { const next = new Set(prev); next.delete(groupId); return next; });
    }
    if (emailId) {
      setBookmarkedEmailIds(prev => { const next = new Set(prev); next.delete(String(emailId)); return next; });
      setEmailMessages(prev =>
        prev.map(m => {
          const id = m.id || m._id || m.messageId || m.providerMessageId;
          return String(id) === String(emailId) ? { ...m, isTodoBookmarked: false } : m;
        })
      );
    }

    try {
      const payload = {};
      if (chatId) payload.chatId = chatId;
      if (emailId) payload.emailId = String(emailId);
      if (groupId) payload.groupId = groupId;

      const { data } = await callAPI('/todo/removeBookmark', {}, 'POST', payload);

      if (data.status && data.kept) {
        if (groupId) setBookmarkedGroupIds(prev => new Set(prev).add(groupId));
        if (emailId) {
          setBookmarkedEmailIds(prev => new Set(prev).add(String(emailId)));
          setEmailMessages(prev =>
            prev.map(m => {
              const id = m.id || m._id || m.messageId || m.providerMessageId;
              return String(id) === String(emailId) ? { ...m, isTodoBookmarked: true } : m;
            })
          );
        }
        $crud.notify({
          type: 'info',
          message: strings.bookmark_already_todo || 'Diese Aufgabe wurde bereits bearbeitet und bleibt bestehen',
        });
      } else if (data.status && data.removed) {
        $crud.notify({
          type: 'success',
          message: strings.bookmark_removed || 'Vorgemerkte Aufgabe entfernt.',
        });
        dispatch({ type: REFRESH_TODO_LIST });
      } else {
        if (groupId) setBookmarkedGroupIds(prev => new Set(prev).add(groupId));
        if (emailId) {
          setBookmarkedEmailIds(prev => new Set(prev).add(String(emailId)));
          setEmailMessages(prev =>
            prev.map(m => {
              const id = m.id || m._id || m.messageId || m.providerMessageId;
              return String(id) === String(emailId) ? { ...m, isTodoBookmarked: true } : m;
            })
          );
        }
        $crud.notify({ type: 'error', message: data.message || 'Error' });
      }
    } catch (error) {
      if (groupId) setBookmarkedGroupIds(prev => new Set(prev).add(groupId));
      if (emailId) {
        setBookmarkedEmailIds(prev => new Set(prev).add(String(emailId)));
        setEmailMessages(prev =>
          prev.map(m => {
            const id = m.id || m._id || m.messageId || m.providerMessageId;
            return String(id) === String(emailId) ? { ...m, isTodoBookmarked: true } : m;
          })
        );
      }
      $crud.notify({ type: 'error', message: strings.error || 'Error' });
    }
  };

  const subscribeToChat = (groupId) => {
    return new Promise((resolve, reject) => {
      try {
        const source = (allChatsRef.current && allChatsRef.current.length > 0)
          ? allChatsRef.current
          : [...AllChats];
        const target = source.find((e) => String(e.group?.id) === String(groupId));
        const unread = Number(target?.unseenChatCount) || 0;
        const tmp = source.map((e) => {
          const match = String(e.group?.id) === String(groupId);
          return {
            ...e,
            unseenChatCount: match ? 0 : e.unseenChatCount,
          };
        });
        allChatsRef.current = tmp;
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: tmp });
        if (unread > 0) {
          dispatch({
            type: ALL_BADGE_COUNT,
            unSeenAllCount: applyOptimisticChatRead(store.getState().unSeenAllCount, {
              isOneToOne: !!target?.group?.isOneToOne,
              isInternal: !!target?.isInternal,
              unreadCount: unread,
            }),
          });
        }
        const subscribeObj = {
          url: `${SOCKET_BASE}/group/${groupId}/subscribe`,
          method: "get",
          headers: {
            Authorization: `jwt ${$user.getToken()}`
          },
        };
        socket.emit('get', subscribeObj, (response) => {
          resolve(response);
        });
      } catch (error) {
        reject(error);
      }
    });
  };


  const unsubscribeFromChat = (groupId) => {
    return new Promise((resolve, reject) => {
      try {
        const unsubscribeObj = {
          url: `${SOCKET_BASE}/group/${groupId}/unsubscribe`,
          method: "get",
          headers: {
            Authorization: `jwt ${$user.getToken()}`
          },
        };
        socket.emit('get', unsubscribeObj, (response) => {
          resolve(response);
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  // API: fetch group secret
  const fetchGroupSecret = async (groupId) => {
    try {
      let getGroupSecretObj = {
        url: `${SOCKET_BASE}/group/${groupId}/getGroupSecret`,
        method: 'get',
        headers: {
          Authorization: `jwt ${$user.getToken()}`
        },
      };
      socket.emit('get', getGroupSecretObj, (response) => {
        if (response?.body?.status && response.body.groupInfo) {
          setGroupSecret(response.body.groupInfo.secretKey);
        }
      });
    } catch (error) {
    }
  };

  // API: fetch group members for @mentions
  const fetchGroupMembers = async (groupId) => {
    try {
      const { data } = await callAPI(`/group/${groupId}/info`, {}, "GET");
      if (data.status && data.groupInfo?.users) {
        let mems = data.groupInfo.users.filter(
          (u) => u.id !== user?.id && !u.isLeave
        );
        mems = mems.map((e) => ({
          ...e,
          name: e.fullName,
          display: e.fullName,
        }));
        // Add "All" option at the beginning if there are members
        if (mems.length > 0) {
          mems.unshift({
            name: strings.All || 'All',
            display: strings.All || 'All',
            id: "idall12322",
            type: "All",
          });
        }
        setMentionSuggestions(mems);
      }
    } catch (error) {
      console.error('Error fetching group members:', error);
    }
  };

  // Helper: get file icon
  const getFileIcon = (fileType) => {
    const icons = {
      pdf: '📄',
      doc: '📝',
      docx: '📝',
      txt: '📄',
      xls: '📊',
      xlsx: '📊',
      ppt: '📑',
      pptx: '📑',
      csv: '📊',
      default: '📎'
    };
    return icons[fileType?.toLowerCase()] || icons.default;
  };

  const getImagePreview = (file) => {
    return URL.createObjectURL(file);
  };

  const processImageFiles = useCallback((files, mode = 'replace', defer = false) => {
    if (!files || files.length === 0) return;
    const allowTypes = ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'webp', 'heic'];
    const validFiles = [];
    const seen = new Set();
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const ext = file.name?.split('.').pop()?.toLowerCase();
      if (!allowTypes.includes(ext)) continue;
      const key = fileFingerprint(file);
      if (seen.has(key)) continue;
      seen.add(key);
      validFiles.push({ file, preview: URL.createObjectURL(file) });
    }
    if (validFiles.length === 0) return;
    const applyState = () => {
      if (mode === 'add' && selectedImage) {
        const existingKey = fileFingerprint(selectedImage.file);
        const extra = validFiles.filter((v) => fileFingerprint(v.file) !== existingKey);
        setSelectedImages([selectedImage, ...extra]);
        setSelectedImage(null);
      } else if (mode === 'add' && selectedImages.length > 0) {
        setSelectedImages(prev => {
          const existingKeys = new Set(prev.map((img) => fileFingerprint(img.file)));
          const extra = validFiles.filter((v) => !existingKeys.has(fileFingerprint(v.file)));
          return extra.length ? [...prev, ...extra] : prev;
        });
      } else if (validFiles.length === 1) {
        setSelectedImage(validFiles[0]);
      } else {
        setSelectedImages(validFiles);
      }
    };
    if (defer) {
      setTimeout(applyState, 0);
    } else {
      applyState();
    }
  }, [selectedImage, selectedImages.length]);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget && !e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    const files = getDroppedFiles(e.dataTransfer);
    if (files.length > 0) {
      const mode = (selectedImage || selectedImages.length > 0) ? 'add' : 'replace';
      if (processMediaFilesRef.current) {
        processMediaFilesRef.current(files, mode);
      } else {
        processImageFiles(files, mode);
      }
    }
  }, [processImageFiles, selectedImage, selectedImages.length]);

  // Helper: show attachment error
  const showAttachmentError = (message) => {
    setAttachmentError(message);
    if (attachmentErrorTimeout.current) {
      clearTimeout(attachmentErrorTimeout.current);
    }
    attachmentErrorTimeout.current = setTimeout(() => {
      setAttachmentError(null);
    }, 3000);
  };

  const processMediaFiles = useCallback((files, mode = 'replace', defer = false) => {
    if (!files || files.length === 0) return;
    const list = Array.from(files).filter(Boolean);
    const imageFiles = [];
    const videoFiles = [];
    for (const file of list) {
      if (isVideoFile(file)) videoFiles.push(file);
      else if (isPhotoFile(file)) imageFiles.push(file);
    }
    if (videoFiles.length === 0 && imageFiles.length === 0) return;

    if (selectedDoc || isRecording || recordedAudio) {
      const label = strings.photo_video_media_lib || strings.upload_image;
      showAttachmentError(
        isGerm
          ? DE.please_remove_current_attachment + " " + label
          : EN.please_remove_current_attachment + " " + (EN.photo_video_media_lib || EN.upload_image)
      );
      return;
    }

    if (videoFiles.length > 1) {
      showAttachmentError(strings.video_one_at_a_time || EN.video_one_at_a_time);
      return;
    }

    const hasImagesAlready = !!(selectedImage || selectedImages.length > 0);
    if (videoFiles.length > 0 && (imageFiles.length > 0 || hasImagesAlready)) {
      showAttachmentError(strings.video_or_images_only || EN.video_or_images_only);
      return;
    }

    if (imageFiles.length > 0 && selectedVideo) {
      showAttachmentError(strings.video_or_images_only || EN.video_or_images_only);
      return;
    }

    if (videoFiles.length === 1) {
      prepareChatVideo(videoFiles[0]).then((result) => {
        if (!result.ok) {
          const msg = strings[result.errorKey] || EN[result.errorKey] || result.errorKey;
          showAttachmentError(msg);
          $crud.notify({ type: "error", message: msg });
          return;
        }
        const apply = () => {
          const jobId = ++videoJobRef.current;
          setSelectedVideo((prev) => {
            if (prev?.url && prev.url !== result.file.url) {
              try { URL.revokeObjectURL(prev.url); } catch (_) { /* ignore */ }
            }
            return result.file;
          });
          setSelectedImage(null);
          setSelectedImages([]);
          setVideoStage("processing");
          setVideoProgress(0);
          compressChatVideo(result.file, {
            onProgress: (pct) => {
              if (videoJobRef.current !== jobId) return;
              setVideoProgress(pct);
            },
          }).then((compressed) => {
            if (videoJobRef.current !== jobId) {
              if (compressed?.url && compressed.url !== result.file.url) {
                try { URL.revokeObjectURL(compressed.url); } catch (_) { /* ignore */ }
              }
              return;
            }
            compressed.replyReady = true;
            setSelectedVideo((prev) => {
              if (
                prev &&
                compressed !== prev &&
                prev.url &&
                String(prev.url).startsWith("blob:") &&
                compressed.url !== prev.url
              ) {
                try { URL.revokeObjectURL(prev.url); } catch (_) { /* ignore */ }
              }
              return compressed;
            });
            setVideoStage(null);
            setVideoProgress(0);
          }).catch(() => {
            if (videoJobRef.current !== jobId) return;
            result.file.replyReady = true;
            setVideoStage(null);
            setVideoProgress(0);
          });
        };
        if (defer) setTimeout(apply, 0);
        else apply();
      });
      return;
    }

    processImageFiles(imageFiles, mode, defer);
  }, [selectedDoc, isRecording, recordedAudio, selectedImage, selectedImages.length, selectedVideo, strings, isGerm, processImageFiles]);

  useEffect(() => {
    processMediaFilesRef.current = processMediaFiles;
  }, [processMediaFiles]);

  // Helper: check if any attachment is selected
  const hasAttachment = () => {
    return selectedDoc || selectedImage || selectedImages.length > 0 || selectedVideo || isRecording || recordedAudio;
  };

  const hasAttachmentBox = () => {
    return selectedDoc || isRecording || recordedAudio;
  };

  // Helper: clear all attachments
  const clearAttachments = () => {
    setSelectedDoc(null);
    if (selectedImage) URL.revokeObjectURL(selectedImage.preview);
    setSelectedImage(null);
    selectedImages.forEach(img => URL.revokeObjectURL(img.preview));
    setSelectedImages([]);
    videoJobRef.current += 1;
    setVideoStage(null);
    setVideoProgress(0);
    if (selectedVideo?.url) {
      try { URL.revokeObjectURL(selectedVideo.url); } catch (_) { /* ignore */ }
    }
    setSelectedVideo(null);
    if (isRecording) {
      stopRecording();
    }
    if (recordedAudio) {
      removeAudio();
    }
  };

  // Helper: convert base64
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Audio recording functions
  const startRecording = async () => {
    try {
      const stream = await getVoiceMediaStream();
      mediaStreamRef.current = stream;
      let options = { mimeType: 'audio/webm;codecs=opus' };
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        options = { mimeType: 'audio/webm' };
      }
      mediaRecorderRef.current = new MediaRecorder(stream, options);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: mediaRecorderRef.current.mimeType });
        if (audioBlob.size === 0) {
          setRecordedAudio(null);
          setAudioDuration(0);
          setAudioPreviewDuration(null);
          return;
        }
        const base64 = await convertBase64(audioBlob);
        const audioUrl = URL.createObjectURL(audioBlob);
        setRecordedAudio({
          blob: audioBlob,
          url: audioUrl,
          base64: base64
        });

        // Set duration immediately from recording time
        const finalDuration = recordingTime;
        setAudioDuration(finalDuration);
        setAudioPreviewDuration(finalDuration);

        // Also try to get precise duration from audio element as backup
        const tempAudio = new Audio(audioUrl);
        tempAudio.addEventListener('loadedmetadata', () => {
          if (tempAudio.duration && isFinite(tempAudio.duration)) {
            setAudioDuration(tempAudio.duration);
            setAudioPreviewDuration(tempAudio.duration);
          }
        });
        tempAudio.addEventListener('error', () => {
          // Keep the recording time as fallback
        });
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
      setRecordingTime(0);
      setAudioDuration(0);
      recordingIntervalRef.current = setInterval(() => {
        setRecordingTime(prev => prev + 1);
      }, 1000);
    } catch (error) {
    }
  };

  const stopRecording = async () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      clearInterval(recordingIntervalRef.current);
      setIsRecording(false);
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach(track => track.stop());
        mediaStreamRef.current = null;
      }
    }
  };

  // Audio playback functions
  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };


  useEffect(() => {
    getJoinRequests()
  }, [])

  useEffect(() => {
    if (fetchAllRequeest) {
      getJoinRequests()
    }
    dispatch({ type: FETCH_ALL_REQUEST, status: false })
  }, [fetchAllRequeest])



  const getJoinRequests = async () => {
    const { data } = await callAPI(`/building/getProjectJoinRequest?isAll=true`, {}, "GET");
    if (data.status) {
      setPendingRequests(data.requests)
    }
  };

  const removeAudio = () => {
    if (recordedAudio?.url) {
      URL.revokeObjectURL(recordedAudio.url);
    }
    setRecordedAudio(null);
  };

  // Helper function to scroll to top of page
  const scrollToTop = () => {
    // Try to find the scroll container
    const scrollContainer = document.querySelector('.latestmessages_scrollbar.loaded');
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // API: reply to message
  const replyToMessage = async (item) => {
    if (item?.canWriteMessages === false || item?.group?.canWriteMessages === false) {
      return;
    }
    const replyBody = (getRichEditorContent() || replyText || "");
    let uniID = makeid(10);
    setReplyLoading(true);
    try {
      // Helper function to move chat to top and update message
      const moveChatToTop = (chatList, updatedChat) => {
        const filteredChats = chatList.filter(chat =>
          chat.id !== item.id && chat.mainId !== item.mainId
        );
        return [updatedChat, ...filteredChats];
      };

      // 1. Document reply
      if (selectedDoc) {
        const fileName = selectedDoc.name;
        const file = selectedDoc;
        const formData = new FormData();
        formData.append('id', item.id);
        formData.append('group', item.group.id);
        formData.append('isGroup', 'true');
        formData.append('message', replyBody || '');
        formData.append('messageType', 'doc');
        formData.append('messageRequestId', uniID);
        formData.append('sender', user.id);
        formData.append('attachedFileName', fileName);
        formData.append('file', file);
        const response = await callAPI(`/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`, {}, 'POST', formData);
        if (response.data.status) {
          $crud.notify({
            type: "success",
            message: strings.reply_sent_successfully,
          });
          closeReplySection();
          scrollToTop();
          if (response.data.status) {
            if (isTabSelect) {
              const updatedChat = applyPreview({
                ...item,
                senderId: user.id,
                message: replyBody || '',
                previewMessage: replyBody || '',
                messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
                createdAt: new Date().toISOString(),
              });
              setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
            }
          } else {
            const updatedChat = applyPreview({
              ...item,
              senderId: user.id,
              message: replyBody || '',
              previewMessage: replyBody || '',
              messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
              createdAt: new Date().toISOString(),
            });
            setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
          }
        } else {
          $crud.notify({
            type: "error",
            message: response.data.message || (strings.reply_failed),
          });
        }
        setSelectedDoc(null);
        setReplyText('');
        setGroupSecret(null);
        return;
      }
      // 2. Image reply
      if (selectedImage) {
        const file = selectedImage.file;
        const fileName = file.name;
        const formData = new FormData();
        formData.append('id', item.id);
        formData.append('group', item.group.id);
        formData.append('isGroup', 'true');
        formData.append('message', replyBody || '');
        formData.append('messageType', 'image');
        formData.append('messageRequestId', uniID);
        formData.append('sender', user.id);
        formData.append('attachedFileName', fileName);
        formData.append('file', file);
        setImageSend({ pct: 0, index: 0, count: 1 });
        const response = await callAPI(`/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`, {}, 'POST', formData, {
          onUploadProgress: (evt) => {
            if (!evt.total) return;
            setImageSend({ pct: Math.min(100, Math.round((evt.loaded * 100) / evt.total)), index: 0, count: 1 });
          },
        });
        if (response.data.status) {
          $crud.notify({
            type: "success",
            message: strings.reply_sent_successfully,
          });
          setImageSend({ pct: 100, index: 0, count: 1 });
          const updatedChat = {
            ...item,
            senderId: user.id,
            message: replyBody || '',
            previewMessage: replyBody || '',
            messageType: 'image',
            createdAt: new Date().toISOString(),
          };
          await finishMediaReply(item, () => {
            if (isTabSelect) setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
            else setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
          });
          setGroupSecret(null);
          return;
        } else {
          setImageSend(null);
          $crud.notify({
            type: "error",
            message: response.data.message || (strings.reply_failed),
          });
        }
        setSelectedImage(null);
        setReplyText('');
        setGroupSecret(null);
        return;
      }
      // 3. Multiple Images reply
      if (selectedImages.length > 0) {
        try {
          // Send images in forward order with sequential upload to maintain order
          for (let i = 0; i < selectedImages.length; i++) {
            const img = selectedImages[i];
            const file = img.file;
            const fileName = file.name;
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('group', item.group.id);
            formData.append('isGroup', 'true');
            // Only add message text to the first image
            formData.append('message', i === 0 ? (replyBody || '') : '');
            formData.append('messageType', 'image');
            formData.append('messageRequestId', uniID);
            formData.append('sender', user.id);
            formData.append('attachedFileName', fileName);
            formData.append('file', file);

            // One bar for the whole batch: finished photos plus the share of the current one.
            const count = selectedImages.length;
            setImageSend({ pct: Math.round((i * 100) / count), index: i, count });
            const response = await callAPI(`/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`, {}, 'POST', formData, {
              onUploadProgress: (evt) => {
                if (!evt.total) return;
                const share = Math.min(1, evt.loaded / evt.total);
                setImageSend({ pct: Math.min(100, Math.round(((i + share) * 100) / count)), index: i, count });
              },
            });
            if (!response.data.status) {
              throw new Error(response.data.message || 'Failed to send image');
            }
            
            // Small delay to ensure server processes with distinct timestamps
            if (i < selectedImages.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
          const updatedChat = {
            ...item,
            senderId: user.id,
            message: replyBody || '',
            previewMessage: replyBody || '',
            messageType: 'image',
            createdAt: new Date().toISOString(),
            count: selectedImages.length,
          };
          $crud.notify({
            type: "success",
            message: strings.reply_sent_successfully,
          });
          setImageSend({ pct: 100, index: selectedImages.length - 1, count: selectedImages.length });
          await finishMediaReply(item, () => {
            if (isTabSelect) setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
            else setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
          });
          setGroupSecret(null);
          return;
        } catch (error) {
          setImageSend(null);
          $crud.notify({
            type: "error",
            message: error.message || (strings.reply_failed),
          });
        }
        setSelectedImages([]);
        setReplyText('');
        setGroupSecret(null);
        return;
      }
      // 4. Video reply
      if (selectedVideo) {
        const jobId = videoJobRef.current;
        let uploadFile = selectedVideo;
        if (!selectedVideo.replyReady) {
          setVideoStage("processing");
          setVideoProgress(0);
          uploadFile = await compressChatVideo(selectedVideo, {
            onProgress: (pct) => {
              if (videoJobRef.current !== jobId) return;
              setVideoProgress(pct);
            },
          });
          uploadFile.replyReady = true;
          if (videoJobRef.current !== jobId) return;
          setSelectedVideo(uploadFile);
        }
        if (videoJobRef.current !== jobId) return;
        setVideoStage("uploading");
        setVideoProgress(0);
        const fileName = uploadFile.name || selectedVideo.name || `video_${Date.now()}.mp4`;
        const formData = new FormData();
        formData.append('id', item.id);
        formData.append('group', item.group.id);
        formData.append('isGroup', 'true');
        formData.append('message', replyBody || '');
        formData.append('messageType', 'video');
        formData.append('messageRequestId', uniID);
        formData.append('sender', user.id);
        formData.append('attachedFileName', fileName);
        formData.append('file', uploadFile, fileName);
        const response = await callAPI2(
          `/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`,
          {},
          'POST',
          formData,
          {
            timeout: 600000,
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            onUploadProgress: (evt) => {
              if (!evt.total || videoJobRef.current !== jobId) return;
              setVideoProgress(Math.min(100, Math.round((evt.loaded * 100) / evt.total)));
            },
          }
        );
        if (videoJobRef.current !== jobId) return;
        if (response.data.status) {
          $crud.notify({
            type: "success",
            message: strings.reply_sent_successfully,
          });
          setVideoProgress(100);
          const updatedChat = applyPreview({
            ...item,
            senderId: user.id,
            message: replyBody || '',
            previewMessage: replyBody || '',
            messageType: 'video',
            createdAt: new Date().toISOString(),
          });
          await finishMediaReply(item, () => {
            if (isTabSelect) setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
            else setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
          });
        } else {
          setVideoStage(null);
          setVideoProgress(0);
          $crud.notify({
            type: "error",
            message: response.data.message || (strings.reply_failed),
          });
        }
        return;
      }
      // 5. Audio reply
      if (recordedAudio) {
        const fileName = `audio_${Date.now()}.mp3`;
        const audioFile = new File([recordedAudio.blob], fileName, { type: 'audio/mp3' });
        const formData = new FormData();
        formData.append('id', item.id);
        formData.append('group', item.group.id);
        formData.append('isGroup', 'true');
        formData.append('message', replyBody || '');
        formData.append('messageType', 'audio');
        formData.append('messageRequestId', uniID);
        formData.append('sender', user.id);
        formData.append('attachedFileName', fileName);
        formData.append('file', audioFile);
        const response = await callAPI(`/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`, {}, 'POST', formData);
        if (response.data.status) {
          $crud.notify({
            type: "success",
            message: strings.reply_sent_successfully,
          });
          closeReplySection();
          scrollToTop();
          if (response.data.status) {
            if (isTabSelect) {
              const updatedChat = {
                ...item,
                senderId: user.id,
                message: replyBody || '',
                previewMessage: replyBody || '',
                messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
                createdAt: new Date().toISOString(),
              };
              setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
            } else {
              const updatedChat = {
                ...item,
                senderId: user.id,
                message: replyBody || '',
                previewMessage: replyBody || '',
                messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
                createdAt: new Date().toISOString(),
              };
              setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
            }
          }
        } else {
          $crud.notify({
            type: "error",
            message: response.data.message || (strings.reply_failed),
          });
        }
        removeAudio();
        setReplyText('');
        setGroupSecret(null);
        return;
      }
      // 5. Text reply
      if (!replyBody.trim()) return;
      const payload = {
        group: item.group.id,
        isGroup: true,
        message: groupSecret ? encryptMessage(replyBody, groupSecret) : replyBody,
        messageType: 'simple',
        sender: user.id,
        messageRequestId: uniID,
        inReplyTo: item.id,
        Rid: item.id,
        secretKey: groupSecret
      };
      const response = await callAPI(`/message/${item.group.isOneToOne ? item.id : item.mainId}/reply`, {}, 'POST', payload);
      if (response.data.status) {
        $crud.notify({
          type: "success",
          message: strings.reply_sent_successfully,
        });
        closeReplySection();
        scrollToTop();
        if (response.data.status) {
          if (isTabSelect) {
            const updatedChat = {
              ...item,
              senderId: user.id,
              message: replyBody || '',
              previewMessage: replyBody || '',
              messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
              createdAt: new Date().toISOString(),
            };
            setAllChats(prevChats => moveChatToTop(prevChats, updatedChat));
          } else {
            const updatedChat = {
              ...item,
              senderId: user.id,
              message: replyBody || '',
              previewMessage: replyBody || '',
              messageType: selectedImage ? 'image' : selectedDoc ? 'doc' : recordedAudio ? 'audio' : 'simple',
              createdAt: new Date().toISOString(),
            };
            setAllChatsReminders(prevChats => moveChatToTop(prevChats, updatedChat));
          }
        }
      } else {
        $crud.notify({
          type: "error",
          message: response.data.message || (strings.reply_failed),
        });
      }
      setReplyText('');
      setGroupSecret(null);
    } catch (error) {
      setVideoStage(null);
      setVideoProgress(0);
      setImageSend(null);
      setReplySent(false);
      $crud.notify({
        type: "error",
        message: strings.reply_failed_generic,
      });
    } finally {
      setReplyLoading(false);
    }
  };

  useEffect(() => {
    if (inActivity && !fetchingPage1Ref.current) {
      const hasVisibleChats =
        (allChatsRef.current && allChatsRef.current.length > 0) ||
        activityMessages.length > 0;
      // The screen is already on screen. Refresh in the background and leave
      // the open chat or email where it is.
      if (hasVisibleChats) {
        setIsTabSelect(true);
        _getMessages(1, true);
        return;
      }

      const hasPreOpenedChat = openChats && openChats.length > 0;
      // A chat the cockpit asked for is about to be opened; clearing the panes
      // on this cold start would wipe it before it ever renders.
      const keepPanes = !!store.getState().pendingChat;
      setGettingChats(true);
      dispatch({ type: RESET_MARKIN_PROJECT, status: true });
      if (!keepPanes) {
        updateGroupChats([]);
        if (!hasPreOpenedChat) {
          updateOpenChats([]);
        }
        updateOpenProjects([]);
      }
      setIsTabSelect(true);
      _getMessages(1, true);
    }
  }, [inActivity]);

  // The chat/email the cockpit navigated to: { kind: "chat"|"email", id }.
  // Its row is lifted to the very top of the list so the user lands on it
  // instead of hunting for it in date order. Released once another row is
  // opened or the screen is left.
  const [hoistedRow, setHoistedRow] = useState(null);

  const restoredWidePaneRef = useRef(false);
  useLayoutEffect(() => {
    if (!isLatestMessagesRoute) {
      restoredWidePaneRef.current = false;
      setHoistedRow(null);
      return;
    }
    if (exclusiveMessagesPane) return;
    if (restoredWidePaneRef.current) return;
    // The cockpit picked the chat to show; don't reopen the previous one first.
    if (store.getState().pendingChat) return;
    // Same for an email: its effect claims the pane below, but only after this
    // layout pass has already run on the arrival commit.
    if (store.getState().pendingEmail) return;
    if (
      (openChats && openChats.length > 0) ||
      (openProjects && openProjects.length > 0) ||
      selectedEmail
    ) {
      restoredWidePaneRef.current = true;
      return;
    }

    const saved = lastMessagesDetail;
    if (saved?.kind === "email" && saved.email) {
      restoredWidePaneRef.current = true;
      handleSelectEmail(saved.email);
      return;
    }

    const source = (allChatsRef.current && allChatsRef.current.length > 0)
      ? allChatsRef.current
      : (activityMessages || []);
    if (!source.length) return;

    const savedGroupId = saved?.kind === "group"
      ? (saved.clickedGroupId || saved.groupChat?.id || saved.project?.group?.id)
      : saved?.kind === "chat"
        ? saved.chat?.id
        : null;
    const row = (savedGroupId && source.find((chat) => String(chat.group?.id) === String(savedGroupId)))
      || source.find((chat) => chat.isOpened);
    if (!row || !row.group) {
      if (!saved) restoredWidePaneRef.current = true;
      return;
    }
    restoredWidePaneRef.current = true;
    if (isTeamsChat(row)) chat_click_teams(row);
    else if (row.group.isOneToOne) chat_click(row);
    else chat_click_group(row);
  }, [isLatestMessagesRoute, exclusiveMessagesPane, activityMessages, openChats, openProjects, selectedEmail]);

  useEffect(() => {
    if (isNewMessage) _changeLastMessage();
  }, [isNewMessage]);

  useEffect(() => {
    const messages = (activityMessages || []).filter((m) => !isArchivedChat(m));
    const target = openChats && openChats.length === 1 ? openChats[0] : null;
    const currentOpenChatId = target?.id;
    const currentOpenChatIdStr = currentOpenChatId ? String(currentOpenChatId) : null;
    const targetUserId = target?.replacementUserId;

    const matchesOpenChat = (msg) => {
      if (!currentOpenChatIdStr) return false;
      if (String(msg.group?.id) === currentOpenChatIdStr) return true;
      if (String(msg.id) === currentOpenChatIdStr || String(msg.mainId) === currentOpenChatIdStr) return true;
      if (targetUserId && msg.group?.isOneToOne) {
        if (msg.senderId === targetUserId) return true;
        if (msg.group?.users) {
          const otherUser = msg.group.users.find(u => (u.id || u) !== user?.id);
          if (otherUser && (otherUser.id || otherUser) === targetUserId) return true;
        }
      }
      return false;
    };

    setAllChats(prevChats => {
      const openedIds = new Set(prevChats.filter(c => c.isOpened).map(c => c.group?.id));
      if (currentOpenChatId) openedIds.add(currentOpenChatId);
      const synced = messages.map(msg => {
        const enriched = applyPreview(msg);
        const hasExplicitIsOpened = msg.hasOwnProperty('isOpened');
        let finalIsOpened;
        if (hasExplicitIsOpened) {
          finalIsOpened = msg.isOpened;
        } else if (currentOpenChatIdStr) {
          finalIsOpened = matchesOpenChat(msg);
        } else {
          finalIsOpened = openedIds.has(msg.group?.id);
        }
        return {
          ...enriched,
          isOpened: finalIsOpened,
          unseenChatCount: finalIsOpened && isLatestMessagesRoute ? 0 : (enriched.unseenChatCount || 0),
        };
      });
      return synced.length > 0 ? synced : prevChats;
    });
  }, [activityMessages, applyPreview, openChats, user?.id, isLatestMessagesRoute]);

  useEffect(() => {
    setAllChatsReminders(dedupeByMainId(excludeArchivedChats(activityMessagesReminders || [])));
  }, [activityMessagesReminders, dedupeByMainId]);

  // Sync block status from groups Redux state to activityMessages
  // This ensures the chat list updates instantly when block/unblock happens
  useEffect(() => {
    if (!groups || groups.length === 0) return;
    
    // Create a map of groupId -> isBlock status from Redux groups
    const blockStatusMap = new Map();
    groups.forEach(group => {
      const otherUser = group.users?.find(u => u.id !== user?.id);
      if (otherUser) {
        blockStatusMap.set(group.id, otherUser.isBlock || false);
      }
    });
    
    // Update AllChats with the latest block status
    setAllChats(prevChats => {
      let hasChanges = false;
      const updatedChats = prevChats.map(chat => {
        const groupId = chat.group?.id;
        if (!groupId || !blockStatusMap.has(groupId)) return chat;
        
        const newIsBlock = blockStatusMap.get(groupId);
        const otherUser = chat.group?.users?.find(u => u.id !== user?.id);
        const currentIsBlock = otherUser?.isBlock || false;
        
        if (currentIsBlock !== newIsBlock && chat.group?.users) {
          hasChanges = true;
          // Update the users array with new isBlock status (guard: users may be undefined)
          const users = chat.group?.users || [];
          const updatedUsers = users.map(u => {
            if (u.id !== user?.id) {
              return { ...u, isBlock: newIsBlock };
            }
            return u;
          });
          return {
            ...chat,
            group: { ...chat.group, users: updatedUsers }
          };
        }
        return chat;
      });
      
      return hasChanges ? updatedChats : prevChats;
    });
  }, [groups, user?.id]);

  // Memoize processed chat lists to avoid calling applyPreview on every render
  const processedChats = useMemo(() => {
    const seen = new Set();
    const list = AllChats.filter((item) => {
      if (isArchivedChat(item)) return false;
      // The Kjuup Pilot chat was removed; a payload row that still marks one gets no row.
      if (isPilotChat(item)) return false;
      if (hideTeamsPref && isTeamsChat(item)) return false;
      const groupId = item?.group?.id;
      if (!groupId) return true;
      if (seen.has(groupId)) return false;
      seen.add(groupId);
      return true;
    }).map(applyPreview);
    list.sort((a, b) => getListSortDate(b) - getListSortDate(a));
    return list;
  }, [AllChats, applyPreview, getListSortDate, hideTeamsPref]);

  // Live "typing…" lines and online dots of the listed chats (socket.onAny,
  // mobile proChatLive): presence only for the people the list shows.
  const chatPartnerKey = useMemo(() => {
    const meId = user ? user.id : null;
    const ids = new Set();
    (processedChats || []).forEach((c) => {
      const id = partnerIdOf(c, meId);
      if (id) ids.add(id);
    });
    return [...ids].sort().join(",");
  }, [processedChats, user]);
  useChatListSocket({ socket, onRoute: isLatestMessagesRoute, chatView: isTabSelect, user, partnerKey: chatPartnerKey });

  const chatListPrefetchDoneRef = useRef(false);
  useEffect(() => {
    if (!processedChats?.length) {
      chatListPrefetchDoneRef.current = false;
      return;
    }
    if (chatListPrefetchDoneRef.current) return;
    chatListPrefetchDoneRef.current = true;
    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0];
    prefetchChatList(processedChats, { userId: user?.id, translationLang: lang, limit: 8 });
  }, [processedChats, language, user?.id]);

  const processedReminders = useMemo(() => {
    const seen = new Set();
    return AllChatsReminder.filter((item) => {
      if (isArchivedChat(item)) return false;
      const groupId = item?.group?.id;
      if (!groupId) return true;
      if (seen.has(groupId)) return false;
      seen.add(groupId);
      return true;
    }).map(applyPreview);
  }, [AllChatsReminder, applyPreview]);

  // Hold the Alle list skeleton until page-1 emails are ready so chats don't flash alone —
  // but not for long once the chats are there: a slow mailbox kept the whole list blank.
  const [emailGateExpired, setEmailGateExpired] = useState(false);
  useEffect(() => {
    if (!mergeEmailsIntoLatestList || emailInitialReady || showSkeleton || emailGateExpired) return undefined;
    const timer = setTimeout(() => setEmailGateExpired(true), 1200);
    return () => clearTimeout(timer);
  }, [mergeEmailsIntoLatestList, emailInitialReady, showSkeleton, emailGateExpired]);
  const awaitingCombinedEmails = mergeEmailsIntoLatestList && !emailInitialReady && !emailGateExpired;
  const messagesListSkeletonVisible = showSkeleton || awaitingCombinedEmails;
  const showMessagesListSkeleton = isLoading || messagesListSkeletonVisible;

  const processedChatsWithEmails = useMemo(() => {
    // Reports mode: no inbox rows in the combined list. Daily reports are
    // never merged here (they are shown on the cockpit only).
    let feedEmails = hideEmailClientPref
      ? []
      : (inboxFeedEmails || []).filter(isCombinedFeedEmail).filter((em) => !isAllScopeReport(em));
    // The email opened from outside the list (task source, cockpit, search) gets
    // its row at once, not only after the inbox list has taken it in.
    if (
      !hideEmailClientPref
      && hoistedRow
      && selectedEmail
      && isCombinedFeedEmail(selectedEmail)
      && matchesHoistedRow({ _isEmail: true, _emailData: selectedEmail }, hoistedRow)
      && !feedEmails.some((em) => emailEntriesShareId(em, selectedEmail))
    ) {
      feedEmails = [selectedEmail, ...feedEmails];
    }
    if (!mergeEmailsIntoLatestList || feedEmails.length === 0) {
      // Chats hidden: only email rows may remain (none here) -> empty list.
      return hideChatsPref ? [] : processedChats;
    }
    const emailItems = feedEmails.map((em) => ({
      _isEmail: true,
      _isReport: false,
      _emailData: em,
      _emailSortDate: new Date(em.date || em.receivedAt || 0).getTime(),
    }));
    const chatItems = hideChatsPref
      ? []
      : processedChats.map((chat) => ({
          ...chat,
          _isEmail: false,
          _isReport: false,
          // Pinned My Space uses an infinite sort key so it stays above chats
          // and emails. Reaction timestamps still win among unpinned chats.
          _emailSortDate: getListSortDate(chat),
        }));
    const merged = [...chatItems, ...emailItems];
    merged.sort((a, b) => b._emailSortDate - a._emailSortDate);
    return merged;
  }, [mergeEmailsIntoLatestList, processedChats, inboxFeedEmails, getListSortDate, hideChatsPref, hideEmailClientPref, hoistedRow, selectedEmail]);

  // Rooms > Intern: with more than one Kjuup+ company the room chats of one
  // company show (mobile ProCompanyFilter without "All").
  const roomCompanies = useMemo(
    () => (reduxInternalProjects || []).filter((c) => c && c.id != null && !c.isLeave),
    [reduxInternalProjects]
  );
  const roomCompany = pickRoomCompany({
    scope: chatScope,
    sub: groupScopeFilter,
    companies: roomCompanies,
    picked: roomCompanyId,
    appCompanyId: selectedCompanyId,
  });
  const roomCompanyFilterId = rowIdOf(roomCompany);

  const filteredChatsWithEmails = useMemo(() => {
    let list = processedChatsWithEmails;
    if (messageFilter !== "all") {
      const roomsScope = chatScope === "rooms";
      list = list.filter((item) => {
        if (messageFilter === "email") return !!item._isEmail && !item._isReport;
        if (item._isEmail) return false;
        if (messageFilter === "direct") return isDirectChatRow(item);
        if (messageFilter === "teams") return isTeamsChat(item);
        if (messageFilter === "groups") {
          if (isDirectChatRow(item)) return false;
          // Rooms = a room's own chat, Groups = the groups inside rooms.
          if (roomsScope !== !!item.defaultChatGroup) return false;
          if (groupScopeFilter === "internal") {
            if (!item.isInternal) return false;
            return roomCompanyFilterId == null || String(item.companyId) === String(roomCompanyFilterId);
          }
          if (groupScopeFilter === "external") return !item.isInternal;
          return true;
        }
        return true;
      });
    }
    if (showUnreadOnly) {
      list = list.filter((item) => {
        if (item._isEmail) {
          const em = item._emailData;
          if (!em) return false;
          // Keep the open email in the unread list until the user leaves it,
          // even after mark-as-read flips `isRead` (opening marks it read).
          if (selectedEmail && emailEntriesShareId(em, selectedEmail)) return true;
          return em.isRead === false;
        }
        // Same sticky rule for chats (My Space included): stay visible while
        // opened after the unread badge clears on open.
        return (item.unseenChatCount || 0) > 0 || !!item.isOpened;
      });
    }
    // Recency order on every chip, as on mobile (no unread-first ordering).
    // The hoisted row outranks it, but never the pinned My Space: it goes right below.
    if (hoistedRow) {
      const at = list.findIndex((item) => matchesHoistedRow(item, hoistedRow));
      let top = 0;
      while (
        top < at
        && !list[top]._isEmail
        && isSelfChatGroup(list[top])
        && isMySpaceRowPinned(list[top])
      ) top += 1;
      if (at > top) list = [...list.slice(0, top), list[at], ...list.slice(top, at), ...list.slice(at + 1)];
    }
    return list;
  }, [processedChatsWithEmails, messageFilter, groupScopeFilter, chatScope, roomCompanyFilterId, showUnreadOnly, selectedEmail, hoistedRow, isMySpaceRowPinned]);

  // When the "Unread only" toggle is active, the full-email-section inbox
  // (rendered via <EmailInbox/>) should also hide read messages. Filtering
  // client-side is intentionally page-scoped — the user keeps scrolling to
  // load more pages and any unread among them remains visible. The badge
  // (`unseenEmailCount`) shows the global INBOX unread total independently.
  // The currently selected email is kept visible until deselected so opening
  // it (which marks it read) doesn't remove the row from under the user.
  const emailMessagesForView = useMemo(() => {
    if (!showUnreadOnly) return emailMessages;
    return emailMessages.filter((m) => {
      if (!m) return false;
      if (selectedEmail && emailEntriesShareId(m, selectedEmail)) return true;
      return m.isRead === false;
    });
  }, [emailMessages, showUnreadOnly, selectedEmail]);

  // --- Multi-select for e-mails in the combined (messages + e-mail) list ---
  // Lets the user batch mark-as-read / delete e-mails straight from the "All"
  // and "E-Mail" tabs, mirroring the dedicated E-Mail section's select mode.
  const [emailSelectMode, setEmailSelectMode] = useState(false);
  const [selectedEmailIds, setSelectedEmailIds] = useState(() => new Set());
  // "Move to" choice of the mail selection bar.
  const [selMoveOpen, setSelMoveOpen] = useState(false);
  const selMoveRef = useRef(null);
  useEffect(() => {
    if (!selMoveOpen) return undefined;
    const onDown = (e) => {
      if (selMoveRef.current && !selMoveRef.current.contains(e.target)) setSelMoveOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [selMoveOpen]);
  useEffect(() => {
    if (!emailSelectMode) setSelMoveOpen(false);
  }, [emailSelectMode]);

  // Ids of the e-mails currently visible in the combined list (respects the
  // active filter + unread toggle) — the basis for the "select all" action.
  const visibleEmailIds = useMemo(() => {
    const ids = [];
    (filteredChatsWithEmails || []).forEach((item) => {
      if (!item || !item._isEmail) return;
      const em = item._emailData || {};
      const id = em.id || em._id || em.providerMessageId;
      if (id) ids.push(id);
    });
    return ids;
  }, [filteredChatsWithEmails]);

  const exitEmailSelectMode = useCallback(() => {
    setEmailSelectMode(false);
    setSelectedEmailIds(new Set());
  }, []);

  const toggleEmailSelectId = useCallback((id) => {
    if (id == null) return;
    setSelectedEmailIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  // True while "select all" is fetching the full id set from the server.
  const [selectAllBusy, setSelectAllBusy] = useState(false);

  // Fetch the ids of EVERY e-mail matching the current combined view
  // (folder + unread toggle + account scope), not just the loaded first
  // page(s). Used by "select all" so batch actions cover all unread e-mails
  // even when there are more than one page. Falls back to the loaded rows for
  // folders that aren't served by the paginated /email/messages endpoint.
  const fetchAllSelectableEmailIds = useCallback(async () => {
    const folder = activeEmailFolder || "INBOX";
    const PAGINATED = ["INBOX", "STARRED", "ARCHIVE"];
    if (folder && !PAGINATED.includes(folder)) return visibleEmailIds;

    const unreadOnlyQuery = showUnreadOnly ? "&unreadOnly=true" : "";
    const folderQuery = folder && folder !== "INBOX" ? `&folder=${encodeURIComponent(folder)}` : "";
    const LIMIT = 500;

    const accountIds =
      activeEmailAccountId === ALL_ACCOUNTS_ID
        ? (emailAccounts || []).map((a) => a.id || a._id).filter(Boolean)
        : [activeEmailAccountId].filter(Boolean);
    if (accountIds.length === 0) return visibleEmailIds;

    const extractMessages = (data) => {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.messages)) return data.messages;
      if (Array.isArray(data?.emails)) return data.emails;
      if (Array.isArray(data?.data)) return data.data;
      if (Array.isArray(data?.data?.messages)) return data.data.messages;
      if (Array.isArray(data?.results)) return data.results;
      return [];
    };

    const ids = new Set();
    await Promise.all(
      accountIds.map(async (acctId) => {
        try {
          // Page with a large limit; loop guarded so an unexpectedly huge
          // mailbox can't spin forever.
          for (let page = 1; page <= 20; page++) {
            const url = `/email/messages?accountId=${acctId}&page=${page}&limit=${LIMIT}${folderQuery}${unreadOnlyQuery}`;
            const { data } = await callAPI(url, {}, "GET");
            const msgs = extractMessages(data);
            msgs.forEach((m) => {
              const id = m.id || m._id || m.providerMessageId;
              if (id) ids.add(id);
            });
            if (msgs.length < LIMIT) break;
          }
        } catch (e) {
          // Ignore a single account's failure; keep whatever we gathered.
        }
      })
    );

    // Safety net: always include rows already loaded on screen.
    visibleEmailIds.forEach((id) => ids.add(id));
    return [...ids];
  }, [activeEmailFolder, showUnreadOnly, activeEmailAccountId, emailAccounts, visibleEmailIds]);

  const toggleSelectAllEmails = useCallback(async () => {
    // Already (at least) everything-visible selected → clear the selection.
    if (visibleEmailIds.length > 0 && selectedEmailIds.size >= visibleEmailIds.length) {
      setSelectedEmailIds(new Set());
      return;
    }
    // Otherwise select every matching e-mail across all pages, not just the
    // loaded first page.
    setSelectAllBusy(true);
    try {
      const ids = await fetchAllSelectableEmailIds();
      setSelectedEmailIds(new Set(ids.length ? ids : visibleEmailIds));
    } finally {
      setSelectAllBusy(false);
    }
  }, [visibleEmailIds, selectedEmailIds, fetchAllSelectableEmailIds]);

  const filterUnseenCounts = useMemo(() => {
    // Prefer `/badge/count` (`unSeenAllCount`) so unread chats on later
    // pages still contribute. Floor each bucket with the loaded list so a
    // stale/optimistic global 0 cannot hide badges while rows still show
    // unread (the sidebar has the same floor). Once every page is loaded,
    // trust the list: a leftover server 1 must not keep the last badge
    // after the user has already opened/read everything on screen.
    const direct = Number(unSeenAllCount?.unseenChatCount) || 0;
    const internal = Number(unSeenAllCount?.unseenInternalProject) || 0;
    const external = Number(unSeenAllCount?.unseenExternalProject) || 0;
    let listDirect = 0;
    let listInternal = 0;
    let listExternal = 0;
    (AllChats || []).forEach((item) => {
      if (!item || item._isEmail) return;
      // Open chats are already being read — don't keep filter-tab badges
      // alive from the row while subscribe /badge/count is still in flight.
      const cnt = item.isOpened ? 0 : (Number(item.unseenChatCount) || 0);
      if (cnt <= 0) return;
      if (isDirectChatRow(item)) listDirect += cnt;
      else if (item.isInternal) listInternal += cnt;
      else listExternal += cnt;
    });
    const chatsLoaded = isChatsOver && (AllChats || []).length > 0;
    const d = chatsLoaded ? listDirect : Math.max(direct, listDirect);
    const i = chatsLoaded ? listInternal : Math.max(internal, listInternal);
    const e = chatsLoaded ? listExternal : Math.max(external, listExternal);
    // After trial end / cancel, emails are removed from Alle — don't inflate counts.
    // Exclude the open email (opening marks it read) so the last E-Mail /
    // Nachrichten badge drops on click instead of waiting for a reload.
    const emailRows = (inboxFeedEmails && inboxFeedEmails.length)
      ? inboxFeedEmails
      : (isInboxFeedFolder(activeEmailFolder) ? (emailMessages || []) : []);
    let listEmail = 0;
    emailRows.forEach((em) => {
      if (!em || isDailyBriefingEmail(em) || isAllScopeReport(em)) return;
      if (selectedEmail && emailEntriesShareId(em, selectedEmail)) return;
      if (em.isRead === true || em.isRead === 1 || em.isRead === "1") return;
      listEmail += 1;
    });
    const emailServer = mergeEmailsIntoLatestList ? (unseenEmailCount || 0) : 0;
    const emailsLoaded = isEmailsOver && emailRows.length > 0;
    const email = mergeEmailsIntoLatestList
      ? (emailsLoaded ? listEmail : Math.max(emailServer, listEmail))
      : 0;
    // Daily reports are not part of Nachrichten (cockpit only) -> no bucket.
    return {
      all: d + i + e + email,
      email,
      groups: i + e,
      direct: d,
      internal: i,
      external: e,
    };
  }, [
    unSeenAllCount?.unseenChatCount,
    unSeenAllCount?.unseenInternalProject,
    unSeenAllCount?.unseenExternalProject,
    unseenEmailCount,
    mergeEmailsIntoLatestList,
    AllChats,
    selectedEmail,
    inboxFeedEmails,
    emailMessages,
    activeEmailFolder,
    isEmailsOver,
    isChatsOver,
  ]);

  // The Unread chip counts chats with unread messages (mobile): the listed
  // chats by their own counts plus the /badge/count `chat` entries (non-muted
  // chats with unread messages) not listed yet, and the unread inbox mails.
  // The chip stays visible at 0, so the filter never needs switching off here.
  const badgeUnreadChats = badgeChatsOf(unSeenAllCount);
  const unreadEmailCount = filterUnseenCounts.email;
  const unreadChatCount = useMemo(
    () => countUnreadChats(processedChats, badgeUnreadChats) + (mergeEmailsIntoLatestList && !hideEmailClientPref ? unreadEmailCount : 0),
    [processedChats, badgeUnreadChats, mergeEmailsIntoLatestList, hideEmailClientPref, unreadEmailCount]
  );
  // Rooms / Groups / Direct (and their Intern / Extern sub-chips) count their
  // unread chats by the same rule, so they add up to the Unread chip.
  const chipUnread = useMemo(() => unreadChatsByChip(processedChats), [processedChats]);
  // The Teams chip only shows while Microsoft Teams chats are in the list.
  const hasTeamsChats = useMemo(() => (processedChats || []).some((chat) => isTeamsChat(chat)), [processedChats]);

  // Rooms > Oversight (mobile KM-1379 #8c): for a viewer who manages company
  // rooms, the company's room list replaces the room chats.
  useEffect(() => {
    if (!loginToken) return undefined;
    let alive = true;
    fetchMyCompanies(loginToken)
      .then((list) => {
        if (alive && list) setMyCompanies(list);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [loginToken]);
  const adminCompanies = useMemo(() => (myCompanies || []).filter(managesCompanyRooms), [myCompanies]);
  const oversight = resolveOversight({
    activeFilter: activeFilterUI,
    scope: chatScope,
    sub: groupScopeFilter,
    unreadOnly: showUnreadOnly,
    companies: adminCompanies,
    picked: oversightCompanyId,
    appCompanyId: selectedCompanyId,
  });
  const oversightOn = oversight.on;
  const oversightCompany = oversight.company;
  const oversightCompanyKey = oversight.key;

  // An oversight room only stays open while its list is on screen here.
  useEffect(() => {
    if (!isLatestMessagesRoute || !oversightRoom) return;
    if (oversightCompanyKey == null || String(oversightRoom.companyId) !== oversightCompanyKey) {
      dispatch({ type: SET_OVERSIGHT_ROOM, payload: null });
    }
  }, [isLatestMessagesRoute, oversightRoom, oversightCompanyKey, dispatch]);

  // Closing the oversight room on a narrow screen brings the list back.
  const prevOversightRoomRef = useRef(oversightRoom);
  useEffect(() => {
    const had = prevOversightRoomRef.current;
    prevOversightRoomRef.current = oversightRoom;
    if (!had || oversightRoom || !isLatestMessagesRoute || !exclusiveMessagesPane) return;
    if (store.getState().openLatestMsgToggle) return;
    const live = store.getState();
    if ((live.openChats || []).length || (live.openProjects || []).length) return;
    dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
  }, [oversightRoom, isLatestMessagesRoute, exclusiveMessagesPane, dispatch]);

  // Legacy hook retained for safety; direct calls now used
  useEffect(() => {
    if (shouldGet) {
      getReminders(shouldGet);
      setShouldGet(false);
    }
  }, [shouldGet]);

  // Add useEffect to track gettingChatsBottom state changes

  const mergeConsecutiveImages = useCallback((sections) => {
    if (!sections || sections.length === 0) return [];
    
    // Create a shallow copy to avoid mutating the original array
    const reversedSections = [...sections].reverse();
    
    let updatedItems = reversedSections.reduce((result, current) => {
      if (!current?.isMultiples) {
        const last = result[result?.length - 1];
        if (current?.messageType === "image") {
          if (last?.messageType === "image") {
            const lastImageTime = new Date(
              last.images[last.images.length - 1].createdAt
            ).getTime();
            const currentTime = new Date(current.createdAt).getTime();
            if (
              last.senderId === current.senderId &&
              last.message === current.message &&
              isSameMediaSend(last, current, lastImageTime, currentTime)
            ) {
              last.isMultiples = true;
              last.images.push({ ...current });
              last.count = last.images.length;
            } else {
              result.push({ ...current, images: [{ ...current }], count: 1 });
            }
          } else {
            result.push({ ...current, images: [{ ...current }], count: 1 });
          }
        } else {
          result.push({ ...current });
        }
      } else {
        result.push({ ...current });
      }
      return result;
    }, []);
    return updatedItems.reverse();
  }, []);

  const _changeLastMessage = () => {
    if (!isNewMessage) return;
    
    const isExist = isNewMessage.unseenChatCount?.findIndex((e) => e.userId === user.id);
    if (isExist === -1) {
      dispatch({ type: IS_NEW_MESSAGE, status: false });
      return;
    }

    // Get current chats from Redux (source of truth)
    let chats = [...(activityMessages || [])];
    const groupId = isNewMessage.group?.id;
    const existingChat = chats.find(chat => String(chat.group?.id) === String(groupId));
    const isCurrentlyOpened = chats.some(chat => chat.isOpened && String(chat.group?.id) === String(groupId));
    // Off /messages the open chat is not being read (it leaves the socket
    // room), so it keeps counting until the user comes back.
    const isBeingRead = isCurrentlyOpened && isLatestMessagesRoute;

    // Microsoft Teams: the server's own count (0 for the owner's own sends), not +1.
    const teamsUnseen = teamsLatestUnseen(isNewMessage, user?.id);

    // Create updated message object, merging existing group state so that
    // properties the socket payload doesn't carry (e.g. isMute) are preserved.
    const latestMessage = {
      ...isNewMessage,
      mainId: isNewMessage.id,
      unseenChatCount: isBeingRead
        ? 0
        : teamsUnseen != null
          ? teamsUnseen
          : (existingChat ? (existingChat.unseenChatCount || 0) + 1 : 1),
      isOpened: isCurrentlyOpened,
      group: existingChat?.group
        ? {
            ...existingChat.group,
            ...isNewMessage.group,
            isPinned: existingChat.group.isPinned,
            isMute: existingChat.group.isMute,
          }
        : isNewMessage.group,
    };
    // Microsoft Teams: keep the row's display name, write flag and hidden actions (not in latestMsg).
    const updatedMessage = existingChat ? mergeTeamsLatestMsg(existingChat, latestMessage) : latestMessage;
    rememberTeamsChats(updatedMessage);

    // Remove ALL entries for this group (not just the first), then add updated one
    chats = chats.filter(chat => chat.group?.id !== groupId);
    chats.unshift(updatedMessage);

    // Sort by most recent first
    chats.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    // Apply preview and image merging
    const processedChats = mergeConsecutiveImages(chats).map(applyPreview);

    // Update Redux
    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: processedChats });
    dispatch({ type: IS_NEW_MESSAGE, status: false });
  };

  const _getMessages = async (page, isBackgroundRefresh = false) => {
    const fetchEpoch = unreadListEpochRef.current;
    const fetchWhileUnread = showUnreadOnlyRef.current;
    const unreadScanStale = () => fetchWhileUnread && unreadListEpochRef.current !== fetchEpoch;
    if (page === 1 && fetchingPage1Ref.current) {
      return;
    }
    if (page === 1) {
      fetchingPage1Ref.current = true;
    }
    // Set loading states only for first page load when no cached data exists
    const showLoadingUI = page === 1 && AllChats.length === 0 && !isBackgroundRefresh;
    if (showLoadingUI) {
      setIsLoading(true);
      setIsContentReady(false);
      setShowSkeleton(true);
    }
    try {
      const { data } = await callAPI(
        `/group/getUserChats?page=${page}&limit=15${translationLangParam()}`,
        {},
        "GET"
      );
      if (unreadScanStale()) {
        setGettingChats(false);
        setGettingChatsBottom(false);
        setIsPaginationTriggered(false);
        return;
      }
      if (data.status) {
        if (data?.chats?.length > 0) {
          data.chats = data?.chats?.map((e) => {
            // Clear preview/message if last message is deleted
            const chatData = mapUserChatRow(e);
            
            // If last message is deleted, ALWAYS clear the preview/message fields immediately
            // This prevents showing deleted message content in preview
            // We will fetch the previous message separately if needed
            if (chatData.lastMessageDeleted) {
              chatData.previewMessage = "";
              chatData.message = "";
              chatData.originalMessage = "";
              chatData._hasPreviousMessage = false; // Reset flag
            }
            return chatData;
          });
          data.chats = excludeArchivedChats(data.chats);
          if (page === 1) {
            data.chats = await ensureMySpaceInList(data.chats);
          }
          // Sync bookmarked group IDs from backend (replace with server truth so deleted bookmarks are cleared)
          const serverBookmarked = new Set();
          for (const chat of data.chats) {
            if (chat.group?.isTodoBookmarked) serverBookmarked.add(chat.group.id);
          }
          if (page === 1) {
            setBookmarkedGroupIds(serverBookmarked);
            const selfChatRow = data.chats.find((c) => c.group?.isSelfChat || isSelfChatGroup(c));
            if (selfChatRow && isSelfChatGroup(selfChatRow)) {
              if (Date.now() - mySpacePinToggledAtRef.current > 5000) {
                const serverPinned = isRowPinned(selfChatRow);
                setIsMySpacePinned(serverPinned);
                writeMySpacePinned(user?.id, serverPinned);
              }
            }
          } else {
            setBookmarkedGroupIds(prev => {
              const merged = new Set(prev);
              serverBookmarked.forEach(id => merged.add(id));
              return merged;
            });
          }

          // Use the freshest rendered list (not the possibly-stale closure
          // value): a quick-reaction reorder may have landed while this request
          // was in flight, and we must not merge the chat back to its old slot.
          const freshAllChats = allChatsRef.current && allChatsRef.current.length > 0 ? allChatsRef.current : AllChats;
          // Prefer live Redux over the request-start closure so a chat opened
          // while this fetch was in flight keeps unseenChatCount at 0.
          const liveState = store.getState();
          const liveActivity = liveState.activityMessages || activityMessages;
          const hasLocalChats = freshAllChats.length > 0;
          const hasReduxChats = liveActivity.length > 0;
          
          if (hasLocalChats || hasReduxChats) {
            let tt = data.chats;
            const openedIds = new Set([
              ...freshAllChats.filter((e) => e.isOpened).map((e) => String(e.group?.id)),
              ...liveActivity.filter((e) => e.isOpened).map((e) => String(e.group?.id)),
              ...(liveState.groupChats || []).filter((e) => e.isOpened).map((e) => String(e.id)),
              ...(liveState.openChats || []).map((e) => String(e.id || e.key)).filter((id) => id && id !== "undefined"),
            ]);
            
            const beingRead = isLatestMessagesRouteRef.current;
            tt = tt.map((e) => {
              const opened = openedIds.has(String(e.group?.id));
              return { ...e, isOpened: opened, unseenChatCount: opened && beingRead ? 0 : e.unseenChatCount };
            });
            // Merge with existing chats (prefer freshest local order, fallback to Redux)
            const existingChats = hasLocalChats ? freshAllChats : liveActivity;
            const existingIds = new Set(existingChats.map((chat) => chat.group?.id).filter(Boolean));
            const freshOnly = tt.filter((chat) => chat.group?.id && !existingIds.has(chat.group.id));
            
            // Deduplicate by group.id, preserving entries with isOpened: true.
            // Chats that were not in the list yet stay at the top, in server order.
            const seenGroupIds = new Map();
            const allChats = [...freshOnly, ...existingChats, ...tt];
            allChats.forEach((chat) => {
              const groupId = chat.group?.id;
              if (!groupId) return;
              const existing = seenGroupIds.get(groupId);
              // Keep the version with isOpened: true, or the first one if neither is opened
              if (!existing || (chat.isOpened && !existing.isOpened)) {
                seenGroupIds.set(groupId, chat);
              }
            });
            // Build merged array: start with opened chats, then rest in order
            const dedupedChats = [];
            const addedIds = new Set();
            [...freshOnly, ...existingChats, ...tt].forEach((chat) => {
              const groupId = chat.group?.id;
              if (groupId && !addedIds.has(groupId)) {
                addedIds.add(groupId);
                dedupedChats.push(seenGroupIds.get(groupId));
              } else if (!groupId) {
                dedupedChats.push(chat);
              }
            });
            const _m = dedupedChats;
            const mergedChats = mergeConsecutiveImages(_m) || [];
            // Process chats with deleted messages to fetch last non-deleted message
            const processedChatsWithPreview = await Promise.all(
              mergedChats.map(async (chat) => {
                if (chat?.lastMessageDeleted) {
                  // Ensure deleted message content is cleared (should already be cleared, but double-check)
                  const clearedChat = {
                    ...chat,
                    previewMessage: "",
                    message: "",
                    originalMessage: "",
                    lastMessageDeleted: true,
                  };
                  
                  const lastNonDeleted = await fetchLastNonDeletedMessage(clearedChat);
                  if (lastNonDeleted) {
                    return {
                      ...clearedChat,
                      ...lastNonDeleted,
                      lastMessageDeleted: false,
                      _hasPreviousMessage: true,
                    };
                  }
                  // If no previous message found, return with cleared fields
                  return clearedChat;
                }
                return chat;
              })
            );
            // Apply preview - this will preserve cleared fields for deleted messages
            const newData = processedChatsWithPreview.map(applyPreview);
            if (newData) {
              dispatch({ type: SET_ACTIVITY_MESSAGES, messages: newData });
              dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: Date.now() });
            }
            // Short delay for smooth transition, then hide loader
            setTimeout(() => {
              setGettingChats(false);
              setGettingChatsBottom(false);
              setIsPaginationTriggered(false);
            }, 150);
          } else {
            // Deduplicate by group.id before processing (keep first occurrence = most recent)
            const seenGroupIds = new Set();
            const dedupedApiChats = (data?.chats || []).filter((chat) => {
              const gid = chat.group?.id;
              if (!gid) return true;
              if (seenGroupIds.has(gid)) return false;
              seenGroupIds.add(gid);
              return true;
            });
            const processedChats = mergeConsecutiveImages(dedupedApiChats) || [];
        // Process chats with deleted messages to fetch last non-deleted message
        const processedChatsWithPreview = await Promise.all(
          processedChats.map(async (chat) => {
            if (chat?.lastMessageDeleted) {
              // Ensure deleted message content is cleared (should already be cleared, but double-check)
              const clearedChat = {
                ...chat,
                previewMessage: "",
                message: "",
                originalMessage: "",
                lastMessageDeleted: true,
              };
              
              const lastNonDeleted = await fetchLastNonDeletedMessage(clearedChat);
              if (lastNonDeleted) {
                return {
                  ...clearedChat,
                  ...lastNonDeleted,
                  lastMessageDeleted: false,
                  _hasPreviousMessage: true,
                };
              }
              // If no previous message found, return with cleared fields
              return clearedChat;
            }
            return chat;
          })
        );
        // Apply preview - this will preserve cleared fields for deleted messages
        const newData = processedChatsWithPreview.map(applyPreview);
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: newData });
        dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: Date.now() });
            setGettingChats(false);
            // Handle loading states for first page (only if we showed loading UI)
            if (showLoadingUI) {
              setIsLoading(false);
              requestAnimationFrame(() => {
                setShowSkeleton(false);
                requestAnimationFrame(() => {
                  setIsContentReady(true);
                });
              });
            }
          }
        }
        else {
          if (page === 1) {
            const recovered = await ensureMySpaceInList([]);
            if (recovered.length > 0) {
              dispatch({ type: SET_ACTIVITY_MESSAGES, messages: recovered.map(applyPreview) });
              dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: Date.now() });
            }
          }
          setIsChatsOver(true);
          setGettingChats(false);
          setGettingChatsBottom(false);
          setIsPaginationTriggered(false);
          // Handle loading states when no chats (only if we showed loading UI)
          if (showLoadingUI) {
            setIsLoading(false);
            requestAnimationFrame(() => {
              setShowSkeleton(false);
              requestAnimationFrame(() => {
                setIsContentReady(true);
              });
            });
          }
        }
      } else {
        setGettingChats(false);
        setGettingChatsBottom(false);
        setIsPaginationTriggered(false);
        // Handle loading states on error (only if we showed loading UI)
        if (showLoadingUI) {
          setIsLoading(false);
          requestAnimationFrame(() => {
            setShowSkeleton(false);
            requestAnimationFrame(() => {
              setIsContentReady(true);
            });
          });
        }
      }
    } catch (error) {
      setGettingChats(false);
      setGettingChatsBottom(false);
      setIsPaginationTriggered(false);
      // Handle loading states on error (only if we showed loading UI)
      if (showLoadingUI) {
        setIsLoading(false);
        requestAnimationFrame(() => {
          setShowSkeleton(false);
          requestAnimationFrame(() => {
            setIsContentReady(true);
          });
        });
      }
    } finally {
      if (page === 1) {
        fetchingPage1Ref.current = false;
        // Always clear the list overlay after a page-1 fetch. The merge-with-
        // existing-chats branch used to omit this, which left the spinner stuck
        // when navigating back to /messages with cached AllChats.
        setGettingChats(false);
      }
    }
  };

  // Auto-load additional pages when either:
  //   (a) a non-"all" filter (Direct/Group Chats) shows too few items
  //       to make the scroll container scrollable — without this, scroll
  //       pagination can't fire on those filter tabs until the user first
  //       scrolls on the "All" tab; or
  //   (b) the "Unread only" toggle is active — chats are returned by the BE
  //       in recency order with no `unreadOnly` filter, so the unread items
  //       (bounded by `unseenChatCount + unseenInternalProject +
  //       unseenExternalProject`) can be spread across many pages. Keep
  //       paginating until we've surfaced them all or the BE reports no
  //       more chats (isChatsOver becomes true).
  useEffect(() => {
    if (!isTabSelect) return;
    if (emailTabActive) return;
    if (gettingChats || gettingChatsBottom || isPaginationTriggered) return;
    if (isChatsOver) return;
    // Wait until the initial page has actually loaded before auto-paginating
    if (AllChats.length === 0) return;

    let shouldLoadMore = false;
    if (showUnreadOnly) {
      // The BE returns chats in recency order with no `unreadOnly` filter, so
      // unread chats can be scattered across many pages. Keep paginating until
      // the BE reports there are no more chats (`isChatsOver`, checked in the
      // guard above). We deliberately do NOT stop early by comparing loaded
      // unread rows against the /badge/count counters: those counters can
      // undercount (stale/cached), which used to leave later-page unread chats
      // hidden until the user toggled the "Unread only" button off and on
      // again. Loading through to exhaustion guarantees every pending unread
      // chat is surfaced, and also means deleting a visible unread chat never
      // leaves later-page unreads stranded (they are already loaded).
      shouldLoadMore = true;
      // Safety cap purely to guard against a pathological loop if the BE never
      // reports it is out of chats. The real stop condition is `isChatsOver`.
      if (page >= 100) {
        shouldLoadMore = false;
      }
    } else if (messageFilter !== "all" && messageFilter !== "email" && messageFilter !== "teams") {
      // Not for Teams: most users have only a few Teams chats, so the tab would
      // page through every chat (skeleton rows each time) without reaching 15.
      // It shows the Teams chats of the pages already loaded.
      const FILTER_AUTOLOAD_TARGET = 15;
      shouldLoadMore = filteredChatsWithEmails.length < FILTER_AUTOLOAD_TARGET;
    }

    if (!shouldLoadMore) return;

    const newPage = page + 1;
    setPage(newPage);
    setGettingChatsBottom(true);
    setIsPaginationTriggered(true);
    _getMessages(newPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    messageFilter,
    groupScopeFilter,
    showUnreadOnly,
    unSeenAllCount?.unseenChatCount,
    unSeenAllCount?.unseenInternalProject,
    unSeenAllCount?.unseenExternalProject,
    filteredChatsWithEmails.length,
    AllChats.length,
    isTabSelect,
    emailTabActive,
    gettingChats,
    gettingChatsBottom,
    isPaginationTriggered,
    isChatsOver,
    page,
  ]);

  const _getMessagesReminders = async (page) => {
    try {
      await getReminders(page);
    } catch (error) {
      setGettingChats(false);
      setGettingChatsBottom(false);
      setIsPaginationTriggered(false);
      setIsLoading(false);
      setShowSkeleton(false);
      setIsContentReady(true);
    } finally {
      setShouldGet(false);
    }
  };

  const getReminders = async (page) => {
    const { data } = await callAPI(
      `/group/getUserChats?page=${page}&limit=15&isReminder=true&chatlimit=15${translationLangParam()}`,
      {},
      "GET"
    );
    if (data.status) {
      data.chats = data.chats.map((e) => {
        return mapUserChatRow(e);
      });
      data.chats = excludeArchivedChats(data.chats);
      if (data.chats.length === 0) {
        setIsReminderOver(true);
        setGettingChats(false);
        setGettingChatsBottom(false);
        setIsPaginationTriggered(false);
        setShouldGet(false);
        if (page === 1) {
          setIsLoading(false);
          setTimeout(() => setShowSkeleton(false), 300);
          setTimeout(() => setIsContentReady(true), 400);
        }
        return;
      }
      if (AllChatsReminder.length > 0) {
        let tt = data.chats;
        let x = AllChatsReminder.filter((e) => e.isOpened);
        x = x.map((e) => {
          return e.group.id;
        });
        x = [...new Set(x)];
        tt = tt.map((e) => {
          return { ...e, isOpened: x.includes(e.group.id) ? true : false };
        });
        let _m = dedupeByMainId([...AllChatsReminder, ...tt]);
        dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: _m });
      } else {
        dispatch({
          type: SET_ACTIVITY_MESSAGES_REMINDERS,
          messages: dedupeByMainId(data.chats),
        });
      }
      setGettingChats(false);
      // Short delay for smooth transition
      setTimeout(() => {
        setGettingChatsBottom(false);
        setIsPaginationTriggered(false);
      }, 150);
      if (page === 1) {
        setIsLoading(false);
        setTimeout(() => setShowSkeleton(false), 300);
        setTimeout(() => setIsContentReady(true), 400);
      }
    } else {
      setIsReminderOver(true);
      setGettingChats(false);
      setGettingChatsBottom(false);
      setIsPaginationTriggered(false);
      if (page === 1) {
        setIsLoading(false);
        setTimeout(() => setShowSkeleton(false), 300);
        setTimeout(() => setIsContentReady(true), 400);
      }
    }
    setShouldGet(false);
  };

  const [pleaseGetMessages, setPleaseGetMessages] = useState(false);

  useEffect(() => {
    if (pleaseGetMessages) {
      _getMessages(1);
      setPleaseGetMessages(false);
    }
  }, [pleaseGetMessages]);

  const _resetAndGetLatestMessages = async () => {
    if (fetchingPage1Ref.current) {
      return;
    }
    fetchingPage1Ref.current = true;
    // Batch all synchronous state updates together to minimize re-renders
    dispatch({ type: RESET_MARKIN_PROJECT, status: true });
    
    // Reset loading states first for immediate visual feedback
    setIsLoading(true);
    setShowSkeleton(true);
    setIsContentReady(false);
    
    // Reset UI state
    setIsTabSelect(true);
    setPage(1);
    setPageReminder(1);
    setIsChatsOver(false);
    setIsReminderOver(false);
    setGettingChatsBottom(false);
    setShouldGet(false);
    
    // Clear open items
    updateGroupChats([]);
    updateOpenChats([]);
    updateOpenProjects([]);
    
    // Start fetching - don't clear existing data yet for smoother transition
    setGettingChats(true);
    
    // Directly fetch messages instead of using pleaseGetMessages state
    try {
      const { data } = await callAPI(
        `/group/getUserChats?page=1&limit=15${translationLangParam()}`,
        {},
        "GET"
      );
      if (data.status && data?.chats?.length > 0) {
        data.chats = data?.chats?.map((e) => {
          const chatData = mapUserChatRow(e);
          
          // If last message is deleted, ALWAYS clear the preview/message fields immediately
          // This prevents showing deleted message content in preview
          if (chatData.lastMessageDeleted) {
            chatData.previewMessage = "";
            chatData.message = "";
            chatData.originalMessage = "";
            chatData._hasPreviousMessage = false; // Reset flag
          }
          return chatData;
        });
        data.chats = excludeArchivedChats(data.chats);
        data.chats = await ensureMySpaceInList(data.chats);
        // Sync bookmarked group IDs from backend (replace with server truth so deleted bookmarks are cleared)
        const serverBookmarked = new Set();
        for (const chat of data.chats) {
          if (chat.group?.isTodoBookmarked) serverBookmarked.add(chat.group.id);
        }
        setBookmarkedGroupIds(serverBookmarked);

        const processedChats = mergeConsecutiveImages(data?.chats) || [];
        // Process chats with deleted messages to fetch last non-deleted message
        const processedChatsWithPreview = await Promise.all(
          processedChats.map(async (chat) => {
            if (chat?.lastMessageDeleted) {
              // Ensure deleted message content is cleared (should already be cleared, but double-check)
              const clearedChat = {
                ...chat,
                previewMessage: "",
                message: "",
                originalMessage: "",
                lastMessageDeleted: true,
              };
              
              const lastNonDeleted = await fetchLastNonDeletedMessage(clearedChat);
              if (lastNonDeleted) {
                return {
                  ...clearedChat,
                  ...lastNonDeleted,
                  lastMessageDeleted: false,
                  _hasPreviousMessage: true,
                };
              }
              // If no previous message found, return with cleared fields
              return clearedChat;
            }
            return chat;
          })
        );
        // Apply preview - this will preserve cleared fields for deleted messages
        const newData = processedChatsWithPreview.map(applyPreview);
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: newData });
        dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: Date.now() });
      } else {
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: [] });
        setIsChatsOver(true);
      }
    } catch (error) {
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: [] });
    } finally {
      fetchingPage1Ref.current = false;
      setGettingChats(false);
      setIsLoading(false);
      // Stagger the skeleton fade-out for smooth transition
      requestAnimationFrame(() => {
        setShowSkeleton(false);
        requestAnimationFrame(() => {
          setIsContentReady(true);
        });
      });
    }
  };

  const _removeAllReminders = async (id) => {
    dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: [] });
    try {
      const { data } = await callAPI(
        "/group/removeReminders",
        {},
        "DELETE",
        null
      );
      if (data.status) {
        $crud.notify({
          type: "success",
          message: data.message,
        });
      }
    } catch (e) { }
  };


  // Reconcile global badge totals with /badge/count after a local mutation.
  // Used after email read/delete; chat open relies on subscribe + the
  // socket decrease handler (which also force-fetches).
  const _reconcileBadgeCount = useCallback(async () => {
    try {
      invalidateBadgeCount();
      const { data } = await getBadgeCount({ force: true });
      if (data?.status) {
        dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
      }
    } catch (_) { /* ignore */ }
  }, [dispatch]);

  // Zero the row + drop filter-tab / SideNav chat badges in the same click.
  // Subscribe + /badge/count still run afterwards to reconcile with the BE.
  const markChatReadLocally = (group) => {
    const groupId = group?.group?.id;
    const unread = Number(group?.unseenChatCount) || 0;
    const source = (allChatsRef.current && allChatsRef.current.length > 0)
      ? allChatsRef.current
      : (AllChats || []);
    const nextChats = source.map((c) => {
      const match = String(c.group?.id) === String(groupId);
      return {
        ...c,
        isOpened: match,
        unseenChatCount: match ? 0 : c.unseenChatCount,
      };
    });
    allChatsRef.current = nextChats;
    setAllChats(nextChats);
    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: nextChats });
    if (unread > 0) {
      dispatch({
        type: ALL_BADGE_COUNT,
        unSeenAllCount: applyOptimisticChatRead(store.getState().unSeenAllCount, {
          isOneToOne: !!group?.group?.isOneToOne,
          isInternal: !!group?.isInternal,
          unreadCount: unread,
        }),
      });
      const roomId = group.buildingList || group.building || group.group?.building;
      if (roomId && !group?.group?.isOneToOne) {
        const nextLists = decrementRoomUnreadInLists(
          store.getState().projects,
          store.getState().internalProjectsAll,
          roomId,
          unread
        );
        if (nextLists.changed) {
          dispatch({ type: PROJECTS, projects: nextLists.projects });
          dispatch({ type: INTERNAL_PROJECTS, projects: nextLists.internalProjectsAll });
        }
      }
    }
    return nextChats;
  };

  const chat_click = async (group, index) => {
    // Before the count is zeroed: the conversation's "N unread" band reads it.
    const unreadCountAtOpen = Number(group?.unseenChatCount) || 0;
    setHoistedRow(null);
    prefetchListChat(group);
    // Hide list on mobile
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });

    markChatReadLocally(group);

    // Update opened chat state (one-to-one)
    updateOpenProjects([]);
    updateGroupChats([]);
    setClickedGroup(null);
    if (integrateEmailInMessages) {
      setSelectedEmail(null);
      if (!emailReplyModeRef.current) {
        setEmailReplyMode(null);
      }
    }

    // Build chat payload for the right panel
    const chatPayload = {
      ...group.group,
      isOpened: true,
      avatar: getOneToOnePartnerAvatar(group, user),
      key: group.id || group.group.id,
      id: group.group.id || group.id || group.group.id,
      unreadCountAtOpen,
    };
    updateOpenChats([chatPayload]);
  };

  // Microsoft Teams mirror (1:1 or group): the room-less chat pane (Coversation) in its Teams mode.
  // No room / project lookup with a Teams group id; the write flag comes with the row.
  const chat_click_teams = (group) => {
    const unreadCountAtOpen = Number(group?.unseenChatCount) || 0;
    setHoistedRow(null);
    prefetchListChat(group);
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });

    markChatReadLocally(group);

    updateOpenProjects([]);
    updateGroupChats([]);
    setClickedGroup(null);
    if (integrateEmailInMessages) {
      setSelectedEmail(null);
      if (!emailReplyModeRef.current) {
        setEmailReplyMode(null);
      }
    }
    fetchGroupSecret(group.group.id);
    updateOpenChats([teamsChatEntry(group, {
      id: group.group.id,
      key: group.id || group.group.id,
      isOpened: true,
      unreadCountAtOpen,
    })]);
  };

  const chat_click_group = async (group, index) => {
    // Before the count is zeroed: the conversation's "N unread" band reads it.
    const unreadCountAtOpen = Number(group?.unseenChatCount) || 0;
    setHoistedRow(null);
    prefetchListChat(group);
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });

    markChatReadLocally(group);

    setClickedGroup(group.group.id);
    if (integrateEmailInMessages) {
      setSelectedEmail(null);
      if (!emailReplyModeRef.current) {
        setEmailReplyMode(null);
      }
    }

    // Build a preloaded chat groups list for the target building from data
    // already in AllChats. ProjectDetail consumes this to render its sidebar
    // instantly and skip the initial /building/:id/chat call (which can take
    // ~1-2s on busy buildings). A silent background refresh runs afterwards.
    const preloadedChatGroups = buildPreloadedChatGroupsFromAllChats(
      allChatsRef.current || AllChats,
      group,
      user
    );

    // Update opened state for group chat
    fetchGroupSecret(group.group.id);
    updateOpenChats([]);
    updateOpenProjects([{
      ...group,
      isOpened: true,
      unseenChatCount: 0,
      unreadCountAtOpen,
      key: `proj-${group.buildingList}-${group.group.id}`,
      preloadedChatGroups,
    }]);
    updateGroupChats([{ ...group.group, isOpened: true, unseenChatCount: 0, unreadCountAtOpen }]);
  };

  // Open a room from a project tag on an email. Uses the app's deeplink
  // mechanism (same as SearchBar.navigateToRoom) so MyProject opens the room
  // AFTER navigation — this survives the route change (a direct openProjects
  // dispatch gets wiped when this page unmounts). We also stash which email to
  // surface via `pendingEmailOpen`, which ProjectDetail reads to switch to the
  // E-Mail section and auto-open that email.
  const openRoomFromEmailTag = async (project, emailId) => {
    if (!project || !project.id) return;

    // Determine internal vs external + company from the rooms lists.
    let isInternal = false;
    let companyId;
    const ext = (reduxProjects || []).find((p) => p && String(p.id) === String(project.id));
    if (ext) {
      isInternal = !!ext.isInternal;
      companyId = ext.cID || ext.companyId || (ext.company && ext.company.id);
    } else {
      const intl = (reduxInternalProjects || []).find((p) => p && String(p.id) === String(project.id));
      if (intl) {
        isInternal = true;
        companyId = intl.cID || intl.companyId || (intl.company && intl.company.id);
      }
    }

    if (integrateEmailInMessages) {
      setSelectedEmail(null);
      setEmailReplyMode(null);
    }
    setEmailTabActive(false);

    // Remember the target email so the room lands on its E-Mail section.
    dispatch({
      type: SET_PENDING_EMAIL_OPEN,
      payload: { buildingId: String(project.id), emailId: emailId ? String(emailId) : null },
    });

    // Deeplink into the room (mirrors SearchBar.navigateToRoom).
    dispatch({ type: SET_DEEPLINK_LOADING, loading: true, isInternal });
    dispatch({ type: SET_DEEPLINK_DATA, payload: { roomId: String(project.id), isInternal, ...(companyId && { companyId }) } });
    history.push("/projects");
    dispatch({ type: RIGHT_TOP, rightTop: "" });
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({ type: TOGGLE_PROJECT, payload: false });
    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
    dispatch({ type: OPEN_CHATS, openChats: [] });
    dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
    dispatch({ type: SET_IN_ACTIVITY, status: false });
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: "project1" });
    dispatch({ type: RIGHT_TOP, rightTop: "project1" });
  };

  const openChatFromNotificationEmail = (params) => {
    if (!params || !params.chatGroupId) return;

    const payload = {
      chatGroupId: params.chatGroupId,
      messageId: params.messageId,
      roomId: params.roomId,
      companyId: params.companyId,
      isInternal: !!(params.companyId || params.isInternal),
      page_no: params.page_no || 1,
    };
    dispatch({ type: SET_DEEPLINK_DATA, payload });
    setEmailDeeplinkScroll({
      chatGroupId: params.chatGroupId,
      messageId: params.messageId,
      page_no: payload.page_no,
    });

    const match = (AllChats || []).find(
      (c) => c && c.group && String(c.group.id) === String(params.chatGroupId)
    );
    if (match) {
      if (match.group.isOneToOne) chat_click(match);
      else chat_click_group(match);
      return;
    }
    navigateToChatDeeplink({ dispatch, history, ...payload });
  };

  const chat_click_reminder = async (group, index) => {
    prefetchListChat(group);
    if (exclusiveMessagesPane) {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    }
    let tmp = [...AllChatsReminder];
    if (tmp.find(e => e.group.id == group.group.id)) {
      updateOpenProjects([])
      updateGroupChats([]);
      updateOpenChats([])
      setClickedGroup(null);
      let myGpp = group.group
      tmp = tmp.map((e) => {
        const opened = e.mainId === group.mainId ? !e.isOpened : false;
        return {
          ...e,
          isOpened: opened,
          unseenChatCount: opened ? 0 : e.unseenChatCount,
        };
      });
      let openedGroup = tmp.find(e => e.mainId === group.mainId && e.isOpened);
      if (openedGroup) {
        fetchGroupSecret(group.group.id);
        updateOpenChats([{ ...myGpp, isOpened: true, avatar: getOneToOnePartnerAvatar(group, user), key: group.mainId || group.group.id }])
      }
      else {
        updateOpenChats([])
      }
      dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: tmp })
    }
  };

  const chat_click_group_reminder = async (group, index) => {
    prefetchListChat(group);
    if (exclusiveMessagesPane) {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    }
    let tmp = [...AllChatsReminder];
    const matchingChat = tmp.find(e => (e.buildingList == group.buildingList && e.group.id == group.group.id));
    
    if (matchingChat) {
      
      tmp = tmp.map((e) => {
        const opened = e.mainId === group.mainId ? !e.isOpened : false;
        return {
          ...e,
          isOpened: opened,
          unseenChatCount: opened ? 0 : e.unseenChatCount,
        };
      });
      
      const openedGroup = tmp.find(e => e.mainId === group.mainId && e.isOpened);
      
      if (openedGroup) {
        fetchGroupSecret(group.group.id);
        const preloadedChatGroups = buildPreloadedChatGroupsFromAllChats(
          AllChatsReminder,
          group,
          user
        );
        updateOpenChats([]);
        updateOpenProjects([{
          ...group,
          isOpened: true,
          unseenChatCount: 0,
          key: `proj-${group.buildingList}-${group.group.id}`,
          preloadedChatGroups,
        }]);
        updateGroupChats([{ ...group.group, isOpened: true, unseenChatCount: 0 }]);
        setClickedGroup(group.group.id);
      } else {
        updateOpenChats([]);
        updateOpenProjects([]);
        updateGroupChats([]);
        setClickedGroup(null);
      }
      
      dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: tmp });
    }
  };


  // Row times (mobile): chats today HH:mm, otherwise the short date; mails today
  // HH:mm, yesterday, then day + month (+ year).
  const formatChatTime = (date) =>
    formatChatListTime(date, strings.date_format_short || (isGerm ? "DD.MM.YY" : "MM/DD/YY"));
  const formatMailTime = (date) =>
    formatMailListTime(date, {
      yesterday: strings.yesterday || (isGerm ? "Gestern" : "Yesterday"),
      locale: isGerm ? "de-DE" : "en-GB",
    });

  const handleMuteToggleFromList = async (e, group, currentMuteState) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const newMuteState = !currentMuteState;
    try {
      await $crud.confirm({
        title: "",
        textContent: newMuteState
          ? strings.mute_chat_confirm
          : strings.unmute_chat_confirm,
        options: {
          ok: strings.ok,
          cancel: strings.cancel,
        },
      });
    } catch {
      return;
    }
    try {
      const { data } = await callAPI(
        "/group/muteUnmuteChat",
        { mute: newMuteState, group: group.group?.id },
        "PUT"
      );
      if (data.status) {
        $crud.notify({
          type: "success",
          message: newMuteState
            ? strings.chat_muted_successfully
            : strings.chat_unmuted_successfully,
        });
        const updateMuteInChats = (chats) =>
          chats.map((c) =>
            c.group?.id === group.group?.id
              ? { ...c, group: { ...c.group, isMute: newMuteState } }
              : c
          );
        setAllChats(updateMuteInChats);
        setAllChatsReminders(updateMuteInChats);
      }
    } catch (error) {
      $crud.notify({ type: "error", message: strings.something_went_wrong });
    }
  };

  const handleMySpacePinToggle = async (e, group) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const groupId = group?.group?.id;
    if (!groupId) return;
    const currentlyPinned = isMySpaceRowPinned(group);
    const nextPinned = !currentlyPinned;
    mySpacePinToggledAtRef.current = Date.now();
    setIsMySpacePinned(nextPinned);
    writeMySpacePinned(user?.id, nextPinned);
    const patchPin = (chats) =>
      (chats || []).map((c) =>
        c.group?.id === groupId
          ? { ...c, group: { ...c.group, isPinned: nextPinned, isSelfChat: true } }
          : c
      );
    const nextChats = patchPin(allChatsRef.current || []);
    allChatsRef.current = nextChats;
    setAllChats(nextChats);
    dispatch({ type: MY_SPACE_PINNED, groupId, isPinned: nextPinned });
    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: nextChats });
    try {
      const { data } = await callAPI(
        "/group/pinUnpinChat",
        { pin: nextPinned, group: groupId },
        "PUT"
      );
      if (!data?.status) {
        console.warn("[My Space pin] persist failed:", data?.message);
      }
    } catch (error) {
      // Keep the optimistic pin. Persist is best-effort so the control still
      // works when the backend endpoint is not deployed yet; localStorage
      // holds the preference for this browser.
      console.warn("[My Space pin] persist failed:", error?.message || error);
    }
  };

  const removeSelectedVideo = () => {
    videoJobRef.current += 1;
    setVideoStage(null);
    setVideoProgress(0);
    setSelectedVideo((prev) => {
      if (prev?.url) {
        try { URL.revokeObjectURL(prev.url); } catch (_) { /* ignore */ }
      }
      return null;
    });
  };

  const isReplyVideoBusy = videoStage === "processing" || videoStage === "uploading";

  const mediaAttachLabel = strings.photo_video_media_lib || strings.upload_image;
  const mediaAttachBlockedTitle = isGerm
    ? DE.please_remove_current_attachment + " " + mediaAttachLabel
    : EN.please_remove_current_attachment + " " + (EN.photo_video_media_lib || EN.upload_image);
  const canAddMoreMedia = !!(selectedImage || selectedImages.length > 0 || selectedVideo);
  const mediaInputDisabled = (hasAttachment() && !canAddMoreMedia) || isReplyVideoBusy;

  const onReplyMediaInput = (e, mode = 'replace') => {
    if (mediaInputDisabled) {
      showAttachmentError(mediaAttachBlockedTitle);
      e.target.value = '';
      return;
    }
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    processMediaFiles(files, mode, true);
  };

  // Thin progress bar over the reply actions while photos / a video are sent; it fills to 100%
  // and reads "Sent" for a moment before the box closes.
  const renderReplySendProgress = () => {
    let pct = null;
    let label = "";
    if (replySent) {
      pct = 100;
      label = strings.reply_media_sent || "Sent";
    } else if (imageSend) {
      pct = imageSend.pct;
      label = imageSend.count > 1
        ? (strings.reply_sending_photos || "Sending photos… {0}/{1}")
            .replace("{0}", imageSend.index + 1)
            .replace("{1}", imageSend.count)
        : (strings.reply_sending_photo || "Sending photo…");
    } else if (isReplyVideoBusy) {
      pct = Math.round(Number(videoProgress) || 0);
      label = videoStage === "processing"
        ? (strings.video_processing || "Compressing video…")
        : (strings.video_uploading || "Uploading video…");
    }
    if (pct == null) return null;
    pct = Math.min(100, Math.max(0, pct));
    return (
      <div
        className={`lmp-send-progress${replySent ? " is-done" : ""}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={label}
      >
        <div className="lmp-send-progress__head">
          <span className="lmp-send-progress__label">
            {replySent ? <MaterialIcon icon="check_circle" size={16} fill={1} /> : null}
            {label}
          </span>
          {!replySent ? <span className="lmp-send-progress__pct">{`${pct}%`}</span> : null}
        </div>
        <div className="lmp-send-progress__track">
          {/* The fill scales with the live percentage. */}
          <div className="lmp-send-progress__fill" style={{ transform: `scaleX(${pct / 100})` }} />
        </div>
      </div>
    );
  };

  const renderReplyVideoPreview = () => {
    if (!selectedVideo) return null;
    const pct = Math.min(100, Math.max(0, Math.round(Number(videoProgress) || 0)));
    const ringR = 26;
    const ringC = 2 * Math.PI * ringR;
    const dash = (pct / 100) * ringC;
    return (
      <div className="selected-image-preview selected-video-preview">
        <div className={`image-preview-content${isReplyVideoBusy ? " is-busy" : ""}`}>
          <video
            src={selectedVideo.url}
            className="preview-image preview-video"
            controls={!isReplyVideoBusy}
            playsInline
            preload="metadata"
          />
          {isReplyVideoBusy && (
            <div className="chat-video-upload-overlay">
              <div className="chat-video-upload-card">
                <div
                  className="chat-video-progress"
                  role="progressbar"
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-valuenow={pct}
                >
                  <svg className="chat-video-progress-ring" viewBox="0 0 72 72" aria-hidden="true">
                    <circle className="chat-video-progress-track" cx="36" cy="36" r={ringR} />
                    <circle
                      className="chat-video-progress-value"
                      cx="36"
                      cy="36"
                      r={ringR}
                      strokeDasharray={`${dash} ${ringC}`}
                    />
                  </svg>
                  <div className="chat-video-progress-pct">{`${pct}%`}</div>
                </div>
                <div className="chat-video-progress-label">
                  {videoStage === "processing"
                    ? (strings.video_processing || "Compressing video…")
                    : (strings.video_uploading || "Uploading video…")}
                </div>
              </div>
            </div>
          )}
          {videoStage !== "uploading" && (
            <button
              className="remove-image-btn icon-btn-shadow"
              onClick={removeSelectedVideo}
              title={strings.remove_image}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
        </div>
        {!isReplyVideoBusy && (
          <label className="add-more-images-btn" title={mediaAttachLabel}>
            <input
              type="file"
              accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
              multiple
              onChange={(e) => onReplyMediaInput(e, 'replace')}
              className="hidden-input"
            />
            <span className="material-symbols-outlined">add</span>
          </label>
        )}
        {(selectedVideo.duration || selectedVideo.name) && (
          <div className="video-preview-meta-inline">
            {[
              selectedVideo.duration ? formatVideoDuration(selectedVideo.duration) : null,
              selectedVideo.name || null,
            ].filter(Boolean).join(" · ")}
          </div>
        )}
      </div>
    );
  };

  // ---- Chat list rows: the mobile Pro chat row, adapted to web ----

  // Plain one-line text for a row preview (no HTML, no markdown markers).
  const cleanPreviewLine = (value) =>
    String(value || "")
      .replace(/<br\s*[/]?>/gi, " ")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\*\*(.*?)\*\*/g, "$1")
      .replace(/__(.*?)__/g, "$1")
      .replace(/~~(.*?)~~/g, "$1")
      .replace(/^[-*]\s+/gm, "")
      .replace(/^\d+\.\s+/gm, "")
      .replace(/\s+/g, " ")
      .trim();

  // Line 2 of a chat row, in the mobile precedence: draft → reaction →
  // (deleted: nothing) → contact / media / map / poll → text. Rooms and groups
  // prefix the last sender's first name when it is someone else.
  const renderRowPreview = (group, kind, { isBlocked = false } = {}) => {
    if (isBlocked) {
      return <span className="lmp-row__preview-text">{strings.you_have_blocked}</span>;
    }
    const draft = findChatDraft(group);
    const draftText = draft ? cleanPreviewLine(getDraftPreviewText(draft.message)) : "";
    if (draftText) {
      return (
        <span className="lmp-row__preview-text">
          <span className="lmp-row__draft">{strings.draft_prefix || (isGerm ? "Entwurf:" : "Draft:")} </span>
          {draftText}
        </span>
      );
    }
    if (!group.lastMessageDeleted && group.lastReactionEmoji && group.lastReactionSenderName) {
      return (
        <>
          <MaterialIcon icon="add_reaction" size={16} className="lmp-row__glyph" />
          <span className="lmp-row__preview-text">
            {group.lastReactionSenderName} {strings.reacted_with || (isGerm ? "reagierte mit" : "reacted with")}{" "}
            <span className="lmp-row__emoji">{group.lastReactionEmoji}</span>
          </span>
        </>
      );
    }
    if (group.lastMessageDeleted) return null;
    const isGroupRow = kind === "room" || kind === "group";
    const prefix =
      isGroupRow && group.senderName && group.senderId != null && String(group.senderId) !== String(user?.id)
        ? `${firstNameOf(group.senderName)}: `
        : "";
    const type = group.messageType;
    const glyphs = {
      image: "photo",
      video: "videocam",
      audio: "mic",
      doc: "description",
      map: "location_on",
      poll: "poll",
      contact: "contact_page",
    };
    if (glyphs[type]) {
      const capital = (s) => {
        const v = String(s || "");
        return v.charAt(0).toUpperCase() + v.slice(1);
      };
      const labels = {
        image:
          (Number(group.count) || 0) > 1
            ? `${group.count} ${strings.m_image || (isGerm ? "Bilder" : "images")}`
            : capital(strings.s_image || (isGerm ? "Bild" : "Image")),
        video: strings.video || "Video",
        audio: strings.audio || "Audio",
        doc: strings.document || (isGerm ? "Dokument" : "Document"),
        map: strings.location || (isGerm ? "Standort" : "Location"),
        poll: strings.create_poll || (isGerm ? "Umfrage" : "Poll"),
        contact: strings.contact || (isGerm ? "Kontakt" : "Contact"),
      };
      let caption = "";
      if (type === "image" || type === "video" || type === "audio" || type === "doc") {
        const source = group.previewMessage || group.message || "";
        const raw = cleanPreviewLine(isGroupRow ? onlyUsername(source, strings) : source);
        const fallbacks = [strings.s_image, strings.m_image, strings.document, strings.video, strings.audio, "Image", "Images", "[Image]"]
          .filter(Boolean)
          .map((s) => String(s).trim().toLowerCase());
        if (raw && !fallbacks.includes(raw.toLowerCase()) && !raw.startsWith("U2FsdGVkX1")) caption = raw;
      }
      return (
        <>
          <MaterialIcon icon={glyphs[type]} size={16} className="lmp-row__glyph" />
          <span className="lmp-row__preview-text">
            {prefix}
            {labels[type]}
            {caption ? ` · ${caption}` : ""}
          </span>
        </>
      );
    }
    const text = cleanPreviewLine(getPreviewText(group));
    if (!text) return null;
    return (
      <span className="lmp-row__preview-text">
        {prefix}
        {text}
      </span>
    );
  };

  // Pin / unpin a room from its chat row (the profile's pinned rooms, the sidebar's pins).
  const toggleRoomPin = (room, pinnedNow) => {
    const pins = (Array.isArray(pinnedRooms) ? pinnedRooms : []).filter((p) => p && p.id != null);
    if (pinnedNow) {
      persistPinnedRooms(pins.filter((p) => String(p.id) !== String(room.id)), dispatch);
      return;
    }
    if (pins.length >= PINNED_ROOMS_MAX) {
      $crud.notify({
        type: "error",
        message: strings.pinned_rooms_max || (isGerm ? "Du kannst maximal 10 Projekte anheften." : "You can pin up to 10 projects."),
      });
      return;
    }
    persistPinnedRooms(
      [
        ...pins,
        {
          id: room.id,
          name: room.name,
          image: room.image || null,
          themeColor: room.themeColor || null,
          isInternal: !!room.isInternal,
          isJoin: true,
          isDone: false,
        },
      ],
      dispatch
    );
  };

  // Opens the inline reply under a chat row and loads what the AI suggestions need.
  const openInlineReply = async (group) => {
    // Clear exit state immediately for fresh animation
    setReplyExiting(null);
    // Clear previous suggestions
    setSuggestions([]);
    setSuggestionsError(null);
    setCurrentReplyMessage(null);
    // Clear reply text and attachments when switching to a new message
    setReplyText('');
    clearAttachments();
    // Set reply target immediately for instant feedback
    setReplyingTo(group.mainId || group.id);
    setActiveGroupId(group.group.id);
    // Fetch data in background (don't await to avoid blocking UI)
    fetchGroupSecret(group.group.id);
    fetchGroupMembers(group.group.id);
    if (activeGroupId && activeGroupId !== group.group.id) {
      unsubscribeFromChat(activeGroupId).catch(() => {});
    }
    subscribeToChat(group.group.id).catch(() => {});
    // Store message for suggestion fetching (useEffect handles decryption + API call)
    if (group.messageType === 'audio') {
      if (group.transcribedAudio) {
        setCurrentReplyMessage(cleanTranscript(group.transcribedAudio));
      } else {
        setSuggestionsLoading(true);
        suggestionsLoadingRef.current = true;
        let apiUrl = `/group/${group.group.id}/getChat?page=1&limit=1`;
        if (group.group.isOneToOne && user?.id) {
          apiUrl += `&userId=${user.id}`;
        } else if (!group.group.isOneToOne && group.building) {
          apiUrl += `&building=${group.building}`;
        }
        try {
          const { data } = await callAPI(apiUrl, {}, 'GET');
          let transcript = null;
          if (data?.status && data?.chatHistory?.length > 0) {
            const lastMsg = data.chatHistory.find(m => m.messageType === 'audio');
            transcript = lastMsg?.transcribedAudio;
            if (!transcript && lastMsg?.fileUrl) {
              const filePath = Array.isArray(lastMsg.fileUrl) ? lastMsg.fileUrl[0] : lastMsg.fileUrl;
              if (filePath) {
                try {
                  const transcriptResp = await callAPI("/message/transcriptAudioFile", {}, "POST", { filePath, chatId: `${lastMsg.id}` });
                  const rd = transcriptResp?.data;
                  transcript = cleanTranscript(rd?.transcribedAudio || rd?.data?.transcribedAudio || rd?.transcript || rd?.data?.transcript || rd?.text || rd?.data?.text);
                } catch (e) {}
              }
            }
          }
          if (transcript) {
            setCurrentReplyMessage(cleanTranscript(transcript));
          } else {
            setSuggestionsLoading(false);
            suggestionsLoadingRef.current = false;
          }
        } catch (e) {
          setSuggestionsLoading(false);
          suggestionsLoadingRef.current = false;
        }
      }
    } else if (group.messageType === 'image') {
      if (group.imageDescription) {
        setCurrentReplyMessage(group.imageDescription);
      } else {
        setSuggestionsLoading(true);
        suggestionsLoadingRef.current = true;
        let imgApiUrl = `/group/${group.group.id}/getChat?page=1&limit=1`;
        if (group.group.isOneToOne && user?.id) {
          imgApiUrl += `&userId=${user.id}`;
        } else if (!group.group.isOneToOne && group.building) {
          imgApiUrl += `&building=${group.building}`;
        }
        try {
          const { data } = await callAPI(imgApiUrl, {}, 'GET');
          let description = null;
          if (data?.status && data?.chatHistory?.length > 0) {
            const lastMsg = data.chatHistory.find(m => m.messageType === 'image');
            description = lastMsg?.imageDescription;
          }
          if (description) {
            setCurrentReplyMessage(description);
          } else {
            setCurrentReplyMessage(group.message || '[Image]');
          }
        } catch (e) {
          setCurrentReplyMessage(group.message || '[Image]');
        }
      }
    } else if (!isMessageEmojiOnly(group.message)) {
      setCurrentReplyMessage(group.message);
    } else {
      setCurrentReplyMessage(null);
    }
  };

  // The row's actions, in the mobile sheet's order: Reply, Bookmark, Mute (My
  // Space: Pin), Pin room. `quick` ones also show as hover icons on the row.
  const getChatRowActions = (group, kind) => {
    const isSelfChat = kind === "self";
    const reaction = !!(group.lastReactionEmoji && group.lastReactionSenderName);
    const chatId = group.mainId || group.id;
    const items = [];
    const canWrite = group.canWriteMessages !== false && group.group?.canWriteMessages !== false;
    // Microsoft Teams chats are answered inside the chat (no list quick reply: it would offer voice
    // messages and AI reply suggestions, which Teams chats do not have).
    if (isTabSelect && !isSelfChat && !group.isOpened && group.messageType !== "poll" && !reaction && canWrite && !isTeamsChat(group)) {
      items.push({
        key: "reply",
        icon: "reply",
        quick: true,
        label: strings.reply || (isGerm ? "Antworten" : "Reply"),
        onSelect: () => openInlineReply(group),
      });
    }
    if (!isSelfChat && !reaction && !["video", "map", "poll"].includes(group.messageType)) {
      const bookmarked = bookmarkedGroupIds.has(group.group?.id);
      // Every task belongs to a project: a room chat or a Teams chat filed under a project brings
      // its own; for a 1:1 chat (or a chat without one) the user picks it first.
      const projectId = chatProjectIdOf(group);
      items.push({
        key: "bookmark",
        icon: bookmarked ? "task_alt" : "add_task",
        quick: true,
        active: bookmarked,
        label: bookmarked
          ? strings.unmark_task || (isGerm ? "Aus Aufgaben entfernen" : "Remove from tasks")
          : strings.mark_as_task || (isGerm ? "Als Aufgabe markieren" : "Mark as task"),
        onSelect: () => {
          if (bookmarked) {
            removeBookmarkTodo({ chatId, groupId: group.group?.id });
          } else {
            const args = [
              chatId,
              group.previewMessage || group.message || group.originalMessage || '',
              group.createdAt || group.updatedAt,
              group.messageType,
              group.group?.id,
              projectId,
              group.group?.isOneToOne,
            ];
            if (projectId) openTodoModal(...args);
            else setTaskProjectFor(args);
          }
        },
      });
    }
    if (!isSelfChat) {
      const muted = !!group.group?.isMute;
      items.push({
        key: "mute",
        icon: muted ? "notifications" : "notifications_off",
        quick: true,
        label: muted ? strings.unmute || (isGerm ? "Stummschaltung aufheben" : "Unmute") : strings.mute || (isGerm ? "Stummschalten" : "Mute"),
        onSelect: () => handleMuteToggleFromList(null, group, muted),
      });
    } else {
      const pinned = isMySpaceRowPinned(group);
      items.push({
        key: "pin",
        icon: "keep",
        quick: true,
        active: pinned,
        label: pinned ? strings.unpin_chat || (isGerm ? "Lösen" : "Unpin") : strings.pin_chat || (isGerm ? "Anpinnen" : "Pin"),
        onSelect: () => handleMySpacePinToggle(null, group),
      });
    }
    // Microsoft Teams: file the chat under a project room for the daily report (the chat stays room-less).
    if (isTeamsChat(group) && group.group?.id != null) {
      const project = teamsProjectOf(group);
      items.push({
        key: "teamsRoom",
        icon: "folder_special",
        label: project
          ? strings.teams_room_change || (isGerm ? "Projekt ändern" : "Change project")
          : strings.teams_room_assign || (isGerm ? "Projekt zuordnen" : "Assign project"),
        onSelect: () => setTeamsRoomRow({ groupId: String(group.group.id), project }),
      });
    }
    if (kind === "room") {
      const roomId = group.buildingList != null && group.buildingList !== "" ? group.buildingList : group.building;
      const room = roomOfChatRow(group, findRoomInLists(roomId, reduxProjects, reduxInternalProjects));
      const pinnedRoom = room ? isRoomPinned(pinnedRooms, room.id) : false;
      if (room && (pinnedRoom || (room.isJoin && !room.isDone))) {
        items.push({
          key: "pinRoom",
          icon: pinnedRoom ? "keep_off" : "keep",
          label: pinnedRoom
            ? strings.pinned_room_unpin_room || (isGerm ? "Projekt lösen" : "Unpin project")
            : strings.pinned_room_pin || (isGerm ? "Projekt anheften" : "Pin project"),
          onSelect: () => toggleRoomPin(room, pinnedRoom),
        });
      }
    }
    return items;
  };

  // The row itself: 36 avatar (unread counter on it), name + muted glyph, time,
  // ⋮ (or × while replying), and the preview line with the hover actions.
  const renderChatRowMain = (group, index) => {
    const kind = chatRowKind(group);
    // A Microsoft Teams mirror: a 1:1 looks like a direct chat, a group like a group; never My Space.
    // Teams people have no Kjuup profile, photo or presence: the display name and its initials.
    const teams = isTeamsChat(group);
    const isSelfChat = kind === "self";
    const isGroupRow = kind === "room" || kind === "group";
    const replyKey = group.mainId || group.id;
    const isReplying = replyingTo === replyKey;
    const isChatMuted = !!group.group?.isMute;
    const unread = group.isOpened ? 0 : Number(group.unseenChatCount) || 0;
    const photoOf = (path) => {
      if (!path || /(^|\/)(user|profile)\.png$/i.test(String(path))) return null;
      return /^https?:\/\//i.test(path) ? path : BASE_URL + path;
    };
    let title = "";
    let avatarName = "";
    let photoUrl = null;
    let color = null;
    let partnerId = null;
    let colleague = false;
    let isBlocked = false;
    if (teams) {
      // "Chat · Projektraum" like a room group row, when the chat is filed under a room.
      avatarName = stripMarkdown(teamsChatTitle(group));
      title = [avatarName, stripMarkdown(teamsProjectOf(group)?.name || "")].filter(Boolean).join(" · ");
    } else if (isGroupRow) {
      const roomName = stripMarkdown(group.buildingName || "");
      if (kind === "room") {
        title = roomName;
        avatarName = roomName;
        photoUrl = photoOf(group.groupImage || group.buildingImage);
        color = chatColorOf(group, { room: true });
      } else {
        const groupName = stripMarkdown(
          group.translatedName || translatedChatNames[group.group?.id] || translatedChatNames[group.mainId] || group.name || ""
        );
        title = [groupName, roomName].filter(Boolean).join(" · ");
        avatarName = title;
        color = chatColorOf(group, { room: false });
      }
    } else {
      const selfUser = {
        ...user,
        avatar: user?.avatar || profile?.avatar || user?.img || user?.profilePicture || null,
      };
      title = stripMarkdown(getOneToOnePartnerName(group, selfUser, strings.my_notes || "My Space"));
      avatarName = title;
      if (!isSelfChat) {
        const otherUser = group.group?.users?.find((u) => (u.id || u) !== user?.id);
        isBlocked = !!otherUser?.isBlock;
        const otherUserId =
          group.group?.otherUserId ||
          (otherUser && (otherUser.id || otherUser)) ||
          (group.senderId && group.senderId !== user?.id ? group.senderId : null);
        const normalizedName = String(title).replace(/\s+/g, " ").trim().toLowerCase();
        colleague =
          group.group?.isKjuupColleague === true ||
          (otherUserId ? kjuupColleagueIds.has(String(otherUserId)) : false) ||
          (!!normalizedName && kjuupColleagueNames.has(normalizedName));
        photoUrl = photoOf(getOneToOnePartnerAvatar(group, selfUser));
        partnerId = partnerIdOf(group, user?.id);
      }
    }
    const actions = getChatRowActions(group, kind);
    const quick = actions.filter((a) => a.quick);
    const openRow = () => {
      if (replyingTo === replyKey) return;
      if (teams) {
        chat_click_teams(group, index);
      } else if (isGroupRow) {
        if (isTabSelect) chat_click_group(group, index);
        else chat_click_group_reminder(group, index);
      } else if (isTabSelect) {
        chat_click(group, index);
      } else {
        chat_click_reminder(group, index);
      }
    };
    const openMenuAt = (at) => setRowMenu({ title, items: actions, ...at });
    const moreLabel = strings.pro_messages_row_more || (isGerm ? "Weitere Optionen" : "More options");
    return (
      <div
        role="button"
        tabIndex={0}
        aria-label={title}
        className={`lmp-row${group.isOpened ? " is-open" : ""}${unread > 0 ? " is-unread" : ""}${emailSelectMode ? " is-dimmed" : ""}${group?.isDeactivated ? " is-deactivated" : ""}`}
        onClick={openRow}
        onKeyDown={(e) => {
          if (e.target !== e.currentTarget) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openRow();
          }
        }}
        onContextMenu={(e) => {
          if (!actions.length || isReplying) return;
          e.preventDefault();
          openMenuAt({ x: e.clientX, y: e.clientY, align: "start" });
        }}
        onMouseEnter={() => prefetchListChat(group)}
      >
        <ChatListAvatar
          kind={kind}
          name={avatarName}
          photoUrl={photoUrl}
          color={color}
          unread={unread}
          partnerId={partnerId}
          colleague={colleague}
          // Teams logo also on a Kjuup + Teams group (native, with a Teams copy).
          teams={teams || !!teamsBridgeOf(group)}
        />
        <div className="lmp-row__text">
          <div className="lmp-row__line1">
            <span className="lmp-row__name">{title}</span>
            {isChatMuted ? (
              <MaterialIcon
                icon="notifications_off"
                size={16}
                className="lmp-row__muted"
                title={strings.chat_muted || (isGerm ? "Stummgeschaltet" : "Muted")}
              />
            ) : null}
            <span className="lmp-row__time">{formatChatTime(group.createdAt)}</span>
            {isReplying ? (
              <button
                type="button"
                className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral lmp-row__close"
                title={strings.cancel_reply || (isGerm ? "Antwort abbrechen" : "Cancel reply")}
                aria-label={strings.cancel_reply || (isGerm ? "Antwort abbrechen" : "Cancel reply")}
                onClick={(e) => {
                  e.stopPropagation();
                  closeReplySection();
                }}
              >
                <MaterialIcon icon="close" size={20} />
              </button>
            ) : actions.length ? (
              <button
                type="button"
                className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral lmp-row__more"
                title={moreLabel}
                aria-label={moreLabel}
                aria-haspopup="menu"
                onClick={(e) => {
                  e.stopPropagation();
                  const r = e.currentTarget.getBoundingClientRect();
                  openMenuAt({ x: r.right, y: r.bottom + 4, anchorTop: r.top - 4, align: "end" });
                }}
              >
                <MaterialIcon icon="more_vert" size={20} />
              </button>
            ) : null}
          </div>
          <div className="lmp-row__line2">
            <span className="lmp-row__preview">
              <LivePreview
                groupId={group.group?.id}
                kind={kind}
                typingLabel={strings.pro_messages_typing || (isGerm ? "schreibt…" : "typing…")}
                isTypingLabel={strings.v2_chat_is_typing || (isGerm ? "schreibt" : "is typing")}
              >
                {teams ? (
                  <span className="lmp-kind-tag lmp-kind-tag--teams">
                    {String(strings.pro_messages_tag_teams || "Teams").toUpperCase()}
                  </span>
                ) : null}
                {renderRowPreview(group, kind, { isBlocked })}
              </LivePreview>
            </span>
            {isSelfChat && isMySpaceRowPinned(group) && unread === 0 ? (
              <MaterialIcon icon="keep" size={18} fill={1} className="lmp-row__pin" />
            ) : null}
            {!isReplying ? <RowQuickActions actions={quick} /> : null}
          </div>
        </div>
      </div>
    );
  };

  const _renderOneToOne = (group, index) => {
    const isSelfChat = isSelfChatGroup(group);
    const isReplying = replyingTo === (group.mainId || group.id);
    return (
      <div className={`lmp-item${isReplying ? " lmp-item--replying" : ""}`}>
        {renderChatRowMain(group, index)}
        {/* Reply UI — hidden for My Space (no incoming messages) */}
        {!isSelfChat && replyingTo === (group.mainId || group.id) && (
          <div
            className={`reply-box reply-box-container ${group.isOpened ? 'active' : ''} ${replyExiting === group.id ? 'reply-exit' : ''} ${isDragOver ? 'drag-over' : ''}`}
            style={{ position: 'relative' }}
            key={`reply-${group.id}`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}>

            {/* Auto Suggestions UI - OneToOne (positioned above input, only when user clicks in textbox) */}
            {!selectedDoc && !recordedAudio && !isRecording && 
             !['doc', 'video'].includes(group.messageType) &&
             (group.messageType === 'audio' || group.messageType === 'image' || !isMessageEmojiOnly(group.message)) &&
             (suggestionsLoading || suggestions.length > 0) && !suggestionsError && (
              <div className="suggestions-container suggestions-fade-in suggestions-latest-messages" style={{ marginBottom: 8 }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <div className="suggestions-wrapper">
                  <div className="suggestions-header">
                    <MaterialIcon icon="stars_2" size={14} color="#e066ed" />
                    <span>{strings.suggested_replies || 'Suggested Replies'}</span>
                  </div>
                  <div className="suggestions-chips">
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(0);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.positive_suggestion_placeholder || 'Positive'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(1);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.neutral_suggestion_placeholder || 'Neutral'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(2);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.negative_suggestion_placeholder || 'Negative'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showMentionSuggestions && isComposerToolbarOpen && (
              <div style={MENTION_SUGGESTIONS_CONTAINER_STYLE}>
                {mentionSuggestions
                  .filter((mention) =>
                    mention.name?.toLowerCase().includes(mentionQuery?.toLowerCase())
                  )
                  .map((mention) => (
                    <div
                      key={mention.id}
                      style={MENTION_SUGGESTION_ROW_STYLE}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => onMentionSelect(mention)}
                    >
                      <div>
                        {mention.type === 'All' ? (
                          <span
                            className="material-symbols-outlined"
                            style={{
                              fontSize: 20, width: 35, height: 35, display: 'flex',
                              alignItems: 'center', justifyContent: 'center',
                              color: '#737373',
                              fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20",
                            }}
                          >group</span>
                        ) : (
                          <img
                            src={mention.avatar ? BASE_URL + mention.avatar : process.env.PUBLIC_URL + '/assets/img/profile.png'}
                            alt=""
                            style={MENTION_AVATAR_STYLE}
                            onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/assets/img/profile.png'; }}
                          />
                        )}
                      </div>
                      <div style={MENTION_NAME_WRAPPER_STYLE}>
                        {mention.name}
                      </div>
                    </div>
                  ))}
              </div>
            )}

            <div 
              className="reply-input-wrapper"
              style={{ display: (selectedDoc || recordedAudio || isRecording) ? 'none' : 'block' }}
            >
              {isComposerToolbarOpen && (
                <div className="chat-wysiwyg-toolbar">
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.bold ? ' active' : ''}`} title="Bold" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("bold"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_bold" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.italic ? ' active' : ''}`} title="Italic" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("italic"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_italic" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.underline ? ' active' : ''}`} title="Underline" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("underline"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_underlined" size={18} /></button>
                  <span className="chat-wysiwyg-separator" />
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.unordered ? ' active' : ''}`} title="Bullet list" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("unordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_bulleted" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.ordered ? ' active' : ''}`} title="Numbered list" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("ordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_numbered" size={18} /></button>
                </div>
              )}
              {isComposerToolbarOpen ? (
                <div
                  ref={richEditorRef}
                  className="chat-rich-editor"
                  contentEditable
                  suppressContentEditableWarning
                  data-placeholder={strings.type_your_reply || "Type your reply"}
                  onPaste={pasteAsPlainText}
                  onDrop={handleComposerDrop}
                  onFocus={() => setIsReplyInputFocused(true)}
                  onBlur={() => setTimeout(() => setIsReplyInputFocused(false), 150)}
                  onKeyDown={(e) => {
                    const outcome = handleComposerEnterKey(e, {
                      editor: richEditorRef.current,
                    });
                    if (outcome === "send") {
                      if (replyLoading || isRecording || isReplyVideoBusy || (!replyText.trim() && !hasAttachment())) return;
                      const md = getRichEditorContent();
                      if (md) setReplyText(md);
                      replyToMessage(group);
                    }
                  }}
                  onInput={() => {
                    const editor = richEditorRef.current;
                    syncComposerEmptiness(setReplyText, editor?.innerText);
                    const sel = window.getSelection();
                    if (sel && sel.rangeCount > 0 && editor) {
                      const range = sel.getRangeAt(0);
                      if (editor.contains(range.startContainer) && range.startContainer.nodeType === Node.TEXT_NODE) {
                        const text = range.startContainer.textContent;
                        const cursorPos = range.startOffset;
                        const textBeforeCursor = text.substring(0, cursorPos);
                        const atIdx = textBeforeCursor.lastIndexOf("@");
                        if (atIdx >= 0) {
                          const chBefore = atIdx > 0 ? textBeforeCursor[atIdx - 1] : null;
                          if (atIdx === 0 || chBefore === " " || chBefore === "\n" || chBefore === "\xa0") {
                            const query = textBeforeCursor.substring(atIdx + 1);
                            if (query.length <= 50) {
                              setMentionQuery(query);
                              setShowMentionSuggestions(true);
                              mentionCursorRef.current = { node: range.startContainer, offset: cursorPos, atIndex: atIdx };
                              return;
                            }
                          }
                        }
                      }
                    }
                    setShowMentionSuggestions(false);
                  }}
                />
              ) : (
              <MentionsInput
                className="reply-input mentions"
                value={replyText}
                onChange={e => setReplyText(e.target.value)}
                onKeyDown={(e) => {
                  const textarea = e.target;
                  const outcome = handleComposerEnterKey(e, {
                    textValue: textarea.value ?? replyText,
                    selectionStart: textarea.selectionStart,
                    onListReplace: (nextValue, nextCursor) => {
                      setReplyText(nextValue);
                      requestAnimationFrame(() => {
                        if (textarea.setSelectionRange) textarea.setSelectionRange(nextCursor, nextCursor);
                      });
                    },
                  });
                  if (outcome === "send") {
                    if (replyLoading || isRecording || isReplyVideoBusy || (!(textarea.value || replyText).trim() && !hasAttachment())) return;
                    replyToMessage(group);
                  }
                }}
                onFocus={() => setIsReplyInputFocused(true)}
                onBlur={() => setTimeout(() => setIsReplyInputFocused(false), 150)}
                placeholder={strings.type_your_reply}
                disabled={replyLoading || hasAttachmentBox()}
                allowSuggestionsAboveCursor
                forceSuggestionsAboveCursor
                suggestionsPortalHost={document.body}
                style={MENTIONS_INPUT_STYLE}
              >
                <Mention
                  markup={"@[__display__](__id__)"}
                  trigger="@"
                  data={mentionSuggestions}
                  displayTransform={(id, display) => `@${display}`}
                  style={{
                    fontWeight: 500,
                  }}
                  renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {suggestion.type === 'All' ? (
                        <span 
                          className="material-symbols-outlined"
                          style={{
                            fontSize: 20,
                            width: 20,
                            height: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#737373',
                            fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20",
                          }}
                        >
                          group
                        </span>
                      ) : (
                        <img
                          src={suggestion.avatar ? BASE_URL + suggestion.avatar : process.env.PUBLIC_URL + '/assets/img/profile.png'}
                          alt=""
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                          onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/assets/img/profile.png'; }}
                        />
                      )}
                      <span>{highlightedDisplay}</span>
                    </div>
                  )}
                />
              </MentionsInput>
              )}
            </div>

            {attachmentError && (
              <div className="attachment-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 8V12" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 16H12.01" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>{attachmentError}</span>
              </div>
            )}
            {selectedDoc && (
              <div className="selected-doc-preview">
                <div className="doc-preview-content">
                  <span className="doc-icon">{getFileIcon(selectedDoc.name?.split('.').pop())}</span>
                  <span className="doc-name">{selectedDoc.name}</span>
                  <button
                    className="remove-doc-btn icon-btn-shadow"
                    onClick={() => setSelectedDoc(null)}
                    title={strings.remove_document}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            )}
            {renderReplyVideoPreview()}
            {selectedImage && (
              <div className="selected-image-preview">
                <div className="image-preview-content">
                  <img src={selectedImage.preview} alt="Selected" className="preview-image" decoding="async" />
                  <button
                    className="remove-image-btn icon-btn-shadow"
                    onClick={() => setSelectedImage(null)}
                    title={strings.remove_image}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                <label className="add-more-images-btn" title={strings.upload_image}>
                  <input
                    type="file"
                    accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                    multiple
                    onChange={(e) => onReplyMediaInput(e, 'add')}
                    className="hidden-input"
                  />
                  <span className="material-symbols-outlined">add</span>
                </label>
              </div>
            )}
            {selectedImages.length > 0 && (
              <div className="selected-images-preview">
                <div className="images-preview-header">
                  <span className="images-count">{selectedImages.length} {selectedImages.length === 1 ? (strings.image) : (strings.images)}</span>
                  <button
                    className="remove-all-images-btn icon-btn-shadow"
                    onClick={() => setSelectedImages([])}
                    title={strings.remove_all_images}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                <div className="images-grid">
                  {selectedImages.map((img, index) => (
                    <div key={index} className="image-preview-item">
                      <img src={img.preview} alt={`Selected ${index + 1}`} className="preview-image" decoding="async" />
                      <button
                        className="remove-single-image-btn icon-btn-shadow"
                        onClick={() => {
                          const newImages = selectedImages.filter((_, i) => i !== index);
                          if (newImages.length === 1) {
                            setSelectedImage(newImages[0]);
                            setSelectedImages([]);
                          } else {
                            setSelectedImages(newImages);
                          }
                        }}
                        title={strings.remove_image}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                  ))}
                  <label className="image-preview-item add-more-images-grid-btn" title={mediaAttachLabel}>
                    <input
                      type="file"
                      accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                      multiple
                      onChange={(e) => onReplyMediaInput(e, 'add')}
                      className="hidden-input"
                    />
                    <span className="material-symbols-outlined">add</span>
                  </label>
                </div>
              </div>
            )}
            {recordedAudio && (
              <div className="selected-audio-preview audio-preview-container">
                <div className="audio-preview-inner">
                  <audio
                    controls
                    ref={audioPreviewRef}
                    src={recordedAudio.url}
                    className="audio-player"
                  />
                  {((audioPreviewDuration && audioPreviewDuration > 0) || recordingTime > 0) && (
                    <div className="audio-duration-text">
                      {strings.chat_list_audio_duration || (isGerm ? "Dauer" : "Duration")}: {audioPreviewDuration && audioPreviewDuration > 0 ? formatAudioDuration(audioPreviewDuration) : formatAudioDuration(recordingTime)}
                    </div>
                  )}
                </div>
                <button
                  className="remove-audio-btn icon-btn-shadow remove-audio-margin"
                  onClick={removeAudio}
                  title={strings.remove_recording}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            )}
            {renderReplySendProgress()}
            <div className="reply-actions">
              <div className="reply-attachments">
                <label
                  className={`attachment-btn icon-btn-shadow attachment-label ${mediaInputDisabled ? 'disabled' : ''}`}
                  title={mediaInputDisabled ? mediaAttachBlockedTitle : mediaAttachLabel}
                >
                  <input
                    type="file"
                    accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                    multiple
                    onChange={(e) => onReplyMediaInput(e, (selectedImage || selectedImages.length > 0) ? 'add' : 'replace')}
                    className="hidden-input"
                    disabled={mediaInputDisabled}
                  />
                  <span className="material-symbols-outlined">perm_media</span>
                </label>
                <label
                  className={`attachment-btn icon-btn-shadow attachment-label ${hasAttachment() && !selectedDoc ? 'disabled' : ''}`}
                  title={hasAttachment() && !selectedDoc ? (isGerm ? DE.please_remove_current_attachment + " " + (strings.upload_document) : EN.please_remove_current_attachment + " " + EN.upload_document) : (strings.upload_document)}
                >
                  <input
                    type="file"
                    accept={DOC_ACCEPT_ATTRIBUTE}
                    onChange={async (e) => {
                      if (hasAttachment() && !selectedDoc) {
                        showAttachmentError(isGerm ? DE.please_remove_current_attachment + " " + (strings.upload_document) : EN.please_remove_current_attachment + " " + EN.upload_document);
                        e.target.value = '';
                        return;
                      }
                      const file = e.target.files[0];
                      if (!file) return;
                      const fileType = file.name?.split(".").pop();
                      if (DOC_EXTENSIONS.includes(fileType?.toLowerCase())) {
                        setSelectedDoc(file);
                      } else {
                        showAttachmentError(strings.please_upload_valid_document);
                      }
                      e.target.value = '';
                    }}
                    className="hidden-input"
                    disabled={hasAttachment() && !selectedDoc}
                  />
                  <span className="material-symbols-outlined">description</span>
                </label>
                <button
                  className={`attachment-btn icon-btn-shadow ${hasAttachment() && !isRecording && !recordedAudio ? 'disabled' : ''} ${isRecording ? 'recording' : ''}`}
                  title={hasAttachment() && !isRecording && !recordedAudio ? (isGerm ? DE.please_remove_current_attachment + " " + (strings.record_audio) : EN.please_remove_current_attachment + " " + EN.record_audio) : (isRecording ? (strings.stop_recording) : (strings.record_audio))}
                  onClick={isRecording ? stopRecording : startRecording}
                  disabled={hasAttachment() && !isRecording && !recordedAudio}
                >
                  <span className="material-symbols-outlined">mic</span>
                  {isRecording && (
                    <div className="recording-indicator">
                      <div className="recording-dot"></div>
                      <span className="recording-time">{Math.floor(recordingTime / 60)}:{(recordingTime % 60).toString().padStart(2, '0')}</span>
                    </div>
                  )}
                </button>
              </div>
              <button
                type="button"
                className="kj-btn kj-btn--primary kj-btn--icon kj-btn--lg kj-btn--round lmp-send"
                title={strings.send || (isGerm ? "Senden" : "Send")}
                aria-label={strings.send || (isGerm ? "Senden" : "Send")}
                onClick={() => {
                  if (isComposerToolbarOpen && richEditorRef.current) {
                    const md = getRichEditorContent();
                    setReplyText(md);
                  }
                  replyToMessage(group);
                }}
                disabled={replyLoading || isRecording || isReplyVideoBusy || (!replyText.trim() && !hasAttachment())}
              >
                {replyLoading ? <div className="loader-spinner loader-spinner-small"></div> : <MaterialIcon icon="send" size={22} fill={1} />}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const _renderGroupChats = (group, index) => {
    const isReplying = replyingTo === (group.mainId || group.id);
    return (
      <div className={`lmp-item${isReplying ? " lmp-item--replying" : ""}`}>
        {renderChatRowMain(group, index)}
        {/* Reply UI */}
        {replyingTo === (group.mainId || group.id) && (
          <div
            className={`reply-box reply-box-container ${group.isOpened ? 'active' : ''} ${replyExiting === group.mainId ? 'reply-exit' : ''} ${isDragOver ? 'drag-over' : ''}`}
            style={{ position: 'relative' }}
            key={`reply-${group.mainId}`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}>

            {/* Auto Suggestions UI - GroupChats (positioned above input, only when user clicks in textbox) */}
            {!selectedDoc && !recordedAudio && !isRecording && 
             !['doc', 'video'].includes(group.messageType) &&
             (group.messageType === 'audio' || group.messageType === 'image' || !isMessageEmojiOnly(group.message)) &&
             (suggestionsLoading || suggestions.length > 0) && !suggestionsError && (
              <div className="suggestions-container suggestions-fade-in suggestions-latest-messages" style={{ marginBottom: 8 }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <div className="suggestions-wrapper">
                  <div className="suggestions-header">
                    <MaterialIcon icon="stars_2" size={14} color="#e066ed" />
                    <span>{strings.suggested_replies || 'Suggested Replies'}</span>
                  </div>
                  <div className="suggestions-chips">
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(0);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.positive_suggestion_placeholder || 'Positive'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(1);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.neutral_suggestion_placeholder || 'Neutral'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                    <button
                      className="suggestion-chip"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlaceholderClick(2);
                      }}
                      disabled={replyLoading}
                    >
                      <span className="suggestion-text">{strings.negative_suggestion_placeholder || 'Negative'}</span>
                      <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showMentionSuggestions && isComposerToolbarOpen && (
              <div style={MENTION_SUGGESTIONS_CONTAINER_STYLE}>
                {mentionSuggestions
                  .filter((mention) =>
                    mention.name?.toLowerCase().includes(mentionQuery?.toLowerCase())
                  )
                  .map((mention) => (
                    <div
                      key={mention.id}
                      style={MENTION_SUGGESTION_ROW_STYLE}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => onMentionSelect(mention)}
                    >
                      <div>
                        {mention.type === 'All' ? (
                          <span
                            className="material-symbols-outlined"
                            style={{
                              fontSize: 20, width: 35, height: 35, display: 'flex',
                              alignItems: 'center', justifyContent: 'center',
                              color: '#737373',
                              fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20",
                            }}
                          >group</span>
                        ) : (
                          <img
                            src={mention.avatar ? BASE_URL + mention.avatar : process.env.PUBLIC_URL + '/assets/img/profile.png'}
                            alt=""
                            style={MENTION_AVATAR_STYLE}
                            onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/assets/img/profile.png'; }}
                          />
                        )}
                      </div>
                      <div style={MENTION_NAME_WRAPPER_STYLE}>
                        {mention.name}
                      </div>
                    </div>
                  ))}
              </div>
            )}

            <div 
              className="reply-input-wrapper"
              style={{ display: (selectedDoc || recordedAudio || isRecording) ? 'none' : 'block' }}
            >
              {isComposerToolbarOpen && (
                <div className="chat-wysiwyg-toolbar">
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.bold ? ' active' : ''}`} title="Bold" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("bold"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_bold" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.italic ? ' active' : ''}`} title="Italic" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("italic"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_italic" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.underline ? ' active' : ''}`} title="Underline" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("underline"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_underlined" size={18} /></button>
                  <span className="chat-wysiwyg-separator" />
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.unordered ? ' active' : ''}`} title="Bullet list" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("unordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_bulleted" size={18} /></button>
                  <button type="button" className={`chat-wysiwyg-btn${activeFormats.ordered ? ' active' : ''}`} title="Numbered list" onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("ordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_numbered" size={18} /></button>
                </div>
              )}
              {isComposerToolbarOpen ? (
                <div
                  ref={richEditorRef}
                  className="chat-rich-editor"
                  contentEditable
                  suppressContentEditableWarning
                  data-placeholder={strings.type_your_reply || "Type your reply"}
                  onPaste={pasteAsPlainText}
                  onDrop={handleComposerDrop}
                  onFocus={() => setIsReplyInputFocused(true)}
                  onBlur={() => setTimeout(() => setIsReplyInputFocused(false), 150)}
                  onKeyDown={(e) => {
                    const outcome = handleComposerEnterKey(e, {
                      editor: richEditorRef.current,
                    });
                    if (outcome === "send") {
                      if (replyLoading || isRecording || isReplyVideoBusy || (!replyText.trim() && !hasAttachment())) return;
                      const md = getRichEditorContent();
                      if (md) setReplyText(md);
                      replyToMessage(group);
                    }
                  }}
                  onInput={() => {
                    const editor = richEditorRef.current;
                    syncComposerEmptiness(setReplyText, editor?.innerText);
                    const sel = window.getSelection();
                    if (sel && sel.rangeCount > 0 && editor) {
                      const range = sel.getRangeAt(0);
                      if (editor.contains(range.startContainer) && range.startContainer.nodeType === Node.TEXT_NODE) {
                        const text = range.startContainer.textContent;
                        const cursorPos = range.startOffset;
                        const textBeforeCursor = text.substring(0, cursorPos);
                        const atIdx = textBeforeCursor.lastIndexOf("@");
                        if (atIdx >= 0) {
                          const chBefore = atIdx > 0 ? textBeforeCursor[atIdx - 1] : null;
                          if (atIdx === 0 || chBefore === " " || chBefore === "\n" || chBefore === "\xa0") {
                            const query = textBeforeCursor.substring(atIdx + 1);
                            if (query.length <= 50) {
                              setMentionQuery(query);
                              setShowMentionSuggestions(true);
                              mentionCursorRef.current = { node: range.startContainer, offset: cursorPos, atIndex: atIdx };
                              return;
                            }
                          }
                        }
                      }
                    }
                    setShowMentionSuggestions(false);
                  }}
                />
              ) : (
              <MentionsInput
                className="reply-input mentions"
                value={replyText}
                onChange={e => setReplyText(e.target.value)}
                onKeyDown={(e) => {
                  const textarea = e.target;
                  const outcome = handleComposerEnterKey(e, {
                    textValue: textarea.value ?? replyText,
                    selectionStart: textarea.selectionStart,
                    onListReplace: (nextValue, nextCursor) => {
                      setReplyText(nextValue);
                      requestAnimationFrame(() => {
                        if (textarea.setSelectionRange) textarea.setSelectionRange(nextCursor, nextCursor);
                      });
                    },
                  });
                  if (outcome === "send") {
                    if (replyLoading || isRecording || isReplyVideoBusy || (!(textarea.value || replyText).trim() && !hasAttachment())) return;
                    replyToMessage(group);
                  }
                }}
                onFocus={() => setIsReplyInputFocused(true)}
                onBlur={() => setTimeout(() => setIsReplyInputFocused(false), 150)}
                placeholder={strings.type_your_reply}
                disabled={replyLoading || hasAttachmentBox()}
                allowSuggestionsAboveCursor
                forceSuggestionsAboveCursor
                suggestionsPortalHost={document.body}
                style={MENTIONS_INPUT_STYLE}
              >
                <Mention
                  markup={"@[__display__](__id__)"}
                  trigger="@"
                  data={mentionSuggestions}
                  displayTransform={(id, display) => `@${display}`}
                  style={{
                    fontWeight: 500,
                  }}
                  renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {suggestion.type === 'All' ? (
                        <span 
                          className="material-symbols-outlined"
                          style={{
                            fontSize: 20,
                            width: 20,
                            height: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#737373',
                            fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20",
                          }}
                        >
                          group
                        </span>
                      ) : (
                        <img
                          src={suggestion.avatar ? BASE_URL + suggestion.avatar : process.env.PUBLIC_URL + '/assets/img/profile.png'}
                          alt=""
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                          onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/assets/img/profile.png'; }}
                        />
                      )}
                      <span>{highlightedDisplay}</span>
                    </div>
                  )}
                />
              </MentionsInput>
              )}
            </div>

            {attachmentError && (
              <div className="attachment-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 8V12" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 16H12.01" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>{attachmentError}</span>
              </div>
            )}
            {selectedDoc && (
              <div className="selected-doc-preview">
                <div className="doc-preview-content">
                  <span className="doc-icon">{getFileIcon(selectedDoc.name?.split('.').pop())}</span>
                  <span className="doc-name">{selectedDoc.name}</span>
                  <button
                    className="remove-doc-btn icon-btn-shadow"
                    onClick={() => setSelectedDoc(null)}
                    title={strings.remove_document}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            )}
            {renderReplyVideoPreview()}
            {selectedImage && (
              <div className="selected-image-preview">
                <div className="image-preview-content">
                  <img src={selectedImage.preview} alt="Selected" className="preview-image" decoding="async" />
                  <button
                    className="remove-image-btn icon-btn-shadow"
                    onClick={() => setSelectedImage(null)}
                    title={strings.remove_image}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                <label className="add-more-images-btn" title={strings.upload_image}>
                  <input
                    type="file"
                    accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                    multiple
                    onChange={(e) => onReplyMediaInput(e, 'add')}
                    className="hidden-input"
                  />
                  <span className="material-symbols-outlined">add</span>
                </label>
              </div>
            )}
            {selectedImages.length > 0 && (
              <div className="selected-images-preview">
                <div className="images-preview-header">
                  <span className="images-count">{selectedImages.length} {selectedImages.length === 1 ? (strings.image) : (strings.images)}</span>
                  <button
                    className="remove-all-images-btn icon-btn-shadow"
                    onClick={() => setSelectedImages([])}
                    title={strings.remove_all_images}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                <div className="images-grid">
                  {selectedImages.map((img, index) => (
                    <div key={index} className="image-preview-item">
                      <img src={img.preview} alt={`Selected ${index + 1}`} className="preview-image" decoding="async" />
                      <button
                        className="remove-single-image-btn icon-btn-shadow"
                        onClick={() => {
                          const newImages = selectedImages.filter((_, i) => i !== index);
                          if (newImages.length === 1) {
                            setSelectedImage(newImages[0]);
                            setSelectedImages([]);
                          } else {
                            setSelectedImages(newImages);
                          }
                        }}
                        title={strings.remove_image}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                  ))}
                  <label className="image-preview-item add-more-images-grid-btn" title={mediaAttachLabel}>
                    <input
                      type="file"
                      accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                      multiple
                      onChange={(e) => onReplyMediaInput(e, 'add')}
                      className="hidden-input"
                    />
                    <span className="material-symbols-outlined">add</span>
                  </label>
                </div>
              </div>
            )}
            {recordedAudio && (
              <div className="selected-audio-preview audio-preview-container">
                <div className="audio-preview-inner">
                  <audio
                    controls
                    ref={audioPreviewRef}
                    src={recordedAudio.url}
                    className="audio-player"
                  />
                  {((audioPreviewDuration && audioPreviewDuration > 0) || recordingTime > 0) && (
                    <div className="audio-duration-text">
                      {strings.chat_list_audio_duration || (isGerm ? "Dauer" : "Duration")}: {audioPreviewDuration && audioPreviewDuration > 0 ? formatAudioDuration(audioPreviewDuration) : formatAudioDuration(recordingTime)}
                    </div>
                  )}
                </div>
                <button
                  className="remove-audio-btn icon-btn-shadow remove-audio-margin"
                  onClick={removeAudio}
                  title={strings.remove_recording}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            )}
            {renderReplySendProgress()}
            <div className="reply-actions">
              <div className="reply-attachments">
                <label
                  className={`attachment-btn icon-btn-shadow attachment-label ${mediaInputDisabled ? 'disabled' : ''}`}
                  title={mediaInputDisabled ? mediaAttachBlockedTitle : mediaAttachLabel}
                >
                  <input
                    type="file"
                    accept={PHOTO_VIDEO_ACCEPT_ATTRIBUTE}
                    multiple
                    onChange={(e) => onReplyMediaInput(e, (selectedImage || selectedImages.length > 0) ? 'add' : 'replace')}
                    className="hidden-input"
                    disabled={mediaInputDisabled}
                  />
                  <span className="material-symbols-outlined">perm_media</span>
                </label>
                <label
                  className={`attachment-btn icon-btn-shadow attachment-label ${hasAttachment() ? 'disabled' : ''}`}
                  title={hasAttachment() ? (isGerm ? DE.please_remove_current_attachment + " " + EN.upload_document : EN.please_remove_current_attachment + " " + EN.upload_document) : (strings.upload_document)}
                >
                  <input
                    type="file"
                    accept={DOC_ACCEPT_ATTRIBUTE}
                    onChange={(e) => {
                      if (hasAttachment()) {
                        showAttachmentError(isGerm ? DE.please_remove_current_attachment + " " + EN.upload_document : EN.please_remove_current_attachment + " " + EN.upload_document);
                        e.target.value = '';
                        return;
                      }
                      const file = e.target.files?.[0];
                      if (file) {
                        setSelectedDoc(file);
                      }
                      e.target.value = '';
                    }}
                    className="hidden-input"
                    disabled={hasAttachment()}
                  />
                  <span className="material-symbols-outlined">description</span>
                </label>
                <button
                  className={`attachment-btn icon-btn-shadow ${isRecording ? 'recording' : ''} ${hasAttachment() && !recordedAudio ? 'disabled' : ''}`}
                  onClick={() => {
                    if (isRecording) {
                      stopRecording();
                    } else if (!hasAttachment() || recordedAudio) {
                      startRecording();
                    } else {
                      showAttachmentError(isGerm ? DE.please_remove_current_attachment + " " + EN.record_audio : EN.please_remove_current_attachment + " " + EN.record_audio);
                    }
                  }}
                  title={isRecording ? (strings.stop_recording) : (strings.record_audio)}
                  disabled={hasAttachment() && !recordedAudio && !isRecording}
                >
                  <span className="material-symbols-outlined">{isRecording ? 'stop' : 'mic'}</span>
                  {isRecording && (
                    <div className="recording-indicator">
                      <div className="recording-dot"></div>
                      <span className="recording-time">{Math.floor(recordingTime / 60)}:{(recordingTime % 60).toString().padStart(2, '0')}</span>
                    </div>
                  )}
                </button>
              </div>
              <button
                type="button"
                className="kj-btn kj-btn--primary kj-btn--icon kj-btn--lg kj-btn--round lmp-send"
                title={strings.send || (isGerm ? "Senden" : "Send")}
                aria-label={strings.send || (isGerm ? "Senden" : "Send")}
                onClick={() => {
                  if (isComposerToolbarOpen && richEditorRef.current) {
                    const md = getRichEditorContent();
                    setReplyText(md);
                  }
                  replyToMessage(group);
                }}
                disabled={replyLoading || isRecording || isReplyVideoBusy || (!replyText.trim() && !hasAttachment())}
              >
                {replyLoading ? <div className="loader-spinner loader-spinner-small"></div> : <MaterialIcon icon="send" size={22} fill={1} />}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  // A mail in the combined list, in the mobile chat look: sender avatar (unread
  // counter on it), sender + time, then the MAIL tag and the subject. Assign /
  // bookmark / archive / delete stay at hand as hover actions; a right click
  // starts the multi-select (the mobile long press).
  const _renderEmailInList = (emailData, index) => {
    const em = emailData;
    const emailId = em.id || em._id || em.messageId || em.providerMessageId;
    // Id used for multi-select batch actions (kept in sync with visibleEmailIds
    // and the bulk handlers, which key off id/_id/providerMessageId).
    const selectId = em.id || em._id || em.providerMessageId;
    const isChecked = emailSelectMode && selectedEmailIds.has(selectId);
    const isSelected = selectedEmail && emailEntriesShareId(em, selectedEmail);
    const isUnread = !em.isRead;
    const senderName = (() => {
      const name = em.fromAddress?.name || em.fromName;
      if (name) return name;
      const addr = em.fromAddress?.email || em.from;
      if (addr) {
        const nameMatch = addr.match(/^(.+?)\s*<.*>$/);
        if (nameMatch) return nameMatch[1].trim();
        const extracted = addr.match(/<(.+?)>/);
        return extracted ? extracted[1] : addr;
      }
      return '';
    })();
    const subject = em.subject || strings.no_subject || '(No Subject)';
    const emailDate = em.date || em.receivedAt;
    const isReport = em.systemTag === "daily_briefing";
    const filed = Array.isArray(em.linkedProjects) && em.linkedProjects.length > 0;
    const isEmailBookmarked = em.isTodoBookmarked || bookmarkedEmailIds.has(String(emailId));
    const hoisted = hoistedRow && matchesHoistedRow({ _isEmail: true, _emailData: em }, hoistedRow);

    const openEmail = () => {
      if (emailSelectMode) {
        toggleEmailSelectId(selectId);
        return;
      }
      if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
      setHoistedRow(null);
      updateOpenChats([]);
      updateOpenProjects([]);
      updateGroupChats([]);
      setClickedGroup(null);
      const nextChats = (AllChats || []).map(c => ({ ...c, isOpened: false }));
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: nextChats });
      setSelectedEmail(em);
    };

    // The room next to the sender: its tag (opens / changes / removes it), or,
    // while the mail has none, the "Raum zuordnen" chip that opens the assign dialog.
    const assignLabel = strings.email_classify_associate || (isGerm ? "Projekt zuordnen" : "Associate to project");
    let roomChip = null;
    if (!isReport && filed) {
      const project = em.linkedProjects[0];
      const tc = getProjectTagColors(resolveProjectColor(project));
      const more = em.linkedProjects.length - 1;
      roomChip = (
        <button
          type="button"
          className="lmp-room-chip"
          title={em.linkedProjects.map((p) => p.name).filter(Boolean).join(", ")}
          style={{ "--lmp-room-color": tc.fg }}
          disabled={emailSelectMode}
          onClick={(e) => {
            e.stopPropagation();
            setTagActionCtx({ email: em, project });
          }}
        >
          <span className="lmp-room-chip__dot" aria-hidden="true" />
          <span className="lmp-room-chip__name">{project.name}</span>
          {more > 0 ? <span className="lmp-room-chip__more">+{more}</span> : null}
        </button>
      );
    } else if (!isReport && !isClassificationPending(em)) {
      roomChip = (
        <button
          type="button"
          className="lmp-room-chip lmp-room-chip--add"
          title={assignLabel}
          disabled={emailSelectMode}
          onClick={(e) => {
            e.stopPropagation();
            setAssignModalEmail(assignModalSnapshot(em));
          }}
        >
          <span className="lmp-room-chip__name">+ {assignLabel}</span>
        </button>
      );
    }

    const quick = [];
    if (!emailSelectMode) {
      if (!isReport) {
        // "Mark as task" only for an email filed under a project (removing stays possible).
        if (isEmailBookmarked || emailProjectIdOf(em)) {
          quick.push({
            key: "bookmark",
            icon: isEmailBookmarked ? "task_alt" : "add_task",
            active: isEmailBookmarked,
            label: isEmailBookmarked
              ? strings.unmark_task || (isGerm ? "Aus Aufgaben entfernen" : "Remove from tasks")
              : strings.mark_as_task || (isGerm ? "Als Aufgabe markieren" : "Mark as task"),
            onSelect: () => {
              if (isEmailBookmarked) removeBookmarkTodo({ emailId });
              else createTodoFromEmail(emailId, emailDate, subject, em);
            },
          });
        }
        if (activeEmailAccountId && selectId) {
          quick.push({
            key: "archive",
            icon: "archive",
            label: strings.email_archive || (isGerm ? "Archivieren" : "Archive"),
            onSelect: () => handleArchiveEmails([selectId]),
          });
        }
      }
      quick.push({
        key: "delete",
        icon: "delete",
        danger: true,
        label: strings.delete || (isGerm ? "Löschen" : "Delete"),
        onSelect: () => deleteEmailMessage(em),
      });
    }

    return (
      <div
        className={`lmp-item${hoisted ? " lm-row-hoisted" : ""}`}
        key={`email-${emailId}-${index}`}
        data-email-row-id={emailId}
      >
        <MailChatRow
          name={senderName}
          email={extractSenderEmail(em)}
          subject={subject}
          time={formatMailTime(emailDate)}
          tag={isReport
            ? strings.email_tag_daily_briefing || (isGerm ? "Tagesbericht" : "Daily report")
            : strings.pro_messages_tag_mail || "Mail"}
          unread={isUnread}
          open={!!isSelected}
          checked={!!isChecked}
          attachment={!!em.hasAttachments}
          attachmentLabel={strings.attachments || (isGerm ? "Anhänge" : "Attachments")}
          roomChip={roomChip}
          quick={quick}
          ariaLabel={senderName || subject}
          ariaPressed={emailSelectMode ? !!isChecked : undefined}
          onOpen={openEmail}
          onContextMenu={(e) => {
            if (isReport || !selectId) return;
            e.preventDefault();
            if (!emailSelectMode) setEmailSelectMode(true);
            setSelectedEmailIds((prev) => (prev.has(selectId) ? prev : new Set(prev).add(selectId)));
          }}
        />
      </div>
    );
  };

  const _renderChats = (item, index, listIndex) => {
    if (item._isEmail) {
      return _renderEmailInList(item._emailData, index);
    }

    const shouldAnimate = animatedChatId === item.group?.id;
    const animationClass = [
      shouldAnimate ? 'chat-item-highlight' : '',
      hoistedRow && matchesHoistedRow(item, hoistedRow) ? 'lm-row-hoisted' : '',
    ].filter(Boolean).join(' ');

    return item.group ? (
      <div key={`${item.group.id}-${item.mainId || item.id}`} className={animationClass} style={{ animationDelay: `${(listIndex || index) * 0.05}s` }}>
        {isDirectMessageChat(item) ? (
          _renderOneToOne(item, index)
        ) : (
          _renderGroupChats(item, index)
        )}
      </div>
    ) : (
      <></>
    );
  };

  useEffect(() => {
    if (!showNewMessageTypeSelector) return;
    const handleClickOutside = (e) => {
      if (newMessageTypeSelectorRef.current && !newMessageTypeSelectorRef.current.contains(e.target)) {
        setShowNewMessageTypeSelector(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNewMessageTypeSelector]);

  // Start a new email from the "+" control (selector option / email-only mode).
  const openNewEmailCompose = () => {
    setShowNewMessageTypeSelector(false);
    if (!activeEmailAccountId && emailAccounts.length > 0) {
      setActiveEmailAccountId(
        emailAccounts.length > 1
          ? ALL_ACCOUNTS_ID
          : (emailAccounts[0].id || emailAccounts[0]._id)
      );
    }
    // Keep the current list tab. If a chat/room/email is already
    // open on the right, leave it so compose can show it as a
    // second bottom tab.
    if (exclusiveMessagesPane) {
      if (!integrateEmailInMessages) setEmailTabActive(true);
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    } else if (!integrateEmailInMessages) {
      setEmailTabActive(true);
      dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    }
    setEmailReplyMode("new");
  };

  // The Unread chip (mobile): turning it on snapshots the list as it is, so
  // turning it off restores that window instead of painting every page the
  // unread scan loaded (in-flight scan requests are ignored).
  const applyUnreadOnly = (next) => {
    if (next === showUnreadOnly) return;
    if (next) {
      // Leaving another mail folder for the chat list: the combined list is the inbox.
      const fromOtherFolder = activeFilterUI === "email" && !isInboxFeedFolder(activeEmailFolder);
      preUnreadSnapshotRef.current = {
        chats: allChatsRef.current ? allChatsRef.current.slice() : [],
        page,
        isChatsOver,
        emails: fromOtherFolder
          ? (inboxFeedEmailsRef.current ? inboxFeedEmailsRef.current.slice() : [])
          : (emailMessagesRef.current ? emailMessagesRef.current.slice() : []),
        inbox: inboxFeedEmailsRef.current ? inboxFeedEmailsRef.current.slice() : [],
        emailPage: emailPageRef.current,
        isEmailsOver,
      };
    } else if (preUnreadSnapshotRef.current) {
      const snap = preUnreadSnapshotRef.current;
      unreadListEpochRef.current += 1;
      skipUnreadOffEmailRefetchRef.current = true;
      // Keep chat updates made while the filter was on (deleted
      // message previews, read state). The snapshot array is only
      // the pre-scan window — later pages loaded to find unreads
      // stay discarded.
      const liveChats = allChatsRef.current || [];
      const liveById = new Map();
      liveChats.forEach((c) => {
        const key = latestChatKey(c);
        if (key) liveById.set(key, c);
      });
      const restoredChats = (snap.chats || []).reduce((acc, c) => {
        const key = latestChatKey(c);
        if (!key) {
          acc.push(c);
          return acc;
        }
        const live = liveById.get(key);
        // Gone from the live list (deleted / archived) — do not
        // bring the row back with the pre-filter snapshot.
        if (liveChats.length > 0 && !live) return acc;
        acc.push(live || c);
        return acc;
      }, []);
      // Mails take their live row too (read while the filter was on), and
      // just-deleted ones stay out. The effect on showUnreadOnly then checks
      // the window against the server without a spinner.
      const liveEmailById = new Map();
      [...(inboxFeedEmailsRef.current || []), ...(emailMessagesRef.current || [])].forEach((m) => {
        emailEntryIds(m).forEach((id) => liveEmailById.set(id, m));
      });
      const freshenEmails = (rows) => dropRecentlyDeletedEmails(
        (rows || []).map((m) => emailEntryIds(m).map((id) => liveEmailById.get(id)).find(Boolean) || m),
        activeEmailFolder
      );
      preUnreadSnapshotRef.current = null;
      allChatsRef.current = restoredChats;
      setAllChats(restoredChats);
      setPage(snap.page);
      setIsChatsOver(snap.isChatsOver);
      setGettingChats(false);
      setGettingChatsBottom(false);
      setIsPaginationTriggered(false);
      setEmailMessages(freshenEmails(snap.emails));
      setInboxFeedEmails(freshenEmails(snap.inbox));
      setEmailPage(snap.emailPage);
      setIsEmailsOver(snap.isEmailsOver);
      setEmailLoading(false);
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: restoredChats });
    }
    setShowUnreadOnly(next);
  };

  // A Teams chat started from the new-chat picker (Teams contacts only). The server lists the chat
  // only once it has a message: a placeholder row shows it at the top now (below a pinned My
  // Space); the first message replaces it. It opens in the room-less pane's Teams mode.
  const openCreatedTeamsChat = (created) => {
    const live = store.getState().activityMessages || [];
    if (!live.some((c) => String(c?.group?.id) === String(created.groupId))) {
      const rows = [mapUserChatRow(newTeamsChatRow(created)), ...live];
      rows.sort((a, b) => getListSortDate(b) - getListSortDate(a));
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: rows });
    }
    dispatch({
      type: SET_PENDING_CHAT,
      payload: {
        chatGroupId: created.groupId,
        isTeams: true,
        name: created.name,
        teamsChatType: created.chatType,
      },
    });
  };

  // Title row (mobile Messages page): the title, the mail multi-select toggle and
  // the new-message button (a Kjuup message or an e-mail when one can be composed).
  const renderListHeader = ({ emailSection = false } = {}) => {
    const hasEmailAccounts = emailAccounts && emailAccounts.length > 0 && !hideEmailClientPref;
    // Compose email only with a connected account AND an active trial/paid plan.
    // Same Neue Nachricht control on every tab (including E-Mail filter).
    const canComposeEmail = hasEmailAccounts && hasActiveKjuupIoPlan;
    // Chats hidden (Kjuup.io preference): the control only creates emails.
    // Without a connected account it leads to the account settings instead.
    const emailOnly = hideChatsPref;
    // Teams chats are started from the Kjuup message picker (its "Teams contacts" tab).
    const hasTypeMenu = canComposeEmail;
    const labelText = emailOnly
      ? (strings.new_email || "Neue E-Mail")
      : hasEmailAccounts
        ? `${strings.start_chat_button} / ${strings.filter_email || strings.email_room_tab || "email"}`
        : strings.start_chat_button;
    const handleClick = () => {
      if (emailOnly) {
        if (canComposeEmail) {
          openNewEmailCompose();
        } else {
          history.push("/profile-setting", { openSection: "email-accounts" });
        }
        return;
      }
      if (hasTypeMenu) {
        setShowNewMessageTypeSelector((v) => !v);
      } else {
        setShowMemberSelection(true);
      }
    };
    const title = emailOnly
      ? strings.email_tab_email || "E-Mail"
      : strings.kjuup_messages_title || (isGerm ? "Nachrichten" : "Messages");
    const selectLabel = strings.email_select || (isGerm ? "Auswählen" : "Select");
    const menuOpen = showNewMessageTypeSelector && hasTypeMenu && !emailOnly;
    return (
      <div className="lmp-header">
        <h2 className="lmp-title">{title}</h2>
        <div className="lmp-title-actions">
          {!emailSection && isTabSelect && integrateEmailInMessages && emailMessages.length > 0 ? (
            <button
              type="button"
              className={`kj-btn kj-btn--icon kj-btn--lg kj-btn--secondary lmp-title-btn${emailSelectMode ? " is-active" : ""}`}
              aria-pressed={emailSelectMode}
              title={selectLabel}
              aria-label={selectLabel}
              onClick={() => {
                if (emailSelectMode) {
                  exitEmailSelectMode();
                } else {
                  setEmailSelectMode(true);
                }
              }}
            >
              <MaterialIcon icon="checklist" size={22} />
            </button>
          ) : null}
          <div className="lmp-new-wrap" ref={newMessageTypeSelectorRef}>
            <button
              type="button"
              className={`kj-btn kj-btn--icon kj-btn--lg kj-btn--primary lmp-title-btn${emailOnly ? " kj-btn--email" : ""}`}
              title={labelText}
              aria-label={labelText}
              aria-haspopup={hasTypeMenu && !emailOnly ? "menu" : undefined}
              aria-expanded={hasTypeMenu && !emailOnly ? menuOpen : undefined}
              onClick={handleClick}
            >
              <MaterialIcon icon="edit_square" size={22} />
            </button>
            {menuOpen && (
              <div className="new-message-type-selector" role="menu">
                <div
                  className="new-message-type-option"
                  role="menuitem"
                  onClick={() => {
                    setShowNewMessageTypeSelector(false);
                    setShowMemberSelection(true);
                  }}
                >
                  <img src={kjuupIcon} alt="" className="new-message-type-logo" />
                  <span>{strings.kjuup_message || "Kjuup Nachricht"}</span>
                </div>
                {canComposeEmail ? (
                  <div
                    className="new-message-type-option"
                    role="menuitem"
                    onClick={openNewEmailCompose}
                  >
                    <span className="material-symbols-outlined new-message-type-icon" style={{ color: "#e066ed" }}>mail</span>
                    <span>{strings.email || "E-Mail"}</span>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Mail multi-select bar (mobile): takes the chips' place while mails are
  // selected. × · "n selected" · select all · read / unread · archive · move ·
  // spam · delete.
  const renderEmailSelectionBar = () => {
    const selectLabelFor = (n) =>
      fillTemplate(strings.pro_messages_selected || (isGerm ? "{n} ausgewählt" : "{n} selected"), { n });
    const count = selectedEmailIds.size;
    const allSelected = visibleEmailIds.length > 0 && count >= visibleEmailIds.length;
    let selHasUnread = false;
    let selHasRead = false;
    const seen = new Set();
    [...(inboxFeedEmails || []), ...(emailMessages || [])].forEach((m) => {
      const id = m && (m.id || m._id || m.providerMessageId);
      if (!id || seen.has(id) || !selectedEmailIds.has(id)) return;
      seen.add(id);
      if (m.isRead === true || m.isRead === 1 || m.isRead === "1") selHasRead = true;
      else selHasUnread = true;
    });
    const run = async (fn, ...args) => {
      if (selectedEmailIds.size === 0) return;
      const ids = [...selectedEmailIds];
      setSelMoveOpen(false);
      await fn(ids, ...args);
      exitEmailSelectMode();
    };
    const label = (key, de, en) => strings[key] || (isGerm ? de : en);
    const canMove = !!activeEmailAccountId;
    const btn = "kj-btn kj-btn--icon kj-btn--neutral";
    return (
      <div className="lmp-selbar" role="toolbar" aria-label={selectLabelFor(count)}>
        <button type="button" className={btn} onClick={exitEmailSelectMode} title={label("close", "Schließen", "Close")} aria-label={label("close", "Schließen", "Close")}>
          <MaterialIcon icon="close" size={22} />
        </button>
        <span className="lmp-selbar__count">{selectLabelFor(count)}</span>
        <button
          type="button"
          className={btn}
          onClick={toggleSelectAllEmails}
          disabled={selectAllBusy}
          title={allSelected ? label("email_deselect_all", "Auswahl aufheben", "Deselect all") : label("email_select_all", "Alle auswählen", "Select all")}
          aria-label={allSelected ? label("email_deselect_all", "Auswahl aufheben", "Deselect all") : label("email_select_all", "Alle auswählen", "Select all")}
        >
          <MaterialIcon
            icon={selectAllBusy ? "refresh" : allSelected ? "deselect" : "select_all"}
            size={22}
            className={selectAllBusy ? "email-refresh-spin" : ""}
          />
        </button>
        {selHasUnread ? (
          <button type="button" className={btn} disabled={count === 0} onClick={() => run(handleMarkEmailsRead)} title={label("mark_read", "Als gelesen markieren", "Mark read")} aria-label={label("mark_read", "Als gelesen markieren", "Mark read")}>
            <MaterialIcon icon="mark_email_read" size={22} />
          </button>
        ) : selHasRead ? (
          <button type="button" className={btn} disabled={count === 0} onClick={() => run(markEmailsUnread)} title={label("mark_unread", "Als ungelesen markieren", "Mark as unread")} aria-label={label("mark_unread", "Als ungelesen markieren", "Mark as unread")}>
            <MaterialIcon icon="mark_email_unread" size={22} />
          </button>
        ) : null}
        {canMove ? (
          <button type="button" className={btn} disabled={count === 0} onClick={() => run(handleArchiveEmails)} title={label("email_archive", "Archivieren", "Archive")} aria-label={label("email_archive", "Archivieren", "Archive")}>
            <MaterialIcon icon="archive" size={22} />
          </button>
        ) : null}
        {canMove ? (
          <div className="lmp-selbar__move email-move-dropdown-wrap" ref={selMoveRef}>
            <button
              type="button"
              className={btn}
              disabled={count === 0}
              aria-haspopup="menu"
              aria-expanded={selMoveOpen}
              onClick={() => setSelMoveOpen((v) => !v)}
              title={label("email_move_to", "Verschieben nach", "Move to")}
              aria-label={label("email_move_to", "Verschieben nach", "Move to")}
            >
              <MaterialIcon icon="drive_file_move" size={22} />
            </button>
            {selMoveOpen ? (
              <div className="email-move-dropdown" role="menu">
                <div className="email-move-dropdown-item" role="menuitem" onClick={() => run(handleMoveEmails, "ARCHIVE")}>
                  <MaterialIcon icon="archive" size={16} />
                  <span>{label("email_folder_archive", "Archiv", "Archive")}</span>
                </div>
                <div className="email-move-dropdown-item" role="menuitem" onClick={() => run(handleMoveEmails, "SPAM")}>
                  <MaterialIcon icon="report" size={16} />
                  <span>{label("email_folder_spam", "Spam", "Spam")}</span>
                </div>
                <div className="email-move-dropdown-item" role="menuitem" onClick={() => run(handleMoveEmails, "TRASH")}>
                  <MaterialIcon icon="delete" size={16} />
                  <span>{label("email_folder_deleted", "Gelöschte Elemente", "Deleted Items")}</span>
                </div>
                {(customFolders || []).length > 0 && <div className="email-move-dropdown-divider" />}
                {(customFolders || []).map((f) => (
                  <div key={f.id} className="email-move-dropdown-item" role="menuitem" onClick={() => run(handleMoveEmails, f.providerFolderId)}>
                    <MaterialIcon icon="folder" size={16} />
                    <span>{f.name}</span>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
        {canMove ? (
          <button type="button" className={btn} disabled={count === 0} onClick={() => run(handleMarkSpam)} title={label("email_mark_spam", "Als Spam markieren", "Mark as spam")} aria-label={label("email_mark_spam", "Als Spam markieren", "Mark as spam")}>
            <MaterialIcon icon="report" size={22} />
          </button>
        ) : null}
        <button
          type="button"
          className="kj-btn kj-btn--icon kj-btn--neutral kj-btn--danger"
          disabled={count === 0}
          onClick={() => run(deleteMultipleEmails)}
          title={label("delete", "Löschen", "Delete")}
          aria-label={label("delete", "Löschen", "Delete")}
        >
          <MaterialIcon icon="delete" size={22} />
        </button>
      </div>
    );
  };

  // Combined-view email pager. Assigned after the email fetchers exist.
  const loadMoreCombinedEmailsRef = useRef(null);
  const refreshLatestOnPullRef = useRef(() => {});
  const listScrollTopRef = useRef(0);
  const pullStartYRef = useRef(0);

  const noteListScroll = (el) => {
    if (!el) return;
    const prev = listScrollTopRef.current;
    const next = el.scrollTop || 0;
    listScrollTopRef.current = next;
    // Scrolling down from the top quietly checks for new messages and emails.
    if (prev <= 8 && next > prev + 12) {
      refreshLatestOnPullRef.current();
    }
  };

  const handleScroll = useCallback((e) => {
    noteListScroll(e.target);
    const bottom =
      parseInt(e.target.scrollHeight - e.target.scrollTop) <=
      parseInt(e.target.clientHeight) + 150;
    if (!bottom) return;

    if (!gettingChatsBottom && !isChatsOver) {
      const newPage = page + 1;
      setPage(newPage);
      setGettingChatsBottom(true);
      setIsPaginationTriggered(true);
      _getMessages(newPage);
    }

    // Also page emails in the combined messages+email list.
    if (loadMoreCombinedEmailsRef.current) loadMoreCombinedEmailsRef.current();
  }, [gettingChatsBottom, isChatsOver, page, _getMessages]);

  const handleScrollReminder = useCallback((e) => {
    const bottom =
      parseInt(e.target.scrollHeight - e.target.scrollTop) <=
      parseInt(e.target.clientHeight) + 150;
    if (bottom && !gettingChatsBottom && !isReminderOver) {
      const newPage = pageReminder + 1;
      setPageReminder(newPage);
      setGettingChatsBottom(true);
      setIsPaginationTriggered(true);
      _getMessagesReminders(newPage);
    }
  }, [gettingChatsBottom, isReminderOver, pageReminder, _getMessagesReminders]);

  const fetchEmailAccounts = useCallback(async () => {
    try {
      const { data } = await callAPI('/email/accounts', {}, 'GET');
      let accounts = [];
      if (data && Array.isArray(data)) {
        accounts = data;
      } else if (data?.accounts && Array.isArray(data.accounts)) {
        accounts = data.accounts;
      }
      const storedOrder = localStorage.getItem("emailAccountOrder");
      if (storedOrder) {
        try {
          const orderIds = JSON.parse(storedOrder);
          accounts.sort((a, b) => {
            const idA = a.id || a._id;
            const idB = b.id || b._id;
            const iA = orderIds.indexOf(idA);
            const iB = orderIds.indexOf(idB);
            if (iA === -1 && iB === -1) return 0;
            if (iA === -1) return 1;
            if (iB === -1) return -1;
            return iA - iB;
          });
        } catch (_) {}
      }
      // Sync server-stored signatures to localStorage for compose components
      try {
        const existing = JSON.parse(localStorage.getItem('emailSignatures') || '{}');
        for (const acc of accounts) {
          const id = acc.id || acc._id;
          if (acc.emailSignature) existing[id] = acc.emailSignature;
        }
        localStorage.setItem('emailSignatures', JSON.stringify(existing));
      } catch (_) {}
      dispatch({ type: SET_EMAIL_ACCOUNTS, payload: accounts });
      if (accounts.length > 0 && !activeEmailAccountId) {
        // With email in the Messages list the effect below switches to All
        // anyway; picking the single account first cost a second inbox fetch
        // and a provider folder refresh on every open.
        setActiveEmailAccountId(
          accounts.length > 1 || integrateEmailInMessages ? ALL_ACCOUNTS_ID : (accounts[0].id || accounts[0]._id)
        );
      }
      // No connected accounts → combined list can show chats without waiting for inbox rows.
      if (accounts.length === 0) {
        setEmailMessages([]);
        setSelectedEmail(null);
        setEmailInitialReady(true);
      }
    } catch (err) {
      console.error('Failed to fetch email accounts:', err);
      setEmailInitialReady(true);
    }
  }, [activeEmailAccountId, dispatch, integrateEmailInMessages]);

  const handleReorderEmailAccounts = useCallback((reordered) => {
    dispatch({ type: SET_EMAIL_ACCOUNTS, payload: reordered });
    const orderIds = reordered.map((a) => a.id || a._id);
    localStorage.setItem("emailAccountOrder", JSON.stringify(orderIds));
  }, [dispatch]);

  const fetchCustomFolders = useCallback(async (accountId, refresh = false) => {
    if (!accountId) return;
    const aid = String(accountId);
    fetchedCustomFoldersAccountsRef.current.add(aid);
    try {
      const url = `/email/accounts/${accountId}/folders${refresh ? '?refresh=true' : ''}`;
      const response = await callAPI(url, {}, 'GET');
      const data = response?.data;
      if (data?.status === true && data?.folders && Array.isArray(data.folders)) {
        const current = customFoldersRef.current || [];
        const otherAccountFolders = current.filter((f) => String(f.emailAccount) !== aid);
        dispatch({ type: SET_EMAIL_CUSTOM_FOLDERS, payload: [...otherAccountFolders, ...data.folders] });
      }
    } catch (err) {
      console.error('Failed to fetch custom folders:', err);
    }
  }, [dispatch]);

  const handleCreateFolder = useCallback(async (name) => {
    if (!activeEmailAccountId || !name) return;
    try {
      const response = await callAPI(`/email/accounts/${activeEmailAccountId}/folders`, {}, 'POST', { name });
      const data = response?.data;
      if (data?.status === true && data?.folder) {
        dispatch({ type: SET_EMAIL_CUSTOM_FOLDERS, payload: [...customFolders, data.folder] });
      } else {
        const msg = data?.message || 'Unknown error creating folder';
        console.error('Create folder failed:', msg, data);
        alert(msg);
        throw new Error(msg);
      }
    } catch (err) {
      console.error('Failed to create folder:', err);
      throw err;
    }
  }, [activeEmailAccountId, customFolders, dispatch]);

  const handleDeleteFolder = useCallback(async (folderId) => {
    if (!activeEmailAccountId || !folderId) return;
    try {
      await callAPI(`/email/accounts/${activeEmailAccountId}/folders/${folderId}`, {}, 'DELETE');
      const deleted = customFolders.find((f) => f.id === folderId);
      dispatch({ type: SET_EMAIL_CUSTOM_FOLDERS, payload: customFolders.filter((f) => f.id !== folderId) });
      if (deleted && activeEmailFolder === deleted.providerFolderId) {
        emailInboxFetchKeyRef.current = null;
        setActiveEmailFolder("INBOX");
        setEmailMessages([]);
        setEmailPage(1);
        setIsEmailsOver(false);
        setSelectedEmail(null);
        setEmailReplyMode(null);
      }
    } catch (err) {
      console.error('Failed to delete folder:', err);
    }
  }, [activeEmailAccountId, customFolders, activeEmailFolder, dispatch]);

  const handleMoveEmails = useCallback(async (messageIds, targetFolder) => {
    if (!activeEmailAccountId || !messageIds || messageIds.length === 0 || !targetFolder) return;
    // Restoring from Trash is the one move users need confirmation for —
    // the mail vanishes from the list they are looking at.
    const isRestore = activeEmailFolder === "TRASH" && targetFolder === "INBOX";
    try {
      let responses;
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        const byAccount = new Map();
        for (const msgId of messageIds) {
          const emailObj = emailMessages.find((m) => (m.id || m._id || m.messageId || m.providerMessageId) === msgId);
          const acctId = emailObj?.__accountId;
          if (acctId) {
            if (!byAccount.has(acctId)) byAccount.set(acctId, []);
            byAccount.get(acctId).push(msgId);
          }
        }
        responses = await Promise.all(
          Array.from(byAccount.entries()).map(([acctId, ids]) =>
            callAPI(`/email/accounts/${acctId}/messages/move`, {}, 'POST', { messageIds: ids, targetFolder, sourceFolder: activeEmailFolder || "INBOX" })
          )
        );
      } else {
        responses = [await callAPI(`/email/accounts/${activeEmailAccountId}/messages/move`, {}, 'POST', {
          messageIds,
          targetFolder,
          sourceFolder: activeEmailFolder || "INBOX",
        })];
      }
      // The endpoint answers 200 with per-message results; keep rows whose
      // provider move failed instead of hiding them as if they had moved.
      const failedIds = new Set();
      for (const res of responses) {
        for (const r of res?.data?.results || []) {
          if (r && r.success === false) failedIds.add(String(r.msgId));
        }
      }
      const movedIds = messageIds.filter((id) => !failedIds.has(String(id)));
      if (isRestore) {
        // Back in the inbox: stop hiding it as a recent delete.
        const restored = new Set(movedIds.map(String));
        recentlyDeletedEmailsRef.current = recentlyDeletedEmailsRef.current.filter(
          (d) => !d.ids.some((id) => restored.has(id))
        );
      }
      setEmailMessages((prev) => prev.filter((m) => {
        const mId = m.id || m._id || m.messageId || m.providerMessageId;
        return !movedIds.includes(mId);
      }));
      if (selectedEmail) {
        const selId = selectedEmail.id || selectedEmail._id || selectedEmail.messageId || selectedEmail.providerMessageId;
        if (movedIds.includes(selId)) {
          setSelectedEmail(null);
        }
      }
      if (failedIds.size > 0) {
        await $crud.notify({ type: "error", message: isRestore ? (strings.email_not_spam_failed || "Failed to move to inbox.") : (strings.email_error || "Error") });
      } else if (isRestore) {
        await $crud.notify({ type: "success", message: strings.email_not_spam_success || "Email moved to inbox." });
      }
    } catch (err) {
      console.error('Failed to move emails:', err);
      if (isRestore) {
        await $crud.notify({ type: "error", message: strings.email_not_spam_failed || "Failed to move to inbox." });
      }
    }
  }, [activeEmailAccountId, activeEmailFolder, selectedEmail, emailMessages, strings]);

  const selectedEmailRef = useRef(null);
  useEffect(() => { selectedEmailRef.current = selectedEmail; }, [selectedEmail]);

  // ── Email classification (new-sender review, handled inline per email) ──────
  const [pendingClassifications, setPendingClassifications] = useState([]);
  // Email whose "Associate to project" popup is open in the combined view.
  const [assignModalEmail, setAssignModalEmail] = useState(null);
  // Clicked project tag: { email, project } → shows navigate/change chooser.
  const [tagActionCtx, setTagActionCtx] = useState(null);
  // Projects/rooms the user belongs to, offered as suggestions when filing an
  // email. The user may also type a brand-new project name in the field.
  const [classificationBuildings, setClassificationBuildings] = useState([]);
  const [emailClassifyProgress, setEmailClassifyProgress] = useState(null);

  const roomsFromRedux = useMemo(() => {
    const out = [];
    const seen = new Set();
    const add = (p) => {
      if (!p) return;
      const id = p.id || p.buildingList;
      if (!id || seen.has(String(id))) return;
      if (p.isDone || p.isCompleted || p.isArchived || p.isDeleted) return;
      if (p.isJoin === false || p.isJoin === 0 || p.isJoin === "0") return;
      seen.add(String(id));
      out.push({
        id,
        name: p.name || "",
        themeColor: p.themeColor || null,
        projectNo: p.projectNo || "",
      });
    };
    (reduxProjects || []).forEach(add);
    (reduxInternalProjects || []).forEach((company) => {
      (company.userProjectList || []).forEach(add);
    });
    return out;
  }, [reduxProjects, reduxInternalProjects]);

  const assignableRooms = useMemo(
    () => (classificationBuildings && classificationBuildings.length ? classificationBuildings : roomsFromRedux),
    [classificationBuildings, roomsFromRedux]
  );

  // Map of building/room id → assigned theme color, so project tags can render
  // in their project's specific color (fallback for emails whose linkedProjects
  // don't yet carry themeColor from the API).
  const projectColorById = useMemo(() => {
    const m = new Map();
    (assignableRooms || []).forEach((b) => {
      if (b && b.themeColor) m.set(String(b.id), b.themeColor);
    });
    return m;
  }, [assignableRooms]);

  const resolveProjectColor = useCallback(
    (p) => (p && p.themeColor) || projectColorById.get(String(p?.id)) || null,
    [projectColorById]
  );

  const fetchPendingClassifications = useCallback(async () => {
    if (!isEmailFeatureEnabled) return;
    try {
      const res = await callAPI(`/email/classification/pending`, {}, "GET");
      const data = res?.data || res;
      if (data && data.status && Array.isArray(data.data)) {
        setPendingClassifications(data.data);
      }
    } catch (e) {
      // non-fatal: the banner just won't show
    }
  }, [isEmailFeatureEnabled]);

  const fetchClassificationBuildings = useCallback(async () => {
    if (!isEmailFeatureEnabled) return;
    try {
      const res = await callAPI(`/email/classification/buildings`, {}, "GET");
      const data = res?.data || res;
      const list = data?.buildings && Array.isArray(data.buildings) ? data.buildings : [];
      setClassificationBuildings(list.map((b) => ({
        id: b.id,
        name: b.name,
        themeColor: b.themeColor || null,
        projectNo: b.projectNo || "",
        aliases: Array.isArray(b.aliases) ? b.aliases : [],
      })));
    } catch (e) {
      // non-fatal: the field just won't have autocomplete suggestions
    }
  }, [isEmailFeatureEnabled]);

  const emailMatchesClassifyId = (m, messageId, extraIds = []) => {
    if (!m) return false;
    const drop = new Set(
      [messageId, ...extraIds]
        .filter((v) => v != null && String(v).trim() !== "")
        .map((v) => String(v))
    );
    const acc = emailRowAccountId(m);
    const keys = [
      m.id,
      m._id,
      m.messageId,
      m.providerMessageId,
      m.internetMessageId,
      classifyMessageId(m),
    ];
    for (const raw of keys) {
      if (raw == null || String(raw).trim() === "") continue;
      const id = String(raw);
      if (drop.has(id)) return true;
      if (acc && drop.has(`${acc}:${id}`)) return true;
      if (acc && id.startsWith(`${acc}:`) && drop.has(id.slice(acc.length + 1))) return true;
    }
    return false;
  };

  const handleEmailClassified = useCallback((messageId, decision, extraIds = []) => {
    // Drop the just-handled email (and any auto-linked siblings) from the queue;
    // spam decisions also remove it from the inbox list so it disappears immediately.
    setPendingClassifications((prev) => prev.filter((m) => !emailMatchesClassifyId(m, messageId, extraIds)));
    if (decision === "spam") {
      setEmailMessages((prev) => prev.filter((m) => !emailMatchesClassifyId(m, messageId, extraIds)));
      setSelectedEmail((prev) => (emailMatchesClassifyId(prev, messageId, extraIds) ? null : prev));
    }
  }, []);

  // Inline classification straight from an inbox row: file the email into a
  // project (existing name match or a new project the server creates) or mark it
  // as SPAM. Replaces the former step-through modal.
  const classifyEmailInline = useCallback(
    async (messageId, decision, projectName, buildingId, companyId, isInternal, onProgress) => {
      const source = assignModalEmail
        || (emailMessages || []).find((m) => emailMatchesClassifyId(m, messageId))
        || selectedEmail;
      const classifyId = classifyMessageId(source) || String(messageId || "").trim();
      if (!classifyId) return;

      const reportProgress = (p) => {
        onProgress?.(p);
        setEmailClassifyProgress(p);
      };
      const clearProgress = () => setEmailClassifyProgress(null);
      const liveCtx = liveEmailClassifyContext(
        source,
        activeEmailFolder,
        (source && (source.__accountId || source.emailAccountId || source.emailAccount))
          || (activeEmailAccountId && activeEmailAccountId !== ALL_ACCOUNTS_ID ? activeEmailAccountId : undefined)
      );
      if (!liveCtx.providerMessageId && source && source.providerMessageId) {
        liveCtx.providerMessageId = source.providerMessageId;
      }

      if (decision === "unlink") {
        try {
          const res = await callAPI(`/email/classification/classify`, {}, "POST", {
            messageId: classifyId,
            decision: "unlink",
            buildingId,
            ...liveCtx,
          });
          const data = res?.data || res;
          if (data && data.status) {
            const persistedId = data.emailMessage && data.emailMessage.id;
            const removeTag = (m) => {
              if (!emailMatchesClassifyId(m, classifyId, [messageId, persistedId].filter(Boolean))) return m;
              const existing = Array.isArray(m.linkedProjects) ? m.linkedProjects : [];
              return { ...m, linkedProjects: buildingId ? existing.filter((x) => String(x.id) !== String(buildingId)) : [] };
            };
            setEmailMessages((prev) => prev.map(removeTag));
            setSelectedEmail((prev) => (prev ? removeTag(prev) : prev));
            $crud.notify({ type: "success", message: strings.email_project_removed || "Project association removed" });
          } else {
            $crud.notify({ type: "error", message: (data && data.message) || strings.something_went_wrong || "Something went wrong" });
          }
        } catch (e) {
          $crud.notify({ type: "error", message: strings.something_went_wrong || "Something went wrong" });
        }
        return;
      }

      if (decision === "spam") {
        // Remove the row immediately so the list doesn't wait on the classify API.
        // No success toast — the disappearing row is the feedback.
        let snapshot = null;
        setEmailMessages((prev) => {
          snapshot = prev.find((m) => emailMatchesClassifyId(m, classifyId, [messageId])) || null;
          return prev.filter((m) => !emailMatchesClassifyId(m, classifyId, [messageId]));
        });
        setPendingClassifications((prev) => prev.filter((m) => !emailMatchesClassifyId(m, classifyId, [messageId])));
        setSelectedEmail((prev) => (emailMatchesClassifyId(prev, classifyId, [messageId]) ? null : prev));

        try {
          const { autoLinkedIds } = await classifySpamWithProgress({
            messageId: classifyId,
            onProgress: reportProgress,
            extra: liveCtx,
          });
          if (autoLinkedIds.length) handleEmailClassified(classifyId, "spam", autoLinkedIds);
        } catch (e) {
          if (snapshot) {
            setEmailMessages((prev) => (
              prev.some((m) => emailMatchesClassifyId(m, classifyId, [messageId])) ? prev : [snapshot, ...prev]
            ));
          }
          $crud.notify({ type: "error", message: (e && e.data && e.data.message) || e?.message || strings.something_went_wrong || "Something went wrong" });
          throw e;
        } finally {
          clearProgress();
        }
        return;
      }

      if (decision === "project" && !(projectName || "").trim()) {
        $crud.notify({ type: "error", message: strings.email_classify_need_project || "Please enter a project name" });
        return;
      }
      const body = { messageId: classifyId, decision, ...liveCtx };
      let matchedBuilding = null;
      if (decision === "project") {
        const name = projectName.trim();
        // Prefer an explicitly chosen existing project (from the type-ahead
        // picker). For a brand-new INTERNAL room, do not reuse an existing
        // external room by name — create via createInternalBuilding so it
        // lands in the Kjuup+ internal section.
        if (buildingId) {
          matchedBuilding = assignableRooms.find((b) => String(b.id) === String(buildingId)) || { id: buildingId, name };
        } else if (isInternal) {
          try {
            matchedBuilding = await createInternalEmailRoom(name, companyId);
            dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
          } catch (createErr) {
            $crud.notify({
              type: "error",
              message: (createErr && createErr.message) || strings.something_went_wrong || "Something went wrong",
            });
            return;
          }
        } else {
          matchedBuilding = assignableRooms.find((b) => (b.name || "").trim().toLowerCase() === name.toLowerCase());
        }
        if (matchedBuilding) body.buildingId = matchedBuilding.id;
        body.buildingName = name;
        // Optional company connection: only relevant when creating a brand-new
        // external room (no matched building). Ignored server-side for existing rooms.
        if (!matchedBuilding && companyId) body.companyId = companyId;
        if (!matchedBuilding && isInternal) body.isInternal = true;
        // Sender→project auto-rules are intentionally NOT created: every email
        // is re-classified on its own, so a sticky sender rule isn't wanted.
        body.rememberSender = false;
        body.applyToAccount = false;
      }
      try {
        const { autoLinkedIds, data, persistedId } = await classifyProjectWithProgress({
          messageId: classifyId,
          body,
          onProgress: reportProgress,
        });
        handleEmailClassified(classifyId, decision, autoLinkedIds);
        if (decision === "project") {
          const name = projectName.trim();
          const serverBuilding = data.building;
          const projId = (serverBuilding && serverBuilding.id) || (matchedBuilding ? matchedBuilding.id : `new-${name}`);
          const tag = {
            id: projId,
            name: (serverBuilding && serverBuilding.name) || name,
            themeColor: (serverBuilding && serverBuilding.themeColor) || null,
          };
          const extraMatchIds = [
            messageId,
            classifyId,
            persistedId,
            source && source.providerMessageId,
            source && source.internetMessageId,
          ].filter(Boolean);
          const addTag = (m) => {
            const isSource = emailMatchesClassifyId(m, classifyId, extraMatchIds);
            const isSimilar = autoLinkedIds.some((id) => emailMatchesClassifyId(m, id));
            if (!isSource && !isSimilar) return m;
            const existing = Array.isArray(m.linkedProjects) ? m.linkedProjects : [];
            if (existing.length === 1 && String(existing[0].id) === String(projId) && (!persistedId || m.id === persistedId)) {
              return m;
            }
            const next = { ...m, linkedProjects: [tag] };
            if (isSource && persistedId && !isPersistedEmailId(m.id)) {
              next.id = persistedId;
              next._id = persistedId;
            }
            return next;
          };
          setEmailMessages((prev) => prev.map(addTag));
          setSelectedEmail((prev) => (prev ? addTag(prev) : prev));
          // A new project may have been created server-side; refresh the list.
          if (!buildingId) fetchClassificationBuildings();
          const similar = autoLinkedIds.length;
          const savedMsg = similar
            ? (strings.email_saved_to_project_similar || "Email saved to project. {count} similar emails were also assigned.").replace("{count}", similar)
            : (strings.email_saved_to_project || "Email saved to project");
          $crud.notify({ type: "success", message: savedMsg });
        }
      } catch (e) {
        $crud.notify({ type: "error", message: (e && e.data && e.data.message) || e?.message || strings.something_went_wrong || "Something went wrong" });
        throw e;
      } finally {
        clearProgress();
      }
    },
    [assignableRooms, handleEmailClassified, fetchClassificationBuildings, strings, dispatch, assignModalEmail, emailMessages, selectedEmail, activeEmailFolder, activeEmailAccountId]
  );

  // Match an email row to its pending-classification entry (any id variant) so
  // the assign popup can pre-fill a server-proposed project name.
  const findPendingForEmail = useCallback(
    (em) => {
      if (!em) return null;
      const ids = [em.id, em._id, em.messageId, em.providerMessageId]
        .filter((v) => v != null)
        .map(String);
      return (
        pendingClassifications.find((p) => {
          const pid = [p.id, p._id, p.messageId, p.providerMessageId]
            .filter((v) => v != null)
            .map(String);
          return pid.some((x) => ids.includes(x));
        }) || null
      );
    },
    [pendingClassifications]
  );

  // Tracks email ids we've already marked read this session so the unread
  // counter is decremented exactly once per email. Without this, opening a
  // single email can fire `markEmailAsRead` several times — the auto-read
  // effect re-runs whenever `selectedEmail` changes, and the detail/enrich
  // fetches re-set `selectedEmail` with a server copy whose `isRead` is still
  // `false` (it was captured before the read PATCH committed), which flips the
  // flag back and defeats the `email.isRead === true` guard. Each extra pass
  // used to dispatch another DECREMENT, zeroing the counter instead of
  // removing just one.
  const markedReadIdsRef = useRef(new Set());

  const isRefreshingRef = useRef(false);
  const emailFolderSearchQueryRef = useRef("");
  const folderSearchSeqRef = useRef(0);
  // Pre-search folder list so clearing "search in this folder" can restore
  // instantly instead of re-hitting live SENT/IMAP endpoints (limit=200).
  const folderListSnapshotRef = useRef(null);
  // Bumped by every page-1 list load and by a folder search. A load whose
  // number is no longer current drops its rows: live Trash/Spam/Sent loads
  // take seconds, and a late answer used to replace the search results (or
  // the folder the user switched to meanwhile).
  const emailListSeqRef = useRef(0);

  // Tracks which accounts have run out of pages in the unified "All Accounts"
  // view. Because each account paginates independently, we keep fetching the
  // next page only for accounts that still returned a full page; once every
  // account is exhausted we flip `isEmailsOver`. Reset on every fresh (page 1)
  // load. Without this, All Accounts only ever showed the first page per
  // account, so "Unread only" + bulk-delete could never reach unread emails on
  // later pages.
  const allAccountsExhaustedRef = useRef(new Set());

  // Mirror of `showUnreadOnly` so the stable fetch callbacks below can read
  // the current value without busting their useCallback memoization (and
  // dragging every dependent effect/refetch with them).
  const showUnreadOnlyRef = useRef(false);
  useEffect(() => { showUnreadOnlyRef.current = showUnreadOnly; }, [showUnreadOnly]);

  // Counts overlapping delete/remove requests so we don't refill the unread
  // list from the server until every in-flight DELETE has committed. Refetching
  // earlier can bring the just-deleted rows back (offset page 1 still contains
  // them) and leave later-page unreads stranded.
  const emailMutationInFlightRef = useRef(0);
  const [emailMutationGen, setEmailMutationGen] = useState(0);
  const beginEmailMutation = useCallback(() => {
    emailMutationInFlightRef.current += 1;
  }, []);
  const endEmailMutation = useCallback(() => {
    emailMutationInFlightRef.current = Math.max(0, emailMutationInFlightRef.current - 1);
    if (emailMutationInFlightRef.current === 0) {
      setEmailMutationGen((g) => g + 1);
    }
  }, []);
  const refillUnreadEmailsInFlightRef = useRef(false);
  // "Load more" of the unread-only list; assigned once refillUnreadEmails exists.
  const growUnreadEmailsRef = useRef(null);
  // Mails deleted in the last minutes. A Gmail delete only stamps TRASH next to
  // the INBOX label until the background provider call drops the row, so an
  // inbox refill right after the delete would still return it.
  // One entry per mail: { at, account, ids }.
  const recentlyDeletedEmailsRef = useRef([]);
  const liveRecentlyDeletedEmails = useCallback(() => {
    const now = Date.now();
    const live = recentlyDeletedEmailsRef.current.filter((d) => now - d.at <= RECENT_DELETE_TTL_MS);
    recentlyDeletedEmailsRef.current = live;
    return live;
  }, []);
  const rememberDeletedEmail = useCallback((email, extraIds) => {
    const ids = [...emailEntryIds(email), ...(extraIds || [])]
      .filter((x) => x != null && String(x).trim() !== "")
      .map(String);
    if (ids.length === 0) return;
    recentlyDeletedEmailsRef.current.push({ at: Date.now(), account: emailRowAccountId(email), ids });
  }, []);
  const dropRecentlyDeletedEmails = useCallback((messages, folder) => {
    if (folder === "TRASH") return messages;
    const live = liveRecentlyDeletedEmails();
    if (live.length === 0) return messages;
    const deleted = new Set();
    live.forEach((d) => d.ids.forEach((id) => deleted.add(id)));
    return messages.filter((m) => !emailEntryIds(m).some((id) => deleted.has(id)));
  }, [liveRecentlyDeletedEmails]);

  // The newest fetch that switched a loading flag on. A superseded fetch used
  // to leave the flag to the newer one, but a newer silent fetch never clears
  // it, so the list kept "loading" and scrolling loaded nothing more.
  const emailLoadingTokenRef = useRef(0);
  const startEmailLoading = useCallback((silent) => {
    if (silent) return null;
    emailLoadingTokenRef.current += 1;
    return emailLoadingTokenRef.current;
  }, []);
  const endEmailLoading = useCallback((token) => {
    if (token == null || token !== emailLoadingTokenRef.current) return;
    setEmailLoading(false);
    setEmailPaginationLoading(false);
  }, []);

  const fetchEmailMessages = useCallback(async (accountId, pageNum = 1, append = false, folder = null, silent = false, pageLimit = 30) => {
    if (!accountId) return;
    const listSeq = append ? emailListSeqRef.current : ++emailListSeqRef.current;
    const loadingToken = startEmailLoading(silent);
    if (!silent) {
      if (pageNum === 1) {
        setEmailLoading(true);
      } else {
        setEmailPaginationLoading(true);
      }
    }
    const SYSTEM_FOLDERS = ["INBOX", "SPAM", "DRAFT", "TRASH", "SENT", "STARRED", "ARCHIVE"];
    const isCustomFolder = folder && !SYSTEM_FOLDERS.includes(folder);
    // When the "Unread only" toggle is active and we're hitting the BE's
    // `/email/messages` endpoint (which supports `unreadOnly`), let the BE
    // pre-filter so we don't have to drag every read message across the
    // wire just to drop them client-side. The SPAM/DRAFT/TRASH/SENT
    // helper endpoints don't support the flag — appending it is harmless
    // there and would only affect the few folders that route through
    // `/email/messages`.
    const unreadOnlyQuery = showUnreadOnlyRef.current ? "&unreadOnly=true" : "";
    try {
      let url;
      if (isCustomFolder) {
        url = `/email/accounts/${accountId}/folder-messages?folder=${encodeURIComponent(folder)}&limit=30`;
      } else if (folder === "SPAM") {
        url = `/email/accounts/${accountId}/spam?limit=30`;
      } else if (folder === "DRAFT") {
        url = `/email/accounts/${accountId}/drafts?limit=200&_=${Date.now()}`;
      } else if (folder === "TRASH") {
        url = `/email/accounts/${accountId}/deleted?limit=200`;
      } else if (folder === "SENT") {
        url = `/email/accounts/${accountId}/sent?limit=200`;
      } else if (folder === "STARRED") {
        url = `/email/messages?accountId=${accountId}&folder=STARRED&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
      } else if (folder === "ARCHIVE") {
        url = `/email/messages?accountId=${accountId}&folder=ARCHIVE&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
      } else {
        url = `/email/messages?accountId=${accountId}&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
        if (folder) url += `&folder=${encodeURIComponent(folder)}`;
      }
      const { data } = await callAPI(url, {}, 'GET');
      if (listSeq !== emailListSeqRef.current || emailFolderSearchQueryRef.current) {
        endEmailLoading(loadingToken);
        return;
      }
      let messages = [];
      if (data && Array.isArray(data)) {
        messages = data;
      } else if (data?.messages && Array.isArray(data.messages)) {
        messages = data.messages;
      } else if (data?.drafts && Array.isArray(data.drafts)) {
        messages = data.drafts;
      } else if (data?.emails && Array.isArray(data.emails)) {
        messages = data.emails;
      } else if (data?.data && Array.isArray(data.data)) {
        messages = data.data;
      } else if (data?.data?.messages && Array.isArray(data.data.messages)) {
        messages = data.data.messages;
      } else if (data?.data?.drafts && Array.isArray(data.data.drafts)) {
        messages = data.data.drafts;
      } else if (data?.results && Array.isArray(data.results)) {
        messages = data.results;
      }
      if (folder === "SENT") {
        messages = tagFolderEmails(dedupeSentFolderMessages(messages), "SENT");
      } else if (folder === "DRAFT" || folder === "TRASH" || folder === "SPAM") {
        messages = tagFolderEmails(messages, folder);
      }
      if (folder === "DRAFT") {
        messages = dropStaleDraftRows(messages, staleDraftIdsRef.current);
      }
      if (isCustomFolder || folder === "SPAM" || folder === "DRAFT" || folder === "TRASH" || folder === "SENT" || messages.length < pageLimit) {
        setIsEmailsOver(true);
      }
      messages = dropRecentlyDeletedEmails(messages, folder);
      mergeBookmarkedEmailIdsFromMessages(messages, { append });
      if (append) {
        setEmailMessages(prev => [...prev, ...messages]);
        if (isInboxFeedFolder(folder)) {
          setInboxFeedEmails((prev) => [...prev, ...messages.filter(isCombinedFeedEmail)]);
        }
      } else if (isRefreshingRef.current) {
        setEmailMessages(messages);
        if (isInboxFeedFolder(folder)) {
          setInboxFeedEmails(messages.filter(isCombinedFeedEmail));
        }
        const sel = selectedEmailRef.current;
        if (sel && !messages.some((m) => emailEntriesShareId(m, sel))) {
          setSelectedEmail(null);
        }
        isRefreshingRef.current = false;
      } else {
        const connectedIds = new Set(
          (emailAccountsRef.current || []).map((a) => String(a.id || a._id)).filter(Boolean)
        );
        const sel = selectedEmailRef.current;
        const selAid = emailRowAccountId(sel);
        const selStillValid =
          sel &&
          connectedIds.size > 0 &&
          (!selAid || connectedIds.has(selAid));
        if (connectedIds.size === 0) {
          setEmailMessages([]);
          if (isInboxFeedFolder(folder)) setInboxFeedEmails([]);
          setSelectedEmail(null);
        } else if (
          folder !== "DRAFT" &&
          selStillValid &&
          !messages.some((m) => emailEntriesShareId(m, sel)) &&
          (!isInboxFeedFolder(folder) || isCombinedFeedEmail(sel))
        ) {
          setEmailMessages([sel, ...messages]);
          if (isInboxFeedFolder(folder)) {
            setInboxFeedEmails(messages.filter(isCombinedFeedEmail));
          }
        } else {
          setEmailMessages(messages);
          if (isInboxFeedFolder(folder)) {
            setInboxFeedEmails(messages.filter(isCombinedFeedEmail));
          }
          if (sel && (folder === "DRAFT" ? !messages.some((m) => emailEntriesShareId(m, sel)) : !selStillValid)) {
            setSelectedEmail(null);
          }
        }
      }
    } catch (err) {
      console.error('Failed to fetch email messages:', err);
    }
    endEmailLoading(loadingToken);
    if (!append && pageNum === 1) {
      setEmailInitialReady(true);
    }
  }, [dropRecentlyDeletedEmails, startEmailLoading, endEmailLoading]);

  // `pageLimitFor(accountKey)` overrides the page size per account (unread refill).
  const fetchAllAccountsMessages = useCallback(async (pageNum = 1, append = false, folder = null, silent = false, pageLimitFor = null) => {
    if (!emailAccounts || emailAccounts.length === 0) {
      setEmailMessages([]);
      setSelectedEmail(null);
      setEmailInitialReady(true);
      return;
    }
    const listSeq = append ? emailListSeqRef.current : ++emailListSeqRef.current;
    const loadingToken = startEmailLoading(silent);
    if (!silent) {
      if (pageNum === 1) {
        setEmailLoading(true);
      } else {
        setEmailPaginationLoading(true);
      }
    }
    try {
      const SYSTEM_FOLDERS = ["INBOX", "SPAM", "DRAFT", "TRASH", "SENT", "STARRED", "ARCHIVE"];
      const isCustomFolder = folder && !SYSTEM_FOLDERS.includes(folder);
      // Only INBOX/STARRED/ARCHIVE route through the paginated `/email/messages`
      // endpoint. SPAM/DRAFT/TRASH/SENT and custom folders are fetched in one
      // shot (no `page`), so they can't be paginated further.
      const isPaginatedFolder = !isCustomFolder && folder !== "SPAM" && folder !== "DRAFT" && folder !== "TRASH" && folder !== "SENT";
      // See `fetchEmailMessages` above for the rationale. We only attach the
      // flag to the `/email/messages` routes that actually support it.
      const unreadOnlyQuery = showUnreadOnlyRef.current ? "&unreadOnly=true" : "";

      // Fresh (page 1) load resets per-account exhaustion tracking.
      if (!append) {
        allAccountsExhaustedRef.current = new Set();
      }

      const finishRows = (rows) => {
        let list = [...rows].sort((a, b) => {
          const da = new Date(a.date || a.receivedAt || 0);
          const db = new Date(b.date || b.receivedAt || 0);
          return db - da;
        });
        if (folder === "SENT") {
          list = tagFolderEmails(dedupeSentFolderMessages(list), "SENT");
        } else if (folder === "DRAFT" || folder === "TRASH" || folder === "SPAM") {
          list = tagFolderEmails(list, folder);
        }
        if (folder === "DRAFT") {
          list = dropStaleDraftRows(list, staleDraftIdsRef.current);
        }
        return list;
      };

      // Sent / Trash / Spam / Drafts read every mailbox live, and the slowest
      // account used to hold the whole list back. Show each account's rows as
      // they arrive; the merge after Promise.all still sets the final list.
      // A silent refresh keeps the shown list until everything is in.
      const showEachAccount = !append && !silent && !isPaginatedFolder;
      let arrivedRows = [];
      const showArrivedRows = (rows) => {
        if (!showEachAccount || rows.length === 0) return;
        if (listSeq !== emailListSeqRef.current || emailFolderSearchQueryRef.current) return;
        arrivedRows = [...arrivedRows, ...rows];
        setEmailMessages(finishRows(arrivedRows));
        if (!silent) setEmailLoading(false);
      };

      const allPromises = emailAccounts.map(async (acct) => {
        const accountId = acct.id || acct._id;
        const accountKey = String(accountId);
        // When loading a further page, skip accounts that already returned a
        // partial/empty page — they have no more to give and re-querying could
        // duplicate rows.
        if (append && isPaginatedFolder && allAccountsExhaustedRef.current.has(accountKey)) {
          return [];
        }
        const pageLimit = (pageLimitFor && pageLimitFor(accountKey)) || 30;
        let url;
        if (isCustomFolder) {
          url = `/email/accounts/${accountId}/folder-messages?folder=${encodeURIComponent(folder)}&limit=30`;
        } else if (folder === "SPAM") {
          url = `/email/accounts/${accountId}/spam?limit=30`;
        } else if (folder === "DRAFT") {
          url = `/email/accounts/${accountId}/drafts?limit=200&_=${Date.now()}`;
        } else if (folder === "TRASH") {
          url = `/email/accounts/${accountId}/deleted?limit=200`;
        } else if (folder === "SENT") {
          url = `/email/accounts/${accountId}/sent?limit=200`;
        } else if (folder === "STARRED") {
          url = `/email/messages?accountId=${accountId}&folder=STARRED&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
        } else if (folder === "ARCHIVE") {
          url = `/email/messages?accountId=${accountId}&folder=ARCHIVE&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
        } else {
          url = `/email/messages?accountId=${accountId}&page=${pageNum}&limit=${pageLimit}${unreadOnlyQuery}`;
          if (folder) url += `&folder=${encodeURIComponent(folder)}`;
        }
        try {
          const { data } = await callAPI(url, {}, 'GET');
          let messages = [];
          if (data && Array.isArray(data)) {
            messages = data;
          } else if (data?.messages && Array.isArray(data.messages)) {
            messages = data.messages;
          } else if (data?.drafts && Array.isArray(data.drafts)) {
            messages = data.drafts;
          } else if (data?.emails && Array.isArray(data.emails)) {
            messages = data.emails;
          } else if (data?.data && Array.isArray(data.data)) {
            messages = data.data;
          } else if (data?.data?.messages && Array.isArray(data.data.messages)) {
            messages = data.data.messages;
          } else if (data?.data?.drafts && Array.isArray(data.data.drafts)) {
            messages = data.data.drafts;
          } else if (data?.results && Array.isArray(data.results)) {
            messages = data.results;
          }
          if (listSeq !== emailListSeqRef.current) return [];
          // A short page means this account has no further pages.
          if (isPaginatedFolder && messages.length < pageLimit) {
            allAccountsExhaustedRef.current.add(accountKey);
          }
          const rows = dropRecentlyDeletedEmails(messages, folder)
            .map((m) => ({ ...m, __accountId: accountId, __accountEmail: acct.email || acct.name }));
          showArrivedRows(rows);
          return rows;
        } catch {
          // Treat a failed request as exhausted so we don't spin on it.
          if (isPaginatedFolder) allAccountsExhaustedRef.current.add(accountKey);
          return [];
        }
      });

      const allResults = await Promise.all(allPromises);
      if (listSeq !== emailListSeqRef.current || emailFolderSearchQueryRef.current) {
        endEmailLoading(loadingToken);
        return;
      }
      const merged = finishRows(allResults.flat());

      mergeBookmarkedEmailIdsFromMessages(merged, { append });

      if (isPaginatedFolder) {
        // More to load as long as at least one account still has pages left.
        const allExhausted = emailAccounts.every((acct) =>
          allAccountsExhaustedRef.current.has(String(acct.id || acct._id))
        );
        setIsEmailsOver(allExhausted);
      } else {
        // Non-paginated folders are fetched in a single shot.
        setIsEmailsOver(true);
      }
      if (append) {
        setEmailMessages((prev) => [...prev, ...merged]);
        if (isInboxFeedFolder(folder)) {
          setInboxFeedEmails((prev) => [...prev, ...merged.filter(isCombinedFeedEmail)]);
        }
      } else {
        setEmailMessages(merged);
        if (isInboxFeedFolder(folder)) {
          setInboxFeedEmails(merged.filter(isCombinedFeedEmail));
        }
        const sel = selectedEmailRef.current;
        if (folder === "DRAFT" && sel && !merged.some((m) => emailEntriesShareId(m, sel))) {
          setSelectedEmail(null);
        }
      }
    } catch (err) {
      console.error('Failed to fetch all-accounts messages:', err);
    }
    endEmailLoading(loadingToken);
    if (!append && pageNum === 1) {
      setEmailInitialReady(true);
    }
  }, [emailAccounts, dropRecentlyDeletedEmails, startEmailLoading, endEmailLoading]);

  const returnedToMessagesRef = useRef(false);
  useEffect(() => {
    if (!isLatestMessagesRoute) {
      returnedToMessagesRef.current = true;
      return;
    }
    if (!returnedToMessagesRef.current) return;
    returnedToMessagesRef.current = false;
    if (!integrateEmailInMessages || !emailAccounts || emailAccounts.length === 0) return;
    const folder = activeEmailFolder || "INBOX";
    if (!activeEmailAccountId || activeEmailAccountId === ALL_ACCOUNTS_ID) {
      fetchAllAccountsMessages(1, false, folder, true);
    } else {
      fetchEmailMessages(activeEmailAccountId, 1, false, folder, true);
    }
  }, [isLatestMessagesRoute]);

  /** Parse GET /email/messages/:id response (shape varies by API version). */
  const extractEmailMessageFromSingleGetResponse = useCallback((data) => {
    if (!data || typeof data !== "object") return null;
    if (data.status === false && !data.message && data.id == null && data.subject == null) return null;
    if (data.message && typeof data.message === "object") return data.message;
    if (
      data.data &&
      typeof data.data === "object" &&
      (data.data.id != null || data.data._id != null || data.data.subject !== undefined)
    ) {
      return data.data;
    }
    if (data.id != null || data._id != null || data.messageId != null || data.providerMessageId != null || data.subject !== undefined) {
      return data;
    }
    return null;
  }, []);

  // Opening an email triggers both the select handler's refresh and the
  // enrich effect below; share one in-flight request per id between them.
  const emailDetailFetchesRef = useRef(new Map());
  const fetchEmailMessageById = useCallback(
    (messageId, accountId, folder) => {
      if (!messageId || !isPersistedEmailId(messageId)) return Promise.resolve(null);
      const key = String(messageId);
      const inFlight = emailDetailFetchesRef.current.get(key);
      if (inFlight) return inFlight;
      const request = (async () => {
        try {
          const params = {};
          if (accountId) params.accountId = accountId;
          if (folder) params.folder = folder;
          const res = await callAPI(
            `/email/messages/${encodeURIComponent(key)}`,
            params,
            "GET"
          );
          const { data, status } = res;
          if (status === 404) return null;
          return extractEmailMessageFromSingleGetResponse(data);
        } catch (err) {
          console.error("Failed to fetch email message by id:", err);
          return null;
        } finally {
          emailDetailFetchesRef.current.delete(key);
        }
      })();
      emailDetailFetchesRef.current.set(key, request);
      return request;
    },
    [extractEmailMessageFromSingleGetResponse]
  );

  const handleEmailAccountSelect = useCallback((accountId) => {
    emailInboxFetchKeyRef.current = null;
    emailFolderSearchQueryRef.current = "";
    folderListSnapshotRef.current = null;
    folderSearchSeqRef.current += 1;
    setIsFolderSearching(false);
    setActiveEmailAccountId(accountId);
    setActiveEmailFolder("INBOX");
    setEmailMessages([]);
    setEmailPage(1);
    setIsEmailsOver(false);
    setSelectedEmail(null);
    dispatch({ type: CLEAR_EMAIL_SEARCH });
  }, [dispatch]);

  const handleSelectEmail = useCallback((email) => {
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    setHoistedRow(null);
    scrollToOpenedEmailRowRef.current = false;
    updateOpenChats([]);
    updateOpenProjects([]);
    updateGroupChats([]);
    setClickedGroup(null);
    setSelectedEmail(email);
    // Defensively re-fetch the full email so the detail view always has
    // up-to-date data (full body, fully populated attachments, all
    // recipient arrays) even when the list response is stale or only
    // returns a thin row.
    const detailId = email && (isPersistedEmailId(email.id) ? email.id : (isPersistedEmailId(email._id) ? email._id : null));
    const detailAccountId =
      email && (
        email.emailAccount
        || email.emailAccountId
        || email.__accountId
        || (activeEmailAccountId && activeEmailAccountId !== ALL_ACCOUNTS_ID ? activeEmailAccountId : undefined)
      );
    if (detailId) {
      (async () => {
        const fresh = await fetchEmailMessageById(detailId, detailAccountId, email.folder || activeEmailFolder);
        if (!fresh) return;
        setSelectedEmail((prev) => {
          if (!prev) return prev;
          if (!emailEntriesShareId(prev, email) && (prev.id || prev._id) !== detailId) return prev;
          return mergeEnrichedEmail(prev, fresh);
        });
        // Recompute the list-row preview from the full body so tracking/image
        // URLs from the thin list payload do not stick around.
        const snippet = fresh.snippet || fresh.bodyText;
        const bodyPreview = firstEmailSentence(fresh.bodyText || fresh.body || fresh.bodyPreview || "");
        if (snippet || bodyPreview) {
          setEmailMessages((prev) =>
            prev.map((m) => {
              const mid = m.id || m._id;
              if (mid !== detailId) return m;
              return {
                ...m,
                snippet: m.snippet || (typeof snippet === "string" ? snippet.replace(/\s+/g, " ").trim().slice(0, 200) : m.snippet),
                bodyPreview: bodyPreview || m.bodyPreview || "",
              };
            })
          );
        }
      })();
    }
  }, [activeEmailFolder, activeEmailAccountId, fetchEmailMessageById, exclusiveMessagesPane]);

  const handleEmailFolderSelect = useCallback((folderKey) => {
    emailInboxFetchKeyRef.current = null;
    emailFolderSearchQueryRef.current = "";
    folderListSnapshotRef.current = null;
    folderSearchSeqRef.current += 1;
    setIsFolderSearching(false);
    setActiveEmailFolder(folderKey);
    setEmailMessages([]);
    setEmailPage(1);
    setIsEmailsOver(false);
    setSelectedEmail(null);
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    dispatch({ type: CLEAR_EMAIL_SEARCH });
  }, [dispatch, exclusiveMessagesPane]);

  const searchFolderMessages = useCallback(async (query) => {
    const trimmed = String(query || "").trim();
    const prevQuery = emailFolderSearchQueryRef.current;
    emailFolderSearchQueryRef.current = trimmed;
    const seq = ++folderSearchSeqRef.current;

    if (!trimmed) {
      setIsFolderSearching(false);
      if (!prevQuery) return;
      const snap = folderListSnapshotRef.current;
      folderListSnapshotRef.current = null;
      if (snap && Array.isArray(snap.messages) && snap.messages.length > 0) {
        setEmailMessages(snap.messages);
        if (Array.isArray(snap.inboxFeed)) setInboxFeedEmails(snap.inboxFeed);
        setEmailPage(snap.page || 1);
        setIsEmailsOver(!!snap.isOver);
        if (activeEmailAccountId) {
          emailInboxFetchKeyRef.current = `${activeEmailAccountId}|${activeEmailFolder}`;
        }
        return;
      }
      emailInboxFetchKeyRef.current = null;
      if (!activeEmailAccountId) return;
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        fetchAllAccountsMessages(1, false, activeEmailFolder);
      } else {
        fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
      }
      return;
    }

    if (!prevQuery) {
      folderListSnapshotRef.current = {
        messages: emailMessagesRef.current.slice(),
        inboxFeed: inboxFeedEmailsRef.current.slice(),
        page: emailPageRef.current,
        isOver: isEmailsOverRef.current,
      };
    }

    // The search owns the list now: a folder load still in flight is dropped.
    emailListSeqRef.current += 1;
    setEmailLoading(false);
    setEmailPaginationLoading(false);
    setIsFolderSearching(true);
    try {
      const params = {
        q: trimmed,
        folder: activeEmailFolder || "INBOX",
        page: 1,
        limit: 50,
      };
      if (activeEmailAccountId && activeEmailAccountId !== ALL_ACCOUNTS_ID) {
        params.accountId = activeEmailAccountId;
      }
      const { data } = await callAPI("/email/messages/search", params, "GET");
      if (seq !== folderSearchSeqRef.current) return;
      const messages = Array.isArray(data?.messages) ? data.messages : [];
      const tagged = messages.map((m) => ({
        ...m,
        __accountId: m.emailAccount || m.emailAccountId || m.__accountId,
      }));
      setEmailMessages(tagged);
      setIsEmailsOver(true);
      setEmailPage(1);
    } catch (err) {
      console.error("Folder search failed:", err);
    } finally {
      if (seq === folderSearchSeqRef.current) setIsFolderSearching(false);
    }
  }, [activeEmailAccountId, activeEmailFolder, fetchAllAccountsMessages, fetchEmailMessages]);

  const handleEmailScroll = useCallback((e) => {
    noteListScroll(e.target);
    if (emailFolderSearchQueryRef.current) return;
    const bottom =
      parseInt(e.target.scrollHeight - e.target.scrollTop) <=
      parseInt(e.target.clientHeight) + 150;
    if (bottom && !emailPaginationLoading && !emailLoading) {
      if (showUnreadOnlyRef.current) {
        if (!isEmailsOver && growUnreadEmailsRef.current) growUnreadEmailsRef.current();
        return;
      }
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        // Unified inbox paginates each account independently until every
        // account is exhausted; only then is there nothing more to load.
        if (!isEmailsOver) {
          const newPage = emailPage + 1;
          setEmailPage(newPage);
          fetchAllAccountsMessages(newPage, true, activeEmailFolder);
        }
        return;
      }
      if (!isEmailsOver) {
        const newPage = emailPage + 1;
        setEmailPage(newPage);
        fetchEmailMessages(activeEmailAccountId, newPage, true, activeEmailFolder);
      } else {
        setEmailPage(1);
        setIsEmailsOver(false);
        fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
      }
    }
  }, [emailPaginationLoading, emailLoading, isEmailsOver, emailPage, activeEmailAccountId, activeEmailFolder, fetchEmailMessages, fetchAllAccountsMessages]);

  // Keep the combined-view email pager current for handleScroll.
  useEffect(() => {
    loadMoreCombinedEmailsRef.current = () => {
      if (!integrateEmailInMessages || emailPaginationLoading || emailLoading || isEmailsOver) return;
      if (showUnreadOnlyRef.current) {
        if (growUnreadEmailsRef.current) growUnreadEmailsRef.current();
        return;
      }
      const nextEmailPage = emailPage + 1;
      setEmailPage(nextEmailPage);
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        fetchAllAccountsMessages(nextEmailPage, true, "INBOX");
      } else if (activeEmailAccountId) {
        fetchEmailMessages(activeEmailAccountId, nextEmailPage, true, "INBOX");
      }
    };
  }, [integrateEmailInMessages, emailPaginationLoading, emailLoading, isEmailsOver, emailPage, activeEmailAccountId, activeEmailFolder, fetchAllAccountsMessages, fetchEmailMessages]);

  // Do not fetch/merge inbox rows after trial end or cancel — Alle stays chat-only.
  const emailShouldFetch =
    hasActiveKjuupIoPlan && (emailTabActive || integrateEmailInMessages);

  useEffect(() => {
    if (!hasActiveKjuupIoPlan) {
      setEmailMessages([]);
      setInboxFeedEmails([]);
      setReportFeedEmails([]);
      setSelectedEmail(null);
      setIsEmailsOver(false);
      setEmailPage(1);
    }
  }, [hasActiveKjuupIoPlan]);

  // Always re-pull accounts when the messages screen becomes email-active.
  // Settings updates Redux on connect, but this also covers remount after
  // linking/unlinking (and the case where Redux was still empty).
  useEffect(() => {
    if (emailShouldFetch) {
      fetchEmailAccounts();
    }
  }, [emailShouldFetch]);

  // Account linked/unlinked (this device via Settings, or another device via
  // socket) — re-pull the account list so the integrated feed reflects it live.
  const lastAccountsChangedAtRef = useRef(null);
  useEffect(() => {
    if (!emailAccountsChangedAt) return;
    if (lastAccountsChangedAtRef.current === emailAccountsChangedAt) return;
    lastAccountsChangedAtRef.current = emailAccountsChangedAt;
    fetchEmailAccounts();
  }, [emailAccountsChangedAt, fetchEmailAccounts]);

  useEffect(() => {
    if (!emailShouldFetch || emailAccounts.length === 0) return;
    for (const acct of emailAccounts) {
      const aid = String(acct.id || acct._id);
      if (!aid || aid === 'undefined') continue;
      if (fetchedCustomFoldersAccountsRef.current.has(aid)) continue;
      fetchCustomFolders(aid);
    }
  }, [emailShouldFetch, emailAccounts, fetchCustomFolders]);

  // Re-sync the active account's custom folders from the server (refresh=true
  // performs an IMAP↔DB reconcile, matching the mobile app). Without this the
  // web session keeps the once-cached folder list and never surfaces folders
  // created elsewhere (e.g. on mobile), even though they exist in the DB.
  useEffect(() => {
    if (!emailShouldFetch || !activeEmailAccountId || activeEmailAccountId === ALL_ACCOUNTS_ID) return;
    fetchCustomFolders(activeEmailAccountId, true);
  }, [emailShouldFetch, activeEmailAccountId, fetchCustomFolders]);

  useEffect(() => {
    if (!emailShouldFetch || !activeEmailAccountId) return;
    const list = emailAccounts || [];
    if (list.length === 0) return;
    if (
      activeEmailAccountId !== ALL_ACCOUNTS_ID &&
      !list.some((a) => String(a.id || a._id) === String(activeEmailAccountId))
    ) {
      return;
    }
    const key = `${activeEmailAccountId}|${activeEmailFolder}`;
    if (emailInboxFetchKeyRef.current === key) return;
    emailInboxFetchKeyRef.current = key;
    if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
      fetchAllAccountsMessages(1, false, activeEmailFolder);
    } else {
      fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
    }
  }, [emailShouldFetch, activeEmailAccountId, activeEmailFolder, emailAccounts, fetchEmailMessages, fetchAllAccountsMessages]);

  // When the connected account set grows/shrinks (e.g. user linked a new inbox
  // in Settings), invalidate the inbox fetch key and reload so new accounts'
  // messages appear without a hard reload. The existing account+folder effect
  // alone won't re-run when the key is already `all|INBOX`.
  const prevEmailAccountIdsRef = useRef(null);
  useEffect(() => {
    if (!emailShouldFetch) return;
    const ids = (emailAccounts || [])
      .map((a) => String(a.id || a._id))
      .filter(Boolean)
      .sort()
      .join(",");
    const prevIdsStr = prevEmailAccountIdsRef.current;
    const prevSet = new Set((prevIdsStr || "").split(",").filter(Boolean));
    const nextSet = new Set(ids.split(",").filter(Boolean));
    const removed = [...prevSet].filter((id) => !nextSet.has(id));

    if (prevIdsStr === null) {
      prevEmailAccountIdsRef.current = ids;
      if (!ids) {
        setEmailMessages([]);
        setSelectedEmail(null);
        setEmailInitialReady(true);
      }
      return;
    }
    if (ids === prevIdsStr) return;
    prevEmailAccountIdsRef.current = ids;
    emailInboxFetchKeyRef.current = null;
    setEmailPage(1);
    setIsEmailsOver(false);

    if (removed.length > 0) {
      const removedSet = new Set(removed);
      setEmailMessages((prev) =>
        prev.filter((m) => {
          const aid = emailRowAccountId(m);
          if (aid) return !removedSet.has(aid);
          // Rows without an account id belonged to the active mailbox.
          if (removedSet.has(String(activeEmailAccountId))) return false;
          return nextSet.size > 0;
        })
      );
      setSelectedEmail((sel) => {
        if (!sel) return sel;
        const aid = emailRowAccountId(sel);
        if (removedSet.has(aid) || (!aid && removedSet.has(String(activeEmailAccountId)))) {
          return null;
        }
        return sel;
      });
      if (removedSet.has(String(activeEmailAccountId))) {
        const remaining = [...nextSet];
        setActiveEmailAccountId(
          remaining.length > 1 ? ALL_ACCOUNTS_ID : (remaining[0] || null)
        );
      }
      _reconcileBadgeCount();
    }

    if (!ids) {
      setEmailMessages([]);
      setSelectedEmail(null);
      setEmailInitialReady(true);
      dispatch({ type: RESET_UNSEEN_EMAIL_COUNT });
      _reconcileBadgeCount();
      return;
    }
    if (!activeEmailAccountId) return;
    if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
      fetchAllAccountsMessages(1, false, activeEmailFolder);
    } else if (!removed.includes(String(activeEmailAccountId))) {
      fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
    }
  }, [emailAccounts, emailShouldFetch, activeEmailAccountId, activeEmailFolder, fetchAllAccountsMessages, fetchEmailMessages, _reconcileBadgeCount, dispatch]);
  // Refetch emails from page 1 whenever the "Unread only" toggle flips so
  // the server-side `unreadOnly` filter is applied (or removed) immediately.
  // Without this, the user would have to navigate away and back to see the
  // filter take effect on the email side.
  useEffect(() => {
    if (!emailShouldFetch || !activeEmailAccountId) return;
    if (emailFolderSearchQueryRef.current) return;
    if (!showUnreadOnly && skipUnreadOffEmailRefetchRef.current) {
      skipUnreadOffEmailRefetchRef.current = false;
      // The pre-filter window is on screen already. Reload the same number of
      // rows quietly, so mail deleted, moved or read while the filter was on
      // (or a delete that errored here but went through) does not stay listed.
      // An unread refill still in flight is dropped (list sequence).
      const limit = Math.max(1, emailPageRef.current || 1) * EMAIL_LIST_PAGE_SIZE;
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        fetchAllAccountsMessages(1, false, activeEmailFolder, true, () => limit);
      } else {
        fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder, true, limit);
      }
      return;
    }
    setEmailPage(1);
    setIsEmailsOver(false);
    emailInboxFetchKeyRef.current = null;
    if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
      fetchAllAccountsMessages(1, false, activeEmailFolder);
    } else {
      fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUnreadOnly]);

  // The unread-only list always loads from the top. `/email/messages` is
  // offset-paginated and every delete, read, archive or move shrinks the
  // server's unread set, so "page N+1" skipped the mails that slid up — and
  // once a page came back short the list counted as complete, leaving older
  // unread mail unreachable. Instead each account is asked for its loaded
  // unread rows (plus one page when growing) from offset 0 and the list is
  // replaced. Scroll is not required to refill (the list can be empty after
  // clearing a page, so the user cannot reach the bottom to paginate).
  const refillUnreadEmails = useCallback(async (grow = false) => {
    if (!showUnreadOnlyRef.current) return;
    if (emailFolderSearchQueryRef.current) return;
    if (!emailShouldFetch || !activeEmailAccountId) return;
    if (refillUnreadEmailsInFlightRef.current) return;
    if (emailMutationInFlightRef.current > 0) return;

    const extra = grow ? EMAIL_LIST_PAGE_SIZE : 0;
    const unreadByAccount = new Map();
    (emailMessagesRef.current || []).forEach((m) => {
      if (!m || m.isRead !== false) return;
      const key = emailRowAccountId(m);
      unreadByAccount.set(key, (unreadByAccount.get(key) || 0) + 1);
    });
    // Just-deleted mail the server may still return is filtered out after the
    // fetch, so ask for that many more rows to keep the window full.
    const deletedByAccount = new Map();
    liveRecentlyDeletedEmails().forEach((d) => {
      deletedByAccount.set(d.account, (deletedByAccount.get(d.account) || 0) + 1);
    });
    // Rows deleted without a loaded row ("select all") have no account: count them for each.
    const limitFor = (key) =>
      Math.max(EMAIL_LIST_PAGE_SIZE, (unreadByAccount.get(key) || 0) + extra)
      + (deletedByAccount.get(key) || 0) + (key ? deletedByAccount.get("") || 0 : 0);
    const sel = selectedEmailRef.current;

    refillUnreadEmailsInFlightRef.current = true;
    if (grow) setEmailPaginationLoading(true);
    setEmailPage(1);
    setIsEmailsOver(false);
    try {
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        await fetchAllAccountsMessages(1, false, activeEmailFolder, true, limitFor);
      } else {
        const loaded = countUnreadEmailRows(emailMessagesRef.current);
        const deleted = liveRecentlyDeletedEmails().length;
        await fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder, true, Math.max(EMAIL_LIST_PAGE_SIZE, loaded + extra) + deleted);
      }
      // The open mail was marked read, so the unread query no longer returns
      // it; keep its row until the user leaves it (the list filter does too).
      if (sel && isInboxFeedFolder(activeEmailFolder) && isCombinedFeedEmail(sel)) {
        const keepOpen = (prev) => (prev.some((m) => emailEntriesShareId(m, sel)) ? prev : [sel, ...prev]);
        setEmailMessages(keepOpen);
        setInboxFeedEmails(keepOpen);
      }
    } catch (err) {
      console.error("Failed to refill unread emails:", err);
      setIsEmailsOver(true);
    } finally {
      refillUnreadEmailsInFlightRef.current = false;
      if (grow) setEmailPaginationLoading(false);
    }
  }, [
    emailShouldFetch,
    activeEmailAccountId,
    activeEmailFolder,
    fetchAllAccountsMessages,
    fetchEmailMessages,
    liveRecentlyDeletedEmails,
  ]);

  useEffect(() => {
    growUnreadEmailsRef.current = () => refillUnreadEmails(true);
  }, [refillUnreadEmails]);

  // Signature of the last automatic refill (mutation generation + unread rows),
  // so a refill that cannot add rows (e.g. it returned only just-deleted mail)
  // does not loop.
  const unreadRefillSigRef = useRef(null);
  const unreadRefillGenRef = useRef(0);
  useEffect(() => {
    unreadRefillSigRef.current = null;
  }, [showUnreadOnly, activeEmailAccountId, activeEmailFolder]);

  useEffect(() => {
    if (!showUnreadOnly) return;
    if (!emailShouldFetch || !activeEmailAccountId) return;
    if (!emailInitialReady) return;
    if (emailLoading || emailPaginationLoading) return;
    if (emailMutationInFlightRef.current > 0) return;
    if (refillUnreadEmailsInFlightRef.current) return;

    const unread = countUnreadEmailRows(emailMessages);
    if (unread >= EMAIL_LIST_PAGE_SIZE) return;
    // After a delete commits, look again even when the last page came back
    // short — the server is the judge of whether unread mail is left.
    const freshMutation = emailMutationGen !== unreadRefillGenRef.current;
    if (isEmailsOver && !freshMutation) return;
    const sig = `${emailMutationGen}:${unread}`;
    if (sig === unreadRefillSigRef.current) return;
    unreadRefillSigRef.current = sig;
    unreadRefillGenRef.current = emailMutationGen;

    refillUnreadEmails();
  }, [
    showUnreadOnly,
    emailShouldFetch,
    activeEmailAccountId,
    emailInitialReady,
    emailLoading,
    emailPaginationLoading,
    emailMutationGen,
    isEmailsOver,
    emailMessages,
    refillUnreadEmails,
  ]);

  // When integrateEmailInMessages is enabled, auto-select "All Accounts" to show unified inbox
  useEffect(() => {
    if (integrateEmailInMessages && emailAccounts.length > 0 && activeEmailAccountId !== ALL_ACCOUNTS_ID) {
      setActiveEmailAccountId(ALL_ACCOUNTS_ID);
    }
  }, [integrateEmailInMessages, emailAccounts]);

  // Auto-open the first email's details when the user switches into an email-style view
  // (either the E-Mail toggle, or — in integrated mode — the "E-Mail" filter tab).
  // Picks the first email once emailMessages is populated (handles the case where
  // emails are still being fetched at click time).
  useEffect(() => {
    if (!autoOpenFirstEmailPendingRef.current) return;
    const isInEmailView = emailTabActive || (integrateEmailInMessages && activeFilterUI === "email");
    if (!isInEmailView) {
      // User switched away before emails loaded — cancel the pending auto-open
      autoOpenFirstEmailPendingRef.current = false;
      return;
    }
    if (selectedEmail) {
      // Another email was opened in the meantime (e.g. user clicked one manually) — stand down
      autoOpenFirstEmailPendingRef.current = false;
      return;
    }
    if (emailMessages && emailMessages.length > 0) {
      autoOpenFirstEmailPendingRef.current = false;
      setSelectedEmail(emailMessages[0]);
    }
  }, [emailTabActive, integrateEmailInMessages, activeFilterUI, emailMessages, selectedEmail]);

  // Apply every socket email event in arrival order (utils/emailSyncQueue).
  useEffect(() => {
    const latestSeq = latestEmailSyncSeq(emailSyncEvents);
    // First run: events from before this list loaded are in its own fetch.
    if (emailSyncSeqRef.current == null) {
      emailSyncSeqRef.current = latestSeq;
      return;
    }
    // The store was reset (logout / login) and numbering restarted.
    if (latestSeq < emailSyncSeqRef.current) emailSyncSeqRef.current = 0;
    const { events, missed } = emailSyncEventsAfter(emailSyncEvents, emailSyncSeqRef.current);
    if (!events.length) return;
    emailSyncSeqRef.current = latestSeq;
    // More events arrived than the queue keeps: re-fetch to fill the gap.
    if (missed) dispatch({ type: EMAIL_CATCH_UP, payload: Date.now() });

    const applyEmailSyncEvent = (emailSyncData) => {
      const { accountId, messages, action, deletedMessageIds } = emailSyncData;

      const connectedIds = new Set(
        (emailAccountsRef.current || []).map((a) => String(a.id || a._id)).filter(Boolean)
      );
      if (connectedIds.size === 0) return;
      if (accountId && !connectedIds.has(String(accountId))) return;

      const isAllAccounts = activeEmailAccountId === ALL_ACCOUNTS_ID;
      // Allow merges while account selection is still null (just remounted /
      // waiting for ALL_ACCOUNTS_ID) so initial-sync socket events aren't dropped.
      if (
        activeEmailAccountId &&
        !isAllAccounts &&
        accountId !== activeEmailAccountId
      ) return;

      const mergeIncomingMessages = (incomingMessages) => {
        if (!Array.isArray(incomingMessages) || incomingMessages.length === 0) return;
        const validMessages = incomingMessages.filter(m => m && !Array.isArray(m) && (m.id || m._id || m.messageId));
        if (validMessages.length === 0) return;

        // Outside INBOX we don't add new rows (sent/starred/etc. shouldn't grow
        // from an inbox sync), but we DO want server-side read-state changes to
        // propagate to whichever folder view is open — otherwise emails read
        // directly in Gmail / Outlook / an IMAP client would stay bold here.
        const isInboxFolder = !activeEmailFolder || activeEmailFolder === "INBOX";

        setEmailMessages(prev => {
          const idOf = m => String(m.messageId || m.id || m._id || "");
          const incomingById = new Map(validMessages.map(m => [idOf(m), m]));
          const updated = prev.map(m => {
            const incoming = incomingById.get(idOf(m));
            if (!incoming) return m;
            const next = { ...m };
            if (incoming.isRead !== m.isRead) {
              next.isRead = incoming.isRead;
            }
            if (incoming.isTodoBookmarked) {
              next.isTodoBookmarked = true;
            }
            if (Array.isArray(incoming.linkedProjects)) {
              next.linkedProjects = incoming.linkedProjects;
            }
            if (incoming.classificationPending !== undefined) {
              next.classificationPending = !!incoming.classificationPending;
            }
            if (incoming.needsClassification !== undefined) {
              next.needsClassification = !!incoming.needsClassification;
            }
            if (incoming.snippet) next.snippet = incoming.snippet;
            if (incoming.bodyPreview) next.bodyPreview = incoming.bodyPreview;
            return next;
          });
          // Search results only take read-state updates, never new rows.
          if (!isInboxFolder || emailFolderSearchQueryRef.current) return updated;
          const existingIds = new Set(updated.map(m => idOf(m)));
          const enriched = isAllAccounts
            ? validMessages.map(m => ({ ...m, __accountId: accountId }))
            : validMessages;
          const newMsgs = enriched.filter(m => !existingIds.has(idOf(m)));
          if (newMsgs.length > 0) {
            const merged = [...newMsgs, ...updated];
            merged.sort((a, b) => new Date(b.date || b.receivedAt || 0) - new Date(a.date || a.receivedAt || 0));
            return merged;
          }
          return updated;
        });
        setInboxFeedEmails((prev) => {
          const idOf = (m) => String(m.messageId || m.id || m._id || "");
          const incomingById = new Map(validMessages.map((m) => [idOf(m), m]));
          const updated = prev.map((m) => {
            const incoming = incomingById.get(idOf(m));
            if (!incoming) return m;
            const next = { ...m };
            if (incoming.isRead !== m.isRead) {
              next.isRead = incoming.isRead;
            }
            if (incoming.isTodoBookmarked) {
              next.isTodoBookmarked = true;
            }
            if (Array.isArray(incoming.linkedProjects)) {
              next.linkedProjects = incoming.linkedProjects;
            }
            if (incoming.classificationPending !== undefined) {
              next.classificationPending = !!incoming.classificationPending;
            }
            if (incoming.needsClassification !== undefined) {
              next.needsClassification = !!incoming.needsClassification;
            }
            if (incoming.snippet) next.snippet = incoming.snippet;
            if (incoming.bodyPreview) next.bodyPreview = incoming.bodyPreview;
            return next;
          });
          const existingIds = new Set(updated.map((m) => idOf(m)));
          const enriched = isAllAccounts
            ? validMessages.map((m) => ({ ...m, __accountId: accountId }))
            : validMessages;
          const newMsgs = enriched.filter((m) => isCombinedFeedEmail(m) && !existingIds.has(idOf(m)));
          if (newMsgs.length > 0) {
            const merged = [...newMsgs, ...updated];
            merged.sort((a, b) => new Date(b.date || b.receivedAt || 0) - new Date(a.date || a.receivedAt || 0));
            return merged;
          }
          return updated;
        });
        setSelectedEmail(prev => {
          if (!prev) return prev;
          const selId = String(prev.messageId || prev.id || prev._id || "");
          const match = validMessages.find(m => String(m.messageId || m.id || m._id || "") === selId);
          if (!match) return prev;
          const next = { ...prev };
          let changed = false;
          if (match.isRead !== prev.isRead) {
            next.isRead = match.isRead;
            changed = true;
          }
          if (Array.isArray(match.linkedProjects)) {
            next.linkedProjects = match.linkedProjects;
            changed = true;
          }
          if (match.classificationPending !== undefined) {
            next.classificationPending = !!match.classificationPending;
            changed = true;
          }
          if (match.needsClassification !== undefined) {
            next.needsClassification = !!match.needsClassification;
            changed = true;
          }
          return changed ? next : prev;
        });
      };

      const applyFlagChanges = (flagChanges) => {
        if (!Array.isArray(flagChanges) || flagChanges.length === 0) return;
        // BE sends EmailMessage.id; list rows may expose id/_id/messageId/
        // providerMessageId depending on source — match any of them.
        const changeMap = new Map();
        for (const c of flagChanges) {
          if (c == null || c.id == null) continue;
          changeMap.set(String(c.id), c.isRead);
          if (c.providerMessageId != null) {
            changeMap.set(String(c.providerMessageId), c.isRead);
          }
        }
        const lookupIsRead = (m) => {
          if (!m) return undefined;
          for (const key of [m.id, m._id, m.messageId, m.providerMessageId]) {
            if (key == null || String(key).trim() === "") continue;
            if (changeMap.has(String(key))) return changeMap.get(String(key));
          }
          return undefined;
        };
        setEmailMessages(prev =>
          prev.map(m => {
            const newIsRead = lookupIsRead(m);
            if (newIsRead !== undefined && newIsRead !== m.isRead) {
              return { ...m, isRead: newIsRead };
            }
            return m;
          })
        );
        setInboxFeedEmails((prev) =>
          prev.map((m) => {
            const newIsRead = lookupIsRead(m);
            if (newIsRead !== undefined && newIsRead !== m.isRead) {
              return { ...m, isRead: newIsRead };
            }
            return m;
          })
        );
        setReportFeedEmails((prev) =>
          prev.map((m) => {
            const newIsRead = lookupIsRead(m);
            if (newIsRead !== undefined && newIsRead !== m.isRead) {
              return { ...m, isRead: newIsRead };
            }
            return m;
          })
        );
        setSelectedEmail(prev => {
          if (!prev) return prev;
          const newIsRead = lookupIsRead(prev);
          if (newIsRead !== undefined && newIsRead !== prev.isRead) {
            return { ...prev, isRead: newIsRead };
          }
          return prev;
        });
      };

      const applyDeletions = (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return;
        const deletedSet = new Set(ids.map(String));
        dropEmailsFromUnreadSnapshot(ids);
        setEmailMessages(prev =>
          prev.filter(m => {
            const id = String(m.messageId || m.id || m._id || m.providerMessageId || "");
            return !deletedSet.has(id);
          })
        );
        setInboxFeedEmails((prev) =>
          prev.filter((m) => {
            const id = String(m.messageId || m.id || m._id || m.providerMessageId || "");
            return !deletedSet.has(id);
          })
        );
        setReportFeedEmails((prev) =>
          prev.filter((m) => {
            const id = String(m.messageId || m.id || m._id || m.providerMessageId || "");
            return !deletedSet.has(id);
          })
        );
        const sel = selectedEmailRef.current;
        if (sel) {
          const selId = String(sel.messageId || sel.id || sel._id || sel.providerMessageId || "");
          if (deletedSet.has(selId)) {
            setSelectedEmail(null);
          }
        }
      };

      if (action === "increase" || action === "updated") {
        if (Array.isArray(messages) && messages.length > 0) {
          mergeIncomingMessages(messages);
        } else if (Number(emailSyncData.messagesSyncedCount) > 0) {
          // Same fallback as mobile: badge/socket said new mail arrived but the
          // payload had no rows (race / truncated broadcast). Silent refetch so
          // the list does not stay stale while the badge updates.
          const folder = activeEmailFolder || "INBOX";
          const isInbox = !activeEmailFolder || activeEmailFolder === "INBOX";
          if (isInbox) {
            if (isAllAccounts) {
              fetchAllAccountsMessages(1, false, folder, true);
            } else if (activeEmailAccountId) {
              fetchEmailMessages(activeEmailAccountId, 1, false, folder, true);
            }
          }
        }
      } else if (action === "flagsUpdated") {
        applyFlagChanges(emailSyncData.flagChanges);
      } else if (action === "decrease" || action === "delete" || action === "sync") {
        applyDeletions(deletedMessageIds);
      }
    };

    events.forEach(applyEmailSyncEvent);
  }, [emailSyncEvents, activeEmailAccountId, activeEmailFolder, fetchEmailMessages, fetchAllAccountsMessages, dropEmailsFromUnreadSnapshot, dispatch]);

  // Merge the first INBOX page from the server. Rows go through the same event
  // queue as socket "updated" events — merged into the lists, never replacing
  // them or dropping loaded pages. Returns a cancel function.
  const mergeInboxFirstPage = () => {
    if (activeEmailFolder && activeEmailFolder !== "INBOX") return undefined;
    if (emailFolderSearchQueryRef.current) return undefined;
    const accounts = emailAccountsRef.current || [];
    if (!accounts.length) return undefined;
    const accountIds =
      !activeEmailAccountId || activeEmailAccountId === ALL_ACCOUNTS_ID
        ? accounts.map((acct) => String(acct.id || acct._id)).filter(Boolean)
        : [String(activeEmailAccountId)];
    const unreadOnlyQuery = showUnreadOnlyRef.current ? "&unreadOnly=true" : "";
    let cancelled = false;
    (async () => {
      for (const accountId of accountIds) {
        try {
          const { data } = await callAPI(
            `/email/messages?accountId=${accountId}&page=1&limit=30&folder=INBOX${unreadOnlyQuery}`,
            {},
            "GET"
          );
          const rows = data?.messages;
          if (cancelled || !Array.isArray(rows) || !rows.length) continue;
          dispatch({ type: EMAIL_SYNC, payload: { action: "updated", accountId, messages: rows, catchUp: true } });
        } catch (e) { /* next poll / event will cover it */ }
      }
    })();
    return () => {
      cancelled = true;
    };
  };
  const mergeInboxFirstPageRef = useRef(mergeInboxFirstPage);
  mergeInboxFirstPageRef.current = mergeInboxFirstPage;

  // After a socket reconnect, tab return or network return: mail pushed while
  // the socket was down shows up.
  useEffect(() => {
    if (!emailCatchUpAt || !isEmailFeatureEnabled) return undefined;
    return mergeInboxFirstPageRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailCatchUpAt]);

  // Safety net while the inbox is on screen: a socket event that never
  // arrived (server restart mid-emit, a lost room join) would otherwise keep
  // stored mail hidden until a reload.
  useEffect(() => {
    // Not while another page is shown: returning to Messages refetches anyway.
    if (!emailShouldFetch || !isEmailFeatureEnabled || !paneActive) return undefined;
    let cancel;
    const timer = setInterval(() => {
      // A delete still in flight would come back from a stale first page.
      if (document.hidden || emailMutationInFlightRef.current > 0) return;
      if (cancel) cancel();
      cancel = mergeInboxFirstPageRef.current();
    }, EMAIL_INBOX_SAFETY_POLL_MS);
    return () => {
      clearInterval(timer);
      if (cancel) cancel();
    };
  }, [emailShouldFetch, isEmailFeatureEnabled, paneActive]);

  // Refresh the new-sender classification queue when the email feature is active
  // and whenever new mail arrives (the sync flags new-sender emails server-side).
  useEffect(() => {
    if (!isEmailFeatureEnabled) return;
    if (!(emailTabActive || integrateEmailInMessages)) return;
    fetchPendingClassifications();
    fetchClassificationBuildings();
  }, [isEmailFeatureEnabled, emailTabActive, integrateEmailInMessages, emailAccounts, emailSyncData, fetchPendingClassifications, fetchClassificationBuildings]);

  // Inline "save to proposed project" prompt shown on the opened email itself
  // (not a modal): when the selected email has a content-based proposal
  // (title/body matched a room name), show "Soll ich die E-Mail im Projekt 'X'
  // abspeichern? Ja/Nein" above the reader. "Nein" just dismisses the banner —
  // the email stays in the classification queue (Review banner) so it can still
  // be filed into another project later.
  const [dismissedContentPrompts, setDismissedContentPrompts] = useState(() => new Set());
  const [savingContentPrompt, setSavingContentPrompt] = useState(false);

  const contentPromptForSelected = useMemo(() => {
    if (!selectedEmail) return null;
    const selId = String(
      selectedEmail.id || selectedEmail._id || selectedEmail.messageId || selectedEmail.providerMessageId || ""
    );
    if (!selId || dismissedContentPrompts.has(selId)) return null;
    return (
      pendingClassifications.find(
        (m) => m && m.proposalSource === "content" && m.proposedBuilding && String(m.id) === selId
      ) || null
    );
  }, [selectedEmail, pendingClassifications, dismissedContentPrompts]);

  const saveEmailToProposedProject = useCallback(
    async (item) => {
      if (!item || !item.proposedBuilding || savingContentPrompt) return;
      setSavingContentPrompt(true);
      try {
        const body = {
          messageId: item.id,
          buildingId: item.proposedBuilding.id,
          buildingName: item.proposedBuilding.name,
          rememberSender: false,
          applyToAccount: false,
        };
        const { autoLinkedIds, data } = await classifyProjectWithProgress({
          messageId: item.id,
          body,
          onProgress: setEmailClassifyProgress,
        });
        handleEmailClassified(item.id, "project", autoLinkedIds);
        const tag = {
          id: (data.building && data.building.id) || item.proposedBuilding.id,
          name: (data.building && data.building.name) || item.proposedBuilding.name,
        };
        const taggedIds = new Set([String(item.id), ...autoLinkedIds.map(String)]);
        const addTag = (m) => {
          if (!m) return m;
          const id = String(m.id || m._id || m.messageId || m.providerMessageId || "");
          if (!taggedIds.has(id)) return m;
          const existing = Array.isArray(m.linkedProjects) ? m.linkedProjects : [];
          if (existing.length === 1 && String(existing[0].id) === String(tag.id)) return m;
          return { ...m, linkedProjects: [tag] };
        };
        setEmailMessages((prev) => prev.map(addTag));
        setSelectedEmail((prev) => (prev ? addTag(prev) : prev));
        const similar = autoLinkedIds.length;
        $crud.notify({
          type: "success",
          message: similar
            ? (strings.email_saved_to_project_similar || "Email saved to project. {count} similar emails were also assigned.").replace("{count}", similar)
            : (strings.email_saved_to_project || "Email saved to project"),
        });
      } catch (e) {
        $crud.notify({ type: "error", message: (e && e.data && e.data.message) || e?.message || strings.something_went_wrong || "Something went wrong" });
      } finally {
        setSavingContentPrompt(false);
        setEmailClassifyProgress(null);
      }
    },
    [savingContentPrompt, handleEmailClassified, strings]
  );

  const dismissContentPrompt = useCallback((item) => {
    if (!item) return;
    setDismissedContentPrompts((prev) => {
      const next = new Set(prev);
      next.add(String(item.id));
      return next;
    });
  }, []);

  const markEmailAsRead = useCallback(async (email) => {
    if (!email || email.isRead === true || email.isRead === 1 || email.isRead === "1") return;
    const messageId = email.id || email._id || email.messageId;
    if (!messageId || !isPersistedEmailId(messageId)) return;
    // Idempotency guard: only ever count one read per email id, even if the
    // auto-read effect re-fires for the same message (see markedReadIdsRef).
    if (markedReadIdsRef.current.has(messageId)) return;
    markedReadIdsRef.current.add(messageId);
    const isBriefing = isDailyBriefingEmail(email);
    const isAllScope = isAllScopeReport(email);
    const linked = Array.isArray(email.linkedProjects) ? email.linkedProjects[0] : null;
    const buildingId = (linked && (linked.id || linked.buildingId)) || email.buildingId;
    const isInternal = !!(linked && (linked.isInternal || linked.buildingProjectType));
    if (isBriefing && isAllScope) {
      dispatch({ type: DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT });
    } else if (isBriefing) {
      dispatch({ type: DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT, buildingId, isInternal });
    } else {
      dispatch({ type: DECREMENT_UNSEEN_EMAIL_COUNT });
    }
    invalidateBadgeCount();
    setEmailMessages((prev) =>
      prev.map((m) => {
        const mid = m.id || m._id || m.messageId;
        return mid === messageId ? { ...m, isRead: true } : m;
      })
    );
    setInboxFeedEmails((prev) =>
      prev.map((m) => {
        const mid = m.id || m._id || m.messageId;
        return mid === messageId ? { ...m, isRead: true } : m;
      })
    );
    setReportFeedEmails((prev) =>
      prev.map((m) => {
        const mid = m.id || m._id || m.messageId;
        return mid === messageId ? { ...m, isRead: true } : m;
      })
    );
    setSelectedEmail((prev) => {
      if (!prev) return prev;
      const pid = prev.id || prev._id || prev.messageId;
      return pid === messageId ? { ...prev, isRead: true } : prev;
    });
    try {
      const { data } = await callAPI(
        `/email/messages/${messageId}`,
        {},
        "PATCH",
        { isRead: true }
      );
      if (data?.status === false && !isBriefing) {
        markedReadIdsRef.current.delete(messageId);
        dispatch({ type: INCREMENT_UNSEEN_EMAIL_COUNT });
        return;
      }
      _reconcileBadgeCount();
    } catch (err) {
      if (!isBriefing) {
        markedReadIdsRef.current.delete(messageId);
      }
      console.error("Failed to mark email as read:", err);
    }
  }, [_reconcileBadgeCount]);

  const markEmailsUnread = useCallback(async (messageIds) => {
    if (!messageIds || messageIds.length === 0) return;
    let previouslyReadCount = 0;
    setEmailMessages((prev) => {
      previouslyReadCount = 0;
      return prev.map((m) => {
        const mid = m.id || m._id;
        if (mid && messageIds.includes(mid)) {
          if (m.isRead === true) previouslyReadCount += 1;
          return { ...m, isRead: false };
        }
        return m;
      });
    });
    if (previouslyReadCount > 0) {
      dispatch({ type: INCREMENT_UNSEEN_EMAIL_COUNT, count: previouslyReadCount });
    }
    const results = await mapWithConcurrency(messageIds, 6, (msgId) =>
      callAPI(`/email/messages/${msgId}`, {}, "PATCH", { isRead: false })
    );
    const failedIds = messageIds.filter((_, i) => {
      const r = results[i];
      return r.status === "rejected" || r.value?.data?.status === false;
    });
    if (failedIds.length > 0) {
      setEmailMessages((prev) =>
        prev.map((m) => {
          const mid = m.id || m._id;
          if (mid && failedIds.includes(mid)) return { ...m, isRead: true };
          return m;
        })
      );
      await $crud.notify({ type: "error", message: `${failedIds.length} ${strings.email_mark_unread_failed || "email(s) could not be marked as unread."}` });
    }
    try {
      const { data } = await getBadgeCount({ force: true });
      if (data?.status) {
        dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
      }
    } catch (_) { /* ignore */ }
  }, [strings, dispatch]);

  const markEmailUnreadFromDetail = useCallback(async (messageIds) => {
    if (!messageIds || messageIds.length === 0) return;
    setEmailActionOverlay({ icon: "mark_email_unread", text: strings.marking_unread || "Marking as unread..." });
    try {
      await markEmailsUnread(messageIds);
      setSelectedEmail(null);
      setEmailReplyMode(null);
    } finally {
      setEmailActionOverlay(null);
    }
  }, [markEmailsUnread, strings]);

  const deleteEmailMessage = useCallback(async (email) => {
    const folder = activeEmailFolder;
    const messageId = email?.id || email?._id;
    const providerMessageId = email?.providerMessageId;

    if (!messageId && !providerMessageId) return;

    const folderLabelMap = {
      DRAFT: strings.email_folder_drafts,
      SENT: strings.email_folder_sent,
      TRASH: strings.email_folder_deleted,
      SPAM: strings.email_folder_spam,
      INBOX: strings.email_folder_inbox,
    };
    const folderLabel = folderLabelMap[folder] || strings.email_folder_inbox;
    const interpolateFolder = (template) =>
      (template || "").replace(/\{folder\}/g, folderLabel);

    if (folder === "TRASH" || folder === "SPAM") {
      const confirmText = interpolateFolder(
        strings.email_delete_permanent_from_folder ||
          "Are you sure you want to permanently delete from {folder}? This action cannot be undone."
      );
      document.body.setAttribute("data-confirm-color", "violet");
      try {
        await $crud.confirm({
          title: "",
          textContent: confirmText,
          options: {
            ok: strings.ok,
            cancel: strings.cancel,
          },
        });
      } catch {
        return;
      } finally {
        document.body.removeAttribute("data-confirm-color");
      }
    }
    const idToRemove = messageId || providerMessageId;
    const isBriefing = isDailyBriefingEmail(email);
    const isAllScope = isAllScopeReport(email);
    const unread = email.isRead !== true && email.isRead !== 1 && email.isRead !== "1";
    const linked = Array.isArray(email.linkedProjects) ? email.linkedProjects[0] : null;
    const buildingId = (linked && (linked.id || linked.buildingId)) || email.buildingId;
    const isInternal = !!(linked && (linked.isInternal || linked.buildingProjectType));
    const dropRow = (m) => emailListRowId(m) !== idToRemove;
    const putBack = (prev) => (prev.some((m) => emailListRowId(m) === idToRemove) ? prev : [...prev, email]);
    const removedFromSnapshot = dropEmailsFromUnreadSnapshot([
      idToRemove,
      messageId,
      providerMessageId,
      email.id,
      email._id,
      email.messageId,
    ]);
    beginEmailMutation();
    setEmailMessages((prev) => prev.filter(dropRow));
    setInboxFeedEmails((prev) => prev.filter(dropRow));
    setReportFeedEmails((prev) => prev.filter(dropRow));
    setSelectedEmail(null);
    setEmailReplyMode(null);
    if (unread) {
      if (isAllScope) {
        dispatch({ type: DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT });
      } else if (isBriefing) {
        dispatch({ type: DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT, buildingId, isInternal });
      } else if (folder === "INBOX") {
        dispatch({ type: DECREMENT_UNSEEN_EMAIL_COUNT });
      }
    }

    const restoreDeletedEmail = () => {
      setEmailMessages(putBack);
      if (isBriefing) setReportFeedEmails(putBack);
      else setInboxFeedEmails(putBack);
      restoreEmailsInUnreadSnapshot(removedFromSnapshot);
      if (!unread) return;
      if (isAllScope) {
        dispatch({ type: INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT });
      } else if (isBriefing) {
        dispatch({ type: INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT, buildingId, isInternal });
      } else if (folder === "INBOX") {
        dispatch({ type: INCREMENT_UNSEEN_EMAIL_COUNT });
      }
    };

    const effectiveAccountId = email?.__accountId || activeEmailAccountId;
    try {
      let result;
      if (isBriefing && messageId) {
        result = await callAPI(`/email/project-messages/${messageId}`, {}, "DELETE");
        // Mailbox delete only stamps TRASH. The report list hides those rows,
        // so this still removes the report when the briefing endpoint rejects it.
        if (result?.data?.status === false) {
          result = await callAPI(`/email/messages/${messageId}`, {}, "DELETE");
        }
      } else if (folder === "DRAFT") {
        const body = { providerMessageId };
        if (email?.draftId) body.draftId = email.draftId;
        result = await callAPI(`/email/accounts/${effectiveAccountId}/drafts/delete`, body, "POST");
      } else if (folder === "TRASH" || folder === "SPAM") {
        result = await callAPI(`/email/accounts/${effectiveAccountId}/provider-delete`, { providerMessageId, folder }, "POST");
      } else if (folder === "SENT") {
        if (messageId) {
          result = await callAPI(`/email/messages/${messageId}`, {}, "DELETE");
        } else {
          result = await callAPI(`/email/accounts/${effectiveAccountId}/provider-delete`, { providerMessageId, folder: "SENT" }, "POST");
        }
      } else {
        result = await callAPI(
          `/email/messages/${encodeURIComponent(messageId || providerMessageId)}`,
          { accountId: effectiveAccountId, providerMessageId },
          "DELETE"
        );
      }

      if (isEmailGoneResult(result)) {
        // A sync already removed the row: the mail is gone, keep it out of the list.
        rememberDeletedEmail(email, [messageId, providerMessageId]);
        _reconcileBadgeCount();
      } else if (result?.data?.status === false) {
        restoreDeletedEmail();
        await $crud.notify({ type: "error", message: result?.data?.message || "Failed to delete email." });
      } else {
        rememberDeletedEmail(email, [messageId, providerMessageId]);
        // Keep filter-tab / SideNav email badges in sync immediately after
        // remove (optimistic decrement above covers unread INBOX; reconcile
        // covers any server-side drift).
        _reconcileBadgeCount();
      }
    } catch (err) {
      console.error("Failed to delete email:", err);
      restoreDeletedEmail();
      await $crud.notify({ type: "error", message: "Failed to delete email." });
    } finally {
      endEmailMutation();
    }
  }, [strings, activeEmailFolder, activeEmailAccountId, _reconcileBadgeCount, beginEmailMutation, endEmailMutation, dropEmailsFromUnreadSnapshot, restoreEmailsInUnreadSnapshot, rememberDeletedEmail]);

  const handleMarkNotSpam = useCallback(async (email) => {
    const providerMessageId = email?.providerMessageId;
    const effectiveAccountId = email?.__accountId || activeEmailAccountId;
    if (!providerMessageId || !effectiveAccountId) return;
    const sourceFolder = activeEmailFolder === "TRASH" ? "TRASH" : "SPAM";
    try {
      const { data } = await callAPI(
        `/email/accounts/${effectiveAccountId}/not-spam`,
        { providerMessageId, sourceFolder },
        "POST"
      );
      if (data?.status === false) {
        await $crud.notify({ type: "error", message: data?.message || strings.email_not_spam_failed || "Failed to move to inbox." });
        return;
      }
      setSelectedEmail(null);
      setEmailReplyMode(null);
      await $crud.notify({ type: "success", message: strings.email_not_spam_success || "Email moved to inbox." });
      setActiveEmailFolder("INBOX");
      setEmailMessages([]);
      setEmailPage(1);
      setIsEmailsOver(false);
      fetchEmailMessages(activeEmailAccountId, 1, false, "INBOX");
    } catch (err) {
      console.error("Failed to mark as not spam:", err);
      await $crud.notify({ type: "error", message: strings.email_not_spam_failed || "Failed to move to inbox." });
    }
  }, [activeEmailAccountId, activeEmailFolder, strings, fetchEmailMessages]);

  const handleToggleStar = useCallback(async (messageId, isStarred) => {
    if (!messageId) return;
    setEmailMessages((prev) =>
      prev.map((m) => {
        const id = m.id || m._id || m.messageId || m.providerMessageId;
        return String(id) === String(messageId) ? { ...m, isStarred } : m;
      })
    );
    if (selectedEmail) {
      const selId = selectedEmail.id || selectedEmail._id || selectedEmail.messageId || selectedEmail.providerMessageId;
      if (String(selId) === String(messageId)) {
        setSelectedEmail((prev) => prev ? { ...prev, isStarred } : prev);
      }
    }
    try {
      const { data } = await callAPI(`/email/messages/${messageId}`, {}, "PATCH", { isStarred });
      if (data?.status === false) {
        setEmailMessages((prev) =>
          prev.map((m) => {
            const id = m.id || m._id || m.messageId || m.providerMessageId;
            return String(id) === String(messageId) ? { ...m, isStarred: !isStarred } : m;
          })
        );
        await $crud.notify({ type: "error", message: strings.email_error || "Error" });
      }
    } catch {
      setEmailMessages((prev) =>
        prev.map((m) => {
          const id = m.id || m._id || m.messageId || m.providerMessageId;
          return String(id) === String(messageId) ? { ...m, isStarred: !isStarred } : m;
        })
      );
      await $crud.notify({ type: "error", message: strings.email_error || "Error" });
    }
  }, [selectedEmail, strings]);

  const handleArchiveEmails = useCallback(async (messageIds) => {
    if (!activeEmailAccountId || !messageIds || messageIds.length === 0) return;
    setEmailMessages((prev) => prev.filter((m) => !messageIds.includes(m.id || m._id || m.messageId || m.providerMessageId)));
    if (selectedEmail) {
      const selId = selectedEmail.id || selectedEmail._id || selectedEmail.messageId || selectedEmail.providerMessageId;
      if (messageIds.includes(selId)) setSelectedEmail(null);
    }
    try {
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        const byAccount = new Map();
        for (const msgId of messageIds) {
          const emailObj = emailMessages.find((m) => (m.id || m._id || m.messageId || m.providerMessageId) === msgId);
          const acctId = emailObj?.__accountId;
          if (acctId) {
            if (!byAccount.has(acctId)) byAccount.set(acctId, []);
            byAccount.get(acctId).push(msgId);
          }
        }
        await Promise.all(
          Array.from(byAccount.entries()).map(([acctId, ids]) =>
            callAPI(`/email/accounts/${acctId}/messages/move`, {}, "POST", { messageIds: ids, targetFolder: "ARCHIVE", sourceFolder: activeEmailFolder })
          )
        );
      } else {
        await callAPI(`/email/accounts/${activeEmailAccountId}/messages/move`, {}, "POST", {
          messageIds,
          targetFolder: "ARCHIVE",
          sourceFolder: activeEmailFolder,
        });
      }
      await $crud.notify({ type: "success", message: strings.email_archived || "Archived" });
    } catch {
      await $crud.notify({ type: "error", message: strings.email_error || "Error" });
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        fetchAllAccountsMessages(1, false, activeEmailFolder);
      } else {
        fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
      }
    }
  }, [activeEmailAccountId, activeEmailFolder, selectedEmail, emailMessages, strings, fetchEmailMessages, fetchAllAccountsMessages]);

  const handleMarkSpam = useCallback(async (messageIds) => {
    if (!activeEmailAccountId || !messageIds || messageIds.length === 0) return;
    setEmailMessages((prev) => prev.filter((m) => !messageIds.includes(m.id || m._id || m.messageId || m.providerMessageId)));
    if (selectedEmail) {
      const selId = selectedEmail.id || selectedEmail._id || selectedEmail.messageId || selectedEmail.providerMessageId;
      if (messageIds.includes(selId)) setSelectedEmail(null);
    }
    try {
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        const byAccount = new Map();
        for (const msgId of messageIds) {
          const emailObj = emailMessages.find((m) => (m.id || m._id || m.messageId || m.providerMessageId) === msgId);
          const acctId = emailObj?.__accountId;
          if (acctId) {
            if (!byAccount.has(acctId)) byAccount.set(acctId, []);
            byAccount.get(acctId).push(msgId);
          }
        }
        await Promise.all(
          Array.from(byAccount.entries()).map(([acctId, ids]) =>
            callAPI(`/email/accounts/${acctId}/messages/move`, {}, "POST", { messageIds: ids, targetFolder: "SPAM", sourceFolder: activeEmailFolder })
          )
        );
      } else {
        await callAPI(`/email/accounts/${activeEmailAccountId}/messages/move`, {}, "POST", {
          messageIds,
          targetFolder: "SPAM",
          sourceFolder: activeEmailFolder,
        });
      }
      await $crud.notify({ type: "success", message: strings.email_marked_spam || "Marked as spam" });
    } catch {
      await $crud.notify({ type: "error", message: strings.email_error || "Error" });
      if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        fetchAllAccountsMessages(1, false, activeEmailFolder);
      } else {
        fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
      }
    }
  }, [activeEmailAccountId, activeEmailFolder, selectedEmail, emailMessages, strings, fetchEmailMessages, fetchAllAccountsMessages]);

  const handleMarkEmailsRead = useCallback(async (messageIds) => {
    if (!messageIds || messageIds.length === 0) return;
    let previouslyUnreadCount = 0;
    setEmailMessages((prev) => {
      previouslyUnreadCount = 0;
      return prev.map((m) => {
        const id = m.id || m._id;
        if (id && messageIds.includes(id)) {
          if (m.isRead === false) previouslyUnreadCount += 1;
          return { ...m, isRead: true };
        }
        return m;
      });
    });
    if (previouslyUnreadCount > 0) {
      dispatch({ type: DECREMENT_UNSEEN_EMAIL_COUNT, count: previouslyUnreadCount });
    }
    const results = await mapWithConcurrency(messageIds, 6, (msgId) =>
      callAPI(`/email/messages/${msgId}`, {}, "PATCH", { isRead: true })
    );
    const failedIds = messageIds.filter((_, i) => {
      const r = results[i];
      return r.status === "rejected" || r.value?.data?.status === false;
    });
    if (failedIds.length > 0) {
      setEmailMessages((prev) =>
        prev.map((m) => {
          const id = m.id || m._id;
          if (id && failedIds.includes(id)) return { ...m, isRead: false };
          return m;
        })
      );
      await $crud.notify({ type: "error", message: strings.email_error || "Error" });
    }
    try {
      const { data } = await getBadgeCount({ force: true });
      if (data?.status) {
        dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
      }
    } catch (_) { /* ignore */ }
  }, [strings, dispatch]);

  // Refresh button: pull provider state (read / deleted / moved) into the DB
  // first, then reload the list so Outlook/Gmail/IMAP changes are visible.
  const handleEmailRefresh = useCallback(async () => {
    setEmailLoading(true);
    setEmailPage(1);
    setIsEmailsOver(false);
    emailInboxFetchKeyRef.current = null;
    isRefreshingRef.current = true;
    try {
      const accountsToSync =
        activeEmailAccountId === ALL_ACCOUNTS_ID
          ? emailAccounts
          : emailAccounts.filter((a) => (a.id || a._id) === activeEmailAccountId);

      await Promise.all(
        (accountsToSync || []).map(async (acct) => {
          const id = acct.id || acct._id;
          if (!id) return;
          try {
            await callAPI(`/email/accounts/${id}/sync`, {}, "POST", { awaitSync: true });
          } catch (err) {
            console.warn("[EmailRefresh] Provider sync failed for", acct.email || id, err?.message || err);
          }
        })
      );

      if (emailFolderSearchQueryRef.current) {
        await searchFolderMessages(emailFolderSearchQueryRef.current);
      } else if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
        emailAccounts.forEach((acct) => fetchCustomFolders(acct.id || acct._id, true));
        await fetchAllAccountsMessages(1, false, activeEmailFolder);
      } else if (activeEmailAccountId) {
        fetchCustomFolders(activeEmailAccountId, true);
        await fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder);
      }
    } catch (e) {
      console.warn("Email refresh failed:", e);
    } finally {
      isRefreshingRef.current = false;
    }
  }, [
    activeEmailAccountId,
    activeEmailFolder,
    emailAccounts,
    fetchAllAccountsMessages,
    fetchCustomFolders,
    fetchEmailMessages,
    searchFolderMessages,
  ]);

  const deleteMultipleEmails = useCallback(async (messageIds, onProgress) => {
    if (!messageIds || messageIds.length === 0) return;
    const folder = activeEmailFolder;

    const folderLabelMap = {
      DRAFT: strings.email_folder_drafts,
      SENT: strings.email_folder_sent,
      TRASH: strings.email_folder_deleted,
      SPAM: strings.email_folder_spam,
      INBOX: strings.email_folder_inbox,
    };
    const folderLabel = folderLabelMap[folder] || strings.email_folder_inbox;
    const interpolateFolder = (template) =>
      (template || "").replace(/\{folder\}/g, folderLabel);

    if (folder === "TRASH" || folder === "SPAM") {
      const confirmText = interpolateFolder(
        strings.email_delete_permanent_from_folder ||
          "Are you sure you want to permanently delete from {folder}? This action cannot be undone."
      );
      document.body.setAttribute("data-confirm-color", "violet");
      try {
        await $crud.confirm({
          title: "",
          textContent: confirmText,
          options: {
            ok: strings.ok,
            cancel: strings.cancel,
          },
        });
      } catch {
        return;
      } finally {
        document.body.removeAttribute("data-confirm-color");
      }
    }

    const total = messageIds.length;
    let completed = 0;
    let failCount = 0;
    // Only show the full-screen progress overlay for bulk deletes. Deleting a
    // single email should just delete it silently — no modal/overlay flash.
    const showProgress = total > 1;
    if (showProgress) setEmailDeleteProgress({ completed: 0, total });
    beginEmailMutation();

    const deleteOne = async (msgId) => {
      try {
        const emailObj = emailMessages.find((m) => emailListRowId(m) === msgId)
          || reportFeedEmails.find((m) => emailListRowId(m) === msgId);
        let result;

        const effectiveAccountId = emailObj?.__accountId || activeEmailAccountId;
        const briefingId = emailObj && (emailObj.id || emailObj._id);
        if (isDailyBriefingEmail(emailObj) && briefingId) {
          result = await callAPI(`/email/project-messages/${briefingId}`, {}, "DELETE");
          if (result?.data?.status === false) {
            result = await callAPI(`/email/messages/${briefingId}`, {}, "DELETE");
          }
        } else if (folder === "DRAFT") {
          const body = { providerMessageId: emailObj?.providerMessageId || msgId };
          if (emailObj?.draftId) body.draftId = emailObj.draftId;
          result = await callAPI(`/email/accounts/${effectiveAccountId}/drafts/delete`, body, "POST");
        } else if (folder === "TRASH" || folder === "SPAM") {
          result = await callAPI(`/email/accounts/${effectiveAccountId}/provider-delete`, { providerMessageId: emailObj?.providerMessageId || msgId, folder }, "POST");
        } else if (folder === "SENT" && emailObj?.id) {
          result = await callAPI(`/email/messages/${emailObj.id}`, {}, "DELETE");
        } else {
          result = await callAPI(
            `/email/messages/${encodeURIComponent(msgId)}`,
            { accountId: effectiveAccountId, providerMessageId: emailObj?.providerMessageId },
            "DELETE"
          );
        }

        if (result?.data?.status === false && !isEmailGoneResult(result)) {
          failCount++;
        } else {
          const unread = emailObj && emailObj.isRead !== true && emailObj.isRead !== 1 && emailObj.isRead !== "1";
          if (unread && isAllScopeReport(emailObj)) {
            dispatch({ type: DECREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT });
          } else if (unread && isDailyBriefingEmail(emailObj)) {
            const linked = Array.isArray(emailObj.linkedProjects) ? emailObj.linkedProjects[0] : null;
            dispatch({
              type: DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
              buildingId: (linked && (linked.id || linked.buildingId)) || emailObj.buildingId,
              isInternal: !!(linked && (linked.isInternal || linked.buildingProjectType)),
            });
          } else if (folder === "INBOX" && unread) {
            dispatch({ type: DECREMENT_UNSEEN_EMAIL_COUNT });
          }
          const dropRow = (m) => emailListRowId(m) !== msgId;
          rememberDeletedEmail(emailObj || { id: msgId }, [msgId]);
          dropEmailsFromUnreadSnapshot([
            msgId,
            emailObj && emailObj.id,
            emailObj && emailObj._id,
            emailObj && emailObj.messageId,
            emailObj && emailObj.providerMessageId,
          ]);
          setEmailMessages((prev) => prev.filter(dropRow));
          setInboxFeedEmails((prev) => prev.filter(dropRow));
          setReportFeedEmails((prev) => prev.filter(dropRow));
          if (selectedEmail && (selectedEmail.id === msgId || selectedEmail._id === msgId || selectedEmail.providerMessageId === msgId)) {
            setSelectedEmail(null);
            setEmailReplyMode(null);
          }
        }
      } catch {
        failCount++;
      } finally {
        completed++;
        if (showProgress) setEmailDeleteProgress({ completed, total });
        if (onProgress) onProgress(completed, total);
      }
    };

    try {
      // Delete in parallel with a bounded concurrency: a serial loop paid the
      // (multi-second) provider round-trip once per email, so N emails took
      // N × latency. Running a small pool of workers keeps the total close to
      // a single delete's latency while not opening hundreds of simultaneous
      // provider connections.
      const CONCURRENCY = 6;
      let cursor = 0;
      const runWorker = async () => {
        while (cursor < messageIds.length) {
          const idx = cursor;
          cursor += 1;
          await deleteOne(messageIds[idx]);
        }
      };
      const workerCount = Math.min(CONCURRENCY, messageIds.length);
      try {
        await Promise.all(Array.from({ length: workerCount }, runWorker));
      } finally {
        // Close the overlay as soon as the deletes are done — the error toast
        // and badge reconcile below must not keep it on screen.
        if (showProgress) setEmailDeleteProgress(null);
      }

      if (failCount > 0) {
        await $crud.notify({ type: "error", message: `${failCount} ${strings.email_delete_failed || "email(s) could not be deleted."}` });
      }

      // Reconcile the unread/badge counters from the server. The optimistic
      // DECREMENT above only covers loaded unread rows, so bulk / "select all"
      // deletes (which include ids from not-yet-loaded pages) would otherwise
      // leave the counters stale until a full page reload.
      try {
        const { data } = await getBadgeCount({ force: true });
        if (data?.status) {
          dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
        }
      } catch (_) { /* ignore */ }
    } finally {
      endEmailMutation();
    }
  }, [selectedEmail, activeEmailFolder, activeEmailAccountId, emailMessages, reportFeedEmails, strings, beginEmailMutation, endEmailMutation, dropEmailsFromUnreadSnapshot, rememberDeletedEmail]);

  const pendingEmail = useSelector(state => state.pendingEmail);
  const pendingEmailRef = useRef(null);
  const pendingEmailResolveGenRef = useRef(0);
  // Set when an email is opened from outside the list (global search, cockpit
  // report) so its row is scrolled into view once rendered. Cleared after one scroll.
  const scrollToOpenedEmailRowRef = useRef(false);

  useEffect(() => {
    if (!pendingEmail) return;
    const pending = pendingEmail;
    const gen = ++pendingEmailResolveGenRef.current;
    if (!integrateEmailInMessages) {
      setEmailTabActive(true);
    }
    setActiveEmailFolder("INBOX");
    // In integrate mode the user might be on a chat-only sub-tab (Direct / Group chats)
    // where emails are filtered out. Reset to the "All" tab so the email row can appear and be
    // highlighted/scrolled into view. "email"-only tab would also work but the user explicitly
    // wants the unified All tab so the surrounding chat context stays visible.
    // Global search always lands on All; every other source (cockpit report,
    // priority row) only leaves a tab that would hide the email it just opened.
    const emailsFitCurrentTab = activeFilterUI === "all" || activeFilterUI === "email";
    if (integrateEmailInMessages && (pending.fromGlobalSearch || !emailsFitCurrentTab)) {
      setMessageFilter("all");
      setActiveFilterUI("all");
    }
    // In integrate mode (Messages & E-Mail unified) keep the unified ALL_ACCOUNTS view so
    // the existing chat+email list isn't filtered down to a single account, which would
    // hide the row that should be highlighted. Only change accountId in the dedicated
    // E-Mail tab where the inbox is rendered per-account.
    if (pending.emailAccountId && !integrateEmailInMessages) {
      setActiveEmailAccountId(pending.emailAccountId);
    }
    // Claim the detail pane so the "restore last opened detail" pass does not
    // reopen the previous chat while this email is still resolving by id.
    restoredWidePaneRef.current = true;
    // The email takes over the detail pane, so drop whatever chat was showing
    // there — same as clicking an email row in the list. Without this the old
    // chat keeps its selected highlight while a different item is open.
    updateOpenChats([]);
    updateOpenProjects([]);
    updateGroupChats([]);
    setClickedGroup(null);
    // The ref holds the freshest rendered list; the closure's AllChats can lag
    // behind a reorder that landed since the effect was created.
    const renderedChats = (allChatsRef.current && allChatsRef.current.length > 0)
      ? allChatsRef.current
      : AllChats;
    if (renderedChats && renderedChats.some((c) => c.isOpened)) {
      const deselected = renderedChats.map((c) => (c.isOpened ? { ...c, isOpened: false } : c));
      allChatsRef.current = deselected;
      setAllChats(deselected);
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: deselected });
    }
    // Either way the email was opened from somewhere other than the list, so
    // bring its row to the top of the list, where the user is already looking.
    setHoistedRow(pending.id ? { kind: "email", id: String(pending.id) } : null);
    scrollToOpenedEmailRowRef.current = true;
    if (pending.fromGlobalSearch && pending.prefetchedEmail) {
      pendingEmailRef.current = null;
      setSelectedEmail(pending.prefetchedEmail);
    } else {
      const messageId = pending.id;
      const accountId = pending.emailAccountId;
      // Already in a loaded list: select it at once, so its row is marked right
      // away, and fetch the full message in the background like a row click.
      const pendingKey = { id: messageId, _id: messageId, messageId, providerMessageId: messageId };
      const loaded = messageId
        ? [...(emailMessagesRef.current || []), ...(inboxFeedEmailsRef.current || [])]
            .find((m) => emailEntriesShareId(m, pendingKey)) || null
        : null;
      pendingEmailRef.current = loaded ? null : pending;
      setSelectedEmail(loaded);
      if (loaded) {
        (async () => {
          const fresh = await fetchEmailMessageById(messageId, accountId);
          if (gen !== pendingEmailResolveGenRef.current || !fresh) return;
          setSelectedEmail((prev) => (prev && emailEntriesShareId(prev, loaded) ? mergeEnrichedEmail(prev, fresh) : prev));
        })();
      } else if (messageId) {
        (async () => {
          const msg = await fetchEmailMessageById(messageId, accountId);
          if (gen !== pendingEmailResolveGenRef.current) return;
          if (!msg || !pendingEmailRef.current) return;
          if (String(pendingEmailRef.current.id) !== String(pending.id)) return;
          setSelectedEmail(msg);
          pendingEmailRef.current = null;
        })();
      } else {
        // Nothing to resolve; leaving the ref set would block the
        // restore-last-detail pass for the rest of the session.
        pendingEmailRef.current = null;
      }
    }
    dispatch({ type: SET_PENDING_EMAIL, payload: null });
  }, [pendingEmail, fetchEmailMessageById, dispatch]);

  useEffect(() => {
    if (!pendingEmailRef.current || emailMessages.length === 0) return;
    const pending = pendingEmailRef.current;
    const pendingKey = { id: pending.id, _id: pending.id, messageId: pending.id, providerMessageId: pending.id };
    const match = emailMessages.find((m) => emailEntriesShareId(m, pendingKey));
    if (match) {
      setSelectedEmail(match);
      pendingEmailRef.current = null;
    }
  }, [emailMessages]);

  // A chat the cockpit asked to open, scrolled to the message a priority came
  // from. It always lands here next to the chat list — the cockpit never sends
  // a chat through its project room — so the row stays visible in context.
  const pendingChat = useSelector(state => state.pendingChat);

  // Microsoft Teams: remember the listed Teams groups, so the entry points whose payloads carry no
  // Teams flag (ToDo, Cockpit, search) open them as Teams chats too.
  useEffect(() => {
    rememberTeamsChats(AllChats);
  }, [AllChats]);

  // Microsoft Teams `teamsChatsChanged` (owner only: a chat was discovered, renamed, left or an
  // import milestone was reached) → the list's first page is fetched and merged in place
  // (mergeFirstPageRows): the loaded older pages and the scroll position stay. One fetch at a time;
  // an event during a fetch runs one more afterwards.
  const teamsMergeRef = useRef({ running: false, again: false });
  const mergeTeamsFirstPage = useCallback(async () => {
    const st = teamsMergeRef.current;
    if (st.running) {
      st.again = true;
      return;
    }
    st.running = true;
    try {
      do {
        st.again = false;
        const { data } = await callAPI(`/group/getUserChats?page=1&limit=15${translationLangParam()}`, {}, "GET");
        if (!data || !data.status || !Array.isArray(data.chats)) continue;
        const fresh = excludeArchivedChats(data.chats.map(mapUserChatRow));
        const live = store.getState();
        const current = (allChatsRef.current && allChatsRef.current.length > 0) ? allChatsRef.current : (live.activityMessages || []);
        const openedIds = new Set([
          ...current.filter((c) => c.isOpened).map((c) => String(c.group?.id)),
          ...(live.openChats || []).map((c) => String(c.id || c.key)),
        ]);
        const beingRead = isLatestMessagesRouteRef.current;
        const marked = fresh.map((c) => {
          const opened = openedIds.has(String(c.group?.id));
          return { ...c, isOpened: opened, unseenChatCount: opened && beingRead ? 0 : c.unseenChatCount };
        });
        const merged = mergeFirstPageRows(current, marked);
        merged.sort((a, b) => getListSortDate(b) - getListSortDate(a));
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: (mergeConsecutiveImages(merged) || []).map(applyPreview) });
      } while (st.again);
    } catch (_) {
      // the next list refresh catches up
    } finally {
      st.running = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translationLangParam, getListSortDate, applyPreview]);
  useEffect(() => {
    if (!socket || typeof socket.on !== "function") return undefined;
    const onTeamsChatsChanged = () => {
      mergeTeamsFirstPage();
    };
    socket.on("teamsChatsChanged", onTeamsChatsChanged);
    return () => {
      if (typeof socket.off === "function") socket.off("teamsChatsChanged", onTeamsChatsChanged);
    };
  }, [socket, mergeTeamsFirstPage]);

  // Microsoft Teams read marker advanced (App.js relays the owner's 'unreadChatCount'): the row
  // takes the remaining count, without reordering.
  useEffect(() => {
    const onTeamsUnread = (e) => {
      const detail = e && e.detail;
      if (!detail || detail.group == null) return;
      const live = store.getState().activityMessages || [];
      let changed = false;
      const next = live.map((c) => {
        if (!c || String(c.group?.id) !== String(detail.group)) return c;
        const count = c.isOpened ? 0 : detail.unreadCount;
        if ((Number(c.unseenChatCount) || 0) === count) return c;
        changed = true;
        return { ...c, unseenChatCount: count };
      });
      if (changed) dispatch({ type: SET_ACTIVITY_MESSAGES, messages: next });
    };
    window.addEventListener(TEAMS_UNREAD_EVENT, onTeamsUnread);
    return () => window.removeEventListener(TEAMS_UNREAD_EVENT, onTeamsUnread);
  }, [dispatch]);

  // A Teams chat was filed under a project room (chat info or the row menu): the row shows it.
  useEffect(() => {
    const onTeamsProject = (e) => {
      const detail = e && e.detail;
      if (!detail || detail.groupId == null) return;
      const live = store.getState().activityMessages || [];
      let changed = false;
      const next = live.map((c) => {
        if (!c || String(c.group?.id) !== String(detail.groupId)) return c;
        changed = true;
        return { ...c, teamsProject: detail.project || null };
      });
      if (changed) dispatch({ type: SET_ACTIVITY_MESSAGES, messages: next });
    };
    window.addEventListener(TEAMS_PROJECT_EVENT, onTeamsProject);
    return () => window.removeEventListener(TEAMS_PROJECT_EVENT, onTeamsProject);
  }, [dispatch]);

  useEffect(() => {
    if (!pendingChat || !pendingChat.chatGroupId) return;
    const groupId = String(pendingChat.chatGroupId);
    dispatch({ type: SET_PENDING_CHAT, payload: null });

    // Claim the detail pane before the "restore last opened detail" pass can.
    restoredWidePaneRef.current = true;
    setEmailTabActive(false);
    setSelectedEmail(null);
    setEmailReplyMode(null);
    // Drives scrollToMessageId / scrollToMessagePage on the conversation,
    // which scrolls the message into view and highlights it.
    setEmailDeeplinkScroll({
      chatGroupId: groupId,
      messageId: pendingChat.messageId || undefined,
      page_no: pendingChat.page_no || 1,
    });

    const source = (allChatsRef.current && allChatsRef.current.length > 0)
      ? allChatsRef.current
      : (activityMessages || []);
    const row = source.find((c) => c && c.group && String(c.group.id) === groupId);
    if (row) {
      if (isTeamsChat(row)) chat_click_teams(row);
      else if (row.group.isOneToOne) chat_click(row);
      else chat_click_group(row);
      // After the click, which releases the previous hoist.
      setHoistedRow({ kind: "chat", id: groupId });
      return;
    }
    setHoistedRow({ kind: "chat", id: groupId });

    // Chats the recent-activity list does not carry (an older room group, a
    // conversation that scrolled off) have no row to click, so the panes are
    // filled from the ids the cockpit resolved via /group/:id/messagePage.
    // A Microsoft Teams chat (both chat types): the room-less pane in its Teams mode. A report row
    // of a Teams chat filed under a project room carries that room's id, but the chat stays room-less.
    if (pendingChat.isTeams || isTeamsTarget(pendingChat, groupId)) {
      fetchGroupSecret(groupId);
      updateOpenProjects([]);
      updateGroupChats([]);
      setClickedGroup(null);
      updateOpenChats([teamsChatEntry(pendingChat, {
        id: groupId,
        key: groupId,
        isOpened: true,
        onlyView: false,
        unseenChatCount: 0,
        ...(pendingChat.name ? { name: pendingChat.name } : {}),
      })]);
      return;
    }

    const isGroupInRoom = !!pendingChat.roomId && pendingChat.isOneToOne !== true;
    fetchGroupSecret(groupId);
    if (isGroupInRoom) {
      updateOpenChats([]);
      updateOpenProjects([{
        id: pendingChat.roomId,
        buildingList: pendingChat.roomId,
        key: `proj-${pendingChat.roomId}-${groupId}`,
        isOpened: true,
        unseenChatCount: 0,
        isInternal: !!pendingChat.isInternal,
        name: pendingChat.name || "",
        group: {
          id: groupId,
          name: pendingChat.name || "",
          isInternal: !!pendingChat.isInternal,
        },
      }]);
      updateGroupChats([{
        id: groupId,
        name: pendingChat.name || "",
        isOpened: true,
        unseenChatCount: 0,
        isInternal: !!pendingChat.isInternal,
      }]);
      setClickedGroup(groupId);
    } else {
      updateOpenProjects([]);
      updateGroupChats([]);
      setClickedGroup(null);
      updateOpenChats([{
        id: groupId,
        key: groupId,
        name: pendingChat.name || "",
        isOpened: true,
        isOneToOne: pendingChat.isOneToOne !== false,
        isInternal: !!pendingChat.isInternal,
        onlyView: false,
        unseenChatCount: 0,
      }]);
    }
  }, [pendingChat]);

  // Keep the Alle inbox snapshot in sync while the inbox folder is showing, so
  // mark-read / delete / classify from Alle or INBOX also update the combined list.
  useEffect(() => {
    if (!isInboxFeedFolder(activeEmailFolder)) return;
    if (emailLoading && emailMessages.length === 0) return;
    setInboxFeedEmails(emailMessages.filter(isCombinedFeedEmail));
  }, [emailMessages, activeEmailFolder, emailLoading]);

  // Ensure opened message appears in the list so the row can be highlighted and scrolled into view.
  useEffect(() => {
    if (emailLoading || !selectedEmail) return;
    // Never inject Sent/Draft/etc. into the inbox list — it would leak into Alle.
    if (isInboxFeedFolder(activeEmailFolder) && !isCombinedFeedEmail(selectedEmail)) return;
    setEmailMessages((prev) => {
      if (prev.some((m) => emailEntriesShareId(m, selectedEmail))) return prev;
      return [selectedEmail, ...prev];
    });
  }, [emailLoading, selectedEmail, activeEmailFolder]);

  // After navigating from global search or the cockpit, the email-list might not contain the
  // row yet (we just prepended it via the effect above). Once it's rendered, scroll it into
  // view so the user sees the highlighted entry without having to manually scroll.
  // The id comes from the matched row, not from the navigation, because the two can key off
  // different fields (messageId vs. providerMessageId) for the same email.
  useEffect(() => {
    if (!scrollToOpenedEmailRowRef.current) return;
    if (!selectedEmail) return;
    // Not in the inbox list yet: the Alle list already shows the opened email's own row.
    const match = (emailMessages || []).find((m) => emailEntriesShareId(m, selectedEmail)) || selectedEmail;
    const targetId = match.id || match._id || match.messageId || match.providerMessageId;
    if (!targetId) return;
    // Defer to next frame so the row is mounted in the DOM before scrolling.
    const raf = requestAnimationFrame(() => {
      try {
        const row = document.querySelector(`[data-email-row-id="${CSS.escape(String(targetId))}"]`);
        // Row still behind the list skeleton: try again on the next list update.
        if (!row) return;
        if (typeof row.scrollIntoView === 'function') {
          row.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      } catch (_) { /* best-effort */ }
      scrollToOpenedEmailRowRef.current = false;
    });
    return () => cancelAnimationFrame(raf);
  }, [emailMessages, selectedEmail]);

  /**
   * The optimized `/email/messages` list endpoint (INBOX/STARRED/ARCHIVE) only returns metadata
   * to keep the listing fast — body and attachments are NOT included. When a user opens an email
   * that was loaded via that endpoint, fetch the full message via `/email/messages/:id` so the
   * detail view has body + attachments.
   *
   * Global search often prefetches bodyText/snippet + attachment *names* but not the attachments
   * array — still enrich in that case so the detail view can show downloadable files.
   */
  // Id of the selected email this effect last enriched. Kept after the fetch
  // resolves: a plain-text or short mail still "looks thin" after merging, and
  // clearing it would refetch on every selectedEmail update.
  const enrichedEmailIdRef = useRef(null);
  const expandedAttachmentIdsRef = useRef(new Set());
  useEffect(() => {
    if (!selectedEmail) return;
    const hasHtml = !!(selectedEmail.bodyHtml || selectedEmail.html);
    const hasBody = !!(hasHtml || selectedEmail.bodyText || selectedEmail.body);
    const bodyChars = String(selectedEmail.bodyHtml || selectedEmail.bodyText || selectedEmail.body || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim().length;
    const looksThin = bodyChars < 120;
    const attachmentRows = Array.isArray(selectedEmail.attachments) ? selectedEmail.attachments : [];
    const hasAttachmentObjects = attachmentRows.length > 0;
    const expectsAttachments = !!(
      selectedEmail.hasAttachments
      || (Array.isArray(selectedEmail.attachmentNames) && selectedEmail.attachmentNames.length > 0)
    );
    const attachmentsLookCollapsed = attachmentRows.some((a) => {
      const name = String(a.filename || a.name || "").trim().toLowerCase();
      const mime = String(a.mimeType || a.contentType || "").toLowerCase();
      return name === "attachment" || name === "noname" || name === "untitled"
        || mime === "message/rfc822" || name.endsWith(".eml");
    });
    const needsAttachments = (expectsAttachments && !hasAttachmentObjects)
      || (attachmentsLookCollapsed && !expandedAttachmentIdsRef.current.has(String(selectedEmail.id || selectedEmail._id || "")));
    // Still fetch when HTML is missing — text/plain is often just tracking URLs.
    if (hasBody && hasHtml && !needsAttachments && !looksThin) return;
    const messageId = isPersistedEmailId(selectedEmail.id)
      ? selectedEmail.id
      : (isPersistedEmailId(selectedEmail._id) ? selectedEmail._id : null);
    if (!messageId) return;
    const idStr = String(messageId);
    if (enrichedEmailIdRef.current === idStr) return;
    enrichedEmailIdRef.current = idStr;
    if (attachmentsLookCollapsed) expandedAttachmentIdsRef.current.add(idStr);
    const accountId = selectedEmail.__accountId
      || selectedEmail.emailAccountId
      || (activeEmailAccountId && activeEmailAccountId !== ALL_ACCOUNTS_ID ? activeEmailAccountId : undefined);
    (async () => {
      const full = await fetchEmailMessageById(
        messageId,
        accountId,
        selectedEmail.folder || activeEmailFolder
      );
      if (enrichedEmailIdRef.current !== idStr || !full) return;
      setSelectedEmail((prev) => {
        if (!prev || !emailEntriesShareId(prev, full)) return prev;
        return mergeEnrichedEmail(prev, full);
      });
      setEmailMessages((prev) => prev.map((m) => (
        emailEntriesShareId(m, full) ? mergeEnrichedEmail(m, full) : m
      )));
    })();
  }, [selectedEmail, activeEmailAccountId, fetchEmailMessageById]);

  useEffect(() => {
    if (!(emailTabActive || integrateEmailInMessages) || !selectedEmail) return;
    markEmailAsRead(selectedEmail);
  }, [emailTabActive, integrateEmailInMessages, selectedEmail, markEmailAsRead]);

  const [emailActionOverlay, setEmailActionOverlay] = useState(null);
  // Full-screen progress overlay for bulk email deletion. `null` when idle,
  // otherwise `{ completed, total }`. A single screen-covering overlay (instead
  // of the previous per-panel overlays) with a live counter + progress bar so
  // the user can see deletion is advancing and not stuck.
  const [emailDeleteProgress, setEmailDeleteProgress] = useState(null);

  const openComposeNew = useCallback(() => {
    if (exclusiveMessagesPane) {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    }
    setEmailReplyMode("new");
    fetchClassificationBuildings();
  }, [fetchClassificationBuildings, exclusiveMessagesPane, dispatch]);

  const openComposeReply = useCallback((email) => {
    setEmailReplyMode("reply");
  }, []);

  const openComposeReplyAll = useCallback((email) => {
    setEmailReplyMode("replyAll");
  }, []);

  const openComposeForward = useCallback((email) => {
    setEmailReplyMode("forward");
  }, []);

  const toggleEmailBookmark = useCallback((em) => {
    if (!em) return;
    const emailId = em.id || em._id || em.messageId || em.providerMessageId;
    if (!emailId) return;
    const isBookmarked = em.isTodoBookmarked || bookmarkedEmailIds.has(String(emailId));
    if (isBookmarked) {
      removeBookmarkTodo({ emailId });
      return;
    }
    // Only an email filed under a project becomes a task.
    if (!emailProjectIdOf(em)) return;
    const summary = getEmailListPreview(em, !!user?.emailSummaryPreviewEnabled)
      || firstEmailSentence(em.bodyText || em.snippet || em.subject)
      || String(em.subject || "").replace(/\s+/g, " ").trim()
      || "(No subject)";
    createTodoFromEmail(emailId, em.date || em.receivedAt, summary, em);
  }, [bookmarkedEmailIds]);

  const cancelReplyMode = useCallback(() => {
    setEmailReplyMode(null);
    if (exclusiveMessagesPane && !selectedEmail) {
      dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    }
  }, [exclusiveMessagesPane, selectedEmail, dispatch]);

  const handleCloseEmailDetail = useCallback(async () => {
    if (emailReplyMode) {
      setSelectedEmail(null);
      return;
    }
    const inlineClosed = await requestCloseInlineEmailCompose();
    if (!inlineClosed) return;
    // Opened from global search → goBack only. Keep email mounted until the search URL
    // restores so we don't flash the mail list before the popup covers it.
    if (location.state?.fromGlobalSearch) {
      dispatch({ type: SET_SEARCH_STATUS, payload: true });
      history.goBack();
      return;
    }
    setSelectedEmail(null);
    setEmailReplyMode(null);
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
  }, [emailReplyMode, requestCloseInlineEmailCompose, history, location.state, dispatch, exclusiveMessagesPane]);

  useEffect(() => {
    const hasPendingEmailCompose = (emailTabActive || integrateEmailInMessages) && emailReplyMode;
    if (!hasPendingEmailCompose) return undefined;
    const unblock = history.block((nextLocation, action) => {
      if (emailNavigationGuardBypassRef.current) {
        emailNavigationGuardBypassRef.current = false;
        return undefined;
      }
      (async () => {
        const allowed = await guardAndLeaveEmailSection(() => {
          emailNavigationGuardBypassRef.current = true;
          if (action === "REPLACE") {
            history.replace(nextLocation);
          } else {
            history.push(nextLocation);
          }
        });
        if (!allowed) {
          emailNavigationGuardBypassRef.current = false;
        }
      })();
      return false;
    });
    return unblock;
  }, [history, emailTabActive, integrateEmailInMessages, emailReplyMode, guardAndLeaveEmailSection]);

  const silentListRefreshAtRef = useRef(0);

  const onLatestListWheel = (e) => {
    if (!e.currentTarget || e.currentTarget.scrollTop > 8) return;
    if (Math.abs(e.deltaY) < 8) return;
    refreshLatestOnPullRef.current();
  };
  const onLatestListTouchStart = (e) => {
    pullStartYRef.current = e.touches && e.touches[0] ? e.touches[0].clientY : 0;
  };
  const onLatestListTouchMove = (e) => {
    if (!e.currentTarget || e.currentTarget.scrollTop > 8) return;
    const y = e.touches && e.touches[0] ? e.touches[0].clientY : 0;
    if (y - pullStartYRef.current > 48) refreshLatestOnPullRef.current();
  };

  const reloadActiveEmailFolder = useCallback((opts = {}) => {
    const silent = !!opts.silent;
    emailInboxFetchKeyRef.current = null;
    if (!activeEmailAccountId) return;
    // Unread list: a quiet reload keeps the loaded window instead of cutting
    // it back to the first page.
    if (silent && showUnreadOnlyRef.current && isInboxFeedFolder(activeEmailFolder)) {
      refillUnreadEmails();
      return;
    }
    if (activeEmailAccountId === ALL_ACCOUNTS_ID) {
      fetchAllAccountsMessages(1, false, activeEmailFolder, silent);
    } else {
      fetchEmailMessages(activeEmailAccountId, 1, false, activeEmailFolder, silent);
    }
  }, [activeEmailAccountId, activeEmailFolder, fetchEmailMessages, fetchAllAccountsMessages, refillUnreadEmails]);

  useEffect(() => {
    refreshLatestOnPullRef.current = () => {
      const now = Date.now();
      if (now - silentListRefreshAtRef.current < 5000) return;
      silentListRefreshAtRef.current = now;
      _getMessages(1, true);
      if (integrateEmailInMessages || emailTabActive) {
        reloadActiveEmailFolder({ silent: true });
      }
    };
  }, [_getMessages, integrateEmailInMessages, emailTabActive, reloadActiveEmailFolder]);

  const handleComposeSent = useCallback((meta) => {
    const sentDraft = !!(meta && meta.sentDraft);
    const savedDraft = !!(meta && meta.savedDraft);
    const onDrafts = String(activeEmailFolder || "").toUpperCase() === "DRAFT";
    const editingDraft = emailReplyModeRef.current === "draft" || onDrafts;
    if (sentDraft || (savedDraft && editingDraft)) {
      const sel = selectedEmailRef.current;
      if (sel) {
        staleDraftIdsRef.current = emailEntryIds(sel);
        setEmailMessages((prev) => prev.filter((m) => !emailEntriesShareId(m, sel)));
      }
      // Clear selection before refetch so keep-selected cannot re-inject the
      // stale draft row (IMAP overwrite gets a new UID; Gmail/Outlook keep it).
      selectedEmailRef.current = null;
      setSelectedEmail(null);
      setEmailReplyMode(null);
    }
    reloadActiveEmailFolder();
    if ((sentDraft || savedDraft) && onDrafts) {
      if (draftsReloadTimerRef.current) clearTimeout(draftsReloadTimerRef.current);
      draftsReloadTimerRef.current = setTimeout(() => {
        reloadActiveEmailFolder({ silent: true });
      }, 800);
    }
  }, [activeEmailFolder, reloadActiveEmailFolder]);

  const handleUpdateRequests = (id, cid, index, isKjuup) => {
    let a = { ...unSeenAllCount }
    if (isKjuup) {
      let f = { ...a, unseenInternalProject: (a.unseenInternalProject - 1) < 0 ? 0 : a.unseenInternalProject - 1 }
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: f })
    }
    else {
      let f = { ...a, unseenExternalProject: (a.unseenExternalProject - 1) < 0 ? 0 : a.unseenExternalProject - 1 }
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: f })
    }

    let tmp = [...pendingRequests]
    tmp.splice(index, 1)
    if (tmp.length == 0) {
      setShowPendingRequests(false)
    }
    setPendingRequests(tmp)
  }

  const slideRef = useRef({ wasOpen: false, snap: null });
  const [slideEntered, setSlideEntered] = useState(false);
  const [, setSlideTick] = useState(0);
  // A room left open from Räume has no chat `.group`. Sliding the list away
  // for that leaves the detail sheet empty (white). Only replace the list when
  // a chat, email, message-list group or an oversight room is actually open.
  const paneOversightRoom = oversightOn ? oversightRoom : null;
  const exclusiveDetailReady =
    (openChats && openChats.length > 0) ||
    !!paneOversightRoom ||
    !!(selectedEmail || emailReplyMode) ||
    (openProjects && openProjects.some((p) => p && p.group && p.group.id));
  const detailLive = exclusiveMessagesPane && !openLatestMsgToggle && exclusiveDetailReady;
  if (detailLive) {
    slideRef.current.snap = {
      openChats,
      openProjects,
      oversightRoom: paneOversightRoom,
      selectedEmail,
      emailReplyMode,
      emailTabActive,
    };
    slideRef.current.wasOpen = true;
  }
  const detailClosing = exclusiveMessagesPane && openLatestMsgToggle && slideRef.current.wasOpen;
  const pane = (detailClosing && slideRef.current.snap)
    ? slideRef.current.snap
    : {
      openChats,
      openProjects,
      oversightRoom: paneOversightRoom,
      selectedEmail,
      emailReplyMode,
      emailTabActive,
    };

  useEffect(() => {
    if (!exclusiveMessagesPane) {
      setSlideEntered(false);
      return undefined;
    }
    if (detailLive) {
      setSlideEntered(false);
      let secondFrame = 0;
      const firstFrame = requestAnimationFrame(() => {
        secondFrame = requestAnimationFrame(() => setSlideEntered(true));
      });
      return () => {
        cancelAnimationFrame(firstFrame);
        cancelAnimationFrame(secondFrame);
      };
    }
    setSlideEntered(false);
    return undefined;
  }, [detailLive, exclusiveMessagesPane]);

  useEffect(() => {
    if (!detailClosing) return undefined;
    const timer = setTimeout(() => {
      slideRef.current.wasOpen = false;
      slideRef.current.snap = null;
      setSlideTick((n) => n + 1);
    }, 320);
    return () => clearTimeout(timer);
  }, [detailClosing]);

  const renderOpenEntryPanes = (asCompanion = false) => {
    const paneClass = `lm-pane ${(asCompanion || isDesktop || exclusiveMessagesPane) ? "lm-pane--desktop" : "lm-pane--mobile"}`;
    const paneStyle = (!asCompanion && !isDesktop && !exclusiveMessagesPane)
      ? { "--lm-mobile-left": isLatestMessagesSidebar ? "88px" : "0px" }
      : undefined;
    const companionWrapStyle = asCompanion
      ? { flex: 1, display: "flex", flexDirection: "column", minWidth: 0, minHeight: 0, width: "100%", overflow: "hidden" }
      : (exclusiveMessagesPane
        ? { flex: 1, display: "flex", flexDirection: "column", width: "100%", height: "100%", minWidth: 0, minHeight: 0, overflow: "hidden", backgroundColor: "#fff" }
        : (isDesktop
        ? { flex: 1, display: "flex", flexDirection: "column", position: "relative", zIndex: 1, width: "100%", maxWidth: "100%", minWidth: 0, minHeight: 0, overflow: "hidden", boxSizing: "border-box", backgroundColor: "#fff" }
        : { position: "fixed", zIndex: 10000002, right: 0, left: isLatestMessagesSidebar ? "88px" : "0px", top: "55px", height: "calc(var(--app-height) - 55px)", maxHeight: "calc(var(--app-height) - 55px)", display: "flex", flexDirection: "column", backgroundColor: "#fff", overflow: "hidden", minHeight: 0, boxSizing: "border-box" }));

    // Räume > Verwaltung: the picked room's oversight view, while no chat is open.
    if (
      !asCompanion &&
      pane.oversightRoom &&
      !(pane.openChats && pane.openChats.length) &&
      !(pane.openProjects && pane.openProjects.length)
    ) {
      return (
        <div style={companionWrapStyle}>
          <OversightRoomDetail room={pane.oversightRoom} />
        </div>
      );
    }

    return (
      <>
        {pane.openChats && pane.openChats.length >= 1 ?
          pane.openChats.map((chat) => (
            <div
              key={chat?.key}
              className={paneClass}
              style={paneStyle}
            >
              <Coversation
                chat={chat}
                chat_key={chat?.key}
                openChatArr={pane.openChats}
                scrollToMessageId={emailDeeplinkScroll && String(emailDeeplinkScroll.chatGroupId) === String(chat?.id) ? emailDeeplinkScroll.messageId : undefined}
                scrollToMessagePage={emailDeeplinkScroll && String(emailDeeplinkScroll.chatGroupId) === String(chat?.id) ? emailDeeplinkScroll.page_no : undefined}
                onMessageHighlighted={() => setEmailDeeplinkScroll(null)}
                handleClose={() => {
                  // Navigation handled in Conversation.js
                }}
              />
            </div>
          ))
          : null}
        {pane.openProjects?.map((project, index) => {
          const tempIndex = index + 1;
          return (
            <div
              key={project.key}
              className={paneClass}
              style={paneStyle}
            >
              <ProjectDetail
                idx={index}
                id={project.buildingList}
                addUserAction={{
                  openAddProjectWindow: project?.openAddProjectWindow,
                  id: project.buildingList,
                }}
                project_key={project.key}
                project={{ ...project, id: project.buildingList }}
                lastIndex={pane.openProjects?.length === tempIndex && index}
                groupIdLat={clickedGroup}
                isFromLatestMsg={true}
                scrollToMessageId={emailDeeplinkScroll && String(emailDeeplinkScroll.chatGroupId) === String(clickedGroup) ? emailDeeplinkScroll.messageId : undefined}
                scrollToMessagePage={emailDeeplinkScroll && String(emailDeeplinkScroll.chatGroupId) === String(clickedGroup) ? emailDeeplinkScroll.page_no : undefined}
                onMessageHighlighted={() => setEmailDeeplinkScroll(null)}
              />
            </div>
          );
        })}
      </>
    );
  };

  const composeCompanionTab = (() => {
    if (!emailReplyMode) return null;
    if (openChats && openChats.length >= 1) {
      const chat = openChats[0];
      const label = getOneToOnePartnerName(
        { group: chat, name: chat.name, senderName: chat.senderName, senderId: chat.senderId },
        user,
        strings.my_notes || "My Space"
      ) || chat.name || "Chat";
      return { key: `chat-${chat.key || chat.id}`, label, icon: "person" };
    }
    if (openProjects && openProjects.length >= 1) {
      const project = openProjects[0];
      const roomName = project.defaultChatGroup
        ? (strings.All || "All")
        : stripMarkdown(translatedChatNames[project.group?.id] || translatedChatNames[project.mainId] || project.name || project.group?.name || "");
      const buildingLabel = project.buildingName;
      const label = [buildingLabel, roomName].filter(Boolean).join(" - ") || (strings.filter_internal_groups || "Chat");
      return { key: `proj-${project.key}`, label, icon: "group" };
    }
    return null;
  })();

  // Filter tabs JSX. Extracted so it can be rendered both above the chat list
  // (when in messages view) and above the full email section (when in integrated
  // mode with the E-Mail filter active), giving the user a single, consistent
  // way to toggle between messages and the email section.
  // Switch the left panel to the email section without a tab click:
  //   - cockpit / sidebar "Kjuup-Email" navigation (?view=email or state.openEmailTab)
  //   - chats hidden by the Kjuup.io workspace preference (email is the only view)
  const emailViewRequested = locationRequestsEmailView(location);
  const wantsEmailView =
    integrateEmailInMessages && !hideEmailClientPref && (emailViewRequested || hideChatsPref);
  useEffect(() => {
    if (!wantsEmailView) return;
    // Chats off: the page is only the email client, even if the last visit
    // left the chat list open (the pane stays mounted across navigation).
    if (hideChatsPref) {
      updateOpenChats([]);
      updateOpenProjects([]);
      updateGroupChats([]);
      setClickedGroup(null);
    }
    if (activeFilterUI !== "email") {
      setActiveFilterUI("email");
      startFilterTransition(() => {
        setMessageFilter("email");
      });
    }
    setEmailTabActive(true);
    autoOpenFirstEmailPendingRef.current = false;
    if (!activeEmailAccountId && emailAccounts.length > 0) {
      setActiveEmailAccountId(
        emailAccounts.length > 1
          ? ALL_ACCOUNTS_ID
          : (emailAccounts[0].id || emailAccounts[0]._id)
      );
    }
    setActiveEmailFolder("INBOX");
    dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    if (emailViewRequested) {
      history.replace({ pathname: location.pathname, search: "", state: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsEmailView, emailViewRequested, emailAccounts.length, hideChatsPref]);

  // Email client off: leave the inbox even if that was the last open view.
  useEffect(() => {
    if (!hideEmailClientPref) return undefined;
    setEmailTabActive(false);
    setActiveFilterUI((prev) => (prev === "email" ? "all" : prev));
    setMessageFilter((prev) => (prev === "email" ? "all" : prev));
    setSelectedEmail(null);
    setEmailReplyMode(null);
    autoOpenFirstEmailPendingRef.current = false;
    return undefined;
  }, [hideEmailClientPref]);

  // Teams off: leave the Teams filter.
  useEffect(() => {
    if (!hideTeamsPref) return;
    setActiveFilterUI((prev) => (prev === "teams" ? "all" : prev));
    setMessageFilter((prev) => (prev === "teams" ? "all" : prev));
  }, [hideTeamsPref]);

  // Sidebar "Kjuup-Chats" -> "Alle" tab (?view=all / state.openAllTab). Mirrors a
  // click on the Alle filter tab, including leaving the full email section.
  // While chats are still hidden the request stays pending (the enable flow
  // updates the preference right before navigating here).
  const allViewRequested = locationRequestsAllView(location);
  useEffect(() => {
    if (!allViewRequested || hideChatsPref) return;
    const previousFilter = activeFilterUI;
    if (activeFilterUI !== "all" || emailTabActive) {
      setActiveFilterUI("all");
      startFilterTransition(() => {
        setMessageFilter("all");
      });
      if (integrateEmailInMessages && (previousFilter === "email" || emailTabActive)) {
        if (!emailReplyModeRef.current) {
          setSelectedEmail(null);
          setEmailReplyMode(null);
        }
        setEmailTabActive(false);
        autoOpenFirstEmailPendingRef.current = false;
        if (!isInboxFeedFolder(activeEmailFolder)) {
          setEmailMessages(inboxFeedEmailsRef.current);
          emailInboxFetchKeyRef.current = null;
          setEmailPage(1);
          setIsEmailsOver(false);
          setActiveEmailFolder("INBOX");
        }
      }
    }
    dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    history.replace({ pathname: location.pathname, search: "", state: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allViewRequested, hideChatsPref, emailTabActive]);

  // Chats hidden AND no email client ("Nur Projekte + Berichte"): the sidebar
  // entry is gone and this page has nothing to show -> back to the cockpit
  // (reached e.g. via startup screen, deeplink or a stale bookmark).
  useEffect(() => {
    if (!hideChatsPref || !hideEmailClientPref) return;
    if (location.pathname !== "/messages") return;
    history.replace("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideChatsPref, hideEmailClientPref, location.pathname]);

  // Switches the list filter (all / email / direct / groups / teams), entering or
  // leaving the full email section in integrated mode. Compose stays open.
  const switchMessageFilter = (key) => {
    const previousFilter = activeFilterUI;
    // The inbox has its own selection: the list's mail selection ends there.
    if (key === "email" && emailSelectMode) exitEmailSelectMode();
    // Snap the active highlight…
    setActiveFilterUI(key);
    if (key === "groups") {
      setGroupScopeFilter("all");
    }
    // …and let React reconcile the (potentially long) chat list as a
    // low-priority transition so the click feels instant even on large lists.
    startFilterTransition(() => {
      setMessageFilter(key);
    });
    // In integrated mode the "E-Mail" filter doubles as the E-Mail toggle:
    // clicking it switches the entire left panel to the full email section
    // (account/folder sidebar + inbox). Any other filter returns to chat view.
    if (integrateEmailInMessages) {
      if (key === "email") {
        if (!emailReplyModeRef.current) {
          updateOpenChats([]);
          updateOpenProjects([]);
          updateGroupChats([]);
          setClickedGroup(null);
          const resetChats = (AllChats || []).map(c => ({ ...c, isOpened: false }));
          dispatch({ type: SET_ACTIVITY_MESSAGES, messages: resetChats });
          setSelectedEmail(null);
          setEmailReplyMode(null);
        }
        setEmailTabActive(true);
        autoOpenFirstEmailPendingRef.current = false;
        // Ensure an account (or "All Accounts") is selected so the email
        // tab never appears with an empty sidebar selection.
        if (!activeEmailAccountId && emailAccounts.length > 0) {
          setActiveEmailAccountId(
            emailAccounts.length > 1
              ? ALL_ACCOUNTS_ID
              : (emailAccounts[0].id || emailAccounts[0]._id)
          );
        }
        setActiveEmailFolder("INBOX");
        dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
      } else if (previousFilter === "email") {
        if (!emailReplyModeRef.current) {
          setSelectedEmail(null);
          setEmailReplyMode(null);
        }
        setEmailTabActive(false);
        autoOpenFirstEmailPendingRef.current = false;
        if (!isInboxFeedFolder(activeEmailFolder)) {
          setEmailMessages(inboxFeedEmailsRef.current);
          emailInboxFetchKeyRef.current = null;
          setEmailPage(1);
          setIsEmailsOver(false);
          setActiveEmailFolder("INBOX");
        }
      }
    }
  };

  // Filter chips (mobile Pro chat list): All · Unread n · Rooms · Groups ·
  // Direct · E-Mail, exactly one active (Unread = All with the unread filter).
  // Only Unread carries a count, the number of chats with unread messages; the
  // Rooms / Groups row below keeps the message counts.
  const onFilterChip = (key) => {
    if (key === "unread") {
      if (activeFilterUI !== "all") {
        setChatScope(null);
        switchMessageFilter("all");
      }
      applyUnreadOnly(true);
      return;
    }
    if (showUnreadOnly) applyUnreadOnly(false);
    if (key === "rooms" || key === "groups") {
      setChatScope(key);
      // Rooms / Groups always start on All (also when tapped again).
      if (activeFilterUI === "groups") setGroupScopeFilter("all");
      else switchMessageFilter("groups");
      return;
    }
    setChatScope(null);
    if (activeFilterUI !== key) switchMessageFilter(key);
  };
  // With chats hidden only "E-Mail" would remain, so the bar is dropped and the
  // page is the email client itself (sidebar entry "E-Mail").
  const renderFilterChips = () => {
    if (!isTabSelect || hideChatsPref) return null;
    const chipLabel = (key, de, en) => strings[key] || (isGerm ? de : en);
    const chips = [
      { key: "all", label: strings.filter_all || (isGerm ? "Alle" : "All") },
      { key: "unread", label: chipLabel("pro_messages_unread", "Ungelesen", "Unread"), count: unreadChatCount },
      { key: "groups", label: chipLabel("pro_messages_groups", "Gruppen", "Groups"), count: chipUnread.groups.all },
      { key: "direct", label: chipLabel("pro_messages_direct", "Direkt", "Direct"), count: chipUnread.direct },
    ];
    if (integrateEmailInMessages && !hideEmailClientPref) {
      chips.push({ key: "email", label: strings.filter_email || "E-Mail", count: unreadEmailCount });
    }
    if (!hideTeamsPref && (hasTeamsChats || activeFilterUI === "teams")) {
      chips.push({ key: "teams", label: strings.pro_messages_tag_teams || "Teams", count: chipUnread.teams });
    }
    let activeChip = activeFilterUI;
    if (showUnreadOnly && activeFilterUI === "all") activeChip = "unread";
    else if (activeFilterUI === "groups") activeChip = chatScope === "rooms" ? "rooms" : "groups";
    // Under Rooms / Groups: All · Intern · Extern (+ Verwaltung under Rooms for a
    // viewer who manages company rooms).
    const showSubChips = activeFilterUI === "groups" && !showUnreadOnly;
    const subChips = [];
    if (showSubChips) {
      const scopeUnread = chatScope === "rooms" ? chipUnread.rooms : chipUnread.groups;
      subChips.push(
        { key: "all", label: strings.filter_all || (isGerm ? "Alle" : "All"), count: scopeUnread.all },
        { key: "internal", label: strings.filter_groups_internal || (isGerm ? "Intern" : "Internal"), count: scopeUnread.internal },
        { key: "external", label: strings.filter_groups_external || (isGerm ? "Extern" : "External"), count: scopeUnread.external }
      );
      if (chatScope === "rooms" && adminCompanies.length > 0) {
        subChips.push({ key: "oversight", label: strings.rooms_oversight || "Supervision" });
      }
    }
    const subActive = subChips.some((c) => c.key === groupScopeFilter) ? groupScopeFilter : "all";
    // The company choice under the chips: Rooms > Intern (Kjuup+ companies, with
    // their unread rooms) or Rooms > Verwaltung (the managed companies).
    let extra = null;
    if (showSubChips && roomCompany) {
      extra = (
        <CompanySelector
          companies={roomCompanies.map((c) => ({ ...c, isSelected: String(c.id) === String(roomCompany.id) }))}
          onSelect={(_, id) => setRoomCompanyId(id)}
        />
      );
    } else if (oversightOn && oversightCompany && adminCompanies.length > 1) {
      extra = (
        <CompanySelector
          companies={adminCompanies.map((c) => ({ ...c, isSelected: String(c.id) === String(oversightCompany.id) }))}
          onSelect={(_, id) => setOversightCompanyId(id)}
          unseenArticleByCompany={{}}
        />
      );
    }
    return (
      <ChatListChips
        chips={chips}
        activeKey={activeChip}
        onSelect={onFilterChip}
        subChips={subChips}
        subActive={subActive}
        onSubSelect={(key) => {
          if (key !== groupScopeFilter) setGroupScopeFilter(key);
        }}
        extra={extra}
        label={strings.kjuup_messages_title || (isGerm ? "Nachrichten" : "Messages")}
        subLabel={chatScope === "projects" ? chipLabel("pro_messages_rooms", "Projekte", "Projects") : chipLabel("pro_messages_groups", "Gruppen", "Groups")}
      />
    );
  };
  const filterTabsContent = renderFilterChips();

  // Rooms > Verwaltung: a room opens its oversight view in this page's own pane.
  const openOversightRoom = (room) => {
    if (!oversightCompany || !room) return;
    updateOpenChats([]);
    updateOpenProjects([]);
    updateGroupChats([]);
    setClickedGroup(null);
    if (!emailReplyModeRef.current) {
      setSelectedEmail(null);
      setEmailReplyMode(null);
    }
    if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({
      type: SET_OVERSIGHT_ROOM,
      payload: {
        id: String(room.id),
        name: room.name || "",
        isInternal: !!room.isInternal,
        companyId: oversightCompany.id,
        companyName: oversightCompany.name,
      },
    });
  };

  // The chat view of the list column: title row, chips (or the mail selection
  // bar), banners, pending invitations, then the rows / oversight list.
  const renderChatListView = () => {
    // List states: the empty card (every chip but plain "All"), the paging footer.
    const listEmptyLabel = strings.pro_messages_no_chats_filter || (isGerm ? "Keine Chats in diesem Filter" : "No chats in this filter");
    const showListEmpty =
      isTabSelect &&
      !oversightOn &&
      !(messageFilter === "all" && !showUnreadOnly) &&
      filteredChatsWithEmails.length === 0 &&
      !gettingChats &&
      !gettingChatsBottom &&
      !isPaginationTriggered;
    return (
      <>
        {/* Title row, then the chips (or the mail selection bar), the
            banners and the pending room invitations (mobile order). */}
        {renderListHeader()}
        {emailSelectMode ? renderEmailSelectionBar() : filterTabsContent}
        <TrialWarningBanner />
        <EmailConnectionWarningBanner />
        <MessagesJoinCard
          count={pendingRequests?.length || 0}
          title={strings.request_confirmation}
          subtitle={pendingRequests?.[0] && strings.invited_you_to_join_room
            ? strings.invited_you_to_join_room
                .replace("Username", pendingRequests[0].addedBy || "")
                .replace("Roomname", pendingRequests[0].projectName || "")
            : null}
          onClick={() => setShowPendingRequests(true)}
        />
        {!isTabSelect && AllChatsReminder.length > 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: '10px 15px 10px 10px',
              backgroundColor: 'var(--kjuup-bg)',
            }}
          >
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: 500, fontSize: "14px" }}>
                {strings.remove_all_todo}
              </span>
            </div>
            <button
              className="reminder-btn icon-btn-shadow icon-btn"
              onClick={async () => {
                try {
                  await $crud.confirm({
                    title: strings.confirm,
                    textContent: strings.remove_all_todo_confirm,
                    options: {
                      ok: strings.ok,
                      cancel: strings.cancel,
                    },
                  });
                } catch (e) {
                  return;
                }
                _removeAllReminders();
              }}
              title={strings.remove_all_todo}
            >
              <span className="material-symbols-outlined todo-close-icon">close</span>
            </button>
          </div>
        ) : !isTabSelect && !gettingChats ? (
          // ToDo view
          <div style={{ height: "100%", display: "flex", flexDirection: "column", backgroundColor: "var(--kjuup-bg)" }}>
            <div style={{ flex: 1, padding: "20px", textAlign: "center" }}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
              }}>
                <FiFileText size={48} color="#737373" style={{ marginBottom: "15px" }} />
                <h4 className="header-margin-gray">
                  {strings.np_todo}
                </h4>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {oversightOn && oversightCompany ? (
          // Räume > Verwaltung: the company's room list replaces the room chats.
          <div className="lmp-oversight">
            <OversightRoomList
              key={String(oversightCompany.id)}
              companyId={oversightCompany.id}
              activeRoomId={oversightRoom ? oversightRoom.id : null}
              onOpenRoom={openOversightRoom}
              className="lmp-oversight-list"
            />
          </div>
        ) : showMessagesListSkeleton ? (
          <div className={`scroll latestmessages_scrollbar loading ${!messagesListSkeletonVisible ? 'skeleton-fade-out' : ''}`} style={{ height: "100%", minHeight: "400px", overflowX: "hidden", paddingTop: 10, backgroundColor: "#fff", position: messagesListSkeletonVisible ? 'relative' : 'absolute', zIndex: messagesListSkeletonVisible ? 1 : 0, pointerEvents: messagesListSkeletonVisible ? 'auto' : 'none' }}>
            <ChatListSkeleton count={6} />
          </div>
        ) : (
          <div className={`scroll latestmessages_scrollbar loaded lmp-list ${isContentReady ? 'company-content-fade-in' : ''}`} onScroll={isTabSelect ? handleScroll : handleScrollReminder} onWheel={onLatestListWheel} onTouchStart={onLatestListTouchStart} onTouchMove={onLatestListTouchMove} style={{ height: "100%", minHeight: "400px", overflowX: "hidden", paddingTop: 10, backgroundColor: "#fff", position: "relative", opacity: messagesListSkeletonVisible ? 0 : 1, transition: "opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)" }}>
            {(isTabSelect ? filteredChatsWithEmails : processedReminders).map((item, index) => {
              return _renderChats(item, index, index);
            })}
            {showListEmpty ? <ChatListEmpty label={listEmptyLabel} /> : null}
            {(gettingChatsBottom || isPaginationTriggered) && !showUnreadOnly && (
              <ChatListSkeleton count={2} compact />
            )}
          </div>
        )}
      </>
    );
  };

  // The page is built in a nested function: eslint-plugin-react-hooks 4.2 counts
  // this component's code paths with plain numbers, and the JSX branches pushed
  // the count past 2^53, which reported false "called conditionally" errors.
  const renderPage = () => (
    <>
      <div
        className={`lm-root${exclusiveMessagesPane ? " lm-root--slide" : ""}${slideEntered && detailLive ? " lm-detail-open" : ""}`}
        style={messagesSplitLayout ? {
          "--lm-left-panel-width": (panelWidths.left !== null
            ? `${panelWidths.left}px`
            : "50%")
        } : undefined}
      >
        <div className="search_bar_main_div">
          <SearchBar />
        </div>
        <div
          ref={panelContainerRef}
          className="lm-panel-container"
        >
          <div
            className={`w-300 latest_messages_wrapper_div common_box_user_list lm-left-panel ${messagesSplitLayout ? 'lm-left-panel--desktop' : 'lm-left-panel--mobile'} ${(!exclusiveMessagesPane && !openLatestMsgToggle) ? "mobile_none" : " mobile_block"}`}
            style={{
              ...(messagesSplitLayout ? {
                "--lm-left-panel-width": (panelWidths.left !== null
                  ? `${panelWidths.left}px`
                  : '50%')
              } : {}),
              ...(!exclusiveMessagesPane && !messagesSplitLayout && !openLatestMsgToggle ? { display: "none" } : {}),
            }}
          >
            <>
                {isEmailFeatureEnabled && !integrateEmailInMessages && (
                <div className="email-toggle-container">
                  <div className={`email-toggle-pill ${emailTabActive ? 'email-active' : 'messages-active'}`}>
                    <div
                      className="email-toggle-slider"
                      style={(() => {
                        const msgBtn = emailToggleMsgRef.current;
                        const emailBtn = emailToggleEmailRef.current;
                        if (!msgBtn || !emailBtn) {
                          return emailTabActive
                            ? { left: msgBtn ? msgBtn.offsetWidth + 2 : '50%', width: emailBtn ? emailBtn.offsetWidth : '50%' }
                            : { left: 2, width: msgBtn ? msgBtn.offsetWidth : '50%' };
                        }
                        return emailTabActive
                          ? { left: msgBtn.offsetWidth + 2, width: emailBtn.offsetWidth }
                          : { left: 2, width: msgBtn.offsetWidth };
                      })()}
                    />
                    <button
                      ref={emailToggleMsgRef}
                      className={`email-toggle-option ${!emailTabActive ? 'active' : ''}`}
                      onClick={async () => {
                        await guardAndLeaveEmailSection(() => {
                          setEmailTabActive(false);
                          setSelectedEmail(null);
                          setEmailReplyMode(null);
                        });
                      }}
                    >
                      {integrateEmailInMessages ? (strings.email_tab_messages_and_email || 'Messages & E-Mail') : strings.email_tab_messages}
                    </button>
                    <button
                      ref={emailToggleEmailRef}
                      className={`email-toggle-option ${emailTabActive ? 'active' : ''}`}
                      onClick={() => {
                        setEmailTabActive(true);
                        updateOpenChats([]);
                        updateOpenProjects([]);
                        setSelectedEmail(null);
                        // Auto-open of the first email is intentionally disabled — the
                        // user prefers to land on the inbox list without a preselection.
                        autoOpenFirstEmailPendingRef.current = false;
                        // Ensure an account (or "All Accounts") is selected so the email
                        // tab never appears with an empty sidebar selection.
                        if (!activeEmailAccountId && emailAccounts.length > 0) {
                          setActiveEmailAccountId(
                            emailAccounts.length > 1
                              ? ALL_ACCOUNTS_ID
                              : (emailAccounts[0].id || emailAccounts[0]._id)
                          );
                        }
                        setActiveEmailFolder("INBOX");
                        dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
                      }}
                      style={{ position: "relative" }}
                    >
                      {strings.email_tab_email || 'E-Mail'}
                      {!emailTabActive && unseenEmailCount > 0 && (
                        <span className="email-toggle-badge">
                          {unseenEmailCount > 99 ? "99+" : unseenEmailCount}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                )}

                {!emailTabActive ? (
                <>
                {renderChatListView()}
              </>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                    {/* The same title row in the E-Mail view, so nothing shifts when
                        toggling: its button starts a new e-mail here as well. The
                        inbox has its own selection, so no select toggle here. */}
                    {renderListHeader({ emailSection: true })}
                    {/* In integrated mode the filter tabs stay visible above the full email
                        section so the user can switch back to the chat list at any time. */}
                    {integrateEmailInMessages && filterTabsContent}
                  <div
                    className="email-section-layout-enter"
                    style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", position: "relative", background: "#fff" }}
                  >
                    <TrialWarningBanner />
                    <EmailConnectionWarningBanner />
                    {!hasActiveKjuupIoPlan ? (
                      <EmailEmptyState
                        variant={
                          showCompanyTrialEndedNote || hasUsedTrial
                            ? "trialEnded"
                            : "noPlan"
                        }
                        onPrimary={() => history.push("/subscription")}
                      />
                    ) : (
                    <div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
                    <EmailFolderSidebar
                      emailAccounts={emailAccounts}
                      activeEmailAccountId={activeEmailAccountId}
                      onSelectAccount={handleEmailAccountSelect}
                      activeFolder={activeEmailFolder}
                      onSelectFolder={handleEmailFolderSelect}
                      onCompose={activeEmailAccountId ? openComposeNew : undefined}
                      onReorderAccounts={handleReorderEmailAccounts}
                      customFolders={customFolders}
                      onCreateFolder={activeEmailAccountId !== ALL_ACCOUNTS_ID ? handleCreateFolder : undefined}
                      onDeleteFolder={activeEmailAccountId !== ALL_ACCOUNTS_ID ? handleDeleteFolder : undefined}
                      onAddAccount={() => history.push("/profile-setting", { openSection: "email-accounts" })}
                      onFixAccount={() => history.push("/profile-setting", { openSection: "email-accounts" })}
                    />
                    <div style={{ flex: 1, minWidth: 0, overflow: "hidden", position: "relative" }}>
                      <EmailInbox
                        emailAccounts={emailAccounts}
                        activeEmailAccountId={activeEmailAccountId}
                        onSelectAccount={handleEmailAccountSelect}
                        emailMessages={emailMessagesForView}
                        emailLoading={emailLoading}
                        onScroll={handleEmailScroll}
                        onSelectEmail={handleSelectEmail}
                        selectedEmail={selectedEmail}
                        selectedEmailId={selectedEmail?.id || selectedEmail?._id || selectedEmail?.messageId || selectedEmail?.providerMessageId}
                        paginationLoading={emailPaginationLoading}
                        hideTabs
                        onCompose={activeEmailAccountId ? openComposeNew : undefined}
                        onCreateTodoFromEmail={createTodoFromEmail}
                        onRemoveTodoBookmark={(emailId) => removeBookmarkTodo({ emailId })}
                        onDeleteEmails={deleteMultipleEmails}
                        onMarkUnread={markEmailsUnread}
                        onMarkRead={handleMarkEmailsRead}
                        onMoveEmails={handleMoveEmails}
                        onArchiveEmails={activeEmailFolder !== "ARCHIVE" && activeEmailFolder !== "TRASH" ? handleArchiveEmails : undefined}
                        onMarkSpam={activeEmailFolder !== "SPAM" ? handleMarkSpam : undefined}
                        onToggleStar={handleToggleStar}
                        customFolders={customFolders}
                        activeFolder={activeEmailFolder}
                        pendingClassifications={pendingClassifications}
                        pendingClassificationCount={pendingClassifications.length}
                        classificationBuildings={assignableRooms}
                        onClassifyEmail={classifyEmailInline}
                        onOpenProject={openRoomFromEmailTag}
                        onSelectAllAcrossPages={fetchAllSelectableEmailIds}
                        onRefresh={handleEmailRefresh}
                        onFolderSearch={searchFolderMessages}
                        isFolderSearching={isFolderSearching}
                      />
                      {emailActionOverlay && (
                        <div className="email-action-overlay">
                          <span className="material-symbols-outlined email-transition-icon">{emailActionOverlay.icon}</span>
                          <div className="email-transition-text">{emailActionOverlay.text}</div>
                          <div className="email-transition-shimmer" />
                        </div>
                      )}
                    </div>
                    </div>
                    )}
                  </div>
                  </div>
                )}
            </>

            {showPendingRequests && (
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000000000000, backgroundColor: "#fff" }}>
                <ProjectNotification updateRequests={handleUpdateRequests} handleClose={() => setShowPendingRequests(false)}
                  requests={pendingRequests} extraType={'latest'} />
              </div>
            )}
          </div>
          <div
            className={exclusiveMessagesPane ? "lm-exclusive-sheet" : undefined}
            style={exclusiveMessagesPane ? {
              backgroundColor: "#fff",
              display: (detailLive || detailClosing) ? "flex" : "none",
              transform: (slideEntered && detailLive) ? "translateX(0)" : "translateX(100%)",
            } : { 
            backgroundColor: "#fff", 
            display: "flex", 
            flex: messagesSplitLayout ? '0 1 auto' : '1 1 auto',
            width: messagesSplitLayout
              ? (panelWidths.right !== null
                ? `${panelWidths.right}px`
                : '50%')
              : '100%',
            maxWidth: messagesSplitLayout
              ? (panelWidths.right !== null
                ? `${panelWidths.right}px`
                : '50%')
              : '100%',
            minWidth: 0,
            minHeight: 0,
            height: "100%",
            alignSelf: "stretch",
            overflow: 'hidden',
            boxSizing: 'border-box'
          }}>
            {(pane.emailTabActive || (integrateEmailInMessages && (pane.selectedEmail || pane.emailReplyMode))) ? (
              <div
                style={exclusiveMessagesPane
                  ? { flex: 1, display: "flex", flexDirection: "column", position: "relative", width: "100%", height: "100%", minWidth: 0, minHeight: 0, overflow: "hidden", backgroundColor: "#fff" }
                  : (isDesktop ?
                  { flex: 1, display: "flex", flexDirection: "column", position: "relative", zIndex: 1, width: '100%', maxWidth: '100%', minWidth: 0, minHeight: 0, height: '100%', overflow: 'hidden', boxSizing: 'border-box' } :
                  (pane.selectedEmail || pane.emailReplyMode)
                    ? { position: "fixed", zIndex: 10000002, right: 0, left: isLatestMessagesSidebar ? '88px' : '0px', top: '55px', height: 'calc(var(--app-height) - 55px)', maxHeight: 'calc(var(--app-height) - 55px)', display: "flex", flexDirection: "column", backgroundColor: "#fff", overflow: 'hidden', minHeight: 0, boxSizing: 'border-box' }
                    : { display: 'none' }
                )}
              >
                {contentPromptForSelected && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      flexWrap: "wrap",
                      padding: "10px 14px",
                      background: "#fff6ef",
                      borderBottom: "1px solid #f2d9c2",
                    }}
                  >
                    <MaterialIcon icon="folder_special" size={18} color={KJUUP_COLORS.base_color} />
                    <span style={{ flex: 1, minWidth: 180, fontSize: 14, color: "#4d4d4d", fontWeight: 500 }}>
                      {(strings.email_classify_save_question || "Soll ich die E-Mail im Projekt '{name}' abspeichern?").replace(
                        "{name}",
                        contentPromptForSelected.proposedBuilding.name
                      )}
                    </span>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        type="button"
                        onClick={() => saveEmailToProposedProject(contentPromptForSelected)}
                        disabled={savingContentPrompt}
                        style={{
                          height: 32,
                          padding: "0 18px",
                          borderRadius: 8,
                          border: "none",
                          cursor: savingContentPrompt ? "default" : "pointer",
                          background: KJUUP_COLORS.base_color,
                          color: "#fff",
                          fontSize: 14,
                          fontWeight: 600,
                        }}
                      >
                        {strings.yes || "Ja"}
                      </button>
                      <button
                        type="button"
                        onClick={() => dismissContentPrompt(contentPromptForSelected)}
                        disabled={savingContentPrompt}
                        style={{
                          height: 32,
                          padding: "0 18px",
                          borderRadius: 8,
                          border: "1.5px solid #d9d9d9",
                          cursor: savingContentPrompt ? "default" : "pointer",
                          background: "#fff",
                          color: "#737373",
                          fontSize: 14,
                          fontWeight: 600,
                        }}
                      >
                        {strings.no || "Nein"}
                      </button>
                    </div>
                  </div>
                )}
                {isDailyBriefingEmail(pane.selectedEmail) && !pane.emailReplyMode ? (
                <DailyBriefingDocument
                  email={pane.selectedEmail}
                  onClose={() => {
                    if (location.state?.fromGlobalSearch) {
                      handleCloseEmailDetail();
                      return;
                    }
                    if (integrateEmailInMessages && !emailTabActive) {
                      setSelectedEmail(null);
                      setEmailReplyMode(null);
                      if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
                    } else {
                      handleCloseEmailDetail();
                    }
                  }}
                  onDelete={deleteEmailMessage}
                />
                ) : (
                <EmailDetailView
                  ref={emailDetailViewRef}
                  email={pane.selectedEmail}
                  onClose={async () => {
                    // Prefer history Back whenever this email was opened from global search,
                    // so the in-app arrow matches the browser back button.
                    if (location.state?.fromGlobalSearch) {
                      handleCloseEmailDetail();
                      return;
                    }
                    if (emailReplyMode) {
                      setSelectedEmail(null);
                      return;
                    }
                    if (integrateEmailInMessages && !emailTabActive) {
                      await guardAndLeaveEmailSection(() => {
                        setSelectedEmail(null);
                        setEmailReplyMode(null);
                        if (exclusiveMessagesPane) dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
                      });
                    } else {
                      handleCloseEmailDetail();
                    }
                  }}
                  onReply={["SPAM", "DRAFT", "TRASH"].includes(activeEmailFolder) ? undefined : openComposeReply}
                  onReplyAll={["SPAM", "DRAFT", "TRASH"].includes(activeEmailFolder) ? undefined : openComposeReplyAll}
                  onForward={["SPAM", "DRAFT", "TRASH"].includes(activeEmailFolder) ? undefined : openComposeForward}
                  onToggleBookmark={toggleEmailBookmark}
                  onDelete={deleteEmailMessage}
                  onNotSpam={handleMarkNotSpam}
                  onMarkSpam={handleMarkSpam}
                  onOpenProject={openRoomFromEmailTag}
                  onOpenChatLink={openChatFromNotificationEmail}
                  onChangeProject={(em) => setAssignModalEmail(assignModalSnapshot(em))}
                  onRemoveProject={(em, bId) => classifyEmailInline(em?.id || em?._id || em?.messageId || em?.providerMessageId, "unlink", "", bId)}
                  projectColorById={projectColorById}
                  onArchive={handleArchiveEmails}
                  onMarkUnread={markEmailUnreadFromDetail}
                  onMoveEmail={handleMoveEmails}
                  onToggleStar={handleToggleStar}
                  customFolders={customFolders}
                  activeFolder={activeEmailFolder}
                  replyMode={pane.emailReplyMode}
                  onCancelReply={cancelReplyMode}
                  onEditDraft={() => setEmailReplyMode("draft")}
                  accountId={activeEmailAccountId === ALL_ACCOUNTS_ID ? (selectedEmail?.__accountId || activeEmailAccountId) : activeEmailAccountId}
                  emailAccounts={emailAccounts}
                  onSent={handleComposeSent}
                  buildings={assignableRooms}
                  companionContent={emailReplyMode && composeCompanionTab ? renderOpenEntryPanes(true) : null}
                  companionTab={composeCompanionTab}
                />
                )}
                {emailActionOverlay && (
                  <div className="email-action-overlay">
                    <span className="material-symbols-outlined email-transition-icon">{emailActionOverlay.icon}</span>
                    <div className="email-transition-text">{emailActionOverlay.text}</div>
                    <div className="email-transition-shimmer" />
                  </div>
                )}
              </div>
            ) : (
              renderOpenEntryPanes()
            )}
          </div>
        </div>
      </div>
      {/* Member Selection Modal */}
      {showMemberSelection && (
        <MemberSelection
          onClose={() => setShowMemberSelection(false)}
          onComplete={() => {
            setShowMemberSelection(false);
            // Don't call _resetAndGetLatestMessages() here - MemberSelection handles
            // its own state setup and navigation for direct chats
          }}
          // A Microsoft Teams chat (and a Kjuup + Teams group) needs a connected Teams account and Kjuup.io.
          teamsEnabled={canPickTeamsContacts(teamsConnected, hasActiveKjuupIoPlan, hideChatsPref)}
          onTeamsChatCreated={openCreatedTeamsChat}
        />
      )}

      {/* Chat row menu (⋮ / right click) */}
      {rowMenu ? <ChatRowMenu menu={rowMenu} onClose={closeRowMenu} /> : null}
      <BookmarkProjectSheet
        open={!!taskProjectFor}
        onPick={(room) => {
          const args = taskProjectFor;
          setTaskProjectFor(null);
          if (args) openTodoModal(...args.slice(0, 5), room.id, args[6]);
        }}
        onClose={() => setTaskProjectFor(null)}
      />
      {teamsRoomRow ? (
        <TeamsChatRoomModal
          groupId={teamsRoomRow.groupId}
          project={teamsRoomRow.project}
          onClose={() => setTeamsRoomRow(null)}
        />
      ) : null}

      {/* Suggestion Loading Popup */}
      {showSuggestionLoadingPopup && (
        <div className="suggestion-loading-popup-overlay">
          <div className="suggestion-loading-popup">
            <div className="suggestion-loading-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <p className="suggestion-loading-text">
              {strings.suggestion_loading_message}
            </p>
          </div>
        </div>
      )}

      {/* ToDo Creating Loader */}
      {showTodoCreatingLoader && (
        <div className="todo-creating-overlay">
          <div className="todo-creating-popup" style={{ minWidth: 320 }}>
            {/* Step indicators */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              gap: 6, 
              marginBottom: 24 
            }}>
              {/* Step 1 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 1 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                {todoCreatingStep > 1 ? '✓' : '1'}
              </div>
              {/* Connector line 1-2 */}
              <div style={{
                width: 32,
                height: 3,
                backgroundColor: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#e0e0e0',
                borderRadius: 2,
                transition: 'background-color 0.3s ease'
              }} />
              {/* Step 2 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                {todoCreatingStep > 2 ? '✓' : '2'}
              </div>
              {/* Connector line 2-3 */}
              <div style={{
                width: 32,
                height: 3,
                backgroundColor: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#e0e0e0',
                borderRadius: 2,
                transition: 'background-color 0.3s ease'
              }} />
              {/* Step 3 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                3
              </div>
            </div>
            {/* Step labels */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 20,
              gap: 4,
            }}>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 1 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 1 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.extracting_message || (isGerm ? 'Nachricht extrahieren' : 'Extracting message')}
              </span>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 2 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.creating_todo || (isGerm ? 'Aufgabe erstellen' : 'Creating ToDo')}
              </span>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 3 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.navigating_to_todo || (isGerm ? 'Zu Aufgaben navigieren' : 'Navigating to ToDo')}
              </span>
            </div>
            
            <div className="todo-creating-spinner-container">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <p className="todo-creating-text">
              {todoCreatingStep === 1 
                ? (strings.extracting_message || (isGerm ? 'Nachricht wird extrahiert...' : 'Extracting message...'))
                : todoCreatingStep === 2
                  ? (strings.creating_todo || (isGerm ? 'Aufgabe wird erstellt...' : 'Creating ToDo...'))
                  : (strings.navigating_to_todo || (isGerm ? 'Weiterleitung zu Aufgaben...' : 'Navigating to ToDo...'))
              }
            </p>
          </div>
        </div>
      )}

      {/* Bulk email delete — single full-screen overlay with live progress */}
      {emailDeleteProgress && (
        <div className="email-delete-fullscreen-overlay">
          <div className="email-delete-progress-card">
            <MaterialIcon icon="delete" size={36} color="#e066ed" style={{ marginBottom: 12 }} />
            <div className="email-delete-progress-text">
              {strings.deleting_emails || "Deleting emails..."}
            </div>
            <div className="email-delete-progress-count">
              {emailDeleteProgress.completed} / {emailDeleteProgress.total}
            </div>
            <div className="email-delete-progress-bar-track">
              <div className="email-delete-progress-bar-fill" style={{ width: ((emailDeleteProgress.completed / (emailDeleteProgress.total || 1)) * 100) + '%' }} />
            </div>
          </div>
        </div>
      )}

      {emailClassifyProgress && !assignModalEmail && (emailClassifyProgress.total > 1 || emailClassifyProgress.phase === "finding") && (
        <EmailClassifyBusyOverlay
          variant="fullscreen"
          label={classifyProgressLabel(emailClassifyProgress, strings)}
          completed={emailClassifyProgress.completed}
          total={emailClassifyProgress.total}
        />
      )}


    {assignModalEmail && (
      <EmailAssignModal
        email={assignModalEmail}
        proposedName={findPendingForEmail(assignModalEmail)?.proposedBuilding?.name}
        buildings={assignableRooms}
        onClassify={classifyEmailInline}
        onClose={() => setAssignModalEmail(null)}
        strings={strings}
      />
    )}

    {tagActionCtx && (
      <ProjectTagActionModal
        project={tagActionCtx.project}
        projectColor={resolveProjectColor(tagActionCtx.project)}
        onNavigate={() => {
          const em = tagActionCtx.email;
          openRoomFromEmailTag(tagActionCtx.project, em?.id || em?._id || em?.messageId || em?.providerMessageId);
          setTagActionCtx(null);
        }}
        onChange={() => {
          const em = tagActionCtx.email;
          setTagActionCtx(null);
          setAssignModalEmail(assignModalSnapshot(em));
        }}
        onRemove={() => {
          const em = tagActionCtx.email;
          const bId = tagActionCtx.project?.id;
          setTagActionCtx(null);
          classifyEmailInline(em?.id || em?._id || em?.messageId || em?.providerMessageId, "unlink", "", bId);
        }}
        onClose={() => setTagActionCtx(null)}
        strings={strings}
      />
    )}

    </>
  );
  return renderPage();
}

const mapStateToProps = (state) => {
  const {
    rightTop,
    unseenNewsCount,
    openChats,
    groups,
    groupChats,
    openProjects,
  } = state;
  return {
    rightTop: rightTop,
    unseenNewsCount: unseenNewsCount,
    openChats: openChats,
    groups: groups,
    groupChats: groupChats,
    openProjects,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetMessages: () =>
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: [] }),
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    setInActivity: (status) =>
      dispatch({ type: SET_IN_ACTIVITY, status: status }),
    updateRightTop: (value) => dispatch({ type: RIGHT_TOP, rightTop: value }),
    updateNewsCount: (count) =>
      dispatch({ type: NEWS_BADGE_COUNT, unseenNewsCount: count }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateGroupChats: (chats) =>
      dispatch({ type: GROUP_CHATS, groupChats: chats }),
    updateOpenProjects: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LatestMessages));
